export let langArr = {};
langArr.en = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'drop_ball': 'Drop ball',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficiend_funds': 'Insufficiend Funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',

'game_rules': 'GAME RULES',
'game_rules_p1': 'Welcome to Plinko – Where Luck Takes the Lead!',
'game_rules_p2': 'Get ready for a thrilling game of chance that’s as simple as it is addictive! Plinko is all about dropping a ball onto a peg-filled pyramid and watching it bounce, twist, and ricochet its way down to a prize-filled slot at the bottom.',
'game_rules_p3': 'Choose between 8 to 16 rows of pegs, then sit back and enjoy the chaos as the ball zigzags through the board, guided by nothing but gravity and luck',
'game_rules_p4': 'Will it land in a low-paying slot… or hit the big win? There’s only one way to find out — drop the ball and let the excitement unfold!',
'general': 'GENERAL',
'general_p1': 'Drop the Plinko ball and hope it lands in one of the high-paying slots at the bottom. The path is unpredictable — every bounce can change your fortune.',
'general_p2': 'The more rows you play, the more intense the action!',
'general_p3': 'So go ahead — trust your luck, hit DROP, and chase that big win through the pegs of Plinko!',
'betting': 'BETTING',
'betting_p1': 'Сhoose the bet amount. Buttons “1/2”, “2x”, “Max” can be used to manage bet size. The bet amount value can be entered manually as well.',
'betting_p2': 'Choose the Risk Level: Low, Medium or High. Lower risk level gives more consistent outcomes (low volatility) while higher gives more variance (high volatility).',
'betting_p3': 'Choose the number of lines in the game: from 8 to 16. Select how many rows of pegs the ball will fall through. More rows = more unpredictability.',
'betting_p4': 'Choose the Bet Mode: Manual or Auto.',
'betting_p5': 'To start the game round press the DROP BALL button. All betting buttons become inactive at the time of the round except for DROP BALL and Bet amount.',
'betting_p6': 'One Plinko ball represents one round. During the round, another round with the same settings using the DROP BALL button can be started. It is possible to change Bet amount while there are "live" balls on the peg table, but not the game Difficulty.',
'betting_p7': 'At the end of the round, the ball reaches the pocket. On each pocket payout multiplier is displayed.',
'betting_p8': 'The calculation of the win is made according to the multiplier where ball landed. The result is added to the balance field.',
'game_menu_p1': 'Most recent bet multipliers are show in bottom part of a game window.',
'game_menu_p2': 'On the “Bet history” button a player may review his latest bets in more details.',
'game_menu_p3': 'Further play history (eg. longer periods), a player may need to access the player history within the gaming platform itself.',
'game_menu_p4': 'Trough game menu, players can control sound options, keyboard shortcuts, and open bet history and game rules.',
'game_menu_p5': 'The game is designed with beautiful background music and sound effects in mind. Music and/or sound effects can be disabled through game menu icons.',
'game_menu_p6': 'Game history will show window with previous bets and bonusing history.',
'autoplay': 'Auto Mode (Autoplay)',
'autoplay_p1': 'Clicking Auto allows you automatically drop a number of balls without clicking each time.',
'autoplay_p2': 'Choose the amount you want to bet per ball.',
'autoplay_p3': 'Select how many times (rounds) you want the ball to drop — up to 100 rounds max.',
'autoplay_p4': 'Press the START button to begin and the button will change to STOP.',
'autoplay_p5': 'Auto Mode will stop when the selected number of drops is completed, you run out of funds or click STOP button.',
'autoplay_p6': 'Each drop uses the same bet amount as the one you selected before starting Auto Mode.',
'turbo_mode': 'Turbo Mode',
'turbo_mode_p1': 'Turbo Drop lets you drop balls blazing fast by holding down the DROP button.',
'turbo_mode_p2': 'Balls will keep falling until you release the button or run out of balance.',
'turbo_mode_p3': 'Balls will keep falling until you release the button or run out of balance.',
'turbo_balance': 'Turbo Balance',
'turbo_balance_p1': 'Before starting Turbo Drop, you choose how much money to set aside for it — this becomes your Turbo Balance.',
'turbo_balance_p2': 'While Turbo Drop is active, the game uses only your Turbo Balance for bets and wins.',
'turbo_balance_p3': 'When you stop Turbo Drop mode, any leftover Turbo Balance goes back to your main balance.',
'turbo_balance_p4': 'You can exit Turbo Drop at any time — but the mode will fully end only after all balls have finished falling and landed in multiplier pockets.',
'free_bets': 'BONUS ROUNDS',
'free_bets_p1': 'Bonus Rounds are awarded by the operator.',
'fairness': 'Fairness',
'fairness_p1': 'Each drop is determined by a provably fair random number generator (RNG).',
'fairness_p2': 'The outcome cannot be predicted or influenced once the ball is dropped.',
'disconection_and_error': 'Disconnection Policy and Error handling',
'disconection_and_error_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled. If the game requires action from a player, the result is counted assuming that the player has chosen the action with no risk without raising the initial bet.',
'disconection_and_error_p2': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'other': 'Other',
'other_p1': 'In the event of a malfunction of the gaming hardware/software, all affected game bets and pay-outs are rendered void and all affected bets are refunded.',
'other_p2': 'The Game Rules as published are in English. Translations into other languages are provided as a service in good faith. In the event of ambiguity between an English version and a translation, the English version always retains priority.',
'rows': 'Rows',
'lvl': 'Lvl',
'low': 'Low',
'high': 'High',
'ok': 'OK',
'exit_turbo_mode': 'Do you want to exit Turbo mode?',
'end': 'END',
'turbo_mode_settings': 'Turbo Mode Settings',
'stop': 'STOP',
'invalid_bet_amount': 'Invalid bet amount',
'cashout_success': 'Cashout successful',
'stop_auto_play_first': 'Stop AUTO play first.',
'turbo_only_when_no_balls': 'Turbo can be activated only when there are no balls on the board.',
'type': 'Bet type',
'wait_balls_to_finish': 'Please wait for all balls to finish.',
'bet_too_large_top_up_turbo_balance': 'Bet too large — top up your Turbo balance!',
};
langArr.sw = {
'loading': 'Inapakia',
'hotkeys': 'Vifunguo vya haraka',
'hotkeys_enabled': 'Vifunguo vya haraka vimewezeshwa',
'enable_hotkeys_checkbox': 'Washa vifunguo vya haraka kwa kuweka alama.',
'drop_ball': 'Achia Mpira',
'double_bet': 'Ongeza dau mara mbili',
'halve_bet': 'Punguza dau kwa nusu',
'min_bet': 'Kiasi cha chini cha dau',
'max': 'Kikomo',
'easy': 'Rahisi',
'medium': 'Kati',
'hard': 'Ngumu',
'daredevil': 'Hatari',
'max_profit': 'Faida ya juu kabisa',
'manual': 'Mwongozo',
'auto': 'Otomatiki',
'bet_amount': 'Kiasi cha dau',
'difficulty': 'Ugumu',
'payout_on_win': 'Malipo Ukishinda',
'number_of_bets': 'Idadi ya Madau',
'on_win': 'Ukishinda',
'on_loss': 'Ukishindwa',
'stop_on_profit': 'Acha kwenye Faida',
'stop_on_loss': 'Acha kwenye Hasara',
'reset': 'Weka upya',
'increase_by': 'Ongeza kwa',
'cashout': 'TOA FEDHA',
'start_game': 'WEKA DAU',
'start_auto_game': 'ANZA',
'difficulity_info': 'Maelezo ya Ugumu',
'chance_collision': 'Nafasi ya kugongana kwa kila mchezo',
'evry_25_lane': 'kwa kila njia 25',
'insufficiend_funds': 'Fedha hazitoshi',
'cashout_inactivity': 'Malipo ya kiotomatiki kwa kutofanya kazi',
'time_running_out': 'Muda unakaribia kuisha! Cheza sasa au tiketi yako itaondolewa moja kwa moja baada ya sekunde 30',
'there_was_error': 'KUNA HITILAFU, JARIBU TENA AU PAKIA UPYA',
'detailed_game_rules': 'Sheria za Mchezo kwa Kina',
'general_rules': 'SHERIA ZA JUMLA',
'general_rules_p1': '• Kizidishi huanza kwa 1 na kupanda hadi ',
'general_rules_p2': '• Ushindi huhesabiwa kwa kuzidisha dau na kizidishi kinachoonyeshwa kwenye kila hatua.',
'general_rules_p3': '• Ikiwa kiwango cha juu cha malipo kitafikiwa, mchezo utajitoa pesa kiotomatiki kwa kiwango cha juu cha malipo.',
'progressive_jackpot': 'JACKPOT INAYOENDELEA',
'progressive_jackpot_ss': 'Njia ya jackpot na uwezekano wa kushinda',
'progressive_jackpot_p1': '% ya kila dau huwekwa kwenye mfuko wa jackpot inayoendelea.',
'progressive_jackpot_p2': 'Jackpot hutolewa kwa kutumia mbinu ya "Mystery" au "must-hit-by". Thamani ya kila jackpot ya "must-hit-by" huamuliwa mara tu baada ya jackpot iliyotangulia kushindwa kwa kutumia jenereta ya namba za bahati nasibu na kuhifadhiwa kama thamani iliyofichwa kwenye hifadhidata ya mbali. Thamani hiyo imefichwa na haijulikani.',
'progressive_jackpot_p3': 'Mara tu thamani ya "must-hit-by" inapofikiwa, mchezaji wa kwanza kuweka dau baada ya hapo atakuwa na nafasi ya kushinda jackpot. Alama ya jackpot itaonekana kwenye njia nasibu, na jackpot itashindwa ikiwa mchezaji atafikia njia yenye alama hiyo. Ikiwa mchezaji hatafikia njia yenye alama ya jackpot kwa sababu ya kujitoa au kuanguka, mchezaji mwingine nasibu atakayeweka dau ataona alama ya jackpot na kupata nafasi ya kushinda. Mchakato huu utaendelea hadi jackpot ishindwe. Ni tiketi/mchezaji mmoja tu anaweza kushinda jackpot.',
'progressive_jackpot_p4': 'KUMBUKA: Raundi ya bonasi haichangii mfuko wa jackpot. Wakati wa raundi ya bonasi, jackpot haiwezi kushindwa.',
'showdown': 'MCHUANO',
'showdown_ss': 'Mraba mwekundu, mahali pa mgongano fulani',
'showdown_p1': 'Baada ya mchezaji kujitoa, mraba mwekundu utaonyeshwa mahali ambapo mgongano ungetokea ikiwa mchezaji angeendelea kuruka njia.',
'return_to_player': 'KUREJESHA KWA MCHEZAJI',
'return_to_player_p1': 'Rejesho la kinadharia kwa mchezaji (RTP) ni ',
'return_to_player_p2': 'Asilimia za RTP hufuatiliwa na kuthibitishwa kila mara na taasisi huru.',
'disconnection_policy': 'SERA YA KUKATIKA MTANDAO',
'disconnection_policy_p1': 'Ikiwa muunganisho utakatika baada ya dau kuwekwa, dau halitafutwa mara moja. Ikiwa kutokuwepo kwa mchezaji kutafikia ',
'disconnection_policy_p2': 'dau litajitowa kiotomatiki na pesa zitawekwa kwenye akaunti ya mchezaji.',
'network_latency': 'UCHELEWESHAJI WA MTANDAO',
'network_latency_p1': 'Ucheleweshaji wa mtandao ni sehemu isiyoepukika ya muunganisho wa Intaneti. Tunachukulia dau na utoaji wa pesa kuwa halali tu wakati yanapofika kwenye seva zetu, bila kujali muda wa ucheleweshaji wa mtandao.',
'sound': 'SAUTI',
'sound_p1': 'Mchezo umebuniwa kwa kuzingatia muziki wa mandhari nzuri na athari za sauti. Ikiwa unataka kulemaza muziki na/au athari za sauti, unaweza kufanya hivyo kupitia menyu ya mchezo.',
'error_handling': 'USHUGHULIKIAJI WA MAKOSA',
'error_handling_p1': 'Endapo kutatokea hitilafu, timu yetu ya msaada itajaribu kutatua tatizo haraka iwezekanavyo na kuendelea na mchezo wa kawaida. Iwapo kuna tatizo na mchezo wenyewe, dau zote zitafutwa na kiasi cha dau kitarudishwa kwa wachezaji.',
'max_payout': 'Malipo ya juu zaidi ni ',
'max_bet_is': 'Dau la juu zaidi ni ',
'min_bet_is': 'Dau la chini zaidi ni ',
'per_bet': 'kwa kila dau.',
'malfunction_voids': 'Hitilafu inabatilisha malipo yote na michezo yote.',
'attention_jackpot': 'Tahadhari, Jackpot kwenye njia ',
'lane': 'njia',
'congratulations': 'hongera',
'you_won': 'umeshinda',
'balance': 'salio',
'time': 'muda',
'jackpot': 'jackpot',
'escaped': 'UMEPONEA',
'max_win': 'USHINDI WA JUU ZAIDI',
'check_internet': 'Tafadhali angalia muunganisho wako wa intaneti',
'websocket_disconected': 'Muunganisho wa WebSocket umekatika',
'websocket_connection_error': 'Hitilafu ya muunganisho wa WebSocket!',
'session_expired': 'Kipindi kimeisha, tafadhali pakia upya',
'remaining_bets': 'Dau Zilizobaki',
'stop_autoplay': 'SIMAMISHA',
'autoplay_and_autocashout': 'MCHEZO KIOTOMATI NA MALIPO KIOTOMATI',
'autoplay_and_autocashout_ss': 'Chaguo kati ya mwongozo na mchezo wa moja kwa moja',
'autoplay_and_autocashout_p1': 'Mchezaji anaweza kuwezesha chaguo la mchezo wa moja kwa moja ambapo dau huwekwa kiotomatiki kwa kila raundi mpya kwa kutumia kiasi cha dau kutoka dau la awali.',
'autoplay_and_autocashout_p2': 'Kizidishi cha utoaji wa pesa kiotomatiki kinaweza kuchaguliwa kutoka kwenye skrini ya mchezo, na kikishawekwa, mchezo utajitoa pesa kiotomatiki ikiwa mchezaji hatapoteza kabla ya kufikia kizidishi kilichochaguliwa.',
'autoplay_and_autocashout_p3': 'Idadi ya juu kabisa ya raundi za mchezo wa moja kwa moja ni ',
'autoplay_button_label': 'Kuanzisha, chagua njia.',
'min_bet_amount_is': 'Kiasi cha chini cha dau ni',
'bonus_rounds': 'RAUNDI ZA BONASI',
'bonus_rounds_ss': 'Raundi za Bonasi zenye muda wa uhalali',
'bonus_rounds_p1': 'Mchezaji anaweza kupewa raundi ya bonasi (yaani dau la bure) kulingana na ofa ya kasino. Picha ibukizi itaonekana kwenye skrini ikimjulisha mchezaji kuhusu raundi za bonasi alizopewa, idadi ya dau, kiasi kwa kila dau, na kwa hiari, muda wa uhalali.',
'bonus_rounds_p2': 'Mara baada ya kutunukiwa, mchezaji anaweza kuchagua wakati wa kuanza raundi ya bonasi. Mara tu raundi ya bonasi inapowashwa, dau la kiotomatiki lenye dau maalum linawekwa, na ni juu ya mchezaji kujitoa pesa wakati wowote.',
'bonus_rounds_p3': 'Raundi za bonasi zinaweza kuwa na kikomo cha muda, baada ya hapo zinakuwa batili na haziwezi kutumika. Muda wa uhalali, ikiwa upo, unaonyeshwa chini ya raundi ya bonasi.',
'bonus_rounds_p4': 'Kutokuwepo kwa mchezaji kunaweza kusababisha kufutwa kwa raundi ya bonasi inayofanya kazi. Katika hali hii, idadi ya raundi za bonasi inapungua, na salio la mchezaji linabaki vile vile.',
'valid_until': 'halali hadi',
'bonus': 'bonasi',
'rounds': 'mizunguko',
'win_eur': 'Shinda EUR',
'complete_your_bet': 'Tafadhali kamilisha dau lako kwanza',
'complete_auto_play': 'Tafadhali kamilisha mchezo kiotomatiki kwanza',
'yes': 'ndio',
'no': 'hapana',
'play_bonus_rounds': 'Cheza mizunguko ya bonasi?',
'bet_history': 'Historia ya Dau',
'jackpot_history': 'Historia ya Jackpot',
'ticket_id': 'ID ya Tiketi',
'created': 'ilianzishwa',
'currency': 'sarafu',
'bet': 'dau',
'bet_eur': 'dau EUR',
'lanes': 'njia',
'cars': 'magari',
'multiplier': 'kizidishi',
'win': 'ushindi',
'no_betting_history': 'Hakuna historia ya dau. Weka dau, na itaonekana hapa.',
'no_jackpot_history': 'Hakuna historia ya jackpot inayopatikana.',
'date': 'tarehe',
'user': 'mtumiaji',
'bet_already_active': 'Dau tayari linaendelea',
'please_play_the_game_in_portait_mode': 'Tafadhali cheza mchezo katika mtazamo wima.',
'bonus_history': 'Historia ya bonasi',
'bonus_type': 'Aina ya bonasi',
'no_bonus_history': 'Hakuna historia ya bonasi inayopatikana.',
'game_menu': 'Menyu ya Mchezo',
'game_menu_ss': 'Kutoka kushoto: Nyumbani, Historia ya Dau, Kanuni za Mchezo, Vifupisho vya Kibodi, Mipangilio ya Sauti FX, Muziki',
// 'game_menu_p1': 'Kupitia menyu ya mchezo, wachezaji wanaweza kudhibiti chaguo za sauti, vifupisho vya kibodi, na kufungua historia ya mchezo pamoja na kanuni za mchezo.',
// 'game_menu_p2': 'Historia ya mchezo itaonyesha dirisha lenye dau za awali na historia ya bonasi.',
'game_rules': 'SHERIA ZA MCHEZO',
'game_rules_p1': 'Karibu kwenye Plinko – Ambapo Bahati Inachukua Hatua!',
'game_rules_p2': 'Jiandae kwa mchezo wa msisimko wa bahati ambayo ni rahisi na inavutia! Plinko ni juu ya kuachia mpira kwenye piramidi iliyojaa vinara (pegs) na kuuchezea ukirukaruka, kugeuka, na kushuka hadi slot iliyojazwa zawadi chini.',
'game_rules_p3': 'Chagua kati ya safu 8 hadi 16 za vinara, kisha jilaze na uchezee ukikutazama mpira ukipingika kupitia ubao, unaongozwa na uzito wa mvuto na bahati tu.',
'game_rules_p4': 'Je, itaingia kwenye slot ya malipo ya chini… au kugonga ushindi mkubwa? Kuna njia moja tu ya kujua — achilia mpira na ufuatilie msisimko ukifunguka!',
'general': 'JUMLA',
'general_p1': 'Achatua mpira wa Plinko na matumaini utaingia kwenye moja ya slot zenye malipo makubwa chini. Njia ni ya kutotabirika — kila kurukaruka kunaweza kubadilisha bahati yako.',
'general_p2': 'Kadri safu unazocheza zinavyoongezeka, ndivyo mchezo unavyokuwa mkali zaidi!',
'general_p3': 'Kwa hivyo endelea — tumaini bahati yako, bonyeza DROP, na fuata ushindi mkubwa kupitia vinara vya Plinko!',
'betting': 'KUBETI',
'betting_p1': 'Chagua kiasi cha dau. Vifungo “1/2”, “2x”, “Max” vinaweza kutumika kudhibiti ukubwa wa dau. Kiasi cha dau kinaweza pia kuingizwa kwa mkono.',
'betting_p2': 'Chagua Kiwango cha Hatari: Chini, Kati au Juu. Hatari ndogo hutoa matokeo thabiti zaidi (mtikisiko mdogo), huku hatari kubwa ikileta mabadiliko makubwa (mtikisiko mkubwa).',
'betting_p3': 'Chagua idadi ya mistari kwenye mchezo: kuanzia 8 hadi 16. Chagua safu ngapi za pini ambazo mpira utapitia. Mistari zaidi = kutotabirika zaidi.',
'betting_p4': 'Chagua Njia ya Dau: Mwongozo au Otomatiki.',
'betting_p5': 'Ili kuanza raundi ya mchezo, bonyeza kitufe cha DROP BALL. Wakati wa raundi, vitufe vyote vya dau vinakuwa havifanyi kazi isipokuwa DROP BALL na kiasi cha dau.',
'betting_p6': 'Mpira mmoja wa Plinko unawakilisha raundi moja. Wakati wa raundi, raundi nyingine yenye mipangilio sawa inaweza kuanzishwa kwa kitufe cha DROP BALL. Inawezekana kubadilisha kiasi cha dau wakati mipira iko hai kwenye ubao, lakini si ugumu wa mchezo.',
'betting_p7': 'Mwisho wa raundi, mpira unafika kwenye mfuko. Kizidishi cha malipo kinaonyeshwa kwenye kila mfuko.',
'betting_p8': 'Hesabu ya ushindi hufanywa kulingana na kizidishi ambacho mpira umetua. Matokeo yanaongezwa kwenye salio.',
'game_menu_p1': 'Vizidishi vya dau vya hivi karibuni vinaonyeshwa chini ya dirisha la mchezo.',
'game_menu_p2': 'Kupitia kitufe cha “Bet history”, mchezaji anaweza kukagua dau zake za hivi karibuni kwa undani zaidi.',
'game_menu_p3': 'Kwa historia ndefu ya uchezaji, mchezaji anaweza kuhitaji kufikia historia yake kupitia jukwaa la michezo lenyewe.',
'game_menu_p4': 'Kupitia menyu ya mchezo, wachezaji wanaweza kudhibiti sauti, mikato ya kibodi, na kufungua historia ya dau na sheria za mchezo.',
'game_menu_p5': 'Mchezo umeundwa kwa kuzingatia muziki mzuri wa mandharinyuma na athari za sauti. Muziki na/au athari za sauti zinaweza kuzimwa kupitia ikoni za menyu ya mchezo.',
'game_menu_p6': 'Historia ya mchezo itaonyesha dirisha lenye dau za awali na historia ya bonasi.',
'autoplay': 'Njia ya Otomatiki (Autoplay)',
'autoplay_p1': 'Kubofya Auto hukuruhusu kuangusha mipira kadhaa kiotomatiki bila kubofya kila mara.',
'autoplay_p2': 'Chagua kiasi unachotaka kuweka dau kwa kila mpira.',
'autoplay_p3': 'Chagua mara ngapi (raundi) unataka mpira uanguke — hadi raundi 100 kwa kiwango cha juu.',
'autoplay_p4': 'Bonyeza kitufe cha START kuanza na kitufe kitabadilika kuwa STOP.',
'autoplay_p5': 'Njia ya Otomatiki itasimama baada ya idadi iliyochaguliwa kukamilika, fedha kuisha au kubofya STOP.',
'autoplay_p6': 'Kila uangushaji hutumia kiasi sawa cha dau ulichochagua kabla ya kuanza Njia ya Otomatiki.',
'turbo_mode': 'Njia ya Turbo',
'turbo_mode_p1': 'Turbo Drop hukuruhusu kuangusha mipira kwa kasi kwa kubonyeza na kushikilia kitufe cha DROP.',
'turbo_mode_p2': 'Mipira itaendelea kuanguka hadi uachie kitufe au salio liishe.',
'turbo_mode_p3': 'Mipira itaendelea kuanguka hadi uachie kitufe au salio liishe.',
'turbo_balance': 'Salio la Turbo',
'turbo_balance_p1': 'Kabla ya kuanza Turbo Drop, unachagua kiasi cha pesa cha kutenga — hiki kinakuwa Salio lako la Turbo.',
'turbo_balance_p2': 'Wakati Turbo Drop inafanya kazi, mchezo hutumia Salio lako la Turbo pekee kwa dau na ushindi.',
'turbo_balance_p3': 'Unaposimamisha Turbo Drop, Salio la Turbo lililobaki hurudi kwenye salio lako kuu.',
'turbo_balance_p4': 'Unaweza kuondoka Turbo Drop wakati wowote — lakini hali itaisha kabisa baada ya mipira yote kuanguka na kutua.',
'free_bets': 'RAUNDI ZA BONASI',
'free_bets_p1': 'Raundi za Bonasi hutolewa na opereta.',
'fairness': 'Ufadhili',
'fairness_p1': 'Kila uachishaji hua na jenereta ya namba ya bahati huria inayoweza kuthibitishwa (RNG).',
'fairness_p2': 'Matokeo hayawezi kutabirika au kuathiriwa mara mpira unapocholewa.',
'disconection_and_error': 'Sera ya Kutokuwepo na Usanidi wa Hitilafu',
'disconection_and_error_p1': 'Kama muunganisho unapotea baada ya dau kuwekwa, dau halitabwishwa. Ikiwa mchezo unahitaji hatua kutoka kwa mchezaji, matokeo yawahi kuhesabiwa ukiwa umechagua chaguo lisilo na hatari bila kuongeza dau la awali.',
'disconection_and_error_p2': 'Endapo kuna hitilafu timu yetu ya msaada itajaribu kurekebisha haraka iwezekanavyo, na kuendeleza mchezo kama kawaida. Katika tukio la hitilafu kwenye mchezo yenyewe, dau zote zitabwatishwa na kiasi kilichowekwa kitarejeshwa kwa wachezaji.',
'other': 'Nyingine',
'other_p1': 'Katika tukio la hitilafu ya hardware/software ya mchezo, dau zote zilizoathirika na malipo hutetwa kuwa batili na dau zote zaathirika zinarudishwa.',
'other_p2': 'Kanuni za Mchezo zilizochapishwa ziko kwa Kiingereza. Tafsiri kwa lugha nyingine hutolewa kama huduma kwa niaba ya nia nzuri. Endapo kutakuwa na utata kati ya toleo la Kiingereza na tafsiri, toleo la Kiingereza lina kipaumbele kila mara.',
'rows': 'Safu',
'lvl': 'Ngazi',
'low': 'Chini',
'high': 'Juu',
'ok': 'OK',
'exit_turbo_mode': 'Je, unataka nje Turbo mode?',
"end": "MWISHO",
"turbo_mode_settings": "Mipangilio ya Modi ya Turbo",
'stop': 'SIMAMISHA',
'invalid_bet_amount': 'Kiasi cha dau batili',
'cashout_success': 'Utoaji wa fedha umefanikiwa',
'stop_auto_play_first': 'Simamisha mchezo wa AUTO kwanza.',
'turbo_only_when_no_balls': 'Turbo inaweza kuanzishwa tu wakati hakuna mipira kwenye ubao.',
'type': 'Aina ya dau',
'wait_balls_to_finish': 'Tafadhali subiri mipira yote kumaliza.',
'bet_too_large_top_up_turbo_balance': 'Dau kubwa sana — ongeza Salio lako la Turbo!',

};
langArr.zu = {
'loading': 'Iyalayisha',
'hotkeys': 'Izinkinobho ezisheshayo',
'hotkeys_enabled': 'Izinkinobho ezisheshayo zivuliwe',
'enable_hotkeys_checkbox': 'Vula izinkinobho ezisheshayo eziboniswe ngezansi ngokumaka le bhokisi.',
'drop_ball': 'Wehlisa ibhola',
'double_bet': 'Phinda kabili ukubheja',
'halve_bet': 'Yehlisa ukubheja ngengxenye',
'min_bet': 'Inani eliphansi lokubheja',
'max': 'Ubukhulu',
'easy': 'Kulula',
'medium': 'Maphakathi',
'hard': 'Kunzima',
'daredevil': 'Isibindi',
'max_profit': 'Inzuzo enkulu',
'manual': 'Ngesandla',
'auto': 'Okuzenzakalelayo',
'bet_amount': 'Inani lokubheja',
'difficulty': 'Ubunzima',
'payout_on_win': 'Inkokhelo uma uwina',
'number_of_bets': 'Inani lokubheja',
'on_win': 'Uma uwina',
'on_loss': 'Uma uhlulwa',
'stop_on_profit': 'Yima uma kunenzuzo',
'stop_on_loss': 'Yima uma kulahleka',
'reset': 'Setha kabusha',
'increase_by': 'Khulisa ngo',
'cashout': 'KHOKHA',
'start_game': 'BHEJA',
'start_auto_game': 'QALA',
'difficulity_info': 'Ulwazi Lobunzima',
'chance_collision': 'Amathuba okushayisana ngomdlalo ngamunye',
'evry_25_lane': 'kuwo wonke imigqa engu-25',
'insufficiend_funds': 'Izimali azanele',
'cashout_inactivity': 'Ukukhokha ngokuzenzakalela ngenxa yokungasebenzi',
'time_running_out': 'Isikhathi siyaphela! Dlala manje noma ithikithi lakho lizokhishwa ngokuzenzakalela ngemizuzwana engu-30',
'there_was_error': 'KUBE NEPHUTHA, SICELA UZAME FUTHI NOMA UPHINDE ULAODISHE',
'detailed_game_rules': 'Imithetho Yomdlalo Enemininingwane',
'general_rules': 'IMITETHO EJWAYELEKILE',
'general_rules_p1': '• I-multiplier iqala ngo-1 futhi inyuke iye ku ',
'general_rules_p2': '• Ukuwina kubalwa ngokuphindaphinda inani lokubheja nge-multiplier eboniswe esinyathelweni ngasinye.',
'general_rules_p3': '• Uma inkokhelo ephezulu ifinyelelwa, umdlalo uzokhokha ngokuzenzakalela ngenani eliphezulu.',
'progressive_jackpot': 'I-JACKPOT EQHUBEKAYO',
'progressive_jackpot_ss': 'Umugqa we-jackpot nethuba lokuwina',
'progressive_jackpot_p1': '% yokubheja ngakunye ifakwa esikhwameni se-jackpot eqhubekayo.',
'progressive_jackpot_p2': 'I-jackpot inikezwa kusetshenziswa indlela ye-"Mystery" noma "must-hit-by". Inani le-jackpot ye-"must-hit-by" linqunywa ngokushesha ngemva kokuwinwa kwe-jackpot edlule kusetshenziswa i-RNG bese ligcinwa njengelinani elibethelwe kudathabheyisi ekude.',
'progressive_jackpot_p3': 'Uma inani le-"must-hit-by" selifinyelelwe, umdlali wokuqala ukubheja ngemuva kwalokho uthola ithuba lokuwina i-jackpot. Uphawu lwe-jackpot luzovela kumugqa ongahleliwe.',
'progressive_jackpot_p4': 'QAPHELA: Umjikelezo webhonasi awufaki mali ku-jackpot. Ngesikhathi sebhonasi i-jackpot ayinakuwinwa.',
'showdown': 'UKUBONISWA',
'showdown_ss': 'Isikwele esibomvu, indawo yokushayisana okuqinisekile',
'showdown_p1': 'Ngemva kokukhokha komdlali, isikwele esibomvu sizoboniswa lapho ukushayisana bekuzokwenzeka khona.',
'return_to_player': 'UKUBUYISELWA KOMDLALI',
'return_to_player_p1': 'Izinga lokubuyiselwa komdlali (RTP) lingu ',
'return_to_player_p2': 'Amaphesenti e-RTP aqinisekiswa njalo yizikhungo ezizimele.',
'disconnection_policy': 'INQUBOMGOMO YOKUNQANYULWA',
'disconnection_policy_p1': 'Uma uxhumano luphazamiseka ngemva kokubheja, ukubheja ngeke kukhanselwe ngokushesha.',
'disconnection_policy_p2': 'ukubheja kuzokhokhwa ngokuzenzakalela futhi izimali zifakwe ku-akhawunti yomdlali.',
'network_latency': 'UKULIBALA KWENETHIWEKHI',
'network_latency_p1': 'Ukulibala kwenethiwekhi kuyinto engenakugwemeka ku-inthanethi.',
'sound': 'UMSINDO',
'sound_p1': 'Umdlalo wakhelwe ngomculo omuhle wangemuva nemisindo.',
'error_handling': 'UKUPHATHWA KWAMAPHUTHA',
'error_handling_p1': 'Uma kwenzeka iphutha, ithimba losizo lizozama ukulilungisa ngokushesha.',
'max_payout': 'Inkokhelo ephezulu ngu ',
'max_bet_is': 'Ukubheja okuphezulu ngu ',
'min_bet_is': 'Ukubheja okuphansi ngu ',
'per_bet': 'ngokubheja ngakunye.',
'malfunction_voids': 'Ukungasebenzi kwenza yonke imiphumela ibe yize.',
'attention_jackpot': 'QAPHELA, i-Jackpot kumugqa ',
'lane': 'umugqa',
'congratulations': 'siyakuhalalisela',
'you_won': 'uwinile',
'balance': 'ibhalansi',
'time': 'isikhathi',
'jackpot': 'i-jackpot',
'escaped': 'UPHUMILE',
'max_win': 'UKUWINA OKUPHEZULU',
'check_internet': 'Sicela uhlole uxhumano lwakho lwe-inthanethi',
'websocket_disconected': 'I-WebSocket inqanyuliwe',
'websocket_connection_error': 'Iphutha lokuxhuma i-WebSocket!',
'session_expired': 'Iseshini iphelile, sicela uphinde ulayishe',
'remaining_bets': 'Ukubheja Okusele',
'stop_autoplay': 'MISA',
'autoplay_and_autocashout': 'UKUDLALA OKUZENZAKALELAYO NOKUKHOKHA OKUZENZAKALELAYO',
'autoplay_and_autocashout_ss': 'Ukukhetha phakathi kokudlala ngesandla noma okuzenzakalelayo',
'autoplay_and_autocashout_p1': 'Umdlali angavula i-autoplay ukuze ukubheja kufakwe ngokuzenzakalela.',
'autoplay_and_autocashout_p2': 'I-multiplier yokukhokha ngokuzenzakalela ingakhethwa esikrinini.',
'autoplay_and_autocashout_p3': 'Inani eliphezulu lemijikelezo ye-autoplay lingu ',
'autoplay_button_label': 'Ukuqala, khetha umugqa.',
'min_bet_amount_is': 'Inani eliphansi lokubheja lingu',
'bonus_rounds': 'Imijikelezo yebhonasi',
'bonus_rounds_ss': 'Imijikelezo yebhonasi enesikhathi sokusebenza',
'bonus_rounds_p1': 'Umdlali angathola imijikelezo yebhonasi njengokuphromoshini.',
'bonus_rounds_p2': 'Uma seyinikiwe, umdlali angakhetha ukuthi aqale nini.',
'bonus_rounds_p3': 'Imijikelezo yebhonasi ingaba nesikhathi sokuphela.',
'valid_until': 'isebenza kuze kube',
'bonus': 'ibhonasi',
'rounds': 'imijikelezo',
'win_eur': 'Wina i-EUR',
'complete_your_bet': 'Sicela uqede ukubheja kuqala',
'complete_auto_play': 'Sicela uqede i-autoplay kuqala',
'yes': 'yebo',
'no': 'cha',
'play_bonus_rounds': 'Dlala imijikelezo yebhonasi?',
'bet_history': 'Umlando wokubheja',
'jackpot_history': 'Umlando we-jackpot',
'ticket_id': 'I-ID yethikithi',
'created': 'isikhathi sokudalwa',
'currency': 'imali',
'bet': 'ukubheja',
'bet_eur': 'ukubheja i-EUR',
'lanes': 'imigqa',
'cars': 'izimoto',
'multiplier': 'i-multiplier',
'win': 'uwinile',
'no_betting_history': 'Awukho umlando wokubheja otholakele.',
'no_jackpot_history': 'Awukho umlando we-jackpot otholakele.',
'date': 'usuku',
'user': 'umsebenzisi',
'bet_already_active': 'Ukubheja sekuyasebenza',
'please_play_the_game_in_portait_mode': 'Sicela udlale umdlalo ngendlela ye-portrait.',
'bonus_history': 'Umlando webhonasi',
'bonus_type': 'Uhlobo lwebhonasi',
'no_bonus_history': 'Awukho umlando webhonasi otholakele.',
'game_menu': 'Imenyu yomdlalo',
'game_menu_ss': 'Kusukela kwesobunxele: Ikhaya, Umlando wokubheja, Imithetho yomdlalo, Izinkinobho zekhibhodi, Umsindo, Umculo',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'IMITHETHO YOMDLALO',
'game_rules_p1': 'Siyakwamukela kuPlinko – Lapho Inhlanhla Iqhamuka Phambili!',
'game_rules_p2': 'Lungela umdlalo ojabulisayo wenhlanhla olula kodwa odakayo! I-Plinko imayelana nokwehlisa ibhola ku-pyramid egcwele ama-pegs nokubuka liqansa, lishintsha indlela, lidlidliza lidlule lize lifike esikhaleni esinembuyiselo engezansi.',
'game_rules_p3': 'Khetha phakathi kwemigqa engu-8 kuya kwengu-16 yama-pegs, bese uhlezi uzijabulise njengoba ibhola liqansa ebhodini, lilawulwa amandla adonsela phansi nenhlanhla kuphela.',
'game_rules_p4': 'Ingabe lizowela emgodini onenani eliphansi... noma lizoshaya inhlanhla enkulu? Kunendlela eyodwa kuphela yokukuthola — wehlisa ibhola futhi ujabulele umdlalo!',
'general': 'UJWAYELEKILE',
'general_p1': 'Wehlisa ibhola lePlinko nethemba lokuthi lizowela emgodini onembuyiselo ephezulu engezansi. Umzila awunakulindeleka — ukugxuma ngakunye kungaguqula inhlanhla yakho.',
'general_p2': 'Imigqa eminingi oyidlalayo, umdlalo uba mnandi kakhulu!',
'general_p3': 'Ngakho phambili — thembela enhlanhleni yakho, chofoza u-DROP, ulandele leyo nqubo eya enhlanhleni enkulu!',
'betting': 'UKUBHEJA',
'betting_p1': 'Khetha inani lokubheja. Izinkinobho “1/2”, “2x”, “Max” zingasetshenziswa ukulawula usayizi wokubheja. Inani lokubheja lingafakwa futhi ngesandla.',
'betting_p2': 'Khetha Izinga Lobungozi: Eliphansi, Elimaphakathi noma Eliphezulu. Izinga eliphansi lobungozi linikeza imiphumela ezinzile (ukuguquguquka okuphansi), kanti eliphezulu linikeza umehluko omkhulu (ukuguquguquka okuphezulu).',
'betting_p3': 'Khetha inani lemigqa emdlalweni: kusukela ku-8 kuya ku-16. Khetha ukuthi ibhola liwele emigqeni emingaki yamapegi. Imigqa eminingi = ukungaqageli okwengeziwe.',
'betting_p4': 'Khetha Imodi Yokubheja: Manual noma Auto.',
'betting_p5': 'Ukuze uqale umzuliswano womdlalo, cindezela inkinobho ethi DROP BALL. Ngesikhathi somzuliswano zonke izinkinobho zokubheja ziyavalwa ngaphandle kwe-DROP BALL nenani lokubheja.',
'betting_p6': 'Ibhola elilodwa le-Plinko limelela umzuliswano owodwa. Ngesikhathi somzuliswano, omunye umzuliswano onezilungiselelo ezifanayo ungaqalwa ngenkinobho ethi DROP BALL. Kungenzeka ukushintsha inani lokubheja ngenkathi kunamabhola asebenzayo etafuleni, kodwa hhayi ubunzima bomdlalo.',
'betting_p7': 'Ekupheleni komzuliswano, ibhola lifika ephaketheni. Isiphindaphindi sokukhokha siboniswa ephaketheni ngalinye.',
'betting_p8': 'Ukubalwa kokuwina kwenziwa ngokwesiphindaphindi lapho ibhola liwile khona. Umphumela wengezwa kubhalansi.',
'game_menu_p1': 'Iziphindaphindi zokubheja zakamuva ziboniswa engxenyeni engezansi yewindi lomdlalo.',
'game_menu_p2': 'Ngenkinobho ethi “Bet history” umdlali angabuyekeza ukubheja kwakhe kwakamuva ngokuningiliziwe.',
'game_menu_p3': 'Ukuze abone umlando wokudlala wesikhathi eside, umdlali kudingeka afinyelele umlando wakhe ngaphakathi kwepulatifomu yokudlala uqobo.',
'game_menu_p4': 'Ngemenyu yomdlalo, abadlali bangalawula izilungiselelo zomsindo, izinqamuleli zekhibhodi, futhi bavule umlando wokubheja nemithetho yomdlalo.',
'game_menu_p5': 'Umdlalo wakhelwe ngomculo wangemuva omuhle nemiphumela yomsindo. Umculo noma imiphumela yomsindo ingacishwa ngezithonjana zemenyu yomdlalo.',
'game_menu_p6': 'Umlando womdlalo uzobonisa iwindi elinamabheji adlule nomlando wamabhonasi.',
'autoplay': 'Imodi ezenzakalelayo (Autoplay)',
'autoplay_p1': 'Ukuchofoza i-Auto kukuvumela ukuthi uwise amabhola amaningi ngokuzenzakalelayo ngaphandle kokuchofoza njalo.',
'autoplay_p2': 'Khetha inani ofuna ukubheja ngalo ngebola ngalinye.',
'autoplay_p3': 'Khetha ukuthi ibhola liwele kangaki (imizuliswano) — kuze kufike ku-100 imizuliswano.',
'autoplay_p4': 'Cindezela inkinobho ethi START ukuze uqale, bese ishintsha ibe yi-STOP.',
'autoplay_p5': 'Imodi ezenzakalelayo izoma uma inani elikhethiwe lokuwisa seliqediwe, imali iphelile noma uchofoze i-STOP.',
'autoplay_p6': 'Ukwehla ngakunye kusebenzisa inani elifanayo lokubheja olikhethile ngaphambi kokuqala Imodi ezenzakalelayo.',
'turbo_mode': 'Imodi ye-Turbo',
'turbo_mode_p1': 'I-Turbo Drop ikuvumela ukuthi uwise amabhola ngokushesha kakhulu ngokubamba inkinobho ethi DROP.',
'turbo_mode_p2': 'Amabhola azoqhubeka ewa kuze kube uyadedela inkinobho noma ibhalansi iphele.',
'turbo_mode_p3': 'Amabhola azoqhubeka ewa kuze kube uyadedela inkinobho noma ibhalansi iphele.',
'turbo_balance': 'Ibhalansi ye-Turbo',
'turbo_balance_p1': 'Ngaphambi kokuqala i-Turbo Drop, ukhetha inani lemali ozoyibeka eceleni — lokhu kuba Ibhalansi yakho ye-Turbo.',
'turbo_balance_p2': 'Ngesikhathi i-Turbo Drop isebenza, umdlalo usebenzisa kuphela Ibhalansi yakho ye-Turbo ekubhejeni nasekuwineni.',
'turbo_balance_p3': 'Uma uyeka i-Turbo Drop, noma iyiphi Ibhalansi ye-Turbo esele ibuyiselwa kubhalansi yakho enkulu.',
'turbo_balance_p4': 'Ungaphuma ku-Turbo Drop nganoma yisiphi isikhathi — kodwa imodi izophela ngokuphelele kuphela uma wonke amabhola eseqedile ukuwa nokuhlala emaphaketheni.',
'free_bets': 'IMIZULISWANO YEBHONASI',
'free_bets_p1': 'Imizuliswano Yebhonasi inikezwa umqhubi.',
'fairness': 'Ubulungiswa',
'fairness_p1': 'Ukwehliswa ngakunye kunqunywa yi-random number generator (RNG) eqinisekisekayo ngokufanele.',
'fairness_p2': 'Umphumela awunakubikezelwa noma uthinteke uma ibhola seliwehlisiwe.',
'disconection_and_error': 'Inqubomgomo Yokuqhawuka Nokuqondwa Kwephutha',
'disconection_and_error_p1': 'Uma ukuxhumana kuphazamiseka ngemva kokubheja, ukubheja ngeke kukhanselwe. Uma umdlalo udinga isenzo kumdlali, umphumela uzobalwa sengathi umdlali ukhethe isenzo esingenabungozi ngaphandle kokukhuphula ukubheja.',
'disconection_and_error_p2': 'Uma kuba nephutha, ithimba lethu losizo lizozama ukuxazulula udaba ngokushesha okukhulu, bese umdlalo uqhubeka. Uma kuba nenkinga ngomdlalo uqobo, ukubheja konke kuzoqedwa bese imali ibuyiselwa abadlali.',
'other': 'Okunye',
'other_p1': 'Uma kudaleka iphutha kwihadiwe noma isoftware yomdlalo, ukubheja nemiphumela ethintekayo kuzokwenqatshelwa futhi izimali zibuyiswe.',
'other_p2': 'Imithetho yomdlalo eshicilelwe isekelwe esiNgisini. Ukuhumusha kwezinye izilimi kunikezwa njengezinsizakalo ezinemigomo emihle. Uma kunomehluko phakathi kwenguqulo yesiNgisi nohumusho, inguqulo yesiNgisi iyahlonishwa kuqala.',
'rows': 'Imigqa',
'lvl': 'Izinga',
'low': 'Phansi',
'high': 'Phezulu',
'ok': 'OK',
'exit_turbo_mode': 'Ufuna ukuphuma ku-Turbo mode?',
"end": "PHELA",
"turbo_mode_settings": "Izilungiselelo ze-Turbo Mode",
'stop': 'MISA',
'invalid_bet_amount': 'Inani lokubheja elingavumelekile',
'cashout_success': 'Ukukhokha kwephumelele',
'stop_auto_play_first': 'Misa umdlalo we-AUTO kuqala.',
'turbo_only_when_no_balls': 'I-Turbo ingaqalwa kuphela lapho kungebhodi amabhola.',
'type': 'Uhlobo lokubheja',
'wait_balls_to_finish': 'Sicela ulinde amabhola ukuthi aqedele.',
'bet_too_large_top_up_turbo_balance': 'Ukubheja kukhulu kakhulu — yengeza Ibhalansi yakho ye-Turbo!',

};
langArr.xh = {
'loading': 'Iyalayisha',
'hotkeys': 'Izitshixo ezikhawulezayo',
'hotkeys_enabled': 'Izitshixo ezikhawulezayo zivuliwe',
'enable_hotkeys_checkbox': 'Vula izitshixo ezikhawulezayo eziboniswe ngezantsi ngokukhangela eli bhokisi.',
'drop_ball': 'Yekisa ibhola',
'double_bet': 'Phinda kabini ukubheja',
'halve_bet': 'Nciphisa ukubheja ngesiqingatha',
'min_bet': 'Ubhejo oluncinane',
'max': 'Ubuninzi',
'easy': 'Kulula',
'medium': 'Phakathi',
'hard': 'Kunzima',
'daredevil': 'Umngcipheko',
'max_profit': 'Inzuzo ephezulu',
'manual': 'Ngokwesandla',
'auto': 'Ngokuzenzekelayo',
'bet_amount': 'Isixa sokubheja',
'difficulty': 'Ubunzima',
'payout_on_win': 'Intlawulo xa uphumelela',
'number_of_bets': 'Inani lobhejo',
'on_win': 'Xa uphumelela',
'on_loss': 'Xa uhlulwa',
'stop_on_profit': 'Yima xa kukho inzuzo',
'stop_on_loss': 'Yima xa kukho ilahleko',
'reset': 'Setha kwakhona',
'increase_by': 'Yandisa ngo',
'cashout': 'KHUPHA IMALI',
'start_game': 'BHEJA',
'start_auto_game': 'QALA',
'difficulity_info': 'Ulwazi Lobunzima',
'chance_collision': 'Amathuba okungqubana ngomdlalo ngamnye',
'evry_25_lane': 'kuzo zonke iindlela ezingama-25',
'insufficiend_funds': 'Imali ayonelanga',
'cashout_inactivity': 'Ukukhupha imali ngokuzenzekelayo ngenxa yokungasebenzi',
'time_running_out': 'Ixesha liyaphela! Dlala ngoku okanye itikiti lakho liya kurhoxiswa ngokuzenzekelayo kwimizuzwana engama-30',
'there_was_error': 'KUBE NEMPHAZAMO, NCEDA UZAME KWAKHONA OKANYE ULAYISHE KWAKHONA',
'detailed_game_rules': 'Imithetho Yomdlalo Enenkcukacha',
'general_rules': 'IMITETHO JIKELELE',
'general_rules_p1': '• I-multiplier iqala ngo-1 kwaye inyuka iye ku ',
'general_rules_p2': '• Ukuphumelela kubalwa ngokuphindaphinda ukubheja nge-multiplier eboniswe kwinqanaba ngalinye.',
'general_rules_p3': '• Ukuba intlawulo ephezulu ifikelelwe, umdlalo uya kukhupha imali ngokuzenzekelayo kwelona nqanaba liphezulu.',
'progressive_jackpot': 'I-JACKPOT EQHUBELELAYO',
'progressive_jackpot_ss': 'Indlela ye-jackpot kunye nethuba lokuphumelela',
'progressive_jackpot_p1': '% yobhejo ngalunye ifakwa kwingxowa ye-jackpot eqhubekayo.',
'progressive_jackpot_p2': 'I-jackpot inikwa kusetyenziswa indlela ye-"Mystery" okanye "must-hit-by". Ixabiso ligcinwa lifihliwe kwidatabase ekude.',
'progressive_jackpot_p3': 'Xa ixabiso le-"must-hit-by" lifikelelwe, umdlali wokuqala ukubheja emva koko unethuba lokuphumelela i-jackpot.',
'progressive_jackpot_p4': 'QAPHELA: Umjikelo webhonasi awufaki mali kwi-jackpot. Ngexesha lebhonasi i-jackpot ayinakuphumelela.',
'showdown': 'UMBONISO',
'showdown_ss': 'Isikwere esibomvu, indawo yokungqubana',
'showdown_p1': 'Emva kokukhupha imali, isikwere esibomvu siya kuboniswa apho ukungqubana bekunokwenzeka khona.',
'return_to_player': 'UKUBUYISELWA KOMDLALI',
'return_to_player_p1': 'Imbuyekezo yethiyori kumdlali (RTP) yi ',
'return_to_player_p2': 'Iipesenti ze-RTP zihlolwe kwaye ziqinisekiswe rhoqo.',
'disconnection_policy': 'UMGAQO-NKQUBO WOKUNQANYULWA',
'disconnection_policy_p1': 'Ukuba uqhagamshelo luphela emva kokubheja, ukubheja akurhoxiswa ngoko nangoko.',
'disconnection_policy_p2': 'imali iya kukhutshwa ngokuzenzekelayo kwaye ifakwe kwiakhawunti yomdlali.',
'network_latency': 'UKULIBAZISEKA KWEENETHIWEKHI',
'network_latency_p1': 'Ukulibaziseka kwenethiwekhi yinxalenye engenakuphepheka yoqhagamshelo lwe-intanethi.',
'sound': 'ISANDI',
'sound_p1': 'Umdlalo uyilwe ngengoma yasemva kunye nezandi.',
'error_handling': 'ULAWULO LWEMPHAZAMO',
'error_handling_p1': 'Xa kukho impazamo, iqela lenkxaso lizama ukuyilungisa ngokukhawuleza.',
'max_payout': 'Intlawulo ephezulu yi ',
'max_bet_is': 'Ubhejo oluphezulu yi ',
'min_bet_is': 'Ubhejo oluphantsi yi ',
'per_bet': 'ngobhejo ngalunye.',
'malfunction_voids': 'Ukungasebenzi kwenza zonke iintlawulo nemidlalo zingasebenzi.',
'attention_jackpot': 'QAPHELA, i-Jackpot kwindlela ',
'lane': 'indlela',
'congratulations': 'siyavuyisana',
'you_won': 'uphumelele',
'balance': 'ibhalansi',
'time': 'ixesha',
'jackpot': 'i-jackpot',
'escaped': 'UPHUMELE',
'max_win': 'UKUPHUMELELA OKUPHEZULU',
'check_internet': 'Nceda ujonge uqhagamshelo lwakho lwe-intanethi',
'websocket_disconected': 'Uqhagamshelo lwe-WebSocket luphelile',
'websocket_connection_error': 'Impazamo yoqhagamshelo lwe-WebSocket!',
'session_expired': 'Iseshoni iphelile, nceda ulayishe kwakhona',
'remaining_bets': 'Ubhejo Oluseleyo',
'stop_autoplay': 'YIMA',
'autoplay_and_autocashout': 'UKUDLALA NGOKUZENZEKELAYO NOKUKHUPHA IMALI',
'autoplay_and_autocashout_ss': 'Ukhetho phakathi kokudlala ngesandla okanye ngokuzenzekelayo',
'autoplay_and_autocashout_p1': 'Umdlali angavula i-autoplay ukuze kubhejwe ngokuzenzekelayo.',
'autoplay_and_autocashout_p2': 'I-multiplier yokukhupha imali ngokuzenzekelayo inokukhethwa kwisikrini.',
'autoplay_and_autocashout_p3': 'Inani eliphezulu lemijikelo ye-autoplay yi ',
'autoplay_button_label': 'Ukuqala, khetha indlela.',
'min_bet_amount_is': 'Ubhejo oluncinane yi',
'bonus_rounds': 'Imijikelo yebhonasi',
'bonus_rounds_ss': 'Imijikelo yebhonasi enexesha lokusebenza',
'bonus_rounds_p1': 'Umdlali angafumana imijikelo yebhonasi ngenxa yentengiso yekhasino.',
'bonus_rounds_p2': 'Emva kokunikezelwa, umdlali angakhetha ukuqala nini.',
'bonus_rounds_p3': 'Imijikelo yebhonasi inokuba nexesha lokuphelelwa.',
'valid_until': 'isebenza kude kube',
'bonus': 'ibhonasi',
'rounds': 'imijikelo',
'win_eur': 'Phumelela i-EUR',
'complete_your_bet': 'Nceda ugqibe ukubheja kuqala',
'complete_auto_play': 'Nceda ugqibe i-autoplay kuqala',
'yes': 'ewe',
'no': 'hayi',
'play_bonus_rounds': 'Dlala imijikelo yebhonasi?',
'bet_history': 'Imbali yokubheja',
'jackpot_history': 'Imbali ye-jackpot',
'ticket_id': 'I-ID yetikiti',
'created': 'ixesha lokudalwa',
'currency': 'imali',
'bet': 'ubhejo',
'bet_eur': 'ubhejo i-EUR',
'lanes': 'iindlela',
'cars': 'iimoto',
'multiplier': 'i-multiplier',
'win': 'uphumelele',
'no_betting_history': 'Akukho mbali yokubheja ifunyenweyo.',
'no_jackpot_history': 'Akukho mbali ye-jackpot ifunyenweyo.',
'date': 'umhla',
'user': 'umsebenzisi',
'bet_already_active': 'Ubhejo sele busebenza',
'please_play_the_game_in_portait_mode': 'Nceda udlale umdlalo kwimo ye-portrait.',
'bonus_history': 'Imbali yebhonasi',
'bonus_type': 'Uhlobo lwebhonasi',
'no_bonus_history': 'Akukho mbali yebhonasi ifunyenweyo',
'game_menu': 'Imenyu yomdlalo',
'game_menu_ss': 'Ukusuka ekhohlo: Ikhaya, Imbali yokubheja, Imithetho yomdlalo, Izitshixo zekhibhodi, Umsindo, Umculo',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'IMIQATHANGO YOMDLALO',
'game_rules_p1': 'Wamkelekile ePlinko – Apho Ithamsanqa Lithatha Indawo Ephambili!',
'game_rules_p2': 'Lungela umdlalo onomtsalane wenzingo elula kodwa onokutsala umdla! IPlinko imalunga nokuwisa ibhola kwipiramidi enama-pegs kwaye uyibukele itsiba, ijikeleze, ize iwe kwislot enembuyekezo ezantsi.',
'game_rules_p3': 'Khetha phakathi kwemigca eli-8 ukuya kweli-16 yepegs, uze uhlale phantsi uyonwabele indlela ibhola ezihamba ngayo – ngokuncedwa ngumxhuzulane nethamsanqa kuphela.',
'game_rules_p4': 'Inokuwela kwislot ephantsi ngemali encinci... okanye iphumelele ibhaso elikhulu? Kukho indlela enye yokufumanisa — yiphose ibhola uze ubukele umdla uqhubeke!',
'general': 'JONGELOLU JIKELELE',
'general_p1': 'Wisa ibhola lePlinko uthembe ukuba iza kuwela kwislot enembuyekezo ephezulu ezantsi. Indlela ayiqikeleleki — ukutsiba ngakunye kungaguqula ithamsanqa lakho.',
'general_p2': 'Imigca emininzi odlala ngayo, kokukhona umdlalo uba nomdla!',
'general_p3': 'Ngoko ke qhubeka — themba ithamsanqa lakho, cofa u-DROP, uze ulandele le ndlela eya kwimpumelelo enkulu!',
'betting': 'UKUBHEJA',
'betting_p1': 'Khetha isixa sokubheja. Amaqhosha “1/2”, “2x”, “Max” angasetyenziswa ukulawula ubungakanani bokubheja. Isixa sokubheja singangeniswa ngesandla.',
'betting_p2': 'Khetha Inqanaba Lomngcipheko: Eliphantsi, Eliphakathi okanye Eliphezulu. Umngcipheko ophantsi unika iziphumo ezizinzileyo (ukuguquguquka okuphantsi), kanti ophezulu unika umahluko omkhulu (ukuguquguquka okuphezulu).',
'betting_p3': 'Khetha inani leemigca emdlalweni: ukusuka ku-8 ukuya ku-16. Khetha ukuba ibhola iwele kwimigca emingaphi yeephegi. Imigca emininzi = ukungaqikeleleki ngakumbi.',
'betting_p4': 'Khetha Imo Yokubheja: Manual okanye Auto.',
'betting_p5': 'Ukuqalisa umjikelo womdlalo, cofa iqhosha elithi DROP BALL. Ngexesha lomjikelo onke amaqhosha okubheja ayavalwa ngaphandle kwe-DROP BALL nesixa sokubheja.',
'betting_p6': 'Ibhola enye ye-Plinko imele umjikelo omnye. Ngexesha lomjikelo, omnye umjikelo oneesetingi ezifanayo ungaqalwa usebenzisa iqhosha elithi DROP BALL. Kuyenzeka ukutshintsha isixa sokubheja ngelixa kukho iibhola ezisebenzayo ebhodini, kodwa hayi ubunzima bomdlalo.',
'betting_p7': 'Ekupheleni komjikelo, ibhola ifika epokothweni. Isiphindaphindi sokuhlawula siboniswa kwipokotho nganye.',
'betting_p8': 'Ukubalwa kokuwina kwenziwa ngokwesiphindaphindi apho ibhola iwe khona. Isiphumo songezwa kubhalansi.',
'game_menu_p1': 'Iziphindaphindi zokubheja zamva nje ziboniswa ezantsi kwefestile yomdlalo.',
'game_menu_p2': 'Ngeqhosha elithi “Bet history” umdlali angajonga ukubheja kwakhe kwakutshanje ngokweenkcukacha.',
'game_menu_p3': 'Ukuze afumane imbali ende yokudlala, umdlali unokufuna ukufikelela kwimbali yakhe ngaphakathi kweqonga lomdlalo ngokwalo.',
'game_menu_p4': 'Ngemenyu yomdlalo, abadlali banokulawula izandi, izishunqulelo zekhibhodi, baze bavule imbali yokubheja nemithetho yomdlalo.',
'game_menu_p5': 'Umdlalo uyilwe ngokugxininisa kumculo wangasemva omnandi kunye neziphumo zesandi. Umculo okanye iziphumo zesandi zingakhubazwa ngee-icon zemenyu yomdlalo.',
'game_menu_p6': 'Imbali yomdlalo iya kubonisa ifestile eneebheji zangaphambili kunye nembali yeebhonasi.',
'autoplay': 'Imo ezenzekelayo (Autoplay)',
'autoplay_p1': 'Ukucofa i-Auto kukuvumela ukuba uwise iibhola ezininzi ngokuzenzekelayo ngaphandle kokucofa rhoqo.',
'autoplay_p2': 'Khetha isixa ofuna ukubheja ngaso kwibhola nganye.',
'autoplay_p3': 'Khetha ukuba mangaphi amaxesha (imijikelo) ofuna ibhola iwe — ukuya kuthi ga kwimijikelo eli-100.',
'autoplay_p4': 'Cofa iqhosha elithi START ukuze uqale, kwaye liya kutshintsha libe yi-STOP.',
'autoplay_p5': 'Imo ezenzekelayo iya kuyeka xa inani elikhethiweyo lokuwisa ligqityiwe, imali iphelile okanye ucofe i-STOP.',
'autoplay_p6': 'Ukwehla ngakunye kusebenzisa isixa esifanayo sokubheja osikhethileyo ngaphambi kokuqala Imo ezenzekelayo.',
'turbo_mode': 'Imo ye-Turbo',
'turbo_mode_p1': 'I-Turbo Drop ikuvumela ukuba uwise iibhola ngokukhawuleza kakhulu ngokubamba iqhosha elithi DROP.',
'turbo_mode_p2': 'Iibhola ziya kuqhubeka ziwa ude ukhulule iqhosha okanye ibhalansi iphele.',
'turbo_mode_p3': 'Iibhola ziya kuqhubeka ziwa ude ukhulule iqhosha okanye ibhalansi iphele.',
'turbo_balance': 'Ibhalansi ye-Turbo',
'turbo_balance_p1': 'Phambi kokuqala i-Turbo Drop, ukhetha isixa semali oza kuyibeka bucala — oku kuba yiBhalansi yakho ye-Turbo.',
'turbo_balance_p2': 'Ngexesha i-Turbo Drop isebenza, umdlalo usebenzisa kuphela iBhalansi ye-Turbo ukubheja nokuwina.',
'turbo_balance_p3': 'Xa uyeka i-Turbo Drop, nayiphi na iBhalansi ye-Turbo eseleyo ibuyiselwa kwibhalansi ephambili.',
'turbo_balance_p4': 'Ungaphuma kwi-Turbo Drop nangaliphi na ixesha — kodwa imo iya kugqitywa ngokupheleleyo kuphela xa zonke iibhola zigqibile ukuwa nokuhlala kwiipokotho.',
'free_bets': 'IMIJIKEL0 YEEBHONASI',
'free_bets_p1': 'Imijikelo yeebhonasi inikwa ngumsebenzisi.',
'fairness': 'Ubulungisa',
'fairness_p1': 'Ukuphosa ngakunye kulawulwa ngumnini wenani eliqinisekisiweyo elingenakuchaphazeleka (RNG).',
'fairness_p2': 'Isiphumo asikwazi ukuqikelelwa okanye sichaphazeleke xa ibhola sele iphosekile.',
'disconection_and_error': 'Umgaqo-nkqubo wokuPhazamiseka kunye noLawulo lweMpazamo',
'disconection_and_error_p1': 'Ukuba unxibelelwano luyaphazamiseka emva kokubheja, ukubheja akuyi kurhoxiswa. Ukuba umdlalo ufuna isenzo kumdlali, isiphumo siya kubalwa ngathi umdlali ukhethe isenzo esingenamngcipheko ngaphandle kokunyusa ukubheja kwangaphambili.',
'disconection_and_error_p2': 'Xa kukho impazamo, iqela lethu loncedo liza kuzama ukuyisombulula ngokukhawuleza, kwaye umdlalo uya kuqhubeka. Ukuba impazamo isemdlalweni ngokwawo, zonke izibhejo ziya kurhoxiswa kwaye imali ibuyiselwe kubadlali.',
'other': 'Okunye',
'other_p1': 'Xa kukho ukuphazamiseka kwesoftware/hardware yomdlalo, zonke izibhejo kunye neembuyekezo ezichaphazelekayo ziya kurhoxiswa kwaye imali ibuyiselwe.',
'other_p2': 'Imithetho yomdlalo epapashiweyo ikwisithethi sesiNgesi. Iinguqulelo kwezinye iilwimi zinikezelwa njengesisa. Xa kukho ukungqinelani phakathi kwenguqulelo yesiNgesi neyezinye, inguqulelo yesiNgesi ithathwa njengeyona iphezulu.',
'rows': 'Imigca',
'lvl': 'Inqanaba',
'low': 'Ezantsi',
'high': 'Phezulu',
'ok': 'OK',
'exit_turbo_mode': 'Ufuna ukuphuma kwi-Turbo mode?',
"end": "ISIPHELO",
"turbo_mode_settings": "Izicwangciso ze-Turbo Mode",
'stop': 'MISA',
'invalid_bet_amount': 'Isixa sokubheja esingavumelekanga',
'cashout_success': 'Ukukhupha imali kuphumelele',
'stop_auto_play_first': 'Misa umdlalo we-AUTO kuqala.',
'turbo_only_when_no_balls': 'I-Turbo ingaqaliswa kuphela xa kungekho mabhola ebhodini.',
'type': 'Uhlobo lokubheja',
'wait_balls_to_finish': 'Nceda ulinde mabhola agqibe.',
'bet_too_large_top_up_turbo_balance': 'Ukubheja kukhulu kakhulu — yandisa iBhalansi yakho ye-Turbo!',

};
langArr.af = {
'loading': 'Laai',
'hotkeys': 'Vinnige sleutels',
'hotkeys_enabled': 'Vinnige sleutels aangeskakel',
'enable_hotkeys_checkbox': 'Skakel vinnige sleutels hieronder aan deur hierdie blokkie aan te merk.',
'drop_ball': 'Laat bal val',
'double_bet': 'Verdubbel die wedbedrag',
'halve_bet': 'Halveer die weddenskap',
'min_bet': 'Minimum weddenskap',
'max': 'Maksimum',
'easy': 'Maklik',
'medium': 'Medium',
'hard': 'Moeilik',
'daredevil': 'Waaghals',
'max_profit': 'Maksimum wins',
'manual': 'Handmatig',
'auto': 'Outomaties',
'bet_amount': 'Wedbedrag',
'difficulty': 'Moeilikheid',
'payout_on_win': 'Uitbetaling by wen',
'number_of_bets': 'Aantal weddenskappe',
'on_win': 'By wen',
'on_loss': 'By verlies',
'stop_on_profit': 'Stop by wins',
'stop_on_loss': 'Stop by verlies',
'reset': 'Herstel',
'increase_by': 'Verhoog met',
'cashout': 'KAS UIT',
'start_game': 'WED',
'start_auto_game': 'BEGIN',
'difficulity_info': 'Moeilikheidsinligting',
'chance_collision': 'Kans op botsing per spel',
'evry_25_lane': 'vir elke 25 bane',
'insufficiend_funds': 'Onvoldoende fondse',
'cashout_inactivity': 'Outomatiese kasbetaling by onaktiwiteit',
'time_running_out': 'Tyd hardloop uit! Speel nou of jou kaartjie word outomaties verwyder in 30 sekondes',
'there_was_error': 'DIE WAS ’N FOUT, PROBEER WEER OF HERLAAI',
'detailed_game_rules': 'Gedetailleerde spelreëls',
'general_rules': 'ALGEMENE REËLS',
'general_rules_p1': '• Die vermenigvuldiger begin by 1 en gaan tot ',
'general_rules_p2': '• Wins word bereken deur die weddenskap te vermenigvuldig met die vermenigvuldiger wat op elke stap vertoon word.',
'general_rules_p3': '• As die maksimum uitbetaling bereik word, sal die spel outomaties by die maksimum bedrag uitbetaal.',
'progressive_jackpot': 'PROGRESWIEWE JACKPOT',
'progressive_jackpot_ss': 'Die jackpot-baan en moontlike wen',
'progressive_jackpot_p1': '% van elke weddenskap word aan ’n progressiewe jackpotfonds toegeken.',
'progressive_jackpot_p2': 'Jackpot word toegeken met "Mystery" of "must-hit-by" meganika. Die waarde van elke "must-hit-by" jackpot word onmiddellik bepaal na die vorige jackpot gewen is deur ’n ewekansige nommergenerator en gestoor as ’n gekodeerde waarde.',
'progressive_jackpot_p3': 'Sodra die "must-hit-by" waarde bereik word, sal die eerste speler wat daarna ’n weddenskap plaas die kans hê om die jackpot te wen.',
'progressive_jackpot_p4': 'LET WEL: Bonusrondes dra nie by tot die jackpotfonds nie. Gedurende die bonusronde kan die jackpot nie gewen word nie.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Rooi blokkie, plek van sekere botsing',
'showdown_p1': 'Nadat die speler uitbetaal het, sal ’n rooi blokkie vertoon word waar die botsing sou plaasgevind het as die speler voortgegaan het om bane oor te slaan.',
'return_to_player': 'TERUGVOERING NA SPELER',
'return_to_player_p1': 'Die algehele teoretiese terugbetaling aan speler (RTP) is ',
'return_to_player_p2': 'RTP-persentasies word voortdurend gemonitor en deur onafhanklike derde partye geverifieer.',
'disconnection_policy': 'VERBINDING BELEID',
'disconnection_policy_p1': 'As die verbinding verlore gaan nadat ’n weddenskap geplaas is, sal die weddenskap nie onmiddellik gekanselleer word nie.',
'disconnection_policy_p2': 'Weddenskap sal outomaties uitbetaal word en krediete sal by die speler se rekening gevoeg word.',
'network_latency': 'NETWERK LATENSIE',
'network_latency_p1': 'Netwerk vertraging is ’n onvermydelike deel van internetverbinding.',
'sound': 'KLANK',
'sound_p1': 'Die spel is ontwerp met mooi agtergrondmusiek en klankeffekte. Jy kan musiek en/of klankeffekte deaktiveer via die spelkieslys.',
'error_handling': 'FOUTHANDELING',
'error_handling_p1': 'In die geval van ’n fout sal ons ondersteuningspan probeer om dit so gou as moontlik reg te stel.',
'max_payout': 'Maksimum uitbetaling is ',
'max_bet_is': 'Maksimum weddenskap is ',
'min_bet_is': 'Minimum weddenskap is ',
'per_bet': 'per weddenskap.',
'malfunction_voids': 'Foutige werking maak alle uitbetalings en speletjies ongeldig.',
'attention_jackpot': 'Aandag, Jackpot by baan ',
'lane': 'baan',
'congratulations': 'geluk',
'you_won': 'jy het gewen',
'balance': 'balans',
'time': 'tyd',
'jackpot': 'jackpot',
'escaped': 'GEKOM',
'max_win': 'MAKS WEN',
'check_internet': 'Kontroleer asseblief jou internetverbinding',
'websocket_disconected': 'Websocket ontkoppel',
'websocket_connection_error': 'Websocket verbindingsfout!',
'session_expired': 'Sessie het verstryk, herlaai asseblief',
'remaining_bets': 'Oorblywende weddenskappe',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'OUTOMATIESE SPEL EN KAS UIT',
'autoplay_and_autocashout_ss': 'Keuse tussen handmatig en outomaties',
'autoplay_and_autocashout_p1': 'Speler kan die outomatiese speel opsie aktiveer sodat weddenskap outomaties geplaas word.',
'autoplay_and_autocashout_p2': 'Outomatiese uitbetalings vermenigvuldiger kan vanaf die skerm gekies word.',
'autoplay_and_autocashout_p3': 'Die maksimum aantal outomatiese rondtes is ',
'autoplay_button_label': 'Om te begin, kies ’n baan.',
'min_bet_amount_is': 'Minimum weddenskap is',
'bonus_rounds': 'bonus rondtes',
'bonus_rounds_ss': 'Die bonus rondtes met geldigheid tydperk',
'bonus_rounds_p1': 'Speler kan ’n bonus ronde (bv. gratis weddenskap) ontvang op grond van ’n casino promosie.',
'bonus_rounds_p2': 'Sodra toegeken kan die speler kies wanneer om te begin.',
'bonus_rounds_p3': 'Bonus rondtes kan ’n tydperk hê waarna dit ongeldig word.',
'valid_until': 'geldig tot',
'bonus': 'bonus',
'rounds': 'rondes',
'win_eur': 'wen EUR',
'complete_your_bet': 'Voltooi asseblief jou weddenskap eers',
'complete_auto_play': 'Voltooi asseblief jou outomatiese spel eers',
'yes': 'ja',
'no': 'nee',
'play_bonus_rounds': 'Speel bonus rondtes?',
'bet_history': 'Wedgeskiedenis',
'jackpot_history': 'Jackpot geskiedenis',
'ticket_id': 'Kaartjie ID',
'created': 'skep tyd',
'currency': 'geldigheid',
'bet': 'weddenskap',
'bet_eur': 'weddenskap EUR',
'lanes': 'bane',
'cars': 'motors',
'multiplier': 'vermenigvuldiger',
'win': 'wen',
'no_betting_history': 'Geen weddenskap geskiedenis gevind nie.',
'no_jackpot_history': 'Geen jackpot geskiedenis beskikbaar nie.',
'date': 'datum',
'user': 'gebruiker',
'bet_already_active': 'Weddenskap reeds aktief',
'please_play_the_game_in_portait_mode': 'Speel asseblief die spel in portretmodus.',
'bonus_history': 'Bonus geskiedenis',
'bonus_type': 'Bonus tipe',
'no_bonus_history': 'Geen bonus geskiedenis beskikbaar nie.',
'game_menu': 'Spel kieslys',
'game_menu_ss': 'Van links: Tuis, Wedgeskiedenis, Speel reëls, Sleutelbord vinnige sleutels, Klankinstellings, Musiek',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'SPELREËLS',
'game_rules_p1': 'Welkom by Plinko – Waar Geluk die Leiding Neem!',
'game_rules_p2': 'Maak gereed vir ’n opwindende kansspel wat eenvoudig én verslawend is! Plinko gaan daaroor om ’n bal op ’n piramide vol penne te laat val en te kyk hoe dit bons, draai en spring totdat dit in ’n gleuf met pryse aan die onderkant beland.',
'game_rules_p3': 'Kies tussen 8 en 16 rye penne, sit terug en geniet die chaos soos die bal zigzag deur die bord beweeg – gedryf deur swaartekrag en geluk alleen.',
'game_rules_p4': 'Sal dit in ’n lae-betaling gleuf land... of die groot wen tref? Daar is net een manier om uit te vind — laat die bal val en laat die opwinding ontvou!',
'general': 'ALGEMEEN',
'general_p1': 'Laat die Plinko-bal val en hoop dit land in een van die hoë-uitbetalingsgleuwe onderaan. Die pad is onvoorspelbaar — elke bons kan jou geluk verander.',
'general_p2': 'Hoe meer rye jy speel, hoe meer intens raak die aksie!',
'general_p3': 'Gaan dus voort — vertrou jou geluk, druk DROP, en jaag daardie groot wen deur Plinko se penne!',
'betting': 'WEDDERY',
'betting_p1': 'Kies die weddenskapbedrag. Die knoppies “1/2”, “2x”, “Max” kan gebruik word om die weddenskapgrootte te bestuur. Die weddenskapbedrag kan ook handmatig ingevoer word.',
'betting_p2': 'Kies die Risikovlak: Laag, Medium of Hoog. ’n Laer risikovlak gee meer konsekwente uitkomste (lae volatiliteit), terwyl ’n hoër vlak meer variasie gee (hoë volatiliteit).',
'betting_p3': 'Kies die aantal lyne in die spel: van 8 tot 16. Kies deur hoeveel rye penne die bal sal val. Meer rye = meer onvoorspelbaarheid.',
'betting_p4': 'Kies die Weddenskapmodus: Handmatig of Outomaties.',
'betting_p5': 'Om die spelronde te begin, druk die DROP BALL-knoppie. Tydens die ronde is alle weddenskapknoppies onaktief behalwe DROP BALL en die weddenskapbedrag.',
'betting_p6': 'Een Plinko-bal verteenwoordig een ronde. Tydens die ronde kan ’n ander ronde met dieselfde instellings begin word met die DROP BALL-knoppie. Dit is moontlik om die weddenskapbedrag te verander terwyl daar “lewende” balle op die bord is, maar nie die spelmoeilikheid nie.',
'betting_p7': 'Aan die einde van die ronde bereik die bal die sak. By elke sak word die uitbetalingsvermenigvuldiger vertoon.',
'betting_p8': 'Die berekening van die wen word gemaak volgens die vermenigvuldiger waar die bal geland het. Die resultaat word by die balans gevoeg.',
'game_menu_p1': 'Die mees onlangse weddenskapvermenigvuldigers word onder in die spelvenster vertoon.',
'game_menu_p2': 'Met die “Bet history”-knoppie kan ’n speler sy jongste weddenskappe in meer besonderhede hersien.',
'game_menu_p3': 'Vir verdere spelgeskiedenis (bv. langer tydperke) moet ’n speler moontlik toegang kry tot sy geskiedenis binne die spelplatform self.',
'game_menu_p4': 'Deur die spelmenu kan spelers klankopsies, sleutelbordkortpaaie beheer en weddenskapgeskiedenis en spelreëls oopmaak.',
'game_menu_p5': 'Die spel is ontwerp met pragtige agtergrondmusiek en klankeffekte in gedagte. Musiek en/of klankeffekte kan via die spelmenu-ikone gedeaktiveer word.',
'game_menu_p6': 'Spelgeskiedenis sal ’n venster wys met vorige weddenskappe en bonusgeskiedenis.',
'autoplay': 'Outomatiese modus (Autoplay)',
'autoplay_p1': 'Deur Auto te klik kan jy outomaties ’n aantal balle laat val sonder om elke keer te klik.',
'autoplay_p2': 'Kies die bedrag wat jy per bal wil wed.',
'autoplay_p3': 'Kies hoe baie kere (rondes) jy wil hê die bal moet val — tot ’n maksimum van 100 rondes.',
'autoplay_p4': 'Druk die START-knoppie om te begin en die knoppie sal na STOP verander.',
'autoplay_p5': 'Outomatiese modus sal stop wanneer die gekose aantal val voltooi is, jy nie meer fondse het nie of jy STOP druk.',
'autoplay_p6': 'Elke val gebruik dieselfde weddenskapbedrag as wat jy gekies het voordat jy Outomatiese modus begin het.',
'turbo_mode': 'Turbo-modus',
'turbo_mode_p1': 'Turbo Drop laat jou balle blitsvinnig laat val deur die DROP-knoppie in te hou.',
'turbo_mode_p2': 'Balle sal aanhou val totdat jy die knoppie loslaat of die balans opraak.',
'turbo_mode_p3': 'Balle sal aanhou val totdat jy die knoppie loslaat of die balans opraak.',
'turbo_balance': 'Turbo-balans',
'turbo_balance_p1': 'Voordat jy Turbo Drop begin, kies jy hoeveel geld om opsy te sit — dit word jou Turbo-balans.',
'turbo_balance_p2': 'Terwyl Turbo Drop aktief is, gebruik die spel slegs jou Turbo-balans vir weddenskappe en winste.',
'turbo_balance_p3': 'Wanneer jy Turbo Drop stop, gaan enige oorblywende Turbo-balans terug na jou hoofbalans.',
'turbo_balance_p4': 'Jy kan Turbo Drop enige tyd verlaat — maar die modus eindig eers volledig nadat alle balle klaar geval het en in vermenigvuldigersakke geland het.',
'free_bets': 'BONUSRONDTE',
'free_bets_p1': 'Bonusronde word deur die operateur toegeken.',
'fairness': 'Eerlikheid',
'fairness_p1': 'Elke val word bepaal deur ’n bewysbaar regverdige ewekansige getalgenereerder (RNG).',
'fairness_p2': 'Die uitkoms kan nie voorspel of beïnvloed word sodra die bal geval het nie.',
'disconection_and_error': 'Ontkoppelingsbeleid en Foutbehandeling',
'disconection_and_error_p1': 'As die verbinding verlore gaan nadat daar gewed is, sal die weddenskap nie gekanselleer word nie. As die spel aksie van die speler verg, sal dit as ’n veilige opsie sonder verhoogde weddenskap bereken word.',
'disconection_and_error_p2': 'In geval van ’n fout sal ons ondersteuning so gou moontlik probeer help en die spel hervat. Indien daar ’n probleem met die spel self is, sal alle weddenskappe gekanselleer en bedrae terugbetaal word.',
'other': 'Ander',
'other_p1': 'In die geval van ’n tegniese fout met die spel se hardeware/sagteware, sal alle geaffekteerde weddenskappe en uitbetalings ongeldig wees en terugbetaal word.',
'other_p2': 'Die spelreëls word in Engels gepubliseer. Vertalings na ander tale word as ’n diens in goeie trou verskaf. In geval van onduidelikheid tussen Engels en ’n vertaling, sal die Engelse weergawe altyd voorrang hê.',
'rows': 'Rye',
'lvl': 'Vlak',
'low': 'Laag',
'high': 'Hoog',
'ok': 'OK',
'exit_turbo_mode': 'Wil jy die Turbo-modus verlaat?',
"end": "EINDE",
"turbo_mode_settings": "Turbo-modus instellings",
'stop': 'STOP',
'invalid_bet_amount': 'Ongeldige weddenskapbedrag',
'cashout_success': 'Uitbetaling suksesvol',
'stop_auto_play_first': 'Stop asseblief die AUTO spel eers.',
'turbo_only_when_no_balls': 'Turbo kan slegs geaktiveer word wanneer daar geen balle op die bord is nie.',
'type': 'Weddery tipe',
'wait_balls_to_finish': 'Wag asseblief vir balle om klaar te maak.',
'bet_too_large_top_up_turbo_balance': 'Weddenskap te groot — vul jou Turbo-balans aan!',

};
langArr.so = {
'loading': 'Soo raraya',
'hotkeys': 'Furayaasha kulul',
'hotkeys_enabled': 'Furayaasha kulul waa la shiday',
'enable_hotkeys_checkbox': 'Shid furayaasha kulul ee hoos ku qoran adigoo hubinaya sanduuqan.',
'drop_ball': 'Dhig kubbadda',
'double_bet': 'Laba jibaar qaddarka shatiga',
'halve_bet': 'Kala bar shatiga',
'min_bet': 'Qaddarka ugu yar ee shatiga',
'max': 'Ugu badnaan',
'easy': 'Fudud',
'medium': 'Dhexdhexaad',
'hard': 'Adag',
'daredevil': 'Geesi',
'max_profit': 'Faa’iidada ugu badan',
'manual': 'Gacanta',
'auto': 'Si toos ah',
'bet_amount': 'Qaddarka shatiga',
'difficulty': 'Culays',
'payout_on_win': 'Bixin marka la guuleysto',
'number_of_bets': 'Tirada shatiyada',
'on_win': 'Marka la guuleysto',
'on_loss': 'Marka la khasaarey',
'stop_on_profit': 'Jooji marka faa’iido la gaaro',
'stop_on_loss': 'Jooji marka khasaaro la gaaro',
'reset': 'Dib u deji',
'increase_by': 'Kordhi',
'cashout': 'LACAG SOO QAADO',
'start_game': 'SHATI',
'start_auto_game': 'BILAW',
'difficulity_info': 'Macluumaadka culayska',
'chance_collision': 'Fursadda isku dhaca ciyaar kasta',
'evry_25_lane': '25 waddo kasta',
'insufficiend_funds': 'Lacag ku filan ma jiro',
'cashout_inactivity': 'Lacag soo qaadista xaflada haddii aan firfircooni jirin',
'time_running_out': 'Waqtigu wuu dhammaanayaa! Ciyaar hadda ama tigidhkaaga si otomaatig ah ayaa loo qaadi doonaa 30 ilbiriqsi gudaheed',
'there_was_error': 'CILAD AYAA JIRTAY, FADLAN ISKU DAY MAR KAL OO AMA DIB U RAAKI',
'detailed_game_rules': 'Xeerarka ciyaarta oo faahfaahsan',
'general_rules': 'XEERARKA GUUD',
'general_rules_p1': '• Kordhiyaha wuxuu ka bilaabmaa 1 wuxuuna gaaraa ',
'general_rules_p2': '• Guulaha waxaa lagu xisaabiyaa adigoo shatiga ku dhufto kordhiyaha lagu muujiyey talaabo kasta.',
'general_rules_p3': '• Haddii lacag bixinta ugu badan la gaaro, ciyaartu si otomaatig ah ayaa lacagta ugu badan looga bixin doonaa.',
'progressive_jackpot': 'JACKPOT HORMARAYA',
'progressive_jackpot_ss': 'Waddada jackpot iyo guusha suurtagalka ah',
'progressive_jackpot_p1': '% kasta oo shatiga ah waxaa loogu talagalay sanduuqa jackpot hormaraya.',
'progressive_jackpot_p2': 'Jackpot waxaa la siinayaa iyadoo la isticmaalayo "Mystery" ama "waa in la gaaraa". Qiimaha jackpot kasta ee "waa in la gaaraa" waxaa isla markiiba go’aamiya generator lambarrada aan kala sooca lahayn kadib markii jackpot-kii hore la guuleysto oo lagu keydiyo si qarsoodi ah.',
'progressive_jackpot_p3': 'Marka qiimaha "waa in la gaaraa" la gaaro, ciyaaryahankii ugu horreeyay ee shatiga dhiga ayaa heli doona fursad uu ku guuleysto jackpot-ka.',
'progressive_jackpot_p4': 'OGOW: Wareegga bonus-ka ma gacan geliyo sanduuqa jackpot. Inta lagu jiro wareegga bonus, jackpot lama heli karo.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Square cas, goobta isku dhaca qaarkood',
'showdown_p1': 'Marka ciyaaryahanku lacag ka baxdo, square cas ayaa lagu soo bandhigi doonaa meesha isku dhaca uu ka dhici lahaa haddii ciyaaryahanku sii wadi lahaa inuu ka boodboodo waddooyinka.',
'return_to_player': 'SOO CELINTA CIYAARYAHANKA',
'return_to_player_p1': 'Celinta guud ee ciyaaryahanka (RTP) waa ',
'return_to_player_p2': 'Boqolkiiba RTP waxaa si joogto ah u kormeeraya oo xaqiijiya dhinacyada saddexaad ee madax-bannaan.',
'disconnection_policy': 'SIYAASADDA GO’AANKA',
'disconnection_policy_p1': 'Haddii xidhiidhka la waayo kadib marka shat la dhigo, shatiga si degdeg ah looma baajin doono.',
'disconnection_policy_p2': 'Shatiga ayaa si otomaatig ah lacag loogu bixiyaa, qaddarka waxaa lagu darayaa akoonka ciyaaryahanka.',
'network_latency': 'DELAYGA SHABAKADDA',
'network_latency_p1': 'Delayga shabakadda waa qayb aan laga fursan karin oo ka mid ah internetka.',
'sound': 'COD',
'sound_p1': 'Ciyaarta waxaa loogu talagalay muusikada asalka ah iyo codadka. Waxaad damin kartaa muusikada ama codadka adigoo adeegsanaya menu-ga ciyaarta.',
'error_handling': 'MAAREYN CILAD',
'error_handling_p1': 'Haddii ay cilad dhacdo, kooxda taageerada waxay isku dayi doonaan inay xalliyaan sida ugu dhaqsaha badan.',
'max_payout': 'Lacag bixinta ugu badan waa ',
'max_bet_is': 'Shatiga ugu badan waa ',
'min_bet_is': 'Shatiga ugu yar waa ',
'per_bet': 'shat kasta.',
'malfunction_voids': 'Cilad ayaa ka dhigaysa dhammaan bixinta iyo ciyaarta mid aan ansax ahayn.',
'attention_jackpot': 'Fiiro gaar ah, Jackpot waddada ',
'lane': 'waddo',
'congratulations': 'Hambalyo',
'you_won': 'waad ku guuleysatay',
'balance': 'miisaan',
'time': 'waqtiga',
'jackpot': 'jackpot',
'escaped': 'BAXDAY',
'max_win': 'GUULDA UGU BADAN',
'check_internet': 'Fadlan hubi xidhiidhkaaga internetka',
'websocket_disconected': 'Websocket go’ay',
'websocket_connection_error': 'Cilad xidhiidhka websocket!',
'session_expired': 'Fadhigu wuu dhacay, fadlan dib u rar',
'remaining_bets': 'Shatiyada haray',
'stop_autoplay': 'JOOJI',
'autoplay_and_autocashout': 'AUTOPLAY IYO CASHOUT',
'autoplay_and_autocashout_ss': 'Xulashada u dhaxaysa gacanta iyo otomaatiga',
'autoplay_and_autocashout_p1': 'Ciyaaryahanku wuu shidi karaa autoplay-ka si shat loo dhigo si otomaatig ah wareeg kasta.',
'autoplay_and_autocashout_p2': 'Multiplier-ka auto cashout waxaa laga dooran karaa shaashadda ciyaarta.',
'autoplay_and_autocashout_p3': 'Tirada ugu badan ee wareegyada otomaatiga waa ',
'autoplay_button_label': 'Si aad u bilowdo, dooro waddo.',
'min_bet_amount_is': 'Qaddarka ugu yar ee shatiga waa',
'bonus_rounds': 'wareegyada bonus',
'bonus_rounds_ss': 'Wareegyada Bonus oo leh muddo ansax ah',
'bonus_rounds_p1': 'Ciyaaryahanku waxaa la siin karaa wareeg bonus (tusaale shat bilaash ah) oo ku saleysan xayaysiis casino.',
'bonus_rounds_p2': 'Marka la siiyo, ciyaaryahanku wuu dooran karaa goorta uu bilaabayo wareega.',
'bonus_rounds_p3': 'Wareegyada bonus waxay yeelan karaan xad wakhti, kadibna waxay noqon doonaan kuwo aan shaqayn.',
'bonus_rounds_p4': 'Haddii ciyaaryahanku caajiso, wareegyada bonus waa la joojin karaa, tiradoodu waa la dhimi karaa, miisaanka ciyaaryahanka waa isku mid.',
'valid_until': 'waxaa ansax ah ilaa',
'bonus': 'bonus',
'rounds': 'wareegyo',
'win_eur': 'guul EUR',
'complete_your_bet': 'Fadlan marka hore dhameystir shatigaaga',
'complete_auto_play': 'Fadlan marka hore dhameystir ciyaarta otomaatiga ah',
'yes': 'haa',
'no': 'maya',
'play_bonus_rounds': 'Ma ciyaari wareegyada bonus?',
'bet_history': 'Taariikhda shatiga',
'jackpot_history': 'Taariikhda jackpot',
'ticket_id': 'ID tigidh',
'created': 'wakhtiga la abuuray',
'currency': 'lacag',
'bet': 'shat',
'bet_eur': 'shat EUR',
'lanes': 'waddooyinka',
'cars': 'baabuur',
'multiplier': 'multiplier',
'win': 'guul',
'no_betting_history': 'Taariikh shat lama helin.',
'no_jackpot_history': 'Taariikh jackpot lama heli karo.',
'date': 'taariikh',
'user': 'isticmaalaha',
'bet_already_active': 'Shat horey ayaa loo shiday',
'please_play_the_game_in_portait_mode': 'Fadlan ciyaar ciyaarta hab sawir.',
'bonus_history': 'Taariikhda bonus',
'bonus_type': 'Nooca bonus',
'no_bonus_history': 'Taariikh bonus lama heli karo.',
'game_menu': 'Menu-ga ciyaarta',
'game_menu_ss': 'Bidix: Guriga, Taariikhda shatiga, Xeerarka ciyaarta, Furayaasha kulul, Dejinta codka, Muusikada',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'XEERARKA CIYAARTA',
'game_rules_p1': 'Ku soo dhowow Plinko – Halka Nasiibku Hogaamiyo!',
'game_rules_p2': 'U diyaar garow ciyaar xiiso leh oo ku saleysan nasiib, fudud laakiin la qabatimayo! Plinko waa in kubbadda lagu sii daayo buurta leh qodxo (pegs) oo la daawado iyadoo boodaysa, wareegaysa, kuna dhaceysa meel abaalmarin leh oo hoose.',
'game_rules_p3': 'Ka dooro inta u dhaxaysa 8 ilaa 16 saf oo qodxo ah, kadib fadhiiso oo ku raaxeyso jahwareerka kubbadda iyadoo sii socota – kaliya waxaa hoggaamiya cuf-jiid iyo nasiib.',
'game_rules_p4': 'Ma ku dhici doontaa meel lacag yar bixisa... mise waxaad heli doontaa guul weyn? Hal waddo oo keliya ayaa jirta si loo ogaado — sii daa kubbadda oo daawo xiisaha!',
'general': 'GUUD AHAAN',
'general_p1': 'Sii daa kubbadda Plinko oo rajee inay ku dhici doonto meel abaalmarin sare leh. Waddadu waa lama filaan — bood kasta wuxuu beddeli karaa nasiibkaaga.',
'general_p2': 'Inta saf ee aad ciyaarto way badan tahay, ayaa ciyaartu u noqonaysaa mid xiiso badan!',
'general_p3': 'Soo soco — ku aamin nasiibkaaga, guji DROP, oo uga daba gal guusha weyn ee Plinko!',
'betting': 'KHAMAAARID',
'betting_p1': 'Dooro qadarka khamaarka. Badhamada “1/2”, “2x”, “Max” waxaa loo isticmaali karaa in lagu maareeyo cabbirka khamaarka. Qadarka khamaarka sidoo kale gacanta ayaa lagu geli karaa.',
'betting_p2': 'Dooro Heerka Khatarta: Hoose, Dhexe ama Sare. Heer khatar hoose wuxuu bixiyaa natiijooyin deggan (kala duwanaansho hoose), halka heer sare uu keeno kala duwanaansho badan (kala duwanaansho sare).',
'betting_p3': 'Dooro tirada khadadka ciyaarta: laga bilaabo 8 ilaa 16. Dooro inta saf ee qodxaha ah ee kubbadu ka dhex dhici doonto. Safaf badan = saadaalin la’aan badan.',
'betting_p4': 'Dooro Habka Khamaarka: Gacanta ama Toos ah.',
'betting_p5': 'Si aad u bilowdo wareegga ciyaarta, riix badhanka DROP BALL. Inta wareeggu socdo dhammaan badhamada khamaarka way xirmayaan marka laga reebo DROP BALL iyo qadarka khamaarka.',
'betting_p6': 'Hal kubbad oo Plinko ah waxay matalaysaa hal wareeg. Inta wareeggu socdo, wareeg kale oo leh isla dejinta ayaa lagu bilaabi karaa badhanka DROP BALL. Waa suurtagal in la beddelo qadarka khamaarka inta ay jiraan kubbado firfircoon, laakiin lama beddeli karo heerka adag ee ciyaarta.',
'betting_p7': 'Dhamaadka wareegga, kubbadu waxay gaartaa jeeb. Jeeb kasta waxaa lagu muujiyaa isku-dhufashada bixinta.',
'betting_p8': 'Xisaabinta guusha waxaa lagu sameeyaa iyadoo loo eegayo isku-dhufashada meesha kubbadu ku dhacday. Natiijada waxaa lagu daraa baaqiga.',
'game_menu_p1': 'Isku-dhufashooyinka khamaarka ee ugu dambeeyay waxaa lagu muujiyaa qaybta hoose ee daaqadda ciyaarta.',
'game_menu_p2': 'Adigoo adeegsanaya badhanka “Bet history” ciyaaryahanku wuxuu si faahfaahsan u eegi karaa khamaarkiisii ugu dambeeyay.',
'game_menu_p3': 'Si loo arko taariikh ciyaareed dheer, ciyaaryahanku wuxuu u baahan karaa inuu galo taariikhdiisa gudaha madasha ciyaarta lafteeda.',
'game_menu_p4': 'Iyadoo loo marayo menu-ga ciyaarta, ciyaartoydu waxay maamuli karaan codka, gaabiyeyaasha kiiboodhka, waxayna furi karaan taariikhda khamaarka iyo xeerarka ciyaarta.',
'game_menu_p5': 'Ciyaarta waxaa loo qaabeeyey iyadoo la tixgelinayo muusig qurux badan iyo saameyn cod. Muusiga ama saameynta codka waa la demi karaa iyadoo loo marayo astaamaha menu-ga ciyaarta.',
'game_menu_p6': 'Taariikhda ciyaarta waxay muujin doontaa daaqad leh khamaarradii hore iyo taariikhda gunnooyinka.',
'autoplay': 'Habka Tooska ah (Autoplay)',
'autoplay_p1': 'Guji Auto si aad si toos ah ugu daadi karto kubbado badan adigoon mar walba gujin.',
'autoplay_p2': 'Dooro qadarka aad rabto inaad ku khamaarato kubbad kasta.',
'autoplay_p3': 'Dooro inta jeer (wareegyo) aad rabto kubbadu inay dhacdo — ugu badnaan 100 wareeg.',
'autoplay_p4': 'Riix badhanka START si aad u bilowdo, badhankuna wuxuu isu beddeli doonaa STOP.',
'autoplay_p5': 'Habka Tooska ah wuu istaagi doonaa marka tirada la doortay la dhammeeyo, lacagtu dhammaato ama aad gujiso STOP.',
'autoplay_p6': 'Daadis kasta wuxuu isticmaalaa isla qadarka khamaarka ee aad dooratay ka hor intaadan bilaabin Habka Tooska ah.',
'turbo_mode': 'Habka Turbo',
'turbo_mode_p1': 'Turbo Drop wuxuu kuu oggolaanayaa inaad kubbado si xawaare sare ah u daadiso adigoo haysta badhanka DROP.',
'turbo_mode_p2': 'Kubbaduhu way sii dhici doonaan ilaa aad ka sii deyso badhanka ama baaqigu dhammaado.',
'turbo_mode_p3': 'Kubbaduhu way sii dhici doonaan ilaa aad ka sii deyso badhanka ama baaqigu dhammaado.',
'turbo_balance': 'Baaqiga Turbo',
'turbo_balance_p1': 'Ka hor intaadan bilaabin Turbo Drop, waxaad dooranaysaa inta lacag ah ee aad gooni u dhigeyso — tanina waxay noqoneysaa Baaqigaaga Turbo.',
'turbo_balance_p2': 'Inta Turbo Drop uu firfircoon yahay, ciyaartu waxay u isticmaashaa kaliya Baaqigaaga Turbo khamaarka iyo guulaha.',
'turbo_balance_p3': 'Markaad joojiso Turbo Drop, wixii Baaqi Turbo ah ee haray waxaa lagu celinayaa baaqigaaga guud.',
'turbo_balance_p4': 'Waxaad ka bixi kartaa Turbo Drop waqti kasta — laakiin habku wuxuu si buuxda u dhammaanayaa kaliya marka dhammaan kubbaduhu dhammaystiraan dhicista oo ay ku degaan jeebabka.',
'free_bets': 'WAREEGYADA GUNNADA',
'free_bets_p1': 'Wareegyada Gunnada waxaa bixiya hawlwadeenka.',
'fairness': 'Cadaalad',
'fairness_p1': 'Rid kasta waxaa lagu go’aamiyaa tiro-iska-random ah oo la caddeeyey (RNG).',
'fairness_p2': 'Natiijada lama saadaalin karo ama lagu saameyn karo marka kubbadda la rido kadib.',
'disconection_and_error': 'Qaanuunka Xirnaanshaha iyo Maareynta Khaladaadka',
'disconection_and_error_p1': 'Haddii xiriirka lumo kadib marka la khamaaro, khamaarka lama joojinayo. Haddii ciyaartu u baahan tahay ficil ciyaaryahan, natiijada waxaa loo tixgeliyaa inuu doortay ficil aan halis lahayn iyadoo aan la kordhin khamaarka hore.',
'disconection_and_error_p2': 'Haddii khalad dhaco, kooxda taageerada waxay isku dayi doonaan iney xaliso sida ugu dhaqsaha badan, ciyaartuna way sii socon doontaa. Haddii ciyaarta lafteedu ay tahay dhibaatada, dhammaan khamaarrada waa la joojin doonaa, lacagtana waa la soo celin doonaa.',
'other': 'Kale',
'other_p1': 'Haddii qalad ka dhaco qalabka ama software-ka ciyaarta, dhammaan khamaarrada iyo lacagaha saameeyey waa la burin doonaa, lacagtana waa la soo celin doonaa.',
'other_p2': 'Xeerarka Ciyaarta waxaa lagu daabacay Ingiriisi. Turjumaadaha luqadaha kale waxaa lagu bixiyay si daacad ah. Haddii ay jirto isfahan la’aan u dhaxeysa Ingiriisi iyo tarjumaad kale, Ingiriisigu waa kan mudnaanta leh.',
'rows': 'Safka',
'lvl': 'Heer',
'low': 'Hoose',
'high': 'Sar',
'ok': 'OK',
'exit_turbo_mode': 'Ma rabtaa inaad ka baxdo Turbo mode?',
"end": "DHAMAAD",
"turbo_mode_settings": "Dejinta Habka Turbo",
"stop": "STOP",
'invalid_bet_amount': 'Qiimaha sharadka ma saxna',
'cashout_success': 'Lacag bixinta waa lagu guuleystay',
'stop_auto_play_first': 'Fadlan marka hore jooji ciyaarta AUTO.',
'turbo_only_when_no_balls': 'Turbo inaweza kuanzishwa tu wakati hakuna mipira kwenye ubao.',
'type': 'Aina ya dau',
'wait_balls_to_finish': 'Tafadhali subiri mipira yote kumaliza.',
'bet_too_large_top_up_turbo_balance': 'Dau kubwa sana — ongeza Salio lako la Turbo!',

};
langArr.tn = {
'loading': 'Go Laela',
'hotkeys': 'Dikgato tse di Potlakileng',
'hotkeys_enabled': 'Dikgato tse di Potlakileng di Asetse',
'enable_hotkeys_checkbox': 'Dira gore dikgato tse di potlakileng tse di bontshiwang mo tlase di tseelwe tiro ka go tlanya lebokoso leno.',
'drop_ball': 'Leka bolo',
'double_bet': 'Feta bets ka bobedi',
'halve_bet': 'Kgaola bets ka borai',
'min_bet': 'Palo ya bets e e kwa tlase',
'max': 'Gabotse',
'easy': 'Motlhofo',
'medium': 'Magareng',
'hard': 'Matshwenyego',
'daredevil': 'Motho yo o dirang ka tshoganetso',
'max_profit': 'Phelo e e Kgolo',
'manual': 'Ka Letsogo',
'auto': 'Ka Boitlhopho',
'bet_amount': 'Palo ya bets',
'difficulty': 'Boima',
'payout_on_win': 'Tsamaiso ya moputso fa o fenya',
'number_of_bets': 'Palo ya bets',
'on_win': 'Fa o fenya',
'on_loss': 'Fa o latlhegile',
'stop_on_profit': 'Emisa fa o na le phaelo',
'stop_on_loss': 'Emisa fa o latlhegile',
'reset': 'Tlhopha gape',
'increase_by': 'Oketsa ka',
'cashout': 'Tsamaiso ya CASHOUT',
'start_game': 'BET',
'start_auto_game': 'SIMULA',
'difficulity_info': 'Tshedimosetso ka boima',
'chance_collision': 'Menyetla ya kotsi mo papading',
'evry_25_lane': 'mo go dipolase tse 25',
'insufficiend_funds': 'Ditlhwatlhwa ga di lekaneng',
'cashout_inactivity': 'Tsamaiso ya party ka go se dirise',
'time_running_out': 'Nako e a fela! Bapala jaanong kgotsa tiket ya gago e tla ntshiwa ka metsotso e 30',
'there_was_error': 'GO NA LE PHETOGO, LEKA GAPE KAPA TSOSELA',
'detailed_game_rules': 'Melao e e Kgaoganyang ka Papadi',
'general_rules': 'MELAO YA MOTHO WOTLE',
'general_rules_p1': '• Multiplier e simolola ka 1 mme e ya go fitlha ',
'general_rules_p2': '• Diphitlho di balwa ka go oketsa palo ya bet ka multiplier e e bontshiwang mo kgatong nngwe le nngwe.',
'general_rules_p3': '• Fa moputso o mogolo o fitlhetse, papadi e tla iketleeletsa go tsamaisa moputso o mogolo.',
'progressive_jackpot': 'JACKPOT E E TSWELELANG',
'progressive_jackpot_ss': 'Polase ya jackpot le moputso o o ka nnang teng',
'progressive_jackpot_p1': '% ya bets nngwe le nngwe e abelwa mokgatlho wa jackpot.',
'progressive_jackpot_p2': 'Jackpot e abiwa ka mekgeletso ya "Mystery" kgotsa "must-hit-by". Boleng jwa jackpot nngwe le nngwe e "must-hit-by" bo tlhomilwe morago ga jackpot e e fetileng ka random number generator mme bo bolokwa jaaka value e e pateleditsweng mo database e e hole.',
'progressive_jackpot_p3': 'Fa boleng jwa "must-hit-by" bo fitlhetse, sebapadi sa ntlha go tsaya bet morago bo tla nna le monyetla wa go fenya jackpot. Sekgala sa jackpot se tla bonala mo polaseng nngwe le jackpot e tla fenywa fa sebapadi se fitlha polase e nang le sekala sa jackpot.',
'progressive_jackpot_p4': 'TSEBISO: Bonase ga e tsenya letseno mo jackpot. Fa bonase e le teng, jackpot e ka se fenywe.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Sekwele se se khubelu, lefelo la kotsi',
'showdown_p1': 'Fa sebapadi a tsamaisa moputso, sekwele se se khubelu se tla bontshiwa mo lefelong le kotsi e ka nnang teng.',
'return_to_player': 'TSHENYEGELONG MO SEBAPADING',
'return_to_player_p1': 'Tshenyegelo ya kakaretso ya teoritiki mo sebapading (RTP) ke ',
'return_to_player_p2': 'Diphesente tsa RTP di tlhokomelwa le go netefadiwa ke diithuti tse di ikemetseng.',
'disconnection_policy': 'MELAO YA KGOLOKO',
'disconnection_policy_p1': 'Fa kgokelo e latlhegile morago ga go tsaya bet, bet ga e tloswe ka nakwana. Fa sebapadi a sa dirise nako go fitlha ',
'disconnection_policy_p2': 'bet e tla tsamaisiwa ka boitlhopho mme ditlhwatlhwa di tla abelwa akhaonto ya sebapadi.',
'network_latency': 'TLHAKANYO YA INTHANETE',
'network_latency_p1': 'Tlhaloso ya netweke ke karolo e e sa lekanngwang ya kgokelo ya Inthanete. Re akanyetsa bets tsotlhe le cashouts e le tse di maleba fela ka nako tse di fitlhelang seva ya rona.',
'sound': 'MODULO WA MAMOSA',
'sound_p1': 'Papadi e rulagantswe ka mmino le mantswe a matle a motswedi. Fa o batla go tima mmino le/ kgotsa mantswe, o ka dira seo ka dikona tsa menu ya papadi.',
'error_handling': 'TLOHO YA PHETOGO',
'error_handling_p1': 'Fa phoso e tlhaga, setlhopha sa rona sa thuso se tla leka go e rarabolola ka bonako mme papadi e tswelele. Fa go na le phoso mo papading ka boyona, bets tsotlhe di tla tloswa mme palo ya bet e tla busiwa mo sebapading.',
'max_payout': 'Moputso o mogolo ke ',
'max_bet_is': 'Bet e kgolo ke ',
'min_bet_is': 'Bet e e kwa tlase ke ',
'per_bet': 'ka bet.',
'malfunction_voids': 'Phoso e dira gore diphuthego tsotlhe di seka tsa balwa.',
'attention_jackpot': 'TSEBISO, Jackpot mo polaseng ',
'lane': 'polasa',
'congratulations': 'ditumediso',
'you_won': 'o fenile',
'balance': 'balance',
'time': 'nako',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Tshekatsheko kgokelo ya gago ya Inthanete',
'websocket_disconected': 'Websocket e kgaogantswe',
'websocket_connection_error': 'Phoso ya kgokelo ya websocket !',
'session_expired': 'Session e fedile, tsosela',
'remaining_bets': 'Bets tse di setseng',
'stop_autoplay': 'EMISA',
'autoplay_and_autocashout': 'AUTOPLAY LE AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Kgetho fa gare ga ka letsogo le autoplay',
'autoplay_and_autocashout_p1': 'Sebapadi se ka tsenya autoplay go dira bet ka boitlhopho mo kgatong nngwe le nngwe go dirisa palo ya bet ya kgatong e e fetileng.',
'autoplay_and_autocashout_p2': 'Multiplier ya auto cashout e ka kgethwa, mme fa e kgethiwa, papadi e tla tsamaisa moputso fa sebapadi se sa tshwanelwa pele ga go fitlha multiplier e kgethegileng.',
'autoplay_and_autocashout_p3': 'Palo e kgolo ya dikgato tsa autoplay ke ',
'autoplay_button_label': 'Go simolola, kgetha polasa.',
'min_bet_amount_is': 'Palo ya bet e e kwa tlase ke',
'bonus_rounds': 'dikgatlho tsa bonase',
'bonus_rounds_ss': 'Dikgatlho tsa Bonase ka nako e e lekanang',
'bonus_rounds_p1': 'Sebapadi se ka fiwa dikgatlho tsa bonase ka kgatelo ya kasino. Popup e tla bontshwa go itsise sebapadi ka dikgatlho tsa bonase tse fiwang, palo ya bets, palo ka bet le nako ya tshwanelo.',
'bonus_rounds_p2': 'Fa dikgatlho tsa bonase di fiwa, sebapadi se ka kgetha go simolola neng. Fa bonase e simolotswe, bet ka boitlhopho e tla dirwa ka stake e e tlhalosiwang.',
'bonus_rounds_p3': 'Dikgatlho tsa bonase di ka nna le nako e e kgethegileng, fa e fetile di fela.',
'bonus_rounds_p4': 'Go se dirise ga sebapadi go ka dira gore bonase e emiswe. Mo kgang eno, palo ya dikgatlho tsa bonase e tla fokotwa mme balance ya sebapadi e tla nna jalo.',
'valid_until': 'e lekanang go fihlela',
'bonus': 'bonase',
'rounds': 'dikgatlho',
'win_eur': 'fenyo EUR',
'complete_your_bet': 'Tshwara bet ya gago pele',
'complete_auto_play': 'Tshwara autoplay pele',
'yes': 'ee',
'no': 'nnyaa',
'play_bonus_rounds': 'Bapala dikgatlho tsa bonase?',
'bet_history': 'Tlaleletso ya bets',
'jackpot_history': 'Tlaleletso ya jackpot',
'ticket_id': 'Ticket ID',
'created': 'nako e e tlhagileng',
'currency': 'mmala wa ditlhwatlhwa',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'dipolase',
'cars': 'dikoloi',
'multiplier': 'multiplier',
'win': 'fenyo',
'no_betting_history': 'Ga go na tlaleletso ya bets. Dira bet mme e tla bonala fa.',
'no_jackpot_history': 'Ga go na tlaleletso ya jackpot.',
'date': 'letsatsi',
'user': 'sebapadi',
'bet_already_active': 'Bet e setse e le teng',
'please_play_the_game_in_portait_mode': 'Bapala papadi mo portrait mode.',
'bonus_history': 'Tlaleletso ya bonase',
'bonus_type': 'Mofuta wa bonase',
'no_bonus_history': 'Ga go na tlaleletso ya bonase.',
'game_menu': 'Menu ya papadi',
'game_menu_ss': 'Go tswa ka letshego: Home, Tlaleletso ya bets, Melao ya papadi, Dikgato tse di Potlakileng, Ditshegetso tsa mantswe le mmino',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'MELAOMETHEO YA PAPADI',
'game_rules_p1': 'Rea go amogela mo Plinko – Felo Fa Mahutafatso A Tswela Pele!',
'game_rules_p2': 'Itokiyele papadi ya botshelo e e itumedisang e bile e le motlhofo go e tshameka! Mo Plinko, o tsaya bolo o e lahla mo toreng ya dipeg, o bo o e lebelela e ntse e tlola, e dikologa, e itaya go fitlha e wela mo selotong se se nang le moputso kwa tlase.',
'game_rules_p3': 'Kgetha magato go simolola ka 8 go fitlha ka 16, o bo o dula fatshe o natefelela tlhakatlhakano fa bolo e feta mo dipakeng ka botshelo – e tsamaisiwa fela ke kgatelelo ya lefatshe le mahutafatso.',
'game_rules_p4': 'A e tla wela mo selotong se se nang le moputso o monnye... kgotsa o kgona go fenyang kgolo? Go na le tsela e le nngwe fela — lahla bolo mme o lebele fa boitumelo bo tlhaga!',
'general': 'TLHALOSO KA BONTLHA',
'general_p1': 'Lahla bolo ya Plinko ka tsholofelo ya gore e tla wela mo selotong se se nang le moputso o mogolo kwa tlase. Tsela ya teng ga e ka ke ya akarediwa — kgato nngwe le nngwe e ka fetola mahutafatso a gago.',
'general_p2': 'Magato a mantsi a o a tshamekang, papadi e nna motlhofo le go feta!',
'general_p3': 'Tsamaya pele — ikanye mahutafatso a gago, tobetsa DROP, mme o latele phenyo e kgolo mo dipakeng tsa Plinko!',
'betting': 'GO BEYA MADI',
'betting_p1': 'Tlhopha madi a beche. Dikonopo tsa “1/2”, “2x”, “Max” di ka dirisiwa go laola bogolo jwa beche. Madi a beche a ka tsenngwa ka seatla.',
'betting_p2': 'Tlhopha Boemo jwa Kotsi: Tlase, Bogare kgotsa Godimo. Boemo jwa kotsi jo bo kwa tlase bo naya ditlamorago tse di tsitsitseng (phokotso ya go fetofetoga), fa jo bo kwa godimo bo naya pharologanyo e kgolo (go fetofetoga go go kwa godimo).',
'betting_p3': 'Tlhopha palo ya mela mo motshamekong: go tswa mo go 8 go fitlha go 16. Tlhopha mela e bolo e tla fologang mo go yone. Mela e mentsi = go sa kgone go bolelelwa pele.',
'betting_p4': 'Tlhopha Mokgwa wa Beche: Ka seatla kgotsa Ka boitiriso.',
'betting_p5': 'Go simolola potoloho ya motshameko, tobetsa konopo ya DROP BALL. Ka nako ya potoloho dikonopo tsotlhe tsa beche di a thibelwa fa e se DROP BALL le madi a beche.',
'betting_p6': 'Bolo e le nngwe ya Plinko e emela potoloho e le nngwe. Ka nako ya potoloho, potoloho e nngwe ka ditlhophiso tse di tshwanang e ka simololwa ka konopo ya DROP BALL. Go a kgonega go fetola madi a beche fa go santse go na le dibolo tse di tshelang mo tafoleng, mme e seng bothata jwa motshameko.',
'betting_p7': 'Kwa bofelong jwa potoloho, bolo e fitlha mo pokothong. Mo pokothong nngwe le nngwe go bontshiwa sekgonagalo sa go duela.',
'betting_p8': 'Go balwa ga phenyo go dirwa go ya ka sekgonagalo se bolo e wetseng mo go sone. Sephetho se okediwa mo balanseng.',
'game_menu_p1': 'Dikgatiso tsa beche tsa bosheng di bontshiwa mo karolong e e kwa tlase ya fensetere ya motshameko.',
'game_menu_p2': 'Ka konopo ya “Bet history” motshameki a ka sekaseka dibetšhe tsa gagwe tsa bosheng ka botlalo.',
'game_menu_p3': 'Go bona hisetori e telele ya go tshameka, motshameki a ka tlhoka go tsena mo hisetoring ya gagwe mo seraleng sa motshameko ka bosone.',
'game_menu_p4': 'Ka menu ya motshameko, batshameki ba ka laola modumo, ditsela tse dikhutshwane tsa khiboto, mme ba bula hisetori ya beche le melao ya motshameko.',
'game_menu_p5': 'Motshameko o dirilwe ka mmino o montle wa morago le ditlamorago tsa modumo. Mmino le/kapa ditlamorago tsa modumo di ka tingwa ka ditshwantsho tsa menu ya motshameko.',
'game_menu_p6': 'Hisetori ya motshameko e tla bontsha fensetere e e nang le dibetšhe tse di fetileng le hisetori ya dibonase.',
'autoplay': 'Mokgwa wa Boitiriso (Autoplay)',
'autoplay_p1': 'Go tobetsa Auto go go letla go fologisa dibolo di le dintsi ka boitiriso ntle le go tobetsa nako le nako.',
'autoplay_p2': 'Tlhopha madi a o batlang go a becha ka bolo nngwe le nngwe.',
'autoplay_p3': 'Tlhopha gore bolo e wele ga kae (dipotoloho) — go fitlha go dipotoloho di le 100.',
'autoplay_p4': 'Tobetsa konopo ya START go simolola, mme e tla fetoga STOP.',
'autoplay_p5': 'Mokgwa wa Boitiriso o tla ema fa palo e e tlhophilweng ya go fologisa e feditswe, madi a fela kgotsa o tobetsa STOP.',
'autoplay_p6': 'Go fologa gongwe le gongwe go dirisa madi a beche a a tshwanang le a o a tlhophileng pele o simolola Mokgwa wa Boitiriso.',
'turbo_mode': 'Mokgwa wa Turbo',
'turbo_mode_p1': 'Turbo Drop e go letla go fologisa dibolo ka lebelo le legolo ka go tshwara konopo ya DROP.',
'turbo_mode_p2': 'Dibolo di tla tswelela di wa go fitlha o tlogela konopo kgotsa balanse e fela.',
'turbo_mode_p3': 'Dibolo di tla tswelela di wa go fitlha o tlogela konopo kgotsa balanse e fela.',
'turbo_balance': 'Balanse ya Turbo',
'turbo_balance_p1': 'Pele o simolola Turbo Drop, o tlhopha madi a o batlang go a beela kwa thoko — seno se nna Balanse ya gago ya Turbo.',
'turbo_balance_p2': 'Fa Turbo Drop e le mo tirisong, motshameko o dirisa fela Balanse ya gago ya Turbo mo dibetšheng le diphenyong.',
'turbo_balance_p3': 'Fa o emisa Turbo Drop, Balanse ya Turbo e e setseng e boela mo balanseng ya gago e kgolo.',
'turbo_balance_p4': 'O ka tswa mo Turbo Drop ka nako nngwe le nngwe — mme mokgwa o tla fela ka botlalo fela fa dibolo tsotlhe di feditse go wa mme di fihlile mo dipokothong.',
'free_bets': 'DIPOTOLOHO TSA BONASE',
'free_bets_p1': 'Dipotoroloho tsa Bonase di abelwa ke motsamaisi.',
'fairness': 'TOKELO',
'fairness_p1': 'Polo nngwe le nngwe e laolwa ke sedirisiwa sa palo e e sa kgethegeng (RNG) e e netefaditsweng.',
'fairness_p2': 'Sephetho se ka se akarediwe kgotsa se fetolwe fa bolo e setse e wele.',
'disconection_and_error': 'Molao wa Kgaoganyo le Taolo ya Diphoso',
'disconection_and_error_p1': 'Fa khokelo e kgaoga morago ga bet e tsentswe, bet e tla tswelela. Fa papadi e tlhoka tiro mo sebapading, sephetho se tla balwa jaaka e kete sebapadi se ne se kgethile tiro e e se nang kotsi ntle le go oketsa bet.',
'disconection_and_error_p2': 'Fa go na le phoso, setlhopha sa thuso se tla leka go e rarabolola ka bonako, mme papadi e tla tswelela. Fa phoso e le mo papading ka bo yone, bets tsotlhe di tla emisiwa mme madi a boele mo sebapading.',
'other': 'TSE DINGWE',
'other_p1': 'Fa go ka nna le bothata mo sedirisiweng/sediriso sa papadi, bets tsotlhe tse di amegang le moputso di tla emisiwa mme madi a boelwe mo sebapading.',
'other_p2': 'Melao ya papadi e phatlaladiwa ka Seesemane. Diphetolelo mo dipuong tse dingwe di fiwa ka maikaelelo a a molemo. Fa go na le kgotlhang magareng ga Seesemane le phetolelo, phetolelo ya Seesemane ke yone e e tlotlegang ka pele.',
'rows': 'Mela',
'lvl': 'Tlhopharolo',
'low': 'A tlase',
'high': 'A godimo',
'ok': 'OK',
'exit_turbo_mode': 'A o batla go tswa mo Turbo mode?',
"end": "BOKGONE",
"turbo_mode_settings": "Dipeakanyo tsa Turbo Mode",
"stop": "EMISA",
'invalid_bet_amount': 'Bogolo jwa bet ga bo a siama',
'cashout_success': 'Cashout e atlegile',
'stop_auto_play_first': 'Tsweetswee emisa papadi ya AUTO pele.',
'turbo_only_when_no_balls': 'Turbo e ka simololwa fela fa go se na dibolo mo boto.',
'type': 'Aina ya dau',
'wait_balls_to_finish': 'Tsweetswee emele dibolo di feditse.',
'bet_too_large_top_up_turbo_balance': 'Dau e kgolo thata — oketsa Salio sa gago sa Turbo!',

};
langArr.ar = {
'loading': 'جارٍ التحميل',
'hotkeys': 'اختصارات لوحة المفاتيح',
'hotkeys_enabled': 'تم تمكين الاختصارات',
'enable_hotkeys_checkbox': 'قم بتمكين الاختصارات المعروضة أدناه عن طريق تحديد هذا المربع.',
'drop_ball': 'إسقاط الكرة',
'double_bet': 'مضاعفة الرهان',
'halve_bet': 'تقسيم الرهان إلى نصفين',
'min_bet': 'الحد الأدنى للرهان',
'max': 'الحد الأقصى',
'easy': 'سهل',
'medium': 'متوسط',
'hard': 'صعب',
'daredevil': 'متهور',
'max_profit': 'أقصى ربح',
'manual': 'يدوي',
'auto': 'تلقائي',
'bet_amount': 'مقدار الرهان',
'difficulty': 'الصعوبة',
'payout_on_win': 'العائد عند الفوز',
'number_of_bets': 'عدد الرهانات',
'on_win': 'عند الفوز',
'on_loss': 'عند الخسارة',
'stop_on_profit': 'توقف عند الربح',
'stop_on_loss': 'توقف عند الخسارة',
'reset': 'إعادة ضبط',
'increase_by': 'زيادة بمقدار',
'cashout': 'سحب الأموال',
'start_game': 'راهن',
'start_auto_game': 'ابدأ',
'difficulity_info': 'معلومات عن الصعوبة',
'chance_collision': 'احتمال التصادم لكل لعبة',
'evry_25_lane': 'لكل 25 مسار',
'insufficiend_funds': 'أموال غير كافية',
'cashout_inactivity': 'سحب تلقائي عند الخمول',
'time_running_out': 'الوقت ينفد! العب الآن أو سيتم سحب تذكرتك تلقائيًا خلال 30 ثانية',
'there_was_error': 'حدث خطأ، يرجى المحاولة مرة أخرى أو إعادة التحميل',
'detailed_game_rules': 'قوانين اللعبة التفصيلية',
'general_rules': 'القواعد العامة',
'general_rules_p1': '• يبدأ المضاعف من 1 ويصل إلى ',
'general_rules_p2': '• يتم حساب الأرباح بضرب قيمة الرهان بالمضاعف المعروض في كل خطوة.',
'general_rules_p3': '• إذا تم الوصول إلى الحد الأقصى للعائد، سيتم سحب الأرباح تلقائيًا عند الحد الأقصى.',
'progressive_jackpot': 'الجاكبوت التقدمي',
'progressive_jackpot_ss': 'مسار الجاكبوت والمكاسب المحتملة',
'progressive_jackpot_p1': '% من كل رهان يخصص لصندوق الجاكبوت التقدمي.',
'progressive_jackpot_p2': 'يتم منح الجاكبوت باستخدام ميكانيكية "Mystery" أو "must-hit-by". يتم تحديد قيمة كل جاكبوت "must-hit-by" فور انتهاء الجاكبوت السابق بواسطة مولد أرقام عشوائية وتخزينها كقيمة مشفرة في قاعدة البيانات.',
'progressive_jackpot_p3': 'بمجرد الوصول إلى قيمة "must-hit-by"، سيكون لدى أول لاعب يراهن بعد ذلك فرصة للفوز بالجاكبوت. يظهر رمز الجاكبوت على مسار عشوائي ويتم الفوز بالجاكبوت إذا وصل اللاعب إلى المسار الذي يحتوي على الرمز.',
'progressive_jackpot_p4': 'ملاحظة: لا تساهم جولة المكافأة في صندوق الجاكبوت. خلال جولة المكافأة لا يمكن الفوز بالجاكبوت.',
'showdown': 'المواجهة النهائية',
'showdown_ss': 'المربع الأحمر، موقع التصادم المحتمل',
'showdown_p1': 'بعد سحب اللاعب للأموال، سيتم عرض مربع أحمر في الموقع الذي كان سيحدث فيه التصادم لو استمر اللاعب في القفز بين المسارات.',
'return_to_player': 'العائد للاعب',
'return_to_player_p1': 'العائد النظري الإجمالي للاعب (RTP) هو ',
'return_to_player_p2': 'يتم مراقبة نسب RTP والتحقق منها باستمرار من قبل أطراف مستقلة.',
'disconnection_policy': 'سياسة الانقطاع',
'disconnection_policy_p1': 'إذا فقد الاتصال بعد وضع الرهان، فلن يتم إلغاء الرهان فورًا. إذا تجاوزت خمول اللاعب ',
'disconnection_policy_p2': 'سيتم سحب الرهان تلقائيًا وتطبيق الرصيد على حساب اللاعب.',
'network_latency': 'تأخير الشبكة',
'network_latency_p1': 'تأخير الشبكة جزء لا مفر منه من الاتصال بالإنترنت. نعتبر جميع الرهانات والسحوبات صالحة فقط في الوقت الذي تصل فيه إلى خادمنا بغض النظر عن مدة التأخير.',
'sound': 'الصوت',
'sound_p1': 'اللعبة مصممة بموسيقى خلفية جميلة ومؤثرات صوتية. إذا رغبت في تعطيل الموسيقى أو المؤثرات الصوتية، يمكنك ذلك من خلال أيقونات قائمة اللعبة.',
'error_handling': 'معالجة الأخطاء',
'error_handling_p1': 'في حالة حدوث خطأ، سيحاول فريق الدعم حل المشكلة في أسرع وقت واستئناف اللعبة العادية. في حالة وجود مشكلة في اللعبة نفسها، سيتم إلغاء جميع الرهانات وإرجاع المبلغ إلى اللاعبين.',
'max_payout': 'أقصى عائد هو ',
'max_bet_is': 'أقصى رهان هو ',
'min_bet_is': 'أقل رهان هو ',
'per_bet': 'لكل رهان.',
'malfunction_voids': 'العطل يلغي جميع المدفوعات واللعب.',
'attention_jackpot': 'تنبيه، الجاكبوت في المسار ',
'lane': 'مسار',
'congratulations': 'تهانينا',
'you_won': 'لقد فزت',
'balance': 'الرصيد',
'time': 'الوقت',
'jackpot': 'الجاكبوت',
'escaped': 'تم الهروب',
'max_win': 'أقصى فوز',
'check_internet': 'يرجى التحقق من اتصال الإنترنت',
'websocket_disconected': 'تم قطع Websocket',
'websocket_connection_error': 'خطأ في اتصال Websocket!',
'session_expired': 'انتهت الجلسة، يرجى إعادة التحميل',
'remaining_bets': 'الرهانات المتبقية',
'stop_autoplay': 'إيقاف',
'autoplay_and_autocashout': 'اللعب التلقائي والسحب التلقائي',
'autoplay_and_autocashout_ss': 'الاختيار بين اللعب اليدوي والتلقائي',
'autoplay_and_autocashout_p1': 'يمكن للاعب تفعيل خيار اللعب التلقائي حيث يتم وضع رهان تلقائي لكل جولة جديدة باستخدام قيمة الرهان السابقة.',
'autoplay_and_autocashout_p2': 'يمكن اختيار مضاعف سحب تلقائي، وعند تعيينه، يتم السحب تلقائيًا إذا لم يُصَب اللاعب قبل الوصول للمضاعف المختار.',
'autoplay_and_autocashout_p3': 'أقصى عدد لجولات اللعب التلقائي هو ',
'autoplay_button_label': 'لبدء اللعب، اختر مساراً.',
'min_bet_amount_is': 'الحد الأدنى للرهان هو',
'bonus_rounds': 'جولات المكافأة',
'bonus_rounds_ss': 'جولات المكافأة والفترة الزمنية',
'bonus_rounds_p1': 'قد يتم منح اللاعب جولة مكافأة (رهان مجاني) بناءً على عرض الكازينو. سيتم عرض نافذة منبثقة لإبلاغ اللاعب بعدد الجولات والمبلغ لكل رهان والفترة الزمنية إذا وجدت.',
'bonus_rounds_p2': 'بمجرد منحها، يمكن للاعب اختيار وقت بدء الجولة. بعد البدء، يتم وضع رهان تلقائي بالمبلغ المحدد.',
'bonus_rounds_p3': 'قد يكون لجولات المكافأة حد زمني، وبعده تصبح غير صالحة.',
'bonus_rounds_p4': 'قد يؤدي خمول اللاعب إلى إلغاء الجولة النشطة. في هذه الحالة، يتم تقليل عدد جولات المكافأة ويظل رصيد اللاعب كما هو.',
'valid_until': 'صالحة حتى',
'bonus': 'مكافأة',
'rounds': 'الجولات',
'win_eur': 'فوز EUR',
'complete_your_bet': 'يرجى إتمام رهانك أولاً',
'complete_auto_play': 'يرجى إتمام اللعب التلقائي أولاً',
'yes': 'نعم',
'no': 'لا',
'play_bonus_rounds': 'هل تريد لعب جولات المكافأة؟',
'bet_history': 'سجل الرهانات',
'jackpot_history': 'سجل الجاكبوت',
'ticket_id': 'رقم التذكرة',
'created': 'وقت الإنشاء',
'currency': 'العملة',
'bet': 'رهان',
'bet_eur': 'رهان EUR',
'lanes': 'المسارات',
'cars': 'السيارات',
'multiplier': 'المضاعف',
'win': 'فوز',
'no_betting_history': 'لا يوجد سجل رهانات. ضع رهاناً وسيظهر هنا.',
'no_jackpot_history': 'لا يوجد سجل جاكبوت.',
'date': 'التاريخ',
'user': 'المستخدم',
'bet_already_active': 'الرهان نشط بالفعل',
'please_play_the_game_in_portait_mode': 'يرجى لعب اللعبة في وضع العمودي.',
'bonus_history': 'سجل المكافآت',
'bonus_type': 'نوع المكافأة',
'no_bonus_history': 'لا يوجد سجل مكافآت.',
'game_menu': 'قائمة اللعبة',
'game_menu_ss': 'من اليسار: الصفحة الرئيسية، سجل الرهانات، قواعد اللعبة، اختصارات لوحة المفاتيح، إعدادات الصوت والموسيقى',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'قواعد اللعبة',
'game_rules_p1': 'مرحبًا بك في بلينكو – حيث يقودك الحظ!',
'game_rules_p2': 'استعد للعبة حظ مثيرة وبسيطة ولكنها تسبب الإدمان! بلينكو هي لعبة تسقط فيها كرة على هرم مليء بالمسامير، وتشاهدها ترتد وتدور وتقفز حتى تصل إلى فتحة تحتوي على جائزة في الأسفل.',
'game_rules_p3': 'اختر بين 8 إلى 16 صفًا من المسامير، ثم استرخِ وشاهد الكرة وهي تتمايل على اللوحة، مدفوعة فقط بالجاذبية والحظ.',
'game_rules_p4': 'هل ستهبط في خانة ذات مكافأة منخفضة... أم تحقق الفوز الكبير؟ الطريقة الوحيدة لمعرفة ذلك هي إسقاط الكرة ودع الحماس يبدأ!',
'general': 'عام',
'general_p1': 'أسقط كرة بلينكو وامل أن تهبط في إحدى الخانات ذات المكافآت العالية في الأسفل. المسار غير متوقع — كل ارتداد يمكن أن يغير مصيرك.',
'general_p2': 'كلما زاد عدد الصفوف، زادت الإثارة!',
'general_p3': 'إذن انطلق — ثق بحظك، اضغط على DROP، وطارد الفوز الكبير بين مسامير بلينكو!',
'betting': 'المراهنة',
'betting_p1': 'اختر مبلغ الرهان. يمكن استخدام الأزرار “1/2”، “2x”، “Max” للتحكم في حجم الرهان. يمكن أيضًا إدخال مبلغ الرهان يدويًا.',
'betting_p2': 'اختر مستوى المخاطرة: منخفض، متوسط أو مرتفع. مستوى المخاطرة المنخفض يعطي نتائج أكثر استقرارًا (تقلب منخفض)، بينما المستوى المرتفع يعطي تباينًا أكبر (تقلب مرتفع).',
'betting_p3': 'اختر عدد الخطوط في اللعبة: من 8 إلى 16. اختر عدد صفوف المسامير التي ستسقط الكرة عبرها. عدد صفوف أكبر = عدم قابلية أكبر للتنبؤ.',
'betting_p4': 'اختر وضع الرهان: يدوي أو تلقائي.',
'betting_p5': 'لبدء جولة اللعب، اضغط على زر DROP BALL. أثناء الجولة تصبح جميع أزرار الرهان غير نشطة باستثناء DROP BALL ومبلغ الرهان.',
'betting_p6': 'تمثل كرة بلينكو واحدة جولة واحدة. أثناء الجولة يمكن بدء جولة أخرى بنفس الإعدادات باستخدام زر DROP BALL. يمكن تغيير مبلغ الرهان أثناء وجود كرات نشطة على اللوحة، ولكن لا يمكن تغيير صعوبة اللعبة.',
'betting_p7': 'في نهاية الجولة تصل الكرة إلى الجيب. يتم عرض مضاعف الدفع على كل جيب.',
'betting_p8': 'يتم احتساب الربح وفقًا للمضاعف الذي هبطت عليه الكرة. تتم إضافة النتيجة إلى الرصيد.',
'game_menu_p1': 'يتم عرض أحدث مضاعفات الرهان في الجزء السفلي من نافذة اللعبة.',
'game_menu_p2': 'من خلال زر “Bet history” يمكن للاعب مراجعة رهاناته الأخيرة بمزيد من التفاصيل.',
'game_menu_p3': 'للاطلاع على سجل لعب أطول (مثل فترات زمنية أطول)، قد يحتاج اللاعب إلى الوصول إلى سجل اللاعب داخل منصة اللعب نفسها.',
'game_menu_p4': 'من خلال قائمة اللعبة، يمكن للاعبين التحكم في إعدادات الصوت واختصارات لوحة المفاتيح وفتح سجل الرهانات وقواعد اللعبة.',
'game_menu_p5': 'تم تصميم اللعبة مع موسيقى خلفية جميلة وتأثيرات صوتية. يمكن تعطيل الموسيقى و/أو التأثيرات الصوتية من خلال أيقونات قائمة اللعبة.',
'game_menu_p6': 'سيعرض سجل اللعبة نافذة تحتوي على الرهانات السابقة وسجل المكافآت.',
'autoplay': 'الوضع التلقائي (Autoplay)',
'autoplay_p1': 'النقر على Auto يسمح لك بإسقاط عدد من الكرات تلقائيًا دون الحاجة إلى النقر في كل مرة.',
'autoplay_p2': 'اختر المبلغ الذي تريد المراهنة به لكل كرة.',
'autoplay_p3': 'حدد عدد المرات (الجولات) التي تريد أن تسقط فيها الكرة — حتى 100 جولة كحد أقصى.',
'autoplay_p4': 'اضغط على زر START للبدء وسيتغير الزر إلى STOP.',
'autoplay_p5': 'سيتوقف الوضع التلقائي عند اكتمال عدد الإسقاطات المحدد أو نفاد الرصيد أو النقر على زر STOP.',
'autoplay_p6': 'كل إسقاط يستخدم نفس مبلغ الرهان الذي اخترته قبل بدء الوضع التلقائي.',
'turbo_mode': 'وضع التيربو',
'turbo_mode_p1': 'يتيح لك Turbo Drop إسقاط الكرات بسرعة فائقة من خلال الضغط المستمر على زر DROP.',
'turbo_mode_p2': 'ستستمر الكرات في السقوط حتى تترك الزر أو ينفد الرصيد.',
'turbo_mode_p3': 'ستستمر الكرات في السقوط حتى تترك الزر أو ينفد الرصيد.',
'turbo_balance': 'رصيد التيربو',
'turbo_balance_p1': 'قبل بدء Turbo Drop، تختار المبلغ الذي تريد تخصيصه — ليصبح رصيد التيربو الخاص بك.',
'turbo_balance_p2': 'أثناء تفعيل Turbo Drop، تستخدم اللعبة رصيد التيربو فقط للرهانات والأرباح.',
'turbo_balance_p3': 'عند إيقاف Turbo Drop، يتم إرجاع أي رصيد تيربو متبقٍ إلى رصيدك الأساسي.',
'turbo_balance_p4': 'يمكنك الخروج من Turbo Drop في أي وقت — لكن الوضع سينتهي بالكامل فقط بعد أن تنتهي جميع الكرات من السقوط وتستقر في جيوب المضاعفات.',
'free_bets': 'جولات المكافآت',
'free_bets_p1': 'يتم منح جولات المكافآت من قبل المشغل.',
'fairness': 'العدالة',
'fairness_p1': 'كل إسقاط يتم تحديده بواسطة مولد أرقام عشوائية يمكن التحقق من عدالته (RNG).',
'fairness_p2': 'لا يمكن التنبؤ بالنتيجة أو التأثير عليها بعد إسقاط الكرة.',
'disconection_and_error': 'سياسة الانفصال والتعامل مع الأخطاء',
'disconection_and_error_p1': 'إذا تم فقدان الاتصال بعد وضع الرهان، فلن يتم إلغاؤه. إذا كانت اللعبة تتطلب إجراءً من اللاعب، يتم اعتبار أنه اختار الإجراء الأقل مخاطرة دون زيادة الرهان.',
'disconection_and_error_p2': 'في حالة حدوث خطأ، سيحاول فريق الدعم حل المشكلة في أسرع وقت ممكن واستئناف اللعبة. في حال وجود خلل في اللعبة نفسها، سيتم إلغاء جميع الرهانات وإعادة المبلغ للاعب.',
'other': 'أخرى',
'other_p1': 'في حالة وجود خلل في الجهاز أو البرنامج، يتم اعتبار جميع الرهانات والمدفوعات المتأثرة لاغية ويتم رد الأموال.',
'other_p2': 'قواعد اللعبة منشورة باللغة الإنجليزية. الترجمة إلى لغات أخرى متوفرة كخدمة بحسن نية. في حال وجود تعارض بين النسخة الإنجليزية والترجمة، تكون النسخة الإنجليزية هي المعتمدة.',
'rows': 'صفوف',
'lvl': 'مستوى',
'low': 'منخفض',
'high': 'عالٍ',
'ok': 'OK',
'exit_turbo_mode': 'هل تريد الخروج من وضع Turbo؟',
"end": "النهاية",
"turbo_mode_settings": "إعدادات وضع التيربو",
"stop": "إيقاف",
'invalid_bet_amount': 'مبلغ الرهان غير صالح',
'cashout_success': 'تم السحب بنجاح'
,'stop_auto_play_first': 'يرجى إيقاف اللعب التلقائي أولاً.',
'turbo_only_when_no_balls': 'يمكن بدء وضع التيربو فقط عندما لا توجد كرات على اللوحة.',
'type': 'نوع العملة',
'wait_balls_to_finish': 'يرجى الانتظار حتى تنتهي الكرات.',
'bet_too_large_top_up_turbo_balance': 'الرهان كبير جدًا — قم بزيادة رصيد التيربو الخاص بك!',

};
langArr.bg = {
'loading': 'Зареждане',
'hotkeys': 'Бързи клавиши',
'hotkeys_enabled': 'Бързите клавиши са активирани',
'enable_hotkeys_checkbox': 'Активирайте бързите клавиши по-долу, като отметнете това поле.',
'drop_ball': 'Пусни топката',
'double_bet': 'Удвой залога',
'halve_bet': 'Половина залог',
'min_bet': 'Минимален залог',
'max': 'Макс',
'easy': 'Лесно',
'medium': 'Средно',
'hard': 'Трудно',
'daredevil': 'Смелчага',
'max_profit': 'Макс печалба',
'manual': 'Ръчно',
'auto': 'Авто',
'bet_amount': 'Сума на залога',
'difficulty': 'Трудност',
'payout_on_win': 'Плащане при победа',
'number_of_bets': 'Брой залози',
'on_win': 'При печалба',
'on_loss': 'При загуба',
'stop_on_profit': 'Спри при печалба',
'stop_on_loss': 'Спри при загуба',
'reset': 'Нулиране',
'increase_by': 'Увеличи с',
'cashout': 'ИЗТЕГЛЯНЕ',
'start_game': 'ЗАЛОГ',
'start_auto_game': 'СТАРТ',
'difficulity_info': 'Информация за трудността',
'chance_collision': 'Вероятност за сблъсък на игра',
'evry_25_lane': 'за всеки 25 ленти',
'insufficiend_funds': 'Недостатъчни средства',
'cashout_inactivity': 'Автоматично изтегляне при бездействие',
'time_running_out': 'Времето изтича! Играйте сега или вашият билет ще бъде изтеглен автоматично за 30 сек',
'there_was_error': 'ВЪЗНИКНА ГРЕШКА, МОЛЯ ОПИТАЙТЕ ОТНОВО ИЛИ РЕФРЕШНЕТЕ',
'detailed_game_rules': 'Подробни правила на играта',
'general_rules': 'ОБЩИ ПРАВИЛА',
'general_rules_p1': '• Мултипликаторът започва от 1 и достига до ',
'general_rules_p2': '• Печалбите се изчисляват чрез умножаване на залога с показания мултипликатор на всяка стъпка.',
'general_rules_p3': '• Ако се достигне максимално плащане, играта автоматично изплаща максималния размер.',
'progressive_jackpot': 'ПРОГРЕСИВЕН ДЖАКПОТ',
'progressive_jackpot_ss': 'Лента на джакпота и възможна печалба',
'progressive_jackpot_p1': '% от всеки залог се отделя за прогресивния джакпот.',
'progressive_jackpot_p2': 'Джакпотът се дава чрез механика "Mystery" или "must-hit-by". Стойността на всеки "must-hit-by" джакпот се определя веднага след предишния джакпот чрез генератор на случайни числа и се съхранява криптирано.',
'progressive_jackpot_p3': 'След достигане на "must-hit-by", първият играч, който залага след това, има шанс да спечели джакпота. Символът на джакпота се появява на произволна лента и се печели ако играчът достигне лентата със символа.',
'progressive_jackpot_p4': 'ЗАБЕЛЕЖКА: Бонус рундът не допринася за джакпота. По време на бонуса джакпотът не може да се спечели.',
'showdown': 'ПОКАЗВАНЕ',
'showdown_ss': 'Червен квадрат, място на потенциален сблъсък',
'showdown_p1': 'След като играчът изтегли печалбата, червен квадрат ще се покаже там, където щеше да има сблъсък при продължаване.',
'return_to_player': 'ВЪРНАТ НА ИГРАЧА',
'return_to_player_p1': 'Общият теоретичен процент на възвръщаемост (RTP) е ',
'return_to_player_p2': 'Процентите на RTP се наблюдават и проверяват непрекъснато от независими страни.',
'disconnection_policy': 'ПОЛИТИКА ПРИ РАЗКЪСВАНЕ НА ВРЪЗКАТА',
'disconnection_policy_p1': 'Ако връзката се загуби след залог, залогът няма да бъде отменен веднага. Ако бездействието на играча достигне ',
'disconnection_policy_p2': 'залогът ще бъде автоматично изтеглен и кредити ще бъдат добавени в сметката на играча.',
'network_latency': 'ЗАКЪСНЕНИЕ НА МРЕЖАТА',
'network_latency_p1': 'Закъснението в мрежата е неизбежна част от интернет свързаността. Всички залози и изтегляния се считат за валидни само когато достигнат нашия сървър, независимо от продължителността на закъснението.',
'sound': 'ЗВУК',
'sound_p1': 'Играта е проектирана с красива музика и звукови ефекти. Ако желаете да изключите музика или ефекти, може да го направите от иконите на менюто.',
'error_handling': 'ОБРАБОТКА НА ГРЕШКИ',
'error_handling_p1': 'В случай на грешка нашият екип ще се опита да я разреши възможно най-скоро и да продължи с нормалната игра. Ако проблемът е в самата игра, всички залози се отменят и залогът се връща на играчите.',
'max_payout': 'Максималното плащане е ',
'max_bet_is': 'Максималният залог е ',
'min_bet_is': 'Минималният залог е ',
'per_bet': 'на залог.',
'malfunction_voids': 'Грешката анулира всички плащания и игри.',
'attention_jackpot': 'Внимание, Джакпот на лента ',
'lane': 'лента',
'congratulations': 'Поздравления',
'you_won': 'спечелихте',
'balance': 'баланс',
'time': 'време',
'jackpot': 'джакпот',
'escaped': 'ИЗБЯГАНО',
'max_win': 'МАКС ФИНАЛ',
'check_internet': 'Моля, проверете интернет връзката',
'websocket_disconected': 'Websocket прекъснат',
'websocket_connection_error': 'Грешка при свързване на Websocket!',
'session_expired': 'Сесията е изтекла, моля презаредете',
'remaining_bets': 'Оставащи залози',
'stop_autoplay': 'СПРИ',
'autoplay_and_autocashout': 'АВТОПЛЕЙ И АВТОИЗТЕГЛЯНЕ',
'autoplay_and_autocashout_ss': 'Избор между ръчен и автоматичен режим',
'autoplay_and_autocashout_p1': 'Играчът може да активира автоматичен режим, където залогът се поставя автоматично за всеки нов рунд, използвайки сумата от предишния залог.',
'autoplay_and_autocashout_p2': 'Може да се избере мултипликатор за автоматично изтегляне и при достигане играта автоматично ще изтегли, ако играчът не е засегнат преди достигането на избрания мултипликатор.',
'autoplay_and_autocashout_p3': 'Максимален брой автоматични рундове е ',
'autoplay_button_label': 'За да започнете, изберете лента.',
'min_bet_amount_is': 'Минималният залог е',
'bonus_rounds': 'бонус рундове',
'bonus_rounds_ss': 'Бонус рундове с валидност',
'bonus_rounds_p1': 'Играчът може да получи бонус рунд (безплатен залог) според промоция на казиното. Появява се изскачащ прозорец с информация за броя бонус рундове, залог на рунд и период на валидност.',
'bonus_rounds_p2': 'След предоставяне на бонус рундовете, играчът може да избере кога да започне. След стартиране се поставя автоматичен залог и играчът може да изтегли печалбата по всяко време.',
'bonus_rounds_p3': 'Бонус рундовете могат да имат времеви лимит, след който стават невалидни.',
'bonus_rounds_p4': 'Бездействието на играча може да доведе до анулиране на активен бонус рунд. В този случай броят на бонус рундовете се намалява, а балансът остава същият.',
'valid_until': 'валиден до',
'bonus': 'бонус',
'rounds': 'рундове',
'win_eur': 'печалба EUR',
'complete_your_bet': 'Моля, завършете първо вашия залог',
'complete_auto_play': 'Моля, завършете първо автоматичната игра',
'yes': 'да',
'no': 'не',
'play_bonus_rounds': 'Искате ли да играете бонус рундове?',
'bet_history': 'История на залозите',
'jackpot_history': 'История на джакпота',
'ticket_id': 'ID на билет',
'created': 'време на създаване',
'currency': 'валута',
'bet': 'залог',
'bet_eur': 'залог EUR',
'lanes': 'ленти',
'cars': 'коли',
'multiplier': 'мултипликатор',
'win': 'печалба',
'no_betting_history': 'Няма история на залозите. Направете залог и ще се появи тук.',
'no_jackpot_history': 'Няма налична история на джакпота.',
'date': 'дата',
'user': 'потребител',
'bet_already_active': 'Залогът вече е активен',
'please_play_the_game_in_portait_mode': 'Моля, играйте в портретен режим.',
'bonus_history': 'История на бонусите',
'bonus_type': 'Тип бонус',
'no_bonus_history': 'Няма налична история на бонусите.',
'game_menu': 'Меню на играта',
'game_menu_ss': 'Отляво: Начало, История на залозите, Правила на играта, Бързи клавиши, Настройки на звук и музика',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'ПРАВИЛА НА ИГРАТА',
'game_rules_p1': 'Добре дошли в Plinko – където късметът води!',
'game_rules_p2': 'Пригответе се за вълнуваща игра на късмет, която е толкова проста, колкото и пристрастяваща! Plinko е игра, в която пускате топче върху пирамида с щифтове и наблюдавате как то отскача, върти се и отскача по пътя си надолу към награден слот в основата.',
'game_rules_p3': 'Изберете между 8 и 16 реда щифтове, след което се отпуснете и се насладете на хаоса, докато топчето се движи зигзагообразно по дъската, движено само от гравитацията и късмета.',
'game_rules_p4': 'Ще се приземи ли в слот с ниска печалба… или ще уцели голямата печалба? Има само един начин да разберете — пуснете топчето и нека вълнението започне!',
'general': 'ОБЩО',
'general_p1': 'Пуснете топчето Plinko и се надявайте да се приземи в някой от слотовете с високи печалби в долната част. Пътят е непредсказуем — всеки отскок може да промени съдбата ви.',
'general_p2': 'Колкото повече редове играете, толкова по-интензивно е действието!',
'general_p3': 'Затова напред — доверете се на късмета си, натиснете DROP и гонете голямата печалба през щифтовете на Plinko!',
'betting': 'ЗАЛОГ',
'betting_p1': 'Изберете сумата на залога. Бутоните “1/2”, “2x”, “Max” могат да се използват за управление на размера на залога. Сумата на залога може да бъде въведена и ръчно.',
'betting_p2': 'Изберете ниво на риск: ниско, средно или високо. По-ниското ниво на риск дава по-последователни резултати (ниска волатилност), докато по-високото дава по-голяма вариация (висока волатилност).',
'betting_p3': 'Изберете броя на линиите в играта: от 8 до 16. Изберете през колко реда с пинове ще премине топката. Повече редове = по-голяма непредсказуемост.',
'betting_p4': 'Изберете режим на залагане: ръчен или автоматичен.',
'betting_p5': 'За да започнете рунда на играта, натиснете бутона DROP BALL. По време на рунда всички бутони за залагане стават неактивни, с изключение на DROP BALL и сумата на залога.',
'betting_p6': 'Една Plinko топка представлява един рунд. По време на рунда може да се започне друг рунд със същите настройки чрез бутона DROP BALL. Възможно е да се промени сумата на залога, докато има активни топки на таблото, но не и трудността на играта.',
'betting_p7': 'В края на рунда топката достига джоба. На всеки джоб е показан мултипликаторът на изплащане.',
'betting_p8': 'Изчисляването на печалбата се извършва според мултипликатора, на който е попаднала топката. Резултатът се добавя към баланса.',
'game_menu_p1': 'Най-новите мултипликатори на залози се показват в долната част на прозореца на играта.',
'game_menu_p2': 'Чрез бутона “Bet history” играчът може да прегледа последните си залози по-подробно.',
'game_menu_p3': 'За по-дълга история на играта (напр. по-дълги периоди) играчът може да трябва да достъпи историята си в самата платформа за игри.',
'game_menu_p4': 'Чрез менюто на играта играчите могат да контролират звуковите настройки, клавишните комбинации и да отворят историята на залозите и правилата на играта.',
'game_menu_p5': 'Играта е проектирана с красива фонова музика и звукови ефекти. Музиката и/или звуковите ефекти могат да бъдат изключени чрез иконите в менюто на играта.',
'game_menu_p6': 'Историята на играта ще покаже прозорец с предишни залози и история на бонусите.',
'autoplay': 'Автоматичен режим (Autoplay)',
'autoplay_p1': 'Кликването върху Auto ви позволява автоматично да пускате определен брой топки без да натискате всеки път.',
'autoplay_p2': 'Изберете сумата, която искате да залагате за всяка топка.',
'autoplay_p3': 'Изберете колко пъти (рундове) искате топката да падне — до максимум 100 рунда.',
'autoplay_p4': 'Натиснете бутона START, за да започнете, и бутонът ще се промени на STOP.',
'autoplay_p5': 'Автоматичният режим ще спре, когато избраният брой пускания приключи, средствата свършат или натиснете STOP.',
'autoplay_p6': 'Всяко пускане използва същата сума на залога, която сте избрали преди да стартирате автоматичния режим.',
'turbo_mode': 'Турбо режим',
'turbo_mode_p1': 'Turbo Drop ви позволява да пускате топките изключително бързо, като задържите бутона DROP.',
'turbo_mode_p2': 'Топките ще продължат да падат, докато пуснете бутона или балансът се изчерпа.',
'turbo_mode_p3': 'Топките ще продължат да падат, докато пуснете бутона или балансът се изчерпа.',
'turbo_balance': 'Турбо баланс',
'turbo_balance_p1': 'Преди да започнете Turbo Drop, избирате колко пари да заделите — това става вашият Турбо баланс.',
'turbo_balance_p2': 'Докато Turbo Drop е активен, играта използва само вашия Турбо баланс за залози и печалби.',
'turbo_balance_p3': 'Когато спрете Turbo Drop, останалият Турбо баланс се връща към основния ви баланс.',
'turbo_balance_p4': 'Можете да излезете от Turbo Drop по всяко време — но режимът ще приключи напълно едва след като всички топки завършат падането си и попаднат в джобовете.',
'free_bets': 'БОНУС РУНДОВЕ',
'free_bets_p1': 'Бонус рундовете се предоставят от оператора.',
'fairness': 'Честност',
'fairness_p1': 'Всяко пускане се определя от доказуемо честен генератор на случайни числа (RNG).',
'fairness_p2': 'Резултатът не може да бъде предсказан или манипулиран след пускането на топчето.',
'disconection_and_error': 'Политика при прекъсване и обработка на грешки',
'disconection_and_error_p1': 'Ако връзката се изгуби след поставяне на залог, залогът няма да бъде отменен. Ако играта изисква действие от играча, резултатът се брои като че ли играчът е избрал действие без риск без да увеличава залога.',
'disconection_and_error_p2': 'В случай на грешка нашият екип за поддръжка ще се опита да реши проблема възможно най-бързо и да възобнови играта. В случай на проблем с играта, всички залози ще бъдат анулирани и сумата върната на играчите.',
'other': 'Други',
'other_p1': 'В случай на неизправност на хардуера/софтуера, всички засегнати залози и изплащания се обявяват за невалидни и сумите се връщат.',
'other_p2': 'Правилата на играта са публикувани на английски език. Преводите на други езици се предоставят като услуга с добри намерения. В случай на неяснота между английската версия и превода, английската версия има предимство.',
'rows': 'Редове',
'lvl': 'Ниво',
'low': 'Ниско',
'high': 'Високо',
'ok': 'OK',
'exit_turbo_mode': 'Искате ли да излезете от Turbo режим?',
"end": "КРАЙ",
"turbo_mode_settings": "Настройки на Turbo режим",
"stop": "СПРИ",
'invalid_bet_amount': 'Невалидна сума на залога',
'cashout_success': 'Успешно изтегляне',
'stop_auto_play_first': 'Моля, първо спрете автоматичната игра.',
'turbo_only_when_no_balls': 'Turbo режим може да се стартира само когато няма топки на таблото.',
'type': 'Тип залог',
'wait_balls_to_finish': 'Моля, изчакайте топките да завършат.',
'bet_too_large_top_up_turbo_balance': 'Залогът е твърде голям — увеличете вашия Турбо баланс!',

};
langArr.de = {
'loading': 'Lädt',
'hotkeys': 'Tastenkürzel',
'hotkeys_enabled': 'Tastenkürzel aktiviert',
'enable_hotkeys_checkbox': 'Aktivieren Sie die unten angezeigten Tastenkürzel, indem Sie dieses Kästchen markieren.',
'drop_ball': 'Ball fallen lassen',
'double_bet': 'Einsatz verdoppeln',
'halve_bet': 'Einsatz halbieren',
'min_bet': 'Mindesteinsatz',
'max': 'Max',
'easy': 'Einfach',
'medium': 'Mittel',
'hard': 'Schwer',
'daredevil': 'Waghalsig',
'max_profit': 'Maximaler Gewinn',
'manual': 'Manuell',
'auto': 'Automatisch',
'bet_amount': 'Einsatzhöhe',
'difficulty': 'Schwierigkeit',
'payout_on_win': 'Auszahlung bei Gewinn',
'number_of_bets': 'Anzahl der Einsätze',
'on_win': 'Bei Gewinn',
'on_loss': 'Bei Verlust',
'stop_on_profit': 'Bei Gewinn stoppen',
'stop_on_loss': 'Bei Verlust stoppen',
'reset': 'Zurücksetzen',
'increase_by': 'Erhöhen um',
'cashout': 'AUSZAHLEN',
'start_game': 'SETZEN',
'start_auto_game': 'START',
'difficulity_info': 'Schwierigkeitsinfo',
'chance_collision': 'Kollisionswahrscheinlichkeit pro Spiel',
'evry_25_lane': 'für jede 25 Bahnen',
'insufficiend_funds': 'Unzureichende Mittel',
'cashout_inactivity': 'Automatisches Auszahlen bei Inaktivität',
'time_running_out': 'Die Zeit läuft ab! Spiele jetzt oder dein Ticket wird in 30 Sekunden automatisch zurückgezogen',
'there_was_error': 'ES IST EIN FEHLER AUFGETRETEN, BITTE ERNEUT VERSUCHEN ODER SEITE NEU LADEN',
'detailed_game_rules': 'Detaillierte Spielregeln',
'general_rules': 'ALLGEMEINE REGELN',
'general_rules_p1': '• Der Multiplikator startet bei 1 und steigt bis ',
'general_rules_p2': '• Gewinne werden berechnet, indem der Einsatz mit dem auf jedem Schritt angezeigten Multiplikator multipliziert wird.',
'general_rules_p3': '• Wenn der maximale Gewinn erreicht wird, erfolgt die automatische Auszahlung zum maximalen Betrag.',
'progressive_jackpot': 'PROGRESSIVER JACKPOT',
'progressive_jackpot_ss': 'Jackpot-Bahn und möglicher Gewinn',
'progressive_jackpot_p1': '% jedes Einsatzes wird dem progressiven Jackpot-Fonds zugewiesen.',
'progressive_jackpot_p2': 'Jackpot wird über „Mystery“- oder „must-hit-by“-Mechanik vergeben. Der Wert jedes „must-hit-by“-Jackpots wird unmittelbar nach dem vorherigen Jackpot durch einen Zufallszahlengenerator bestimmt und verschlüsselt in der Datenbank gespeichert.',
'progressive_jackpot_p3': 'Sobald der „must-hit-by“-Wert erreicht ist, hat der erste Spieler, der danach setzt, die Chance auf den Jackpot. Ein Jackpot-Symbol erscheint auf einer zufälligen Bahn, und der Jackpot wird gewonnen, wenn der Spieler diese Bahn erreicht.',
'progressive_jackpot_p4': 'HINWEIS: Die Bonusrunde trägt nicht zum Jackpot-Fonds bei. Während der Bonusrunde kann kein Jackpot gewonnen werden.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Rotes Quadrat, Ort der möglichen Kollision',
'showdown_p1': 'Nach Auszahlung des Spielers wird ein rotes Quadrat an der Stelle angezeigt, an der die Kollision aufgetreten wäre, wenn der Spieler weiter Bahnen übersprungen hätte.',
'return_to_player': 'RÜCKZAHLUNG AN SPIELER',
'return_to_player_p1': 'Der theoretische Gesamtrückzahlungswert für den Spieler (RTP) beträgt ',
'return_to_player_p2': 'Die RTP-Prozentsätze werden kontinuierlich überwacht und von unabhängigen Dritten überprüft.',
'disconnection_policy': 'VERBINDUNGSPOLITIK',
'disconnection_policy_p1': 'Wenn die Verbindung nach dem Setzen eines Einsatzes unterbrochen wird, wird der Einsatz nicht sofort storniert. Wenn die Inaktivität des Spielers ',
'disconnection_policy_p2': 'erreicht, wird der Einsatz automatisch ausgezahlt und dem Spielerkonto gutgeschrieben.',
'network_latency': 'NETZWERKVERZÖGERUNG',
'network_latency_p1': 'Netzwerkverzögerungen sind ein unvermeidbarer Teil der Internetverbindung. Wir betrachten alle Einsätze und Auszahlungen nur zum Zeitpunkt des Servereingangs als gültig, unabhängig von der Dauer der Verzögerung.',
'sound': 'TON',
'sound_p1': 'Das Spiel ist mit schöner Hintergrundmusik und Soundeffekten gestaltet. Sie können Musik und/oder Soundeffekte über die Spielmenü-Symbole deaktivieren.',
'error_handling': 'FEHLERBEHANDLUNG',
'error_handling_p1': 'Im Falle eines Fehlers wird unser Support-Team versuchen, das Problem so schnell wie möglich zu lösen, und das Spiel fortzusetzen. Bei Problemen mit dem Spiel selbst werden alle Einsätze storniert und die Einsatzbeträge an die Spieler zurückerstattet.',
'max_payout': 'Maximale Auszahlung ist ',
'max_bet_is': 'Maximaler Einsatz ist ',
'min_bet_is': 'Mindestbetrag ist ',
'per_bet': 'pro Einsatz.',
'malfunction_voids': 'Fehler machen alle Zahlungen und Spiele ungültig.',
'attention_jackpot': 'Achtung, Jackpot auf Bahn ',
'lane': 'Bahn',
'congratulations': 'Glückwunsch',
'you_won': 'Du hast gewonnen',
'balance': 'Kontostand',
'time': 'Zeit',
'jackpot': 'Jackpot',
'escaped': 'ENTKOMMEN',
'max_win': 'MAX GEWINN',
'check_internet': 'Bitte überprüfen Sie Ihre Internetverbindung',
'websocket_disconected': 'Websocket getrennt',
'websocket_connection_error': 'Websocket-Verbindungsfehler!',
'session_expired': 'Sitzung abgelaufen, bitte neu laden',
'remaining_bets': 'Verbleibende Einsätze',
'stop_autoplay': 'STOPP',
'autoplay_and_autocashout': 'AUTOPLAY UND AUTOAUSZAHLUNG',
'autoplay_and_autocashout_ss': 'Auswahl zwischen manuell und Autoplay',
'autoplay_and_autocashout_p1': 'Ein Spieler kann die Autoplay-Option aktivieren, bei der für jede neue Runde automatisch ein Einsatz in der Höhe des vorherigen Einsatzes gesetzt wird.',
'autoplay_and_autocashout_p2': 'Ein Auto-Cashout-Multiplikator kann ausgewählt werden, und bei Aktivierung wird das Spiel automatisch auszahlen, wenn der Spieler vor Erreichen des ausgewählten Multiplikators nicht getroffen wird.',
'autoplay_and_autocashout_p3': 'Die maximale Anzahl an Autoplay-Runden ist ',
'autoplay_button_label': 'Wählen Sie zum Starten eine Bahn.',
'min_bet_amount_is': 'Mindestbetrag ist',
'bonus_rounds': 'Bonusrunden',
'bonus_rounds_ss': 'Bonusrunden mit Gültigkeitszeitraum',
'bonus_rounds_p1': 'Ein Spieler kann eine Bonusrunde (z. B. Gratiswette) basierend auf einer Casino-Promotion erhalten. Ein Popup zeigt die Anzahl der Runden, Einsatzhöhe und ggf. den Gültigkeitszeitraum an.',
'bonus_rounds_p2': 'Nach der Vergabe kann der Spieler wählen, wann die Bonusrunde gestartet wird. Nach Start wird automatisch ein Einsatz mit dem festgelegten Betrag platziert.',
'bonus_rounds_p3': 'Bonusrunden können eine zeitliche Begrenzung haben, nach deren Ablauf sie ungültig werden.',
'bonus_rounds_p4': 'Inaktivität des Spielers kann zur Stornierung einer aktiven Bonusrunde führen. In diesem Fall wird die Anzahl der Bonusrunden verringert und der Kontostand bleibt unverändert.',
'valid_until': 'gültig bis',
'bonus': 'Bonus',
'rounds': 'Runden',
'win_eur': 'Gewinn EUR',
'complete_your_bet': 'Bitte setzen Sie zuerst Ihren Einsatz',
'complete_auto_play': 'Bitte schließen Sie zuerst das Autoplay ab',
'yes': 'ja',
'no': 'nein',
'play_bonus_rounds': 'Bonusrunden spielen?',
'bet_history': 'Einsatzhistorie',
'jackpot_history': 'Jackpothistorie',
'ticket_id': 'Ticket-ID',
'created': 'Erstellungszeit',
'currency': 'Währung',
'bet': 'Einsatz',
'bet_eur': 'Einsatz EUR',
'lanes': 'Bahnen',
'cars': 'Autos',
'multiplier': 'Multiplikator',
'win': 'Gewinn',
'no_betting_history': 'Keine Einsatzhistorie gefunden. Machen Sie einen Einsatz, dann erscheint er hier.',
'no_jackpot_history': 'Keine Jackpothistorie verfügbar.',
'date': 'Datum',
'user': 'Spieler',
'bet_already_active': 'Einsatz bereits aktiv',
'please_play_the_game_in_portait_mode': 'Bitte spielen Sie das Spiel im Hochformat.',
'bonus_history': 'Bonushistorie',
'bonus_type': 'Bonustyp',
'no_bonus_history': 'Keine Bonushistorie verfügbar.',
'game_menu': 'Spielmenü',
'game_menu_ss': 'Von links: Startseite, Einsatzhistorie, Spielregeln, Tastenkürzel, Sound- und Musikeinstellungen',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'SPIELREGELN',
'game_rules_p1': 'Willkommen bei Plinko – Wo das Glück den Ton angibt!',
'game_rules_p2': 'Mach dich bereit für ein aufregendes Glücksspiel, das so einfach wie süchtig machend ist! Bei Plinko lässt du eine Kugel auf eine mit Stiften gefüllte Pyramide fallen und beobachtest, wie sie springt, dreht und ihren Weg nach unten in einen gewinnbringenden Slot am Boden findet.',
'game_rules_p3': 'Wähle zwischen 8 und 16 Reihen von Stiften, lehne dich zurück und genieße das Chaos, während die Kugel zickzackförmig über das Spielfeld hüpft, nur geleitet von Schwerkraft und Glück.',
'game_rules_p4': 'Wird sie in einem niedrig bezahlten Slot landen... oder den großen Gewinn erzielen? Es gibt nur eine Möglichkeit, das herauszufinden – wirf die Kugel und lass die Spannung beginnen!',
'general': 'ALLGEMEIN',
'general_p1': 'Lass die Plinko-Kugel fallen und hoffe, dass sie in einem der hochbezahlten Slots am unteren Rand landet. Der Weg ist unvorhersehbar – jeder Sprung kann dein Schicksal verändern.',
'general_p2': 'Je mehr Reihen du spielst, desto intensiver wird das Spiel!',
'general_p3': 'Also los – vertraue deinem Glück, drücke DROP und jage den großen Gewinn durch die Stifte von Plinko!',
'betting': 'WETTEN',
'betting_p1': 'Wählen Sie den Einsatzbetrag. Die Schaltflächen “1/2”, “2x”, “Max” können verwendet werden, um die Einsatzhöhe zu steuern. Der Einsatzbetrag kann auch manuell eingegeben werden.',
'betting_p2': 'Wählen Sie das Risikoniveau: Niedrig, Mittel oder Hoch. Ein niedrigeres Risikoniveau bietet konstantere Ergebnisse (geringe Volatilität), während ein höheres mehr Schwankungen (hohe Volatilität) bietet.',
'betting_p3': 'Wählen Sie die Anzahl der Linien im Spiel: von 8 bis 16. Wählen Sie, durch wie viele Reihen von Stiften der Ball fällt. Mehr Reihen = mehr Unvorhersehbarkeit.',
'betting_p4': 'Wählen Sie den Wettmodus: Manuell oder Automatisch.',
'betting_p5': 'Um die Spielrunde zu starten, drücken Sie die Taste DROP BALL. Während der Runde sind alle Wetttasten außer DROP BALL und dem Einsatzbetrag deaktiviert.',
'betting_p6': 'Eine Plinko-Kugel stellt eine Runde dar. Während der Runde kann mit der Taste DROP BALL eine weitere Runde mit denselben Einstellungen gestartet werden. Es ist möglich, den Einsatzbetrag zu ändern, während sich „aktive“ Kugeln auf dem Spielfeld befinden, jedoch nicht den Schwierigkeitsgrad des Spiels.',
'betting_p7': 'Am Ende der Runde erreicht die Kugel ein Fach. In jedem Fach wird der Auszahlungs-Multiplikator angezeigt.',
'betting_p8': 'Die Berechnung des Gewinns erfolgt gemäß dem Multiplikator, auf dem die Kugel gelandet ist. Das Ergebnis wird dem Guthaben hinzugefügt.',
'game_menu_p1': 'Die neuesten Wett-Multiplikatoren werden im unteren Bereich des Spielfensters angezeigt.',
'game_menu_p2': 'Über die Schaltfläche „Bet history“ kann der Spieler seine letzten Wetten detaillierter einsehen.',
'game_menu_p3': 'Für eine weitergehende Spielhistorie (z. B. längere Zeiträume) muss der Spieler möglicherweise auf seine Historie innerhalb der Spielplattform selbst zugreifen.',
'game_menu_p4': 'Über das Spielmenü können Spieler Soundoptionen, Tastenkombinationen steuern sowie Wettverlauf und Spielregeln öffnen.',
'game_menu_p5': 'Das Spiel wurde mit schöner Hintergrundmusik und Soundeffekten gestaltet. Musik und/oder Soundeffekte können über die Symbole im Spielmenü deaktiviert werden.',
'game_menu_p6': 'Der Spielverlauf zeigt ein Fenster mit vorherigen Wetten und der Bonus-Historie.',
'autoplay': 'Automatikmodus (Autoplay)',
'autoplay_p1': 'Durch Klicken auf Auto können Sie automatisch mehrere Kugeln fallen lassen, ohne jedes Mal klicken zu müssen.',
'autoplay_p2': 'Wählen Sie den Betrag, den Sie pro Kugel setzen möchten.',
'autoplay_p3': 'Wählen Sie, wie oft (Runden) die Kugel fallen soll — bis zu maximal 100 Runden.',
'autoplay_p4': 'Drücken Sie die START-Taste, um zu beginnen, und die Taste wechselt zu STOP.',
'autoplay_p5': 'Der Automatikmodus stoppt, wenn die ausgewählte Anzahl an Abwürfen abgeschlossen ist, das Guthaben aufgebraucht ist oder Sie STOP drücken.',
'autoplay_p6': 'Jeder Abwurf verwendet denselben Einsatzbetrag, den Sie vor dem Start des Automatikmodus ausgewählt haben.',
'turbo_mode': 'Turbo-Modus',
'turbo_mode_p1': 'Mit Turbo Drop können Sie Kugeln blitzschnell fallen lassen, indem Sie die DROP-Taste gedrückt halten.',
'turbo_mode_p2': 'Die Kugeln fallen weiter, bis Sie die Taste loslassen oder das Guthaben aufgebraucht ist.',
'turbo_mode_p3': 'Die Kugeln fallen weiter, bis Sie die Taste loslassen oder das Guthaben aufgebraucht ist.',
'turbo_balance': 'Turbo-Guthaben',
'turbo_balance_p1': 'Bevor Sie Turbo Drop starten, wählen Sie den Geldbetrag, den Sie dafür reservieren — dies wird Ihr Turbo-Guthaben.',
'turbo_balance_p2': 'Während Turbo Drop aktiv ist, verwendet das Spiel ausschließlich Ihr Turbo-Guthaben für Einsätze und Gewinne.',
'turbo_balance_p3': 'Wenn Sie Turbo Drop beenden, wird jedes verbleibende Turbo-Guthaben Ihrem Hauptguthaben gutgeschrieben.',
'turbo_balance_p4': 'Sie können Turbo Drop jederzeit verlassen — der Modus endet jedoch vollständig erst, nachdem alle Kugeln gefallen sind und in den Multiplikator-Fächern gelandet sind.',
'free_bets': 'BONUSRUNDEN',
'free_bets_p1': 'Bonusrunden werden vom Betreiber vergeben.',
'fairness': 'Fairness',
'fairness_p1': 'Jeder Wurf wird durch einen nachweislich fairen Zufallszahlengenerator (RNG) bestimmt.',
'fairness_p2': 'Das Ergebnis kann nach dem Fall der Kugel nicht vorhergesagt oder beeinflusst werden.',
'disconection_and_error': 'Verbindungsrichtlinie und Fehlerbehandlung',
'disconection_and_error_p1': 'Wenn die Verbindung nach dem Setzen einer Wette unterbrochen wird, wird die Wette nicht storniert. Wenn die Spielaktion vom Spieler verlangt, wird das Ergebnis so gewertet, als hätte der Spieler die risikofreie Aktion ohne Erhöhung der Wette gewählt.',
'disconection_and_error_p2': 'Im Fehlerfall versucht unser Support-Team, das Problem so schnell wie möglich zu beheben und das reguläre Spiel fortzusetzen. Bei einem Fehler im Spiel selbst werden alle Wetten storniert und der Einsatzbetrag an die Spieler zurückerstattet.',
'other': 'Sonstiges',
'other_p1': 'Bei einer Fehlfunktion der Spielhardware/-software werden alle betroffenen Wetten und Auszahlungen für ungültig erklärt und alle betroffenen Einsätze zurückerstattet.',
'other_p2': 'Die Spielregeln sind auf Englisch veröffentlicht. Übersetzungen in andere Sprachen werden als Service in gutem Glauben bereitgestellt. Im Falle von Unklarheiten zwischen der englischen Version und einer Übersetzung hat die englische Version Vorrang.',
'rows': 'Reihen',
'lvl': 'Stufe',
'low': 'Niedrig',
'high': 'Hoch',
'ok': 'OK',
'exit_turbo_mode': 'Möchten Sie den Turbo-Modus verlassen?',
"end": "ENDE",
"turbo_mode_settings": "Turbo-Modus-Einstellungen",
"stop": "STOPP",
'invalid_bet_amount': 'Ungültiger Einsatzbetrag',
'cashout_success': 'Erfolgreich ausgezahlt',
'stop_auto_play_first': 'Bitte stoppen Sie zuerst die automatische Wiedergabe.',
'turbo_only_when_no_balls': 'Der Turbo-Modus kann nur gestartet werden, wenn sich keine Kugeln auf dem Spielfeld befinden.',
'type': 'Wetteart',
'wait_balls_to_finish': 'Bitte warten Sie, bis die Kugeln fertig sind.',
'bet_too_large_top_up_turbo_balance': 'Der Einsatz ist zu hoch – füllen Sie Ihr Turbo-Guthaben auf!',

};
langArr.el = {
'loading': 'Φόρτωση',
'hotkeys': 'Συντομεύσεις',
'hotkeys_enabled': 'Συντομεύσεις Ενεργές',
'enable_hotkeys_checkbox': 'Ενεργοποιήστε τις συντομεύσεις που εμφανίζονται παρακάτω, επιλέγοντας αυτό το κουτάκι.',
'drop_ball': 'Αφήστε την μπάλα',
'double_bet': 'Διπλασιάστε το στοίχημα',
'halve_bet': 'Μειώστε το στοίχημα στο μισό',
'min_bet': 'Ελάχιστο στοίχημα',
'max': 'Μέγιστο',
'easy': 'Εύκολο',
'medium': 'Μέτριο',
'hard': 'Δύσκολο',
'daredevil': 'Τολμηρός',
'max_profit': 'Μέγιστο Κέρδος',
'manual': 'Χειροκίνητο',
'auto': 'Αυτόματο',
'bet_amount': 'Ποσό Στοιχήματος',
'difficulty': 'Δυσκολία',
'payout_on_win': 'Απόδοση σε Νίκη',
'number_of_bets': 'Αριθμός Στοιχημάτων',
'on_win': 'Σε Νίκη',
'on_loss': 'Σε Ήττα',
'stop_on_profit': 'Σταμάτα στο Κέρδος',
'stop_on_loss': 'Σταμάτα στην Ήττα',
'reset': 'Επαναφορά',
'increase_by': 'Αύξηση κατά',
'cashout': 'ΑΝΑΛΗΨΗ',
'start_game': 'ΣΤΟΙΧΗΜΑ',
'start_auto_game': 'ΕΝΑΡΞΗ',
'difficulity_info': 'Πληροφορίες Δυσκολίας',
'chance_collision': 'Πιθανότητα σύγκρουσης ανά παιχνίδι',
'evry_25_lane': 'για κάθε 25 λωρίδες',
'insufficiend_funds': 'Ανεπαρκή κεφάλαια',
'cashout_inactivity': 'Αυτόματη ανάληψη λόγω αδράνειας',
'time_running_out': 'Ο χρόνος τελειώνει! Παίξτε τώρα ή το εισιτήριό σας θα αφαιρεθεί αυτόματα σε 30 δευτερόλεπτα',
'there_was_error': 'ΥΠΗΡΞΕ ΣΦΑΛΜΑ, ΠΡΟΣΠΑΘΗΣΤΕ ΞΑΝΑ Ή ΑΝΑΝΕΩΣΤΕ',
'detailed_game_rules': 'Λεπτομερείς Κανόνες Παιχνιδιού',
'general_rules': 'ΓΕΝΙΚΟΙ ΚΑΝΟΝΕΣ',
'general_rules_p1': '• Ο πολλαπλασιαστής ξεκινά από 1 και φτάνει έως ',
'general_rules_p2': '• Τα κέρδη υπολογίζονται πολλαπλασιάζοντας το ποσό του στοιχήματος με τον πολλαπλασιαστή που εμφανίζεται σε κάθε βήμα.',
'general_rules_p3': '• Αν επιτευχθεί η μέγιστη απόδοση, το παιχνίδι θα πραγματοποιήσει αυτόματα ανάληψη στο μέγιστο ποσό.',
'progressive_jackpot': 'ΠΡΟΟΔΕΥΤΙΚΟ ΤΖΑΚΠΟΤ',
'progressive_jackpot_ss': 'Λωρίδα Τζακπότ και πιθανή νίκη',
'progressive_jackpot_p1': '% από κάθε στοίχημα πηγαίνει στο προοδευτικό ταμείο τζακπότ.',
'progressive_jackpot_p2': 'Το τζακπότ απονέμεται χρησιμοποιώντας τη μηχανική "Mystery" ή "must-hit-by". Η τιμή κάθε "must-hit-by" τζακπότ καθορίζεται αμέσως μετά την προηγούμενη νίκη από έναν γεννήτορα τυχαίων αριθμών και αποθηκεύεται κρυπτογραφημένη στη βάση δεδομένων.',
'progressive_jackpot_p3': 'Μόλις επιτευχθεί η τιμή "must-hit-by", ο πρώτος παίκτης που θα τοποθετήσει στοίχημα μετά έχει την ευκαιρία να κερδίσει το τζακπότ. Ένα σύμβολο τζακπότ εμφανίζεται σε τυχαία λωρίδα και κερδίζεται αν ο παίκτης φτάσει στη λωρίδα με το σύμβολο.',
'progressive_jackpot_p4': 'ΣΗΜΕΙΩΣΗ: Ο γύρος μπόνους δεν συμβάλλει στο ταμείο τζακπότ. Κατά τη διάρκεια του γύρου μπόνους δεν μπορεί να κερδηθεί τζακπότ.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Κόκκινο τετράγωνο, θέση πιθανής σύγκρουσης',
'showdown_p1': 'Μετά την ανάληψη του παίκτη, εμφανίζεται ένα κόκκινο τετράγωνο στη θέση όπου θα συνέβαινε η σύγκρουση αν ο παίκτης συνέχιζε να παρακάμπτει λωρίδες.',
'return_to_player': 'ΕΠΙΣΤΡΟΦΗ ΣΤΟΝ ΠΑΙΚΤΗ',
'return_to_player_p1': 'Η συνολική θεωρητική επιστροφή στον παίκτη (RTP) είναι ',
'return_to_player_p2': 'Τα ποσοστά RTP παρακολουθούνται συνεχώς και επαληθεύονται από ανεξάρτητα τρίτα μέρη.',
'disconnection_policy': 'ΠΟΛΙΤΙΚΗ ΑΠΟΣΥΝΔΕΣΗΣ',
'disconnection_policy_p1': 'Αν χαθεί η σύνδεση μετά την τοποθέτηση στοιχήματος, το στοίχημα δεν ακυρώνεται άμεσα. Αν η αδράνεια του παίκτη φτάσει ',
'disconnection_policy_p2': 'το στοίχημα θα εκκαθαριστεί αυτόματα και η πίστωση θα εφαρμοστεί στον λογαριασμό του παίκτη.',
'network_latency': 'ΚΑΘΥΣΤΕΡΗΣΗ ΔΙΚΤΥΟΥ',
'network_latency_p1': 'Η καθυστέρηση δικτύου είναι αναπόφευκτο μέρος της σύνδεσης στο Διαδίκτυο. Θεωρούμε όλα τα στοιχήματα και τις αναλήψεις έγκυρα μόνο τη στιγμή που φτάνουν στον διακομιστή μας, ανεξαρτήτως της διάρκειας καθυστέρησης.',
'sound': 'ΗΧΟΣ',
'sound_p1': 'Το παιχνίδι είναι σχεδιασμένο με όμορφη μουσική υπόκρουση και ηχητικά εφέ. Αν θέλετε να απενεργοποιήσετε τη μουσική ή/και τα ηχητικά εφέ, μπορείτε να το κάνετε μέσω των εικονιδίων του μενού παιχνιδιού.',
'error_handling': 'ΔΙΑΧΕΙΡΙΣΗ ΣΦΑΛΜΑΤΩΝ',
'error_handling_p1': 'Σε περίπτωση σφάλματος, η ομάδα υποστήριξης θα προσπαθήσει να λύσει το πρόβλημα όσο το δυνατόν γρηγορότερα και να συνεχίσει το παιχνίδι. Σε περίπτωση προβλήματος με το ίδιο το παιχνίδι, όλα τα στοιχήματα ακυρώνονται και τα ποσά επιστρέφονται στους παίκτες.',
'max_payout': 'Η μέγιστη απόδοση είναι ',
'max_bet_is': 'Το μέγιστο στοίχημα είναι ',
'min_bet_is': 'Το ελάχιστο στοίχημα είναι ',
'per_bet': 'ανά στοίχημα.',
'malfunction_voids': 'Η δυσλειτουργία ακυρώνει όλες τις πληρωμές και τα παιχνίδια.',
'attention_jackpot': 'Προσοχή, Τζακπότ στη λωρίδα ',
'lane': 'λωρίδα',
'congratulations': 'συγχαρητήρια',
'you_won': 'κερδίσατε',
'balance': 'υπόλοιπο',
'time': 'χρόνος',
'jackpot': 'τζακπότ',
'escaped': 'ΔΡΑΣΗΚΕ',
'max_win': 'ΜΕΓΙΣΤΟ ΚΕΡΔΟΣ',
'check_internet': 'Ελέγξτε τη σύνδεση στο διαδίκτυο',
'websocket_disconected': 'Websocket αποσυνδέθηκε',
'websocket_connection_error': 'Σφάλμα σύνδεσης Websocket!',
'session_expired': 'Η συνεδρία έχει λήξει, παρακαλώ επαναφορτώστε',
'remaining_bets': 'Υπόλοιπα στοιχήματα',
'stop_autoplay': 'ΣΤΟΠ',
'autoplay_and_autocashout': 'ΑΥΤΟΜΑΤΟ ΠΑΙΧΝΙΔΙ ΚΑΙ ΑΥΤΟΜΑΤΗ ΑΝΑΛΗΨΗ',
'autoplay_and_autocashout_ss': 'Επιλογή μεταξύ χειροκίνητου και αυτόματου',
'autoplay_and_autocashout_p1': 'Ένας παίκτης μπορεί να ενεργοποιήσει την επιλογή αυτόματου παιχνιδιού, όπου τοποθετείται αυτόματα ένα στοίχημα για κάθε νέο γύρο χρησιμοποιώντας το ποσό του προηγούμενου στοιχήματος.',
'autoplay_and_autocashout_p2': 'Μπορεί να επιλεγεί ένας πολλαπλασιαστής αυτόματης ανάληψης και όταν επιλεγεί, το παιχνίδι θα πραγματοποιήσει αυτόματα ανάληψη αν ο παίκτης δεν χτυπηθεί πριν φτάσει τον επιλεγμένο πολλαπλασιαστή.',
'autoplay_and_autocashout_p3': 'Ο μέγιστος αριθμός γύρων αυτόματου παιχνιδιού είναι ',
'autoplay_button_label': 'Για να ξεκινήσετε, επιλέξτε μια λωρίδα.',
'min_bet_amount_is': 'Το ελάχιστο ποσό στοιχήματος είναι',
'bonus_rounds': 'γύροι μπόνους',
'bonus_rounds_ss': 'Οι γύροι μπόνους με περίοδο ισχύος',
'bonus_rounds_p1': 'Ένας παίκτης μπορεί να λάβει γύρο μπόνους (π.χ. δωρεάν στοίχημα) βάσει προώθησης καζίνο. Ένα αναδυόμενο παράθυρο θα εμφανιστεί στην οθόνη ενημερώνοντας τον παίκτη για τους γύρους μπόνους, τον αριθμό στοιχημάτων, το ποσό ανά στοίχημα και προαιρετικά την περίοδο ισχύος.',
'bonus_rounds_p2': 'Μόλις δοθούν, ο παίκτης μπορεί να επιλέξει πότε θα ξεκινήσει ο γύρος μπόνους. Αφού ξεκινήσει ο γύρος, το στοίχημα τοποθετείται αυτόματα με το καθορισμένο ποσό.',
'bonus_rounds_p3': 'Οι γύροι μπόνους μπορεί να έχουν χρονικό περιορισμό, μετά τον οποίο καθίστανται άκυροι.',
'bonus_rounds_p4': 'Η αδράνεια του παίκτη μπορεί να οδηγήσει στην ακύρωση ενός ενεργού γύρου μπόνους. Σε αυτή την περίπτωση, ο αριθμός των γύρων μπόνους μειώνεται και το υπόλοιπο του παίκτη παραμένει το ίδιο.',
'valid_until': 'έγκυρο μέχρι',
'bonus': 'μπόνους',
'rounds': 'γύροι',
'win_eur': 'κερδίστε EUR',
'complete_your_bet': 'Ολοκληρώστε πρώτα το στοίχημά σας',
'complete_auto_play': 'Ολοκληρώστε πρώτα το αυτόματο παιχνίδι',
'yes': 'ναι',
'no': 'όχι',
'play_bonus_rounds': 'Παίξε γύρους μπόνους;',
'bet_history': 'Ιστορικό στοιχημάτων',
'jackpot_history': 'Ιστορικό τζακπότ',
'ticket_id': 'Αριθμός Εισιτηρίου',
'created': 'ώρα δημιουργίας',
'currency': 'νόμισμα',
'bet': 'στοίχημα',
'bet_eur': 'στοίχημα EUR',
'lanes': 'λωρίδες',
'cars': 'αυτοκίνητα',
'multiplier': 'πολλαπλασιαστής',
'win': 'νίκη',
'no_betting_history': 'Δεν βρέθηκε ιστορικό στοιχημάτων. Κάντε ένα στοίχημα και θα εμφανιστεί εδώ.',
'no_jackpot_history': 'Δεν υπάρχει διαθέσιμο ιστορικό τζακπότ.',
'date': 'ημερομηνία',
'user': 'παίκτης',
'bet_already_active': 'Το στοίχημα είναι ήδη ενεργό',
'please_play_the_game_in_portait_mode': 'Παίξτε το παιχνίδι σε κατακόρυφη λειτουργία.',
'bonus_history': 'Ιστορικό μπόνους',
'bonus_type': 'Τύπος μπόνους',
'no_bonus_history': 'Δεν υπάρχει διαθέσιμο ιστορικό μπόνους.',
'game_menu': 'Μενού παιχνιδιού',
'game_menu_ss': 'Από αριστερά: Αρχική, Ιστορικό στοιχημάτων, Κανόνες παιχνιδιού, Συντομεύσεις πληκτρολογίου, Ρυθμίσεις ήχου και μουσικής',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'ΚΑΝΟΝΕΣ ΠΑΙΧΝΙΔΙΟΥ',
'game_rules_p1': 'Καλώς ήρθατε στο Plinko – όπου η τύχη παίρνει τα ηνία!',
'game_rules_p2': 'Ετοιμαστείτε για ένα συναρπαστικό παιχνίδι τύχης που είναι τόσο απλό όσο και εθιστικό! Στο Plinko, αφήνετε μια μπάλα να πέσει πάνω σε μια πυραμίδα γεμάτη καρφιά και παρακολουθείτε πώς αναπηδά, στρίβει και αναπηδά μέχρι να φτάσει σε μια θέση με έπαθλο στο κάτω μέρος.',
'game_rules_p3': 'Επιλέξτε μεταξύ 8 έως 16 σειρών καρφιών, καθίστε αναπαυτικά και απολαύστε το χάος καθώς η μπάλα ζιγκ-ζαγκ διασχίζει την πίστα, καθοδηγούμενη μόνο από τη βαρύτητα και την τύχη.',
'game_rules_p4': 'Θα καταλήξει σε μια θέση με χαμηλή πληρωμή... ή θα πετύχει το μεγάλο κέρδος; Υπάρχει μόνο ένας τρόπος να το μάθετε — αφήστε την μπάλα να πέσει και αφήστε τη συγκίνηση να ξεκινήσει!',
'general': 'ΓΕΝΙΚΑ',
'general_p1': 'Ρίξτε την μπάλα Plinko και ελπίζετε να καταλήξει σε μια από τις θέσεις με υψηλές πληρωμές στο κάτω μέρος. Η διαδρομή είναι απρόβλεπτη — κάθε αναπήδηση μπορεί να αλλάξει την τύχη σας.',
'general_p2': 'Όσο περισσότερες σειρές παίζετε, τόσο πιο έντονη γίνεται η δράση!',
'general_p3': 'Οπότε προχωρήστε — εμπιστευτείτε την τύχη σας, πατήστε DROP και κυνηγήστε το μεγάλο κέρδος μέσα από τα καρφιά του Plinko!',
'betting': 'ΣΤΟΙΧΗΜΑ',
'betting_p1': 'Επιλέξτε το ποσό του στοιχήματος. Τα κουμπιά “1/2”, “2x”, “Max” μπορούν να χρησιμοποιηθούν για τη διαχείριση του ποσού του στοιχήματος. Το ποσό του στοιχήματος μπορεί επίσης να εισαχθεί χειροκίνητα.',
'betting_p2': 'Επιλέξτε Επίπεδο Ρίσκου: Χαμηλό, Μεσαίο ή Υψηλό. Ένα χαμηλότερο επίπεδο ρίσκου προσφέρει πιο σταθερά αποτελέσματα (χαμηλή μεταβλητότητα), ενώ ένα υψηλότερο προσφέρει μεγαλύτερη διακύμανση (υψηλή μεταβλητότητα).',
'betting_p3': 'Επιλέξτε τον αριθμό των γραμμών στο παιχνίδι: από 8 έως 16. Επιλέξτε από πόσες σειρές πινάκια θα περάσει η μπάλα. Περισσότερες σειρές = μεγαλύτερη απρόβλεπτη συμπεριφορά.',
'betting_p4': 'Επιλέξτε Λειτουργία Στοιχήματος: Χειροκίνητη ή Αυτόματη.',
'betting_p5': 'Για να ξεκινήσετε τον γύρο του παιχνιδιού, πατήστε το κουμπί DROP BALL. Κατά τη διάρκεια του γύρου όλα τα κουμπιά στοιχήματος απενεργοποιούνται εκτός από το DROP BALL και το ποσό στοιχήματος.',
'betting_p6': 'Μία μπάλα Plinko αντιπροσωπεύει έναν γύρο. Κατά τη διάρκεια του γύρου, μπορεί να ξεκινήσει ένας άλλος γύρος με τις ίδιες ρυθμίσεις χρησιμοποιώντας το κουμπί DROP BALL. Είναι δυνατή η αλλαγή του ποσού στοιχήματος ενώ υπάρχουν «ενεργές» μπάλες στον πίνακα, αλλά όχι η δυσκολία του παιχνιδιού.',
'betting_p7': 'Στο τέλος του γύρου, η μπάλα φτάνει σε μια θήκη. Σε κάθε θήκη εμφανίζεται ο πολλαπλασιαστής πληρωμής.',
'betting_p8': 'Ο υπολογισμός του κέρδους γίνεται σύμφωνα με τον πολλαπλασιαστή στον οποίο κατέληξε η μπάλα. Το αποτέλεσμα προστίθεται στο υπόλοιπο.',
'game_menu_p1': 'Οι πιο πρόσφατοι πολλαπλασιαστές στοιχημάτων εμφανίζονται στο κάτω μέρος του παραθύρου του παιχνιδιού.',
'game_menu_p2': 'Μέσω του κουμπιού “Bet history” ο παίκτης μπορεί να ελέγξει τα τελευταία του στοιχήματα με περισσότερες λεπτομέρειες.',
'game_menu_p3': 'Για περαιτέρω ιστορικό παιχνιδιού (π.χ. μεγαλύτερες χρονικές περιόδους), ο παίκτης μπορεί να χρειαστεί να αποκτήσει πρόσβαση στο ιστορικό του εντός της ίδιας της πλατφόρμας παιχνιδιών.',
'game_menu_p4': 'Μέσω του μενού του παιχνιδιού, οι παίκτες μπορούν να ελέγχουν τις ρυθμίσεις ήχου, τις συντομεύσεις πληκτρολογίου και να ανοίγουν το ιστορικό στοιχημάτων και τους κανόνες του παιχνιδιού.',
'game_menu_p5': 'Το παιχνίδι έχει σχεδιαστεί με όμορφη μουσική υπόκρουση και ηχητικά εφέ. Η μουσική και/ή τα ηχητικά εφέ μπορούν να απενεργοποιηθούν μέσω των εικονιδίων του μενού του παιχνιδιού.',
'game_menu_p6': 'Το ιστορικό παιχνιδιού θα εμφανίσει ένα παράθυρο με προηγούμενα στοιχήματα και ιστορικό μπόνους.',
'autoplay': 'Αυτόματη λειτουργία (Autoplay)',
'autoplay_p1': 'Κάνοντας κλικ στο Auto μπορείτε να αφήσετε αυτόματα έναν αριθμό μπαλών χωρίς να χρειάζεται να κάνετε κλικ κάθε φορά.',
'autoplay_p2': 'Επιλέξτε το ποσό που θέλετε να στοιχηματίσετε ανά μπάλα.',
'autoplay_p3': 'Επιλέξτε πόσες φορές (γύρους) θέλετε να πέσει η μπάλα — έως και 100 γύρους το μέγιστο.',
'autoplay_p4': 'Πατήστε το κουμπί START για να ξεκινήσετε και το κουμπί θα αλλάξει σε STOP.',
'autoplay_p5': 'Η αυτόματη λειτουργία θα σταματήσει όταν ολοκληρωθεί ο επιλεγμένος αριθμός ρίψεων, εξαντληθούν τα χρήματα ή πατήσετε STOP.',
'autoplay_p6': 'Κάθε ρίψη χρησιμοποιεί το ίδιο ποσό στοιχήματος που επιλέξατε πριν ξεκινήσετε την Αυτόματη λειτουργία.',
'turbo_mode': 'Λειτουργία Turbo',
'turbo_mode_p1': 'Το Turbo Drop σας επιτρέπει να ρίχνετε μπάλες με εξαιρετικά γρήγορο ρυθμό κρατώντας πατημένο το κουμπί DROP.',
'turbo_mode_p2': 'Οι μπάλες θα συνεχίσουν να πέφτουν μέχρι να αφήσετε το κουμπί ή να εξαντληθεί το υπόλοιπο.',
'turbo_mode_p3': 'Οι μπάλες θα συνεχίσουν να πέφτουν μέχρι να αφήσετε το κουμπί ή να εξαντληθεί το υπόλοιπο.',
'turbo_balance': 'Υπόλοιπο Turbo',
'turbo_balance_p1': 'Πριν ξεκινήσετε το Turbo Drop, επιλέγετε πόσα χρήματα θα δεσμεύσετε — αυτό γίνεται το Υπόλοιπο Turbo σας.',
'turbo_balance_p2': 'Όσο το Turbo Drop είναι ενεργό, το παιχνίδι χρησιμοποιεί μόνο το Υπόλοιπο Turbo για στοιχήματα και κέρδη.',
'turbo_balance_p3': 'Όταν σταματήσετε το Turbo Drop, οποιοδήποτε υπόλοιπο Turbo απομένει επιστρέφει στο κύριο υπόλοιπό σας.',
'turbo_balance_p4': 'Μπορείτε να εξέλθετε από το Turbo Drop οποιαδήποτε στιγμή — αλλά η λειτουργία θα ολοκληρωθεί πλήρως μόνο αφού όλες οι μπάλες ολοκληρώσουν την πτώση τους και καταλήξουν στις θήκες πολλαπλασιαστών.',
'free_bets': 'ΓΥΡΟΙ ΜΠΟΝΟΥΣ',
'free_bets_p1': 'Οι γύροι μπόνους απονέμονται από τον πάροχο.',
'fairness': 'Δικαιοσύνη',
'fairness_p1': 'Κάθε ρίψη καθορίζεται από έναν αποδεδειγμένα δίκαιο γεννήτρια τυχαίων αριθμών (RNG).',
'fairness_p2': 'Το αποτέλεσμα δεν μπορεί να προβλεφθεί ή να επηρεαστεί μετά την πτώση της μπάλας.',
'disconection_and_error': 'Πολιτική Αποσύνδεσης και Διαχείριση Σφαλμάτων',
'disconection_and_error_p1': 'Εάν η σύνδεση χαθεί μετά από τοποθέτηση στοιχήματος, το στοίχημα δεν ακυρώνεται. Εάν το παιχνίδι απαιτεί ενέργεια από τον παίκτη, το αποτέλεσμα θεωρείται ότι ο παίκτης επέλεξε την ενέργεια χωρίς ρίσκο χωρίς να αυξήσει το αρχικό στοίχημα.',
'disconection_and_error_p2': 'Σε περίπτωση σφάλματος, η ομάδα υποστήριξης θα προσπαθήσει να επιλύσει το ζήτημα το συντομότερο δυνατό και να συνεχίσει το παιχνίδι κανονικά. Σε περίπτωση προβλήματος με το ίδιο το παιχνίδι, όλα τα στοιχήματα ακυρώνονται και τα ποσά επιστρέφονται στους παίκτες.',
'other': 'Άλλα',
'other_p1': 'Σε περίπτωση βλάβης του υλικού/λογισμικού παιχνιδιού, όλα τα επηρεαζόμενα στοιχήματα και πληρωμές ακυρώνονται και τα ποσά επιστρέφονται.',
'other_p2': 'Οι κανόνες του παιχνιδιού είναι δημοσιευμένοι στα Αγγλικά. Οι μεταφράσεις σε άλλες γλώσσες παρέχονται ως υπηρεσία με καλή πίστη. Σε περίπτωση ασάφειας μεταξύ της αγγλικής έκδοσης και μιας μετάφρασης, προτεραιότητα έχει πάντα η αγγλική έκδοση.',
'rows': 'Σειρές',
'lvl': 'Επίπεδο',
'low': 'Χαμηλό',
'high': 'Υψηλό',
'ok': 'OK',
'exit_turbo_mode': 'Θέλετε να βγείτε από τη λειτουργία Turbo;',
"end": "ΤΕΛΟΣ",
"turbo_mode_settings": "Ρυθμίσεις Turbo Mode",
"stop": "ΣΤΟΠ",
'invalid_bet_amount': 'Μη έγκυρο ποσό στοιχήματος',
'cashout_success': 'Επιτυχής ανάληψη',
'stop_auto_play_first': 'Παρακαλώ σταματήστε πρώτα την αυτόματη αναπαραγωγή.',
'turbo_only_when_no_balls': 'Η λειτουργία Turbo μπορεί να ξεκινήσει μόνο όταν δεν υπάρχουν μπάλες στον πίνακα.',
'type': 'Τύπος στοιχήματος',
'wait_balls_to_finish': 'Παρακαλώ περιμένετε μέχρι να τελειώσουν οι μπάλες.',
'bet_too_large_top_up_turbo_balance': 'Το στοίχημα είναι πολύ μεγάλο – αναπληρώστε το Υπόλοιπο Turbo σας!',

};
langArr.es = {
'loading': 'Cargando',
'hotkeys': 'Teclas rápidas',
'hotkeys_enabled': 'Teclas rápidas activadas',
'enable_hotkeys_checkbox': 'Habilita las teclas rápidas mostradas a continuación marcando esta casilla.',
'drop_ball': 'Dejar caer la bola',
'double_bet': 'Duplicar apuesta',
'halve_bet': 'Reducir apuesta a la mitad',
'min_bet': 'Apuesta mínima',
'max': 'Máx',
'easy': 'Fácil',
'medium': 'Medio',
'hard': 'Difícil',
'daredevil': 'Atrevido',
'max_profit': 'Ganancia máxima',
'manual': 'Manual',
'auto': 'Automático',
'bet_amount': 'Monto de la apuesta',
'difficulty': 'Dificultad',
'payout_on_win': 'Pago al ganar',
'number_of_bets': 'Número de apuestas',
'on_win': 'Al ganar',
'on_loss': 'Al perder',
'stop_on_profit': 'Detener al ganar',
'stop_on_loss': 'Detener al perder',
'reset': 'Restablecer',
'increase_by': 'Incrementar en',
'cashout': 'COBRAR',
'start_game': 'APOSTAR',
'start_auto_game': 'INICIAR',
'difficulity_info': 'Información de dificultad',
'chance_collision': 'Probabilidad de colisión por juego',
'evry_25_lane': 'por cada 25 carriles',
'insufficiend_funds': 'Fondos insuficientes',
'cashout_inactivity': 'Cobro automático por inactividad',
'time_running_out': '¡Se está acabando el tiempo! Juega ahora o tu boleto se retirará automáticamente en 30 segundos',
'there_was_error': 'HUBO UN ERROR, POR FAVOR INTENTA DE NUEVO O RECARGA',
'detailed_game_rules': 'Reglas detalladas del juego',
'general_rules': 'REGLAS GENERALES',
'general_rules_p1': '• El multiplicador comienza en 1 y sube hasta ',
'general_rules_p2': '• Las ganancias se calculan multiplicando la apuesta por el multiplicador mostrado en cada paso.',
'general_rules_p3': '• Si se alcanza el pago máximo, el juego se cobrará automáticamente al monto máximo.',
'progressive_jackpot': 'JACKPOT PROGRESIVO',
'progressive_jackpot_ss': 'Carril del jackpot y posible ganancia',
'progressive_jackpot_p1': '% de cada apuesta se dedica al fondo progresivo del jackpot.',
'progressive_jackpot_p2': 'El jackpot se otorga usando mecánica "Mystery" o "must-hit-by". El valor de cada jackpot "must-hit-by" se determina inmediatamente después del jackpot anterior mediante un generador de números aleatorios y se almacena cifrado en la base de datos.',
'progressive_jackpot_p3': 'Una vez alcanzado el valor "must-hit-by", el primer jugador que apueste después tendrá la oportunidad de ganar el jackpot. Aparecerá un símbolo de jackpot en un carril aleatorio, y se gana si el jugador llega al carril con el símbolo.',
'progressive_jackpot_p4': 'NOTA: La ronda de bonificación no contribuye al fondo del jackpot. Durante la ronda de bonificación no se puede ganar el jackpot.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Cuadro rojo, ubicación de colisión probable',
'showdown_p1': 'Después de que el jugador cobre, se mostrará un cuadro rojo en la ubicación donde habría ocurrido la colisión si el jugador hubiera continuado saltando carriles.',
'return_to_player': 'RETORNO AL JUGADOR',
'return_to_player_p1': 'El retorno teórico total al jugador (RTP) es ',
'return_to_player_p2': 'Los porcentajes de RTP se supervisan y verifican continuamente por terceros independientes.',
'disconnection_policy': 'POLÍTICA DE DESCONEXIÓN',
'disconnection_policy_p1': 'Si se pierde la conexión después de realizar una apuesta, la apuesta no se cancelará inmediatamente. Si la inactividad del jugador alcanza ',
'disconnection_policy_p2': 'la apuesta se cobrará automáticamente y los créditos se aplicarán a la cuenta del jugador.',
'network_latency': 'LATENCIA DE RED',
'network_latency_p1': 'La latencia de la red es una parte inevitable de la conectividad a Internet. Consideramos todas las apuestas y cobros válidos solo en el momento en que llegan a nuestro servidor, independientemente de la duración de la latencia.',
'sound': 'SONIDO',
'sound_p1': 'El juego está diseñado con música de fondo y efectos de sonido. Si desea desactivar la música y/o los efectos de sonido, puede hacerlo a través de los íconos del menú del juego.',
'error_handling': 'GESTIÓN DE ERRORES',
'error_handling_p1': 'En caso de error, nuestro equipo de soporte intentará resolver el problema lo antes posible y reanudar el juego. Si hay un problema con el juego en sí, todas las apuestas serán canceladas y se devolverá el monto a los jugadores.',
'max_payout': 'El pago máximo es ',
'max_bet_is': 'La apuesta máxima es ',
'min_bet_is': 'La apuesta mínima es ',
'per_bet': 'por apuesta.',
'malfunction_voids': 'El mal funcionamiento anula todos los pagos y juegos.',
'attention_jackpot': 'Atención, Jackpot en carril ',
'lane': 'carril',
'congratulations': 'felicitaciones',
'you_won': 'has ganado',
'balance': 'saldo',
'time': 'tiempo',
'jackpot': 'jackpot',
'escaped': 'ESCAPADO',
'max_win': 'GANANCIA MÁXIMA',
'check_internet': 'Por favor, comprueba tu conexión a Internet',
'websocket_disconected': 'Websocket desconectado',
'websocket_connection_error': '¡Error de conexión Websocket!',
'session_expired': 'La sesión ha caducado, por favor recarga',
'remaining_bets': 'Apuestas restantes',
'stop_autoplay': 'DETENER',
'autoplay_and_autocashout': 'JUEGO AUTOMÁTICO Y COBRO AUTOMÁTICO',
'autoplay_and_autocashout_ss': 'Selección entre manual y automático',
'autoplay_and_autocashout_p1': 'Un jugador puede activar la opción de juego automático, donde se coloca automáticamente una apuesta para cada nueva ronda usando el monto de la apuesta anterior.',
'autoplay_and_autocashout_p2': 'Se puede seleccionar un multiplicador de cobro automático, y al hacerlo, el juego cobrará automáticamente si el jugador no es alcanzado antes de llegar al multiplicador seleccionado.',
'autoplay_and_autocashout_p3': 'El número máximo de rondas automáticas es ',
'autoplay_button_label': 'Para comenzar, elige un carril.',
'min_bet_amount_is': 'El monto mínimo de apuesta es',
'bonus_rounds': 'rondas de bonificación',
'bonus_rounds_ss': 'Las rondas de bonificación con período de validez',
'bonus_rounds_p1': 'Un jugador puede recibir una ronda de bonificación (por ejemplo, apuesta gratis) según una promoción del casino. Aparecerá una ventana emergente mostrando al jugador las rondas otorgadas, cantidad por apuesta y opcionalmente el período de validez.',
'bonus_rounds_p2': 'Una vez otorgadas, el jugador puede elegir cuándo iniciar la ronda de bonificación. Una vez iniciada, se coloca automáticamente una apuesta con la cantidad especificada.',
'bonus_rounds_p3': 'Las rondas de bonificación pueden tener un límite de tiempo, después del cual quedan inválidas.',
'bonus_rounds_p4': 'La inactividad del jugador puede resultar en la cancelación de una ronda de bonificación activa. En este caso, se reduce el número de rondas y el saldo del jugador permanece igual.',
'valid_until': 'válido hasta',
'bonus': 'bono',
'rounds': 'rondas',
'win_eur': 'ganar EUR',
'complete_your_bet': 'Por favor, completa tu apuesta primero',
'complete_auto_play': 'Por favor, completa primero el juego automático',
'yes': 'sí',
'no': 'no',
'play_bonus_rounds': '¿Jugar rondas de bonificación?',
'bet_history': 'Historial de apuestas',
'jackpot_history': 'Historial de jackpot',
'ticket_id': 'ID de boleto',
'created': 'hora de creación',
'currency': 'moneda',
'bet': 'apuesta',
'bet_eur': 'apuesta EUR',
'lanes': 'carriles',
'cars': 'coches',
'multiplier': 'multiplicador',
'win': 'ganancia',
'no_betting_history': 'No se encontró historial de apuestas. Haz una apuesta y aparecerá aquí.',
'no_jackpot_history': 'No hay historial de jackpot disponible.',
'date': 'fecha',
'user': 'usuario',
'bet_already_active': 'Apuesta ya activa',
'please_play_the_game_in_portait_mode': 'Por favor, juega en modo vertical.',
'bonus_history': 'Historial de bonos',
'bonus_type': 'Tipo de bono',
'no_bonus_history': 'No hay historial de bonos disponible.',
'game_menu': 'Menú del juego',
'game_menu_ss': 'De izquierda a derecha: Inicio, Historial de apuestas, Reglas del juego, Atajos de teclado, Configuración de sonido y música',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'REGLAS DEL JUEGO',
'game_rules_p1': '¡Bienvenido a Plinko, donde la suerte toma la delantera!',
'game_rules_p2': 'Prepárate para un emocionante juego de azar tan simple como adictivo. Plinko consiste en dejar caer una bola sobre una pirámide llena de clavijas y observar cómo rebota, gira y zigzaguea hasta caer en una ranura llena de premios al final.',
'game_rules_p3': 'Elige entre 8 y 16 filas de clavijas, luego siéntate y disfruta del caos mientras la bola zigzaguea a través del tablero, guiada solo por la gravedad y la suerte.',
'game_rules_p4': '¿Caerá en una ranura de baja recompensa... o logrará el gran premio? Solo hay una forma de saberlo: ¡deja caer la bola y deja que la emoción comience!',
'general': 'GENERAL',
'general_p1': 'Deja caer la bola Plinko y espera que caiga en una de las ranuras con mayores pagos al fondo. El camino es impredecible: cada rebote puede cambiar tu suerte.',
'general_p2': '¡Cuantas más filas juegues, más intensa será la acción!',
'general_p3': 'Así que adelante: confía en tu suerte, presiona DROP y persigue esa gran victoria entre las clavijas de Plinko.',
'betting': 'APUESTAS',
'betting_p1': 'Elige el monto de la apuesta. Los botones “1/2”, “2x”, “Max” se pueden usar para gestionar el tamaño de la apuesta. El monto de la apuesta también se puede introducir manualmente.',
'betting_p2': 'Elige el Nivel de Riesgo: Bajo, Medio o Alto. Un nivel de riesgo más bajo ofrece resultados más consistentes (baja volatilidad), mientras que uno más alto ofrece mayor variación (alta volatilidad).',
'betting_p3': 'Elige el número de líneas en el juego: de 8 a 16. Selecciona cuántas filas de clavijas atravesará la bola. Más filas = mayor imprevisibilidad.',
'betting_p4': 'Elige el Modo de Apuesta: Manual o Automático.',
'betting_p5': 'Para iniciar la ronda del juego, pulsa el botón DROP BALL. Durante la ronda, todos los botones de apuesta quedan inactivos excepto DROP BALL y el monto de la apuesta.',
'betting_p6': 'Una bola de Plinko representa una ronda. Durante la ronda, se puede iniciar otra ronda con la misma configuración usando el botón DROP BALL. Es posible cambiar el monto de la apuesta mientras haya bolas “activas” en el tablero, pero no la dificultad del juego.',
'betting_p7': 'Al final de la ronda, la bola llega a un bolsillo. En cada bolsillo se muestra el multiplicador de pago.',
'betting_p8': 'El cálculo de la ganancia se realiza según el multiplicador en el que aterrizó la bola. El resultado se añade al saldo.',
'game_menu_p1': 'Los multiplicadores de apuestas más recientes se muestran en la parte inferior de la ventana del juego.',
'game_menu_p2': 'A través del botón “Bet history”, el jugador puede revisar sus últimas apuestas con más detalle.',
'game_menu_p3': 'Para un historial de juego más amplio (por ejemplo, períodos más largos), el jugador puede necesitar acceder a su historial dentro de la propia plataforma de juego.',
'game_menu_p4': 'A través del menú del juego, los jugadores pueden controlar las opciones de sonido, los atajos de teclado y abrir el historial de apuestas y las reglas del juego.',
'game_menu_p5': 'El juego está diseñado con hermosa música de fondo y efectos de sonido. La música y/o los efectos de sonido se pueden desactivar mediante los iconos del menú del juego.',
'game_menu_p6': 'El historial del juego mostrará una ventana con apuestas anteriores y el historial de bonificaciones.',
'autoplay': 'Modo Automático (Autoplay)',
'autoplay_p1': 'Al hacer clic en Auto, puedes soltar automáticamente varias bolas sin tener que hacer clic cada vez.',
'autoplay_p2': 'Elige el monto que deseas apostar por cada bola.',
'autoplay_p3': 'Selecciona cuántas veces (rondas) quieres que caiga la bola — hasta un máximo de 100 rondas.',
'autoplay_p4': 'Pulsa el botón START para comenzar y el botón cambiará a STOP.',
'autoplay_p5': 'El modo automático se detendrá cuando se complete el número seleccionado de caídas, se agoten los fondos o pulses STOP.',
'autoplay_p6': 'Cada caída utiliza el mismo monto de apuesta que seleccionaste antes de iniciar el Modo Automático.',
'turbo_mode': 'Modo Turbo',
'turbo_mode_p1': 'Turbo Drop te permite soltar bolas a gran velocidad manteniendo presionado el botón DROP.',
'turbo_mode_p2': 'Las bolas seguirán cayendo hasta que sueltes el botón o se agote el saldo.',
'turbo_mode_p3': 'Las bolas seguirán cayendo hasta que sueltes el botón o se agote el saldo.',
'turbo_balance': 'Saldo Turbo',
'turbo_balance_p1': 'Antes de iniciar Turbo Drop, eliges cuánto dinero reservar — esto se convierte en tu Saldo Turbo.',
'turbo_balance_p2': 'Mientras Turbo Drop está activo, el juego utiliza únicamente tu Saldo Turbo para apuestas y ganancias.',
'turbo_balance_p3': 'Cuando detienes Turbo Drop, cualquier Saldo Turbo restante vuelve a tu saldo principal.',
'turbo_balance_p4': 'Puedes salir de Turbo Drop en cualquier momento — pero el modo finalizará por completo solo después de que todas las bolas hayan terminado de caer y aterrizado en los bolsillos de multiplicadores.',
'free_bets': 'RONDAS DE BONIFICACIÓN',
'free_bets_p1': 'Las rondas de bonificación son otorgadas por el operador.',
'fairness': 'Equidad',
'fairness_p1': 'Cada caída se determina mediante un generador de números aleatorios demostrablemente justo (RNG).',
'fairness_p2': 'El resultado no puede ser predicho ni influenciado una vez que la bola ha caído.',
'disconection_and_error': 'Política de desconexión y manejo de errores',
'disconection_and_error_p1': 'Si la conexión se pierde después de realizar una apuesta, esta no se cancelará. Si el juego requiere acción del jugador, el resultado se contará asumiendo que el jugador eligió la acción sin riesgo sin aumentar la apuesta inicial.',
'disconection_and_error_p2': 'En caso de error, nuestro equipo de soporte intentará resolver el problema lo antes posible y reanudar el juego normal. En caso de un problema con el juego, todas las apuestas serán canceladas y el monto apostado devuelto a los jugadores.',
'other': 'Otros',
'other_p1': 'En caso de mal funcionamiento del hardware/software del juego, todas las apuestas y pagos afectados serán anulados y todas las apuestas afectadas serán reembolsadas.',
'other_p2': 'Las reglas del juego están publicadas en inglés. Las traducciones a otros idiomas se proporcionan como un servicio de buena fe. En caso de ambigüedad entre la versión en inglés y una traducción, la versión en inglés tiene prioridad.',
'rows': 'Filas',
'lvl': 'Nivel',
'low': 'Bajo',
'high': 'Alto',
'ok': 'OK',
'exit_turbo_mode': '¿Desea salir del modo Turbo?',
"end": "FIN",
"turbo_mode_settings": "Configuración del modo Turbo",
"stop": "DETENER",
'invalid_bet_amount': 'Monto de apuesta inválido',
'cashout_success': 'Cobro exitoso',
'stop_auto_play_first': 'Por favor, detén primero el modo automático.',
'turbo_only_when_no_balls': 'El modo Turbo solo se puede iniciar cuando no hay bolas en el tablero.',
'type': 'Tipo de apuesta',
'wait_balls_to_finish': 'Por favor, espera a que las bolas terminen.',
'bet_too_large_top_up_turbo_balance': '¡La apuesta es demasiado grande – recarga tu Saldo Turbo!',
};
langArr.fr = {
'loading': 'Chargement',
'hotkeys': 'Raccourcis clavier',
'hotkeys_enabled': 'Raccourcis clavier activés',
'enable_hotkeys_checkbox': 'Activez les raccourcis clavier ci-dessous en cochant cette case.',
'drop_ball': 'Faire un pari',
'double_bet': 'Doubler un montant de pari',
'halve_bet': 'Diviser un montant de pari par deux',
'min_bet': 'Montant minimum du pari',
'max': 'Max',
'easy': 'Facile',
'medium': 'Moyen',
'hard': 'Difficile',
'daredevil': 'Casse-cou',
'max_profit': 'Profit maximal',
'manual': 'Manuel',
'auto': 'Auto',
'bet_amount': 'Montant du pari',
'difficulty': 'Difficulté',
'payout_on_win': 'Gain en cas de victoire',
'number_of_bets': 'Nombre de paris',
'on_win': 'En cas de victoire',
'on_loss': 'En cas de perte',
'stop_on_profit': 'Arrêter en cas de profit',
'stop_on_loss': 'Arrêter en cas de perte',
'reset': 'Réinitialiser',
'increase_by': 'Augmenter de',
'cashout': 'ENCACHER',
'start_game': 'PARIER',
'start_auto_game': 'DÉMARRER',
'difficulity_info': 'Infos sur la difficulté',
'chance_collision': 'Chance de collision par jeu',
'evry_25_lane': 'Tous les 25 parcours',
'insufficiend_funds': 'Fonds insuffisants',
'cashout_inactivity': 'Encaissement en cas d\'inactivité',
'time_running_out': 'Le temps est presque écoulé ! Jouez maintenant ou votre ticket sera retiré automatiquement dans 30 secondes',
'there_was_error': 'IL Y A EU UNE ERREUR, VEUILLEZ ESSAYER À NOUVEAU OU RECHARGER',
'detailed_game_rules': 'Règles du jeu détaillées',
'general_rules': 'RÈGLES GÉNÉRALES',
'general_rules_p1': '• Le multiplicateur commence à 1 et monte jusqu\'à',
'general_rules_p2': '• Les gains sont calculés en multipliant le montant du pari par le multiplicateur affiché à chaque étape.',
'general_rules_p3': '• Si le paiement maximum est atteint, le jeu encaissera automatiquement au montant du paiement maximum.',
'progressive_jackpot': 'JACKPOT PROGRESSIF',
'progressive_jackpot_ss': 'Le parcours du jackpot et le gain possible',
'progressive_jackpot_p1': '% de chaque mise est dédié à un fonds de jackpot progressif.',
'progressive_jackpot_p2': 'Le jackpot est attribué en utilisant une mécanique "Mystery" ou "must-hit-by". La valeur de chaque jackpot "must-hit-by" est déterminée immédiatement après qu\'un jackpot précédent a été gagné par un générateur de nombres aléatoires et stockée comme une valeur cryptée dans la base de données distante. La valeur est cryptée et donc cachée et n\'est pas connue.',
'progressive_jackpot_p3': 'Une fois que la valeur "must-hit-by" est atteinte, le premier joueur à parier après cette valeur aura la chance de gagner le jackpot. Un symbole de jackpot apparaîtra sur un parcours aléatoire, et le jackpot sera gagné si le joueur atteint le parcours avec le symbole. Si le joueur ne parvient pas à atteindre le parcours avec le symbole du jackpot en encaissant ou en s\'écrasant, le prochain joueur aléatoire à parier verra apparaître le symbole du jackpot et aura la chance de gagner. Ce processus se répète jusqu\'à ce que le jackpot soit gagné. Un seul ticket/joueur peut gagner le jackpot.',
'progressive_jackpot_p4': 'NOTE : Le tour bonus ne contribue pas au fonds du jackpot. Pendant le tour bonus, le jackpot ne peut pas être gagné.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Carré rouge, emplacement de la collision certaine',
'showdown_p1': 'Après que le joueur ait encaissé, un carré rouge sera affiché à l\'emplacement où la collision se serait produite si le joueur avait continué à sauter les parcours.',
'return_to_player': 'RETOUR AU JOUEUR',
'return_to_player_p1': 'Le retour théorique au joueur (RTP) global est de',
'return_to_player_p2': 'Les pourcentages RTP sont continuellement surveillés et vérifiés par des tiers indépendants.',
'disconnection_policy': 'POLITIQUE DE DÉCONNEXION',
'disconnection_policy_p1': 'Si la connexion est perdue après qu\'un pari ait été placé, le pari ne sera pas annulé immédiatement. Si l\'inactivité du joueur atteint',
'disconnection_policy_p2': 'le pari sera automatiquement encaissé et les crédits seront appliqués au compte du joueur.',
'network_latency': 'LATENCE RÉSEAU',
'network_latency_p1': 'La latence réseau fait partie intégrante de la connectivité Internet. Nous considérons tous les paris et encaissements comme valides uniquement au moment où ils atteignent notre serveur, quelle que soit la durée de la latence réseau.',
'sound': 'SON',
'sound_p1': 'Le jeu est conçu avec une belle musique de fond et des effets sonores. Si vous souhaitez désactiver la musique et/ou les effets sonores, vous pouvez le faire via les icônes du menu du jeu.',
'error_handling': 'GESTION DES ERREURS',
'error_handling_p1': 'En cas d\'erreur, notre équipe d\'assistance tentera de résoudre le problème dès que possible et de reprendre le jeu normalement. En cas de problème avec le jeu lui-même, tous les paris seront annulés et le montant du pari sera retourné aux joueurs.',
'max_payout': 'Le paiement maximum est de',
'max_bet_is': 'Le pari maximum est de',
'min_bet_is': 'Le pari minimum est de',
'per_bet': 'par pari.',
'malfunction_voids': 'Le dysfonctionnement annule tous les paiements et jeux.',
'attention_jackpot': 'Attention, jackpot sur le parcours',
'lane': 'parcours',
'congratulations': 'félicitations',
'you_won': 'vous avez gagné',
'balance': 'solde',
'time': 'temps',
'jackpot': 'jackpot',
'escaped': 'ÉCHAPPÉ',
'max_win': 'GAGNE MAXIMAL',
'check_internet': 'Veuillez vérifier votre connexion Internet',
'websocket_disconected': 'Websocket déconnecté',
'websocket_connection_error': 'Erreur de connexion Websocket !',
'session_expired': 'Session expirée, veuillez recharger',
'remaining_bets': 'Paris restants',
'stop_autoplay': 'ARRÊTER',
'autoplay_and_autocashout': 'AUTOPLAY ET AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Sélection entre manuel et autoplay',
'autoplay_and_autocashout_p1': 'Un joueur peut activer l\'option autoplay où un pari est automatiquement placé pour chaque nouveau tour en utilisant le montant du pari du tour précédent.',
'autoplay_and_autocashout_p2': 'Un multiplicateur d\'encaissement automatique peut être sélectionné depuis l\'écran du jeu, et une fois défini, le jeu encaissera automatiquement si le joueur n\'est pas touché avant d\'atteindre le multiplicateur sélectionné.',
'autoplay_and_autocashout_p3': 'Le nombre maximum de tours autoplay est de',
'autoplay_button_label': 'Pour commencer, choisissez un parcours.',
'min_bet_amount_is': 'Le montant minimum du pari est',
'bonus_rounds': 'Tours bonus',
'bonus_rounds_ss': 'Les tours bonus avec période de validité',
'bonus_rounds_p1': 'Un joueur peut recevoir un tour bonus (c\'est-à-dire un pari gratuit) en fonction d\'une promotion du casino. Un graphique popup apparaîtra à l\'écran pour informer le joueur des tours bonus attribués, du nombre de paris, du montant par pari et éventuellement de la période de validité.',
'bonus_rounds_p2': 'Une fois attribués, le joueur peut choisir quand commencer le tour bonus. Une fois le tour bonus commencé, un pari automatique avec la mise spécifiée est placé, et il appartient au joueur d\'encaisser à tout moment.',
'bonus_rounds_p3': 'Les tours bonus peuvent avoir une limite de temps, après laquelle ils deviennent caducs et inutilisables. La période de validité, si elle existe, est affichée sous le tour bonus.',
'bonus_rounds_p4': 'L\'inactivité du joueur peut entraîner l\'annulation d\'un tour bonus actif. Dans ce cas, le nombre de tours bonus est réduit et le solde du joueur reste le même.',
'valid_until': 'valide jusqu\'à',
'bonus': 'bonus',
'rounds': 'tours',
'win_eur': 'gagner EUR',
'complete_your_bet': 'Veuillez d\'abord compléter votre pari',
'complete_auto_play': 'Veuillez d\'abord compléter votre autoplay',
'yes': 'oui',
'no': 'non',
'play_bonus_rounds': 'Jouer aux tours bonus ?',
'bet_history': 'Historique des paris',
'jackpot_history': 'Historique des jackpots',
'ticket_id': 'ID du ticket',
'created': 'heure de création',
'currency': 'monnaie',
'bet': 'pari',
'bet_eur': 'pari EUR',
'lanes': 'parcours',
'cars': 'voitures',
'multiplier': 'multiplicateur',
'win': 'gain',
'no_betting_history': 'Aucun historique de paris trouvé. Faites un pari, il apparaîtra ici.',
'no_jackpot_history': 'Aucun historique de jackpot disponible.',
'date': 'date',
'user': 'utilisateur',
'bet_already_active': 'Le pari est déjà actif',
'please_play_the_game_in_portait_mode': 'Veuillez jouer en mode portrait.',
'bonus_history': 'Historique des bonus',
'bonus_type': 'Type de bonus',
'no_bonus_history': 'Aucun historique de bonus disponible.',
'game_menu': 'Menu du jeu',
'game_menu_ss': 'De gauche à droite : Accueil, Historique des paris, Règles du jeu, Raccourcis clavier, Paramètres des effets sonores, Musique',
// 'game_menu_p1': 'Grâce au menu du jeu, les joueurs peuvent contrôler les options de son, les raccourcis clavier, ainsi qu\'ouvrir l\'historique du jeu et les règles du jeu.',
// 'game_menu_p2': 'L\'historique du jeu affichera une fenêtre avec les paris précédents et l\'historique des bonus.',
'game_rules': 'RÈGLES DU JEU',
'game_rules_p1': 'Bienvenue à Plinko – Où la chance mène la danse !',
'game_rules_p2': 'Préparez-vous pour un jeu de hasard palpitant, aussi simple qu’addictif ! Plinko consiste à laisser tomber une bille sur une pyramide remplie de chevilles, puis à la regarder rebondir, tourner et ricocher jusqu’à atteindre une fente remplie de prix en bas.',
'game_rules_p3': 'Choisissez entre 8 et 16 rangées de chevilles, puis asseyez-vous et profitez du chaos pendant que la bille zigzague à travers le plateau, guidée uniquement par la gravité et la chance.',
'game_rules_p4': 'Va-t-elle tomber dans une fente à faible gain… ou décrocher le gros lot ? Il n’y a qu’une seule façon de le savoir — laissez tomber la bille et laissez l’excitation commencer !',
'general': 'GÉNÉRAL',
'general_p1': 'Laissez tomber la bille Plinko et espérez qu’elle atterrisse dans l’une des fentes à haute valeur en bas. Le chemin est imprévisible — chaque rebond peut changer votre fortune.',
'general_p2': 'Plus vous jouez de rangées, plus l’action est intense !',
'general_p3': 'Alors allez-y — faites confiance à votre chance, appuyez sur DROP, et poursuivez ce gros gain à travers les chevilles de Plinko !',
'betting': 'PARIS',
'betting_p1': 'Choisissez le montant de la mise. Les boutons “1/2”, “2x”, “Max” peuvent être utilisés pour gérer le montant de la mise. Le montant peut également être saisi manuellement.',
'betting_p2': 'Choisissez le niveau de risque : Faible, Moyen ou Élevé. Un niveau de risque plus faible offre des résultats plus stables (faible volatilité), tandis qu’un niveau plus élevé offre une plus grande variation (forte volatilité).',
'betting_p3': 'Choisissez le nombre de lignes dans le jeu : de 8 à 16. Sélectionnez le nombre de rangées de clous que la balle traversera. Plus de rangées = plus d’imprévisibilité.',
'betting_p4': 'Choisissez le mode de mise : Manuel ou Automatique.',
'betting_p5': 'Pour démarrer le tour de jeu, appuyez sur le bouton DROP BALL. Pendant le tour, tous les boutons de mise sont désactivés sauf DROP BALL et le montant de la mise.',
'betting_p6': 'Une balle de Plinko représente un tour. Pendant le tour, un autre tour peut être lancé avec les mêmes paramètres en utilisant le bouton DROP BALL. Il est possible de modifier le montant de la mise tant qu’il y a des balles « actives » sur le plateau, mais pas la difficulté du jeu.',
'betting_p7': 'À la fin du tour, la balle arrive dans une case. Chaque case affiche le multiplicateur de paiement.',
'betting_p8': 'Le calcul du gain est effectué selon le multiplicateur sur lequel la balle s’est arrêtée. Le résultat est ajouté au solde.',
'game_menu_p1': 'Les multiplicateurs de mise les plus récents sont affichés en bas de la fenêtre du jeu.',
'game_menu_p2': 'Via le bouton “Bet history”, le joueur peut consulter ses dernières mises avec plus de détails.',
'game_menu_p3': 'Pour un historique de jeu plus complet (par exemple sur des périodes plus longues), le joueur peut devoir accéder à son historique directement sur la plateforme de jeu.',
'game_menu_p4': 'Via le menu du jeu, les joueurs peuvent contrôler les paramètres audio, les raccourcis clavier et ouvrir l’historique des mises et les règles du jeu.',
'game_menu_p5': 'Le jeu est conçu avec une belle musique de fond et des effets sonores. La musique et/ou les effets sonores peuvent être désactivés via les icônes du menu du jeu.',
'game_menu_p6': 'L’historique du jeu affichera une fenêtre avec les mises précédentes et l’historique des bonus.',
'autoplay': 'Mode Automatique (Autoplay)',
'autoplay_p1': 'En cliquant sur Auto, vous pouvez laisser tomber automatiquement plusieurs balles sans avoir à cliquer à chaque fois.',
'autoplay_p2': 'Choisissez le montant que vous souhaitez miser par balle.',
'autoplay_p3': 'Sélectionnez le nombre de fois (tours) que vous souhaitez faire tomber la balle — jusqu’à un maximum de 100 tours.',
'autoplay_p4': 'Appuyez sur le bouton START pour commencer et le bouton passera à STOP.',
'autoplay_p5': 'Le mode automatique s’arrêtera lorsque le nombre de chutes sélectionné sera atteint, que les fonds seront épuisés ou si vous appuyez sur STOP.',
'autoplay_p6': 'Chaque chute utilise le même montant de mise que celui sélectionné avant de démarrer le mode automatique.',
'turbo_mode': 'Mode Turbo',
'turbo_mode_p1': 'Turbo Drop vous permet de faire tomber des balles à une vitesse extrêmement élevée en maintenant le bouton DROP enfoncé.',
'turbo_mode_p2': 'Les balles continueront de tomber jusqu’à ce que vous relâchiez le bouton ou que le solde soit épuisé.',
'turbo_mode_p3': 'Les balles continueront de tomber jusqu’à ce que vous relâchiez le bouton ou que le solde soit épuisé.',
'turbo_balance': 'Solde Turbo',
'turbo_balance_p1': 'Avant de démarrer le Turbo Drop, vous choisissez le montant d’argent à réserver — il devient votre Solde Turbo.',
'turbo_balance_p2': 'Lorsque le Turbo Drop est actif, le jeu utilise uniquement votre Solde Turbo pour les mises et les gains.',
'turbo_balance_p3': 'Lorsque vous arrêtez le Turbo Drop, tout solde Turbo restant est reversé à votre solde principal.',
'turbo_balance_p4': 'Vous pouvez quitter le Turbo Drop à tout moment — mais le mode ne se terminera complètement qu’après que toutes les balles aient fini de tomber et atteint les cases de multiplicateurs.',
'free_bets': 'TOURS BONUS',
'free_bets_p1': 'Les tours bonus sont accordés par l’opérateur.',
'fairness': 'Équité',
'fairness_p1': 'Chaque chute est déterminée par un générateur de nombres aléatoires (RNG) prouvablement équitable.',
'fairness_p2': 'Le résultat ne peut être prédit ou influencé une fois la bille tombée.',
'disconection_and_error': 'Politique de déconnexion et gestion des erreurs',
'disconection_and_error_p1': 'Si la connexion est perdue après qu’un pari ait été placé, le pari ne sera pas annulé. Si le jeu requiert une action du joueur, le résultat est compté comme si le joueur avait choisi l’action sans risque sans augmenter la mise initiale.',
'disconection_and_error_p2': 'En cas d’erreur, notre équipe de support tentera de résoudre le problème rapidement et de reprendre le jeu normal. En cas de problème avec le jeu lui-même, tous les paris seront annulés et les mises retournées aux joueurs.',
'other': 'Autres',
'other_p1': 'En cas de dysfonctionnement du matériel/logiciel du jeu, tous les paris et paiements affectés sont annulés et tous les paris concernés sont remboursés.',
'other_p2': 'Les règles du jeu sont publiées en anglais. Les traductions dans d’autres langues sont fournies en bonne foi. En cas d’ambiguïté entre la version anglaise et une traduction, la version anglaise prévaut.',
'rows': 'Rangées',
'lvl': 'Niveau',
'low': 'Bas',
'high': 'Haut',
'ok': 'OK',
'exit_turbo_mode': 'Voulez-vous quitter le mode Turbo ?',
"end": "FIN",
"turbo_mode_settings": "Paramètres du mode Turbo",
"stop": "ARRÊTER",
'invalid_bet_amount': 'Montant de pari invalide',
'cashout_success': 'Encaissement réussi',
'stop_auto_play_first': 'Veuillez d\'abord arrêter le mode automatique.',
'turbo_only_when_no_balls': 'Le mode Turbo ne peut être démarré que lorsqu\'il n\'y a pas de balles sur le plateau.',
'type': 'Type de pari',
'wait_balls_to_finish': 'Veuillez attendre que les balles se terminent.',
'bet_too_large_top_up_turbo_balance': 'Le pari est trop élevé – reconstituez votre Solde Turbo !',
};
langArr.he = {
'loading': 'טוען',
'hotkeys': 'קיצורי מקלדת',
'hotkeys_enabled': 'קיצורי מקלדת מופעלים',
'enable_hotkeys_checkbox': 'אפשר את קיצורי המקשים המופיעים למטה על ידי סימון תיבה זו.',
'drop_ball': 'שחרר כדור',
'double_bet': 'הכפל את ההימור',
'halve_bet': 'חצי את ההימור',
'min_bet': 'הימור מינימלי',
'max': 'מקסימום',
'easy': 'קל',
'medium': 'בינוני',
'hard': 'קשה',
'daredevil': 'נועז',
'max_profit': 'רווח מקסימלי',
'manual': 'ידני',
'auto': 'אוטומטי',
'bet_amount': 'סכום ההימור',
'difficulty': 'קושי',
'payout_on_win': 'תשלום בניצחון',
'number_of_bets': 'מספר ההימורים',
'on_win': 'בזמן ניצחון',
'on_loss': 'בזמן הפסד',
'stop_on_profit': 'עצור ברווח',
'stop_on_loss': 'עצור בהפסד',
'reset': 'איפוס',
'increase_by': 'הגדל ב',
'cashout': 'משוך מזומנים',
'start_game': 'הימור',
'start_auto_game': 'התחל',
'difficulity_info': 'מידע על הקושי',
'chance_collision': 'סיכוי להתנגשות לכל משחק',
'evry_25_lane': 'לכל 25 מסלולים',
'insufficiend_funds': 'חוסר במזומנים',
'cashout_inactivity': 'משיכת מזומנים אוטומטית עקב חוסר פעילות',
'time_running_out': 'הזמן אוזל! שחק עכשיו או שהכרטיס שלך יוסר אוטומטית תוך 30 שניות',
'there_was_error': 'אירעה שגיאה, נא לנסות שוב או לרענן',
'detailed_game_rules': 'כללי משחק מפורטים',
'general_rules': 'כללים כלליים',
'general_rules_p1': '• המכפיל מתחיל ב-1 ועולה עד ',
'general_rules_p2': '• הזכיות מחושבות על ידי הכפלת סכום ההימור במכפיל שמוצג בכל שלב.',
'general_rules_p3': '• אם הושג התשלום המרבי, המשחק ימשוך אוטומטית את הסכום המרבי.',
'progressive_jackpot': 'ג\'קפוט פרוגרסיבי',
'progressive_jackpot_ss': 'מסלול הג\'קפוט והזכייה האפשרית',
'progressive_jackpot_p1': '% מכל הימור מוקדש לקרן הג\'קפוט הפרוגרסיבי.',
'progressive_jackpot_p2': 'הג\'קפוט מוענק באמצעות מנגנון "Mystery" או "must-hit-by". ערך כל ג\'קפוט "must-hit-by" נקבע מיד לאחר הג\'קפוט הקודם על ידי מחולל מספרים אקראי ונשמר כערך מוצפן במסד הנתונים.',
'progressive_jackpot_p3': 'ברגע שהערך "must-hit-by" הושג, השחקן הראשון שמבצע הימור אחריו יקבל הזדמנות לזכות בג\'קפוט. סמל ג\'קפוט יופיע במסלול אקראי והג\'קפוט יזכה אם השחקן יגיע למסלול עם הסמל.',
'progressive_jackpot_p4': 'הערה: סבב הבונוס אינו תורם לקרן הג\'קפוט. במהלך סבב הבונוס אין אפשרות לזכות בג\'קפוט.',
'showdown': 'התמודדות',
'showdown_ss': 'ריבוע אדום, מיקום התנגשות מסוימת',
'showdown_p1': 'לאחר שהשחקן מושך מזומנים, ריבוע אדום יוצג במיקום שבו הייתה מתרחשת ההתנגשות אם השחקן היה ממשיך לדלג על מסלולים.',
'return_to_player': 'החזר לשחקן',
'return_to_player_p1': 'החזר תיאורטי כולל לשחקן (RTP) הוא ',
'return_to_player_p2': 'אחוזי ה-RTP מנוטרים ומאומתים באופן רציף על ידי צדדים שלישיים עצמאיים.',
'disconnection_policy': 'מדיניות ניתוק',
'disconnection_policy_p1': 'אם הקשר אובד לאחר שהימור בוצע, ההימור לא יבוטל מיד. אם חוסר הפעילות של השחקן מגיע ל-',
'disconnection_policy_p2': 'ההימור ימשוך אוטומטית והקרדיטים יתווספו לחשבון השחקן.',
'network_latency': 'שהייה ברשת',
'network_latency_p1': 'שהיית רשת היא חלק בלתי נמנע מחיבור לאינטרנט. אנו מחשיבים את כל ההימורים והמשיכות כתקפים רק בזמן שהם מגיעים לשרת שלנו, ללא קשר לאורך השהייה ברשת.',
'sound': 'צליל',
'sound_p1': 'המשחק מעוצב עם מוזיקת רקע יפה ואפקטים קוליים. אם ברצונך להשבית מוזיקה ו/או אפקטים קוליים, ניתן לעשות זאת דרך סמלי התפריט של המשחק.',
'error_handling': 'ניהול שגיאות',
'error_handling_p1': 'במקרה של שגיאה, צוות התמיכה שלנו ינסה לפתור את הבעיה במהירות האפשרית ולהמשיך במשחק. במקרה של בעיה במשחק עצמו, כל ההימורים יבוטלו והסכום יוחזר לשחקנים.',
'max_payout': 'תשלום מקסימלי הוא ',
'max_bet_is': 'ההימור המקסימלי הוא ',
'min_bet_is': 'ההימור המינימלי הוא ',
'per_bet': 'להימור.',
'malfunction_voids': 'תקלה מבטלת את כל התשלומים והמשחקים.',
'attention_jackpot': 'תשומת לב, ג\'קפוט במסלול ',
'lane': 'מסלול',
'congratulations': 'מזל טוב',
'you_won': 'נצחת',
'balance': 'יתרה',
'time': 'זמן',
'jackpot': 'ג\'קפוט',
'escaped': 'נמלט',
'max_win': 'ניצחון מקסימלי',
'check_internet': 'אנא בדוק את חיבור האינטרנט שלך',
'websocket_disconected': 'Websocket מנותק',
'websocket_connection_error': 'שגיאת חיבור Websocket!',
'session_expired': 'הסשן פג, נא לרענן',
'remaining_bets': 'הימורים נותרו',
'stop_autoplay': 'עצור',
'autoplay_and_autocashout': 'ניגון אוטומטי ומשיכת מזומנים אוטומטית',
'autoplay_and_autocashout_ss': 'בחירה בין ידני לאוטומטי',
'autoplay_and_autocashout_p1': 'שחקן יכול להפעיל את אפשרות הניגון האוטומטי, כאשר הימור מונח אוטומטית לכל סבב חדש באמצעות סכום ההימור הקודם.',
'autoplay_and_autocashout_p2': 'ניתן לבחור מכפיל משיכה אוטומטית, ואם מוגדר, המשחק ימשוך אוטומטית אם השחקן לא נפגע לפני הגעה למכפיל הנבחר.',
'autoplay_and_autocashout_p3': 'מספר מקסימלי של סבבי ניגון אוטומטי הוא ',
'autoplay_button_label': 'כדי להתחיל, בחר מסלול.',
'min_bet_amount_is': 'סכום ההימור המינימלי הוא',
'bonus_rounds': 'סבבי בונוס',
'bonus_rounds_ss': 'סבבי הבונוס עם תקופת תוקף',
'bonus_rounds_p1': 'שחקן עשוי לקבל סבב בונוס (למשל הימור חינם) בהתאם למבצע קזינו. חלון קופץ יופיע על המסך ויודיע לשחקן על סבבי הבונוס שהוענקו, מספר ההימורים, הסכום לכל הימור ואפשרות לתקופת תוקף.',
'bonus_rounds_p2': 'לאחר שהוענקו, השחקן יכול לבחור מתי להתחיל את סבב הבונוס. לאחר התחלת הסבב, הימור אוטומטי יונח עם הסכום שצויין.',
'bonus_rounds_p3': 'סבבי הבונוס עשויים להיות מוגבלים בזמן, ולאחר מכן הם מבוטלים.',
'bonus_rounds_p4': 'חוסר פעילות של השחקן עשוי לגרום לביטול סבב בונוס פעיל. במקרה זה, מספר סבבי הבונוס מצטמצם והיתרה של השחקן נשארת זהה.',
'valid_until': 'תקף עד',
'bonus': 'בונוס',
'rounds': 'סבבים',
'win_eur': 'נצח EUR',
'complete_your_bet': 'אנא השלם את ההימור שלך קודם',
'complete_auto_play': 'אנא השלם את הניגון האוטומטי קודם',
'yes': 'כן',
'no': 'לא',
'play_bonus_rounds': 'לשחק סבבי בונוס?',
'bet_history': 'היסטוריית הימורים',
'jackpot_history': 'היסטוריית ג\'קפוט',
'ticket_id': 'מספר כרטיס',
'created': 'שעת יצירה',
'currency': 'מטבע',
'bet': 'הימור',
'bet_eur': 'הימור EUR',
'lanes': 'מסלולים',
'cars': 'מכוניות',
'multiplier': 'מכפיל',
'win': 'ניצחון',
'no_betting_history': 'לא נמצאה היסטוריית הימורים. בצע הימור והוא יופיע כאן.',
'no_jackpot_history': 'אין היסטוריית ג\'קפוט זמינה.',
'date': 'תאריך',
'user': 'שחקן',
'bet_already_active': 'ההימור כבר פעיל',
'please_play_the_game_in_portait_mode': 'אנא שחק במצב פורטרט.',
'bonus_history': 'היסטוריית בונוס',
'bonus_type': 'סוג הבונוס',
'no_bonus_history': 'אין היסטוריית בונוס זמינה.',
'game_menu': 'תפריט המשחק',
'game_menu_ss': 'משמאל: בית, היסטוריית הימורים, כללי המשחק, קיצורי מקלדת, הגדרות סאונד ומוזיקה',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'חוקי המשחק',
'game_rules_p1': 'ברוכים הבאים לפלינקו – המקום שבו המזל מוביל!',
'game_rules_p2': 'התכוננו למשחק מזל מרגש, פשוט וממכר! בפלינקו משחררים כדור על פירמידה מלאה יתדות וצופים כיצד הוא קופץ, מסתובב ומתגלגל למטה לתא פרסים בתחתית.',
'game_rules_p3': 'בחרו בין 8 ל-16 שורות יתדות, ואז שבו ותהנו מהכאוס כשהכדור זיגזג בלוח, מונע רק על ידי כוח הכבידה והמזל.',
'game_rules_p4': 'האם הוא ייפול לתא עם תשלום נמוך... או יזכה בפרס הגדול? יש רק דרך אחת לגלות – שחררו את הכדור ותנו להתרגשות להתחיל!',
'general': 'כללי',
'general_p1': 'שחררו את כדור הפלינקו וקווו שייפול לאחד התאים עם התשלום הגבוה בתחתית. המסלול לא צפוי – כל קפיצה יכולה לשנות את המזל שלכם.',
'general_p2': 'ככל שתשחקו בשורות יותר, הפעולה תהיה יותר אינטנסיבית!',
'general_p3': 'אז קדימה – סמכו על המזל שלכם, לחצו DROP ורדפו אחרי הזכייה הגדולה בין היתדות של פלינקו!',
'betting': 'הימורים',
'betting_p1': 'בחר את סכום ההימור. ניתן להשתמש בכפתורים “1/2”, “2x”, “Max” לניהול סכום ההימור. ניתן גם להזין את סכום ההימור ידנית.',
'betting_p2': 'בחר רמת סיכון: נמוכה, בינונית או גבוהה. רמת סיכון נמוכה מציעה תוצאות יציבות יותר (תנודתיות נמוכה), בעוד שרמה גבוהה מציעה שונות גדולה יותר (תנודתיות גבוהה).',
'betting_p3': 'בחר את מספר הקווים במשחק: מ־8 עד 16. בחר בכמה שורות של פינים הכדור יעבור. יותר שורות = יותר חוסר צפיות.',
'betting_p4': 'בחר מצב הימור: ידני או אוטומטי.',
'betting_p5': 'כדי להתחיל סבב משחק, לחץ על כפתור DROP BALL. במהלך הסבב כל כפתורי ההימור מושבתים למעט DROP BALL וסכום ההימור.',
'betting_p6': 'כדור Plinko אחד מייצג סבב אחד. במהלך הסבב ניתן להתחיל סבב נוסף עם אותן הגדרות באמצעות כפתור DROP BALL. ניתן לשנות את סכום ההימור כל עוד יש כדורים “פעילים” בלוח, אך לא את רמת הקושי של המשחק.',
'betting_p7': 'בסיום הסבב, הכדור מגיע לתא. בכל תא מוצג מכפיל הזכייה.',
'betting_p8': 'חישוב הזכייה מתבצע לפי המכפיל שבו נחת הכדור. התוצאה מתווספת ליתרה.',
'game_menu_p1': 'מכפילי ההימור האחרונים מוצגים בתחתית חלון המשחק.',
'game_menu_p2': 'באמצעות כפתור “Bet history” השחקן יכול לבדוק את ההימורים האחרונים שלו בפירוט רב יותר.',
'game_menu_p3': 'להיסטוריית משחק רחבה יותר (לדוגמה, לתקופות זמן ארוכות יותר), ייתכן שהשחקן יצטרך לגשת להיסטוריה שלו בתוך פלטפורמת המשחק עצמה.',
'game_menu_p4': 'דרך תפריט המשחק, השחקנים יכולים לשלוט בהגדרות השמע, בקיצורי המקלדת ולפתוח את היסטוריית ההימורים ואת חוקי המשחק.',
'game_menu_p5': 'המשחק מעוצב עם מוזיקת רקע יפה ואפקטים קוליים. ניתן לכבות את המוזיקה ו/או האפקטים הקוליים באמצעות אייקוני תפריט המשחק.',
'game_menu_p6': 'היסטוריית המשחק תציג חלון עם הימורים קודמים והיסטוריית בונוסים.',
'autoplay': 'מצב אוטומטי (Autoplay)',
'autoplay_p1': 'בלחיצה על Auto ניתן להפיל אוטומטית מספר כדורים ללא צורך בלחיצה בכל פעם.',
'autoplay_p2': 'בחר את הסכום שברצונך להמר על כל כדור.',
'autoplay_p3': 'בחר כמה פעמים (סבבים) תרצה שהכדור ייפול — עד מקסימום של 100 סבבים.',
'autoplay_p4': 'לחץ על כפתור START כדי להתחיל והכפתור ישתנה ל־STOP.',
'autoplay_p5': 'המצב האוטומטי ייעצר כאשר יושלם מספר ההפלות שנבחר, כאשר הכספים יאזלו או כשתלחץ על STOP.',
'autoplay_p6': 'כל הפלה משתמשת באותו סכום הימור שנבחר לפני תחילת המצב האוטומטי.',
'turbo_mode': 'מצב טורבו',
'turbo_mode_p1': 'Turbo Drop מאפשר להפיל כדורים במהירות גבוהה במיוחד על ידי לחיצה ממושכת על כפתור DROP.',
'turbo_mode_p2': 'הכדורים ימשיכו ליפול עד שתשחרר את הכפתור או עד שהיתרה תאזל.',
'turbo_mode_p3': 'הכדורים ימשיכו ליפול עד שתשחרר את הכפתור או עד שהיתרה תאזל.',
'turbo_balance': 'יתרת טורבו',
'turbo_balance_p1': 'לפני תחילת Turbo Drop, בחר כמה כסף לשריין — סכום זה יהפוך ליתרת הטורבו שלך.',
'turbo_balance_p2': 'כאשר Turbo Drop פעיל, המשחק משתמש רק ביתרת הטורבו שלך לצורך הימורים וזכיות.',
'turbo_balance_p3': 'כאשר אתה עוצר את Turbo Drop, כל יתרת טורבו שנותרה חוזרת ליתרה הראשית שלך.',
'turbo_balance_p4': 'ניתן לצאת מ־Turbo Drop בכל עת — אך המצב יסתיים לחלוטין רק לאחר שכל הכדורים יסיימו ליפול ויגיעו לתאי המכפילים.',
'free_bets': 'סבבי בונוס',
'free_bets_p1': 'סבבי הבונוס מוענקים על ידי המפעיל.',
'fairness': 'הגינות',
'fairness_p1': 'כל הפלה נקבעת על ידי מחולל מספרים אקראיים הוגן (RNG).',
'fairness_p2': 'התוצאה אינה ניתנת לחיזוי או להשפעה לאחר שהכדור נפל.',
'disconection_and_error': 'מדיניות ניתוק וטיפול בשגיאות',
'disconection_and_error_p1': 'אם החיבור נותק לאחר ביצוע ההימור, ההימור לא יבוטל. אם המשחק דורש פעולה מהשחקן, התוצאה תיחשב כאילו בחר השחקן פעולה ללא סיכון ללא הגדלת ההימור ההתחלתי.',
'disconection_and_error_p2': 'במקרה של שגיאה, צוות התמיכה שלנו ינסה לפתור את הבעיה בהקדם ולהמשיך במשחק רגיל. במקרה של בעיה במשחק עצמו, כל ההימורים יבוטלו והסכומים יוחזרו לשחקנים.',
'other': 'אחר',
'other_p1': 'במקרה של תקלה בחומרה או בתוכנה של המשחק, כל ההימורים והתשלומים שהושפעו יבטלו וכל ההימורים המושפעים יוחזרו.',
'other_p2': 'חוקי המשחק פורסמו באנגלית. תרגומים לשפות אחרות ניתנים כשירות בתום לב. במקרה של אי-בהירות בין הגרסה האנגלית לתרגום, הגרסה האנגלית היא הקובעת.',
'rows': 'שורות',
'lvl': 'רמה',
'low': 'נמוך',
'high': 'גבוה',
'ok': 'OK',
'exit_turbo_mode': 'האם ברצונך לצאת ממצב טורבו?',
"end": "סיום",
"turbo_mode_settings": "הגדרות מצב טורבו",
"stop": "עצור",
'invalid_bet_amount': 'סכום הימור לא חוקי',
'cashout_success': 'משיכת מזומנים הצליחה',
'stop_auto_play_first': 'אנא עצור את מצב האוטומטי קודם.',
'turbo_only_when_no_balls': 'ניתן להתחיל את מצב הטורבו רק כאשר אין כדורים על הלוח.',
'type': 'סוג הימור',
'wait_balls_to_finish': 'אנא המתן לסיום הכדורים.',
'bet_too_large_top_up_turbo_balance': 'ההימור גבוה מדי – טען מחדש את יתרת הטורבו שלך!',
};
langArr.hr = {
'loading': 'Učitavanje',
'hotkeys': 'Tipke prečaca',
'hotkeys_enabled': 'Tipke prečaca omogućene',
'enable_hotkeys_checkbox': 'Omogućite tipke prečaca prikazane dolje označavanjem ovog okvira.',
'drop_ball': 'Ispusti kuglu',
'double_bet': 'Udvostručite ulog',
'halve_bet': 'Prepolovite ulog',
'min_bet': 'Minimalni ulog',
'max': 'Maks',
'easy': 'Lako',
'medium': 'Srednje',
'hard': 'Teško',
'daredevil': 'Odvažan',
'max_profit': 'Maksimalna dobit',
'manual': 'Ručni',
'auto': 'Automatski',
'bet_amount': 'Iznos uloga',
'difficulty': 'Težina',
'payout_on_win': 'Isplata pri dobitku',
'number_of_bets': 'Broj uloga',
'on_win': 'Pri dobitku',
'on_loss': 'Pri gubitku',
'stop_on_profit': 'Zaustavi pri dobitku',
'stop_on_loss': 'Zaustavi pri gubitku',
'reset': 'Resetiraj',
'increase_by': 'Povećaj za',
'cashout': 'ISPLATI',
'start_game': 'ULOŽI',
'start_auto_game': 'POČNI',
'difficulity_info': 'Informacije o težini',
'chance_collision': 'Šansa za sudar po igri',
'evry_25_lane': 'za svakih 25 staza',
'insufficiend_funds': 'Nedovoljno sredstava',
'cashout_inactivity': 'Automatska isplata zbog neaktivnosti',
'time_running_out': 'Vrijeme istječe! Igraj sada ili će tvoja karta biti automatski uklonjena za 30 sekundi',
'there_was_error': 'DOŠLO JE DO POGREŠKE, POKUŠAJTE PONOVO ILI OBNOVITE STRANICU',
'detailed_game_rules': 'Detaljna pravila igre',
'general_rules': 'OPĆA PRAVILA',
'general_rules_p1': '• Množitelj počinje od 1 i ide do ',
'general_rules_p2': '• Dobitci se računaju množenjem uloga s prikazanim množiteljem na svakom koraku.',
'general_rules_p3': '• Ako se postigne maksimalna isplata, igra će se automatski isplatiti s maksimalnim iznosom.',
'progressive_jackpot': 'PROGRESIVNI JACKPOT',
'progressive_jackpot_ss': 'Staza jackpota i moguća dobit',
'progressive_jackpot_p1': '% od svakog uloga ide u progresivni jackpot fond.',
'progressive_jackpot_p2': 'Jackpot se dodjeljuje korištenjem mehanike "Mystery" ili "must-hit-by". Vrijednost svakog "must-hit-by" jackpota određuje se odmah nakon prethodnog pomoću generatora slučajnih brojeva i pohranjuje kao šifrirana vrijednost u udaljenu bazu podataka.',
'progressive_jackpot_p3': 'Kada se postigne vrijednost "must-hit-by", prvi igrač koji postavi ulog nakon toga imat će priliku osvojiti jackpot. Jackpot simbol će se pojaviti na slučajnoj stazi i jackpot se osvaja ako igrač stigne do staze sa simbolom.',
'progressive_jackpot_p4': 'NAPOMENA: Bonus runda ne doprinosi jackpot fondu. Tijekom bonus runde jackpot se ne može osvojiti.',
'showdown': 'SUČELJAVANJE',
'showdown_ss': 'Crveni kvadrat, lokacija moguće kolizije',
'showdown_p1': 'Nakon što igrač isplati, crveni kvadrat će se prikazati na lokaciji gdje bi došlo do kolizije da je igrač nastavio preskakati staze.',
'return_to_player': 'POVRAT IGRAČU',
'return_to_player_p1': 'Ukupni teoretski povrat igraču (RTP) je ',
'return_to_player_p2': 'RTP postotci se kontinuirano prate i provjeravaju od strane neovisnih trećih strana.',
'disconnection_policy': 'POLITIKA PREKIDA VEZE',
'disconnection_policy_p1': 'Ako veza bude izgubljena nakon što je ulog postavljen, ulog se neće odmah poništiti. Ako neaktivnost igrača dostigne ',
'disconnection_policy_p2': 'ulog će se automatski isplatiti i krediti će biti dodani na račun igrača.',
'network_latency': 'LATENCIJA MREŽE',
'network_latency_p1': 'Latencija mreže je neizbježan dio internetske povezanosti. Sve uloge i isplate smatramo važećima samo u trenutku kada stignu na naš server, bez obzira na trajanje latencije.',
'sound': 'ZVUK',
'sound_p1': 'Igra je dizajnirana s lijepom glazbom u pozadini i zvučnim efektima. Ako želite onemogućiti glazbu i/ili zvučne efekte, to možete učiniti putem ikona u izborniku igre.',
'error_handling': 'RUKOVANJE POGREŠKAMA',
'error_handling_p1': 'U slučaju pogreške, naš tim za podršku pokušat će riješiti problem što je prije moguće i nastaviti s igrom. U slučaju problema s igrom, svi ulozi će biti poništeni i ulog vraćen igračima.',
'max_payout': 'Maksimalna isplata je ',
'max_bet_is': 'Maksimalni ulog je ',
'min_bet_is': 'Minimalni ulog je ',
'per_bet': 'po ulogu.',
'malfunction_voids': 'Kvar poništava sve isplate i igre.',
'attention_jackpot': 'Pažnja, Jackpot na stazi ',
'lane': 'staza',
'congratulations': 'čestitamo',
'you_won': 'osvojili ste',
'balance': 'saldo',
'time': 'vrijeme',
'jackpot': 'jackpot',
'escaped': 'POBJEGAO',
'max_win': 'MAKS DOBITAK',
'check_internet': 'Provjerite svoju internetsku vezu',
'websocket_disconected': 'Websocket prekinut',
'websocket_connection_error': 'Pogreška websocket veze!',
'session_expired': 'Sesija je istekla, molimo osvježite',
'remaining_bets': 'Preostali ulozi',
'stop_autoplay': 'ZAUSTAVI',
'autoplay_and_autocashout': 'AUTOPLAY I AUTOMATSKA ISPLATA',
'autoplay_and_autocashout_ss': 'Odabir između ručnog i automatskog',
'autoplay_and_autocashout_p1': 'Igrač može aktivirati opciju automatske igre, gdje se ulog automatski postavlja za svaki novi krug koristeći iznos prethodnog uloga.',
'autoplay_and_autocashout_p2': 'Množitelj automatske isplate može se odabrati na ekranu igre, a kada je postavljen, igra će se automatski isplatiti ako igrač nije pogođen prije dosezanja odabranog množitelja.',
'autoplay_and_autocashout_p3': 'Maksimalni broj automatskih krugova je ',
'autoplay_button_label': 'Za početak, odaberite stazu.',
'min_bet_amount_is': 'Minimalni iznos uloga je',
'bonus_rounds': 'bonus krugovi',
'bonus_rounds_ss': 'Bonus krugovi s valjanom periodom',
'bonus_rounds_p1': 'Igrač može dobiti bonus krug (npr. besplatan ulog) prema promotivnoj ponudi casina. Pojavit će se skočni prozor s informacijama o dodijeljenim bonus krugovima, broju uloga, iznosu po ulogu i eventualnom periodu valjanosti.',
'bonus_rounds_p2': 'Nakon dodjele, igrač može odabrati kada započeti bonus krug. Kada se bonus krug započne, automatski se postavlja ulog sa specificiranim iznosom.',
'bonus_rounds_p3': 'Bonus krugovi mogu imati vremensko ograničenje, nakon čega postaju nevažeći.',
'bonus_rounds_p4': 'Neaktivnost igrača može rezultirati poništavanjem aktivnog bonus kruga. U tom slučaju broj bonus krugova se smanjuje, a saldo igrača ostaje isti.',
'valid_until': 'vrijedi do',
'bonus': 'bonus',
'rounds': 'krugovi',
'win_eur': 'osvojili EUR',
'complete_your_bet': 'Prvo dovršite svoj ulog',
'complete_auto_play': 'Prvo dovršite automatsku igru',
'yes': 'da',
'no': 'ne',
'play_bonus_rounds': 'Igrati bonus krugove?',
'bet_history': 'Povijest uloga',
'jackpot_history': 'Povijest jackpota',
'ticket_id': 'ID karte',
'created': 'vrijeme kreiranja',
'currency': 'valuta',
'bet': 'ulog',
'bet_eur': 'ulog EUR',
'lanes': 'staze',
'cars': 'automobili',
'multiplier': 'množitelj',
'win': 'dobitak',
'no_betting_history': 'Nema pronađene povijesti uloga. Postavite ulog i pojavit će se ovdje.',
'no_jackpot_history': 'Nema dostupne povijesti jackpota.',
'date': 'datum',
'user': 'korisnik',
'bet_already_active': 'Ulog je već aktivan',
'please_play_the_game_in_portait_mode': 'Molimo igrajte igru u portretnom načinu.',
'bonus_history': 'Povijest bonusa',
'bonus_type': 'Vrsta bonusa',
'no_bonus_history': 'Nema dostupne povijesti bonusa.',
'game_menu': 'Izbornik igre',
'game_menu_ss': 'S lijeva: Početna, Povijest uloga, Pravila igre, Tipkovnički prečaci, Postavke zvuka i glazbe',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'PRAVILA IGRE',
'game_rules_p1': 'Dobrodošli u Plinko – gdje sreća vodi!',
'game_rules_p2': 'Pripremite se za uzbudljivu igru na sreću koja je jednostavna i zarazna! Plinko se sastoji od puštanja kuglice na piramidu punu klinova i gledanja kako se odbija, okreće i kotrlja do džepa s nagradama na dnu.',
'game_rules_p3': 'Odaberite između 8 i 16 redova klinova, zatim se opustite i uživajte u kaosu dok kuglica vijuga kroz ploču, vođena samo gravitacijom i srećom.',
'game_rules_p4': 'Hoće li kuglica pasti u džep s malom isplatom… ili osvojiti veliki dobitak? Postoji samo jedan način da saznate — pustite kuglicu i neka počne uzbuđenje!',
'general': 'OPĆE',
'general_p1': 'Pustite Plinko kuglicu i nadajte se da će pasti u jedan od džepova s visokim isplatama na dnu. Putanja je nepredvidiva — svaki odskočni potez može promijeniti vašu sreću.',
'general_p2': 'Što više redova igrate, to je akcija intenzivnija!',
'general_p3': 'Zato samo naprijed — vjerujte svojoj sreći, pritisnite ISPUSTI LOPTICUi jurite za velikim dobitkom kroz klinove Plinka!',
'betting': 'KLADIONICA',
'betting_p1': 'Odaberite iznos uloga. Gumbi “1/2”, “2x”, “Max” mogu se koristiti za upravljanje veličinom uloga. Iznos uloga može se unijeti i ručno.',
'betting_p2': 'Odaberite razinu rizika: Niska, Srednja ili Visoka. Niža razina rizika daje stabilnije ishode (niska volatilnost), dok viša razina donosi veću varijaciju (visoka volatilnost).',
'betting_p3': 'Odaberite broj linija u igri: od 8 do 16. Odaberite koliko će redova klinova lopta proći. Više redova = veća nepredvidivost.',
'betting_p4': 'Odaberite način uloga: Ručni ili Automatski.',
'betting_p5': 'Za početak kruga igre pritisnite gumb DROP BALL. Tijekom kruga svi gumbi za uloge postaju neaktivni osim DROP BALL i iznosa uloga.',
'betting_p6': 'Jedna Plinko lopta predstavlja jedan krug. Tijekom kruga može se započeti novi krug s istim postavkama pomoću gumba DROP BALL. Moguće je promijeniti iznos uloga dok na ploči postoje „aktivne” lopte, ali ne i težinu igre.',
'betting_p7': 'Na kraju kruga lopta dolazi u džep. Na svakom džepu prikazan je multiplikator isplate.',
'betting_p8': 'Izračun dobitka vrši se prema multiplikatoru na kojem je lopta završila. Rezultat se dodaje na saldo.',
'game_menu_p1': 'Najnoviji multiplikatori uloga prikazani su u donjem dijelu prozora igre.',
'game_menu_p2': 'Putem gumba “Bet history” igrač može pregledati svoje posljednje uloge s više detalja.',
'game_menu_p3': 'Za daljnju povijest igre (npr. dulja razdoblja), igrač će možda trebati pristupiti povijesti unutar same platforme za igranje.',
'game_menu_p4': 'Kroz izbornik igre igrači mogu upravljati zvučnim postavkama, tipkovničkim prečacima te otvoriti povijest uloga i pravila igre.',
'game_menu_p5': 'Igra je osmišljena s lijepom pozadinskom glazbom i zvučnim efektima. Glazba i/ili zvučni efekti mogu se isključiti putem ikona izbornika igre.',
'game_menu_p6': 'Povijest igre prikazat će prozor s prethodnim ulozima i poviješću bonusa.',
'autoplay': 'Automatski način (Autoplay)',
'autoplay_p1': 'Klikom na Auto možete automatski ispuštati više lopti bez potrebe za svakim pojedinačnim klikom.',
'autoplay_p2': 'Odaberite iznos koji želite uložiti po lopti.',
'autoplay_p3': 'Odaberite koliko puta (krugova) želite da lopta padne — maksimalno do 100 krugova.',
'autoplay_p4': 'Pritisnite gumb START za početak, a gumb će se promijeniti u STOP.',
'autoplay_p5': 'Automatski način će se zaustaviti kada se dovrši odabrani broj ispuštanja, kada ponestane sredstava ili kada pritisnete gumb STOP.',
'autoplay_p6': 'Svako ispuštanje koristi isti iznos uloga koji je odabran prije pokretanja automatskog načina.',
'turbo_mode': 'Turbo način',
'turbo_mode_p1': 'Turbo Drop omogućuje ispuštanje lopti velikom brzinom držanjem gumba DROP.',
'turbo_mode_p2': 'Lopte će nastaviti padati dok ne otpustite gumb ili dok ne ponestane sredstava.',
'turbo_mode_p3': 'Lopte će nastaviti padati dok ne otpustite gumb ili dok ne ponestane sredstava.',
'turbo_balance': 'Turbo saldo',
'turbo_balance_p1': 'Prije pokretanja Turbo Dropa odaberite iznos novca koji želite izdvojiti — to postaje vaš Turbo saldo.',
'turbo_balance_p2': 'Dok je Turbo Drop aktivan, igra koristi isključivo vaš Turbo saldo za uloge i dobitke.',
'turbo_balance_p3': 'Kada zaustavite Turbo Drop, sav preostali Turbo saldo vraća se na glavni saldo.',
'turbo_balance_p4': 'Turbo Drop možete napustiti u bilo kojem trenutku — ali način će se u potpunosti završiti tek nakon što sve lopte završe padanje i dođu u džepove s multiplikatorima.',
'free_bets': 'BONUS RUNDE',
'free_bets_p1': 'Bonus runde dodjeljuje operater.',
'fairness': 'Pravičnost',
'fairness_p1': 'Svaki pad određuje dokazivo pošten generator slučajnih brojeva (RNG).',
'fairness_p2': 'Ishod se ne može predvidjeti niti utjecati nakon pada kuglice.',
'disconection_and_error': 'Pravila prekida veze i rukovanje pogreškama',
'disconection_and_error_p1': 'Ako se veza izgubi nakon što je oklada postavljena, oklada se neće otkazati. Ako igra zahtijeva akciju igrača, rezultat se računa pretpostavljajući da je igrač odabrao akciju bez rizika bez povećanja početne oklade.',
'disconection_and_error_p2': 'U slučaju pogreške, naš tim za podršku pokušat će riješiti problem što je prije moguće i nastaviti uobičajenu igru. U slučaju problema s igrom, sve oklade će biti otkazane i ulozi vraćeni igračima.',
'other': 'Ostalo',
'other_p1': 'U slučaju kvara hardvera ili softvera, sve pogođene oklade i isplate postaju ništavne, a svi pogođeni ulozi vraćaju se igračima.',
'other_p2': 'Pravila igre su objavljena na engleskom jeziku. Prijevodi na druge jezike pružaju se kao usluga dobronamjerno. U slučaju nejasnoća između engleske verzije i prijevoda, engleska verzija ima prioritet.',
'rows': 'Redovi',
'lvl': 'Razina',
'low': 'Nisko',
'high': 'Visoko',
'ok': 'OK',
'exit_turbo_mode': 'Želite li izaći iz Turbo moda?',
"end": "KRAJ",
"turbo_mode_settings": "Postavke Turbo moda",
"stop": "ZAUSTAVI",
'invalid_bet_amount': 'Nevažeći iznos uloga',
'cashout_success': 'Isplata uspješna',
'stop_auto_play_first': 'Prvo zaustavite automatsku igru.',
'turbo_only_when_no_balls': 'Turbo mod može se pokrenuti samo kada na tabli nema kuglica.',
'type': 'Vrsta oklade',
'wait_balls_to_finish': 'Pričekajte da sve kuglice završe.',
'bet_too_large_top_up_turbo_balance': 'Ulog je prevelik – nadopunite svoj Turbo saldo!',
};
langArr.hu = {
'loading': 'Betöltés',
'hotkeys': 'Gyorsbillentyűk',
'hotkeys_enabled': 'Gyorsbillentyűk engedélyezve',
'enable_hotkeys_checkbox': 'Engedélyezze az alábbi gyorsbillentyűket a jelölőnégyzet bejelölésével.',
'drop_ball': 'Golyó ejtése',
'double_bet': 'Fogadás duplázása',
'halve_bet': 'Fogadás felezése',
'min_bet': 'Minimális tét',
'max': 'Max',
'easy': 'Könnyű',
'medium': 'Közepes',
'hard': 'Nehéz',
'daredevil': 'Vakmerő',
'max_profit': 'Maximális nyereség',
'manual': 'Kézi',
'auto': 'Automatikus',
'bet_amount': 'Tét összege',
'difficulty': 'Nehézség',
'payout_on_win': 'Kifizetés nyerés esetén',
'number_of_bets': 'Fogadások száma',
'on_win': 'Nyeremény esetén',
'on_loss': 'Veszteség esetén',
'stop_on_profit': 'Állj meg nyereségnél',
'stop_on_loss': 'Állj meg veszteségnél',
'reset': 'Alaphelyzet',
'increase_by': 'Növelés',
'cashout': 'KIFIZETÉS',
'start_game': 'TÉT',
'start_auto_game': 'INDÍTÁS',
'difficulity_info': 'Nehézség információ',
'chance_collision': 'Ütközés esélye játékonként',
'evry_25_lane': 'minden 25 sávra',
'insufficiend_funds': 'Nincs elég fedezet',
'cashout_inactivity': 'Automatikus kifizetés inaktivitás miatt',
'time_running_out': 'Idő fogy! Játssz most, vagy a jegyed automatikusan visszavonásra kerül 30 másodperc múlva',
'there_was_error': 'HIBÁTLÉPÉS TÖRTÉNT, KÉRJÜK PRÓBÁLD ÚJRA VAGY FRISSÍTS',
'detailed_game_rules': 'Részletes játékszabályok',
'general_rules': 'ÁLTALÁNOS SZABÁLYOK',
'general_rules_p1': '• A szorzó 1-től indul és felmegy ',
'general_rules_p2': '• A nyereményeket a tét és az adott lépésnél megjelenő szorzó szorzataként számítják.',
'general_rules_p3': '• Ha az elérhető maximális kifizetéshez érünk, a játék automatikusan kifizeti a maximális összeget.',
'progressive_jackpot': 'PROGRESSZÍV JACKPOT',
'progressive_jackpot_ss': 'A jackpot sáv és a lehetséges nyeremény',
'progressive_jackpot_p1': 'Minden tét % -a a progresszív jackpot alapba kerül.',
'progressive_jackpot_p2': 'A jackpot "Mystery" vagy "must-hit-by" mechanikával kerül kiosztásra. Minden "must-hit-by" jackpot értékét a korábbi jackpot megnyerése után egy véletlenszám-generátor határozza meg, és titkosított formában tárolja az adatbázis.',
'progressive_jackpot_p3': 'Ha a "must-hit-by" érték eléri, az első játékos, aki utána tétet tesz, esélyt kap a jackpot megnyerésére. A jackpot szimbólum véletlenszerű sávra kerül, és a jackpot megnyeréséhez a játékosnak el kell érnie a szimbólummal jelölt sávot.',
'progressive_jackpot_p4': 'MEGJEGYZÉS: A bónusz kör nem járul hozzá a jackpot alaphoz. Bónusz kör alatt a jackpot nem nyerhető.',
'showdown': 'SZEMBESZÁLLÁS',
'showdown_ss': 'Piros négyzet, a lehetséges ütközés helye',
'showdown_p1': 'A játékos kifizetése után a piros négyzet megjelenik azon a helyen, ahol az ütközés történne, ha a játékos tovább folytatná a sávok kihagyását.',
'return_to_player': 'VISSZATÉRÉS A JÁTÉKOSNAK',
'return_to_player_p1': 'A teljes elméleti visszatérés a játékosnak (RTP) ',
'return_to_player_p2': 'Az RTP százalékokat folyamatosan figyelik és ellenőrzik független harmadik felek.',
'disconnection_policy': 'LECSATLAKOZÁSI SZABÁLYZAT',
'disconnection_policy_p1': 'Ha a kapcsolat megszakad a tét megtétele után, a tét nem kerül azonnal törlésre. Ha a játékos inaktivitása eléri ',
'disconnection_policy_p2': 'a tét automatikusan kifizetésre kerül, és a kredit a játékos fiókjához kerül.',
'network_latency': 'HÁLÓZATI KÉSÉS',
'network_latency_p1': 'A hálózati késés az internetkapcsolat elkerülhetetlen része. Minden tét és kifizetés csak akkor érvényes, amikor az a szerverünkre érkezik, függetlenül a késés időtartamától.',
'sound': 'HANG',
'sound_p1': 'A játékot gyönyörű háttérzenével és hanghatásokkal tervezték. Ha szeretnéd kikapcsolni a zenét és/vagy a hanghatásokat, megteheted a játék menüikonjai segítségével.',
'error_handling': 'HIBAKEZELÉS',
'error_handling_p1': 'Hiba esetén támogatói csapatunk a lehető leghamarabb megpróbálja megoldani a problémát, és folytatni a játékot. Ha a játékkal van probléma, minden tét törlésre kerül és a tét összege visszakerül a játékosokhoz.',
'max_payout': 'A maximális kifizetés ',
'max_bet_is': 'A maximális tét ',
'min_bet_is': 'A minimális tét ',
'per_bet': 'tétként.',
'malfunction_voids': 'Hiba érvényteleníti az összes kifizetést és játékot.',
'attention_jackpot': 'Figyelem, Jackpot a sávon ',
'lane': 'sáv',
'congratulations': 'gratulálunk',
'you_won': 'nyertél',
'balance': 'egyensúly',
'time': 'idő',
'jackpot': 'jackpot',
'escaped': 'ELMENEKÜLT',
'max_win': 'MAX NYEREMÉNY',
'check_internet': 'Kérjük, ellenőrizze internetkapcsolatát',
'websocket_disconected': 'Websocket megszakadt',
'websocket_connection_error': 'Websocket kapcsolati hiba!',
'session_expired': 'A munkamenet lejárt, kérjük frissítsen',
'remaining_bets': 'Megmaradt tétek',
'stop_autoplay': 'MEGÁLLÍTÁS',
'autoplay_and_autocashout': 'AUTOMATIKUS JÁTÉK ÉS AUTOMATIKUS KIFIZETÉS',
'autoplay_and_autocashout_ss': 'Kézi és automatikus választás',
'autoplay_and_autocashout_p1': 'A játékos aktiválhatja az automatikus játék opciót, ahol minden új körre automatikusan tét kerül a korábbi tét összegével.',
'autoplay_and_autocashout_p2': 'Automatikus kifizetési szorzó választható, és ha be van állítva, a játék automatikusan kifizet, ha a játékost nem éri el a szorzó.',
'autoplay_and_autocashout_p3': 'Az automatikus játékok maximális száma ',
'autoplay_button_label': 'Kezdéshez válassz egy sávot.',
'min_bet_amount_is': 'A minimális tét összege',
'bonus_rounds': 'bónusz körök',
'bonus_rounds_ss': 'A bónusz körök érvényességi ideje',
'bonus_rounds_p1': 'A játékos bónusz kört kaphat (pl. ingyenes tét) a kaszinó promóciója alapján. Egy felugró ablak jelenik meg, amely tájékoztatja a játékost a kiosztott bónusz körökről, tétek számáról, tét összegéről és az esetleges érvényességi időről.',
'bonus_rounds_p2': 'Miután kiosztásra kerültek, a játékos eldöntheti, mikor kezdi el a bónusz kört. A bónusz kör kezdete után a megadott tét automatikusan elhelyezésre kerül.',
'bonus_rounds_p3': 'A bónusz köröknek lehet időkorlátja, amely után érvénytelenné válnak.',
'bonus_rounds_p4': 'A játékos tétlensége az aktív bónusz kör törléséhez vezethet. Ebben az esetben a bónusz körök száma csökken, és a játékos egyenlege változatlan marad.',
'valid_until': 'érvényes eddig',
'bonus': 'bónusz',
'rounds': 'körök',
'win_eur': 'nyeremény EUR',
'complete_your_bet': 'Kérjük, először fejezze be a tétet',
'complete_auto_play': 'Kérjük, először fejezze be az automatikus játékot',
'yes': 'igen',
'no': 'nem',
'play_bonus_rounds': 'Bónusz körök játszása?',
'bet_history': 'Tét előzmények',
'jackpot_history': 'Jackpot előzmények',
'ticket_id': 'Jegy ID',
'created': 'létrehozás ideje',
'currency': 'pénznem',
'bet': 'tét',
'bet_eur': 'tét EUR',
'lanes': 'sávok',
'cars': 'autók',
'multiplier': 'szorzó',
'win': 'nyeremény',
'no_betting_history': 'Nincs elérhető tét előzmény. Tegyen tétet, és itt megjelenik.',
'no_jackpot_history': 'Nincs elérhető jackpot előzmény.',
'date': 'dátum',
'user': 'felhasználó',
'bet_already_active': 'A tét már aktív',
'please_play_the_game_in_portait_mode': 'Kérjük, játsszon portré módban.',
'bonus_history': 'Bónusz előzmények',
'bonus_type': 'Bónusz típusa',
'no_bonus_history': 'Nincs elérhető bónusz előzmény.',
'game_menu': 'Játék menü',
'game_menu_ss': 'Balról: Főoldal, Tét előzmények, Játékszabályok, Billentyűparancsok, Hang és zene beállítások',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'JÁTÉKSZABÁLYOK',
'game_rules_p1': 'Üdvözlünk a Plinkóban – ahol a szerencse vezet!',
'game_rules_p2': 'Készülj fel egy izgalmas szerencsejátékra, ami egyszerű és függőséget okoz! A Plinkóban egy labdát ejtesz le egy tüskékkel teli piramisra, és figyeled, ahogy pattog, fordul, és lecsorog a nyereményes rekeszbe alul.',
'game_rules_p3': 'Válassz 8 és 16 tüskés sor között, majd dőlj hátra, és élvezd a káoszt, miközben a labda cikk-cakkban halad lefelé, csak a gravitáció és a szerencse vezérli.',
'game_rules_p4': 'Alacsony nyereményes rekeszbe esik majd… vagy megüti a nagy nyereményt? Csak egy módja van kideríteni — ejtsd le a labdát, és élvezd az izgalmat!',
'general': 'ÁLTALÁNOS',
'general_p1': 'Ejd le a Plinkó-labdát, és reméld, hogy az egyik magas nyereményű rekeszbe esik alul. Az út kiszámíthatatlan — minden pattogás megváltoztathatja a szerencséd.',
'general_p2': 'Minél több sort játszol, annál izgalmasabb a játék!',
'general_p3': 'Tehát hajrá — bízz a szerencsédben, nyomd meg a DROP gombot, és hajszold a nagy nyereményt a Plinkó tüskéi között!',
'betting': 'TÉTELEK',
'betting_p1': 'Válassza ki a tét összegét. Az “1/2”, “2x”, “Max” gombokkal kezelhető a tét nagysága. A tét összege kézzel is megadható.',
'betting_p2': 'Válassza ki a kockázati szintet: Alacsony, Közepes vagy Magas. Az alacsonyabb kockázati szint egyenletesebb eredményeket biztosít (alacsony volatilitás), míg a magasabb nagyobb szórást jelent (magas volatilitás).',
'betting_p3': 'Válassza ki a sorok számát a játékban: 8 és 16 között. Adja meg, hány sor csapon halad át a golyó. Több sor = nagyobb kiszámíthatatlanság.',
'betting_p4': 'Válassza ki a tét módját: Kézi vagy Automatikus.',
'betting_p5': 'A kör indításához nyomja meg a DROP BALL gombot. A kör ideje alatt minden fogadási gomb inaktív, kivéve a DROP BALL gombot és a tét összegét.',
'betting_p6': 'Egy Plinko golyó egy kört jelent. A kör során azonos beállításokkal újabb kör indítható a DROP BALL gombbal. A tét összege módosítható, amíg „aktív” golyók vannak a táblán, de a játék nehézsége nem.',
'betting_p7': 'A kör végén a golyó egy zsebbe érkezik. Minden zsebön megjelenik a kifizetési szorzó.',
'betting_p8': 'A nyeremény kiszámítása azon a szorzón alapul, ahol a golyó landolt. Az eredmény hozzáadódik az egyenleghez.',
'game_menu_p1': 'A legutóbbi tétszorzók a játékablak alsó részén jelennek meg.',
'game_menu_p2': 'A “Bet history” gomb segítségével a játékos részletesebben megtekintheti legutóbbi fogadásait.',
'game_menu_p3': 'Hosszabb játék-előzmények (pl. hosszabb időszakok) megtekintéséhez a játékosnak lehet, hogy a játékszolgáltató platformján belül kell elérnie a saját előzményeit.',
'game_menu_p4': 'A játék menüjén keresztül a játékosok vezérelhetik a hangbeállításokat, a billentyűparancsokat, valamint megnyithatják a fogadási előzményeket és a játékszabályokat.',
'game_menu_p5': 'A játék szép háttérzenével és hangeffektekkel készült. A zene és/vagy a hangeffektek a játék menüikonjain keresztül kikapcsolhatók.',
'game_menu_p6': 'A játéktörténet egy ablakban jeleníti meg a korábbi fogadásokat és a bónusztörténetet.',
'autoplay': 'Automatikus mód (Autoplay)',
'autoplay_p1': 'Az Auto gombra kattintva több golyó automatikusan ejthető le anélkül, hogy minden alkalommal kattintani kellene.',
'autoplay_p2': 'Válassza ki az egy golyóra eső tét összegét.',
'autoplay_p3': 'Adja meg, hányszor (körben) szeretné leejteni a golyót — legfeljebb 100 körig.',
'autoplay_p4': 'Nyomja meg a START gombot az indításhoz, a gomb pedig STOP-ra vált.',
'autoplay_p5': 'Az automatikus mód leáll, amikor a kiválasztott ejtések száma teljesül, elfogynak az összegek vagy megnyomja a STOP gombot.',
'autoplay_p6': 'Minden ejtés ugyanazt a tétösszeget használja, amelyet az automatikus mód indítása előtt választott ki.',
'turbo_mode': 'Turbo mód',
'turbo_mode_p1': 'A Turbo Drop lehetővé teszi a golyók rendkívül gyors leejtését a DROP gomb lenyomva tartásával.',
'turbo_mode_p2': 'A golyók addig esnek, amíg el nem engedi a gombot vagy el nem fogy az egyenleg.',
'turbo_mode_p3': 'A golyók addig esnek, amíg el nem engedi a gombot vagy el nem fogy az egyenleg.',
'turbo_balance': 'Turbo egyenleg',
'turbo_balance_p1': 'A Turbo Drop indítása előtt válassza ki, mennyi pénzt különít el — ez lesz a Turbo egyenlege.',
'turbo_balance_p2': 'Amíg a Turbo Drop aktív, a játék kizárólag a Turbo egyenleget használja a fogadásokhoz és nyereményekhez.',
'turbo_balance_p3': 'A Turbo Drop leállításakor a megmaradt Turbo egyenleg visszakerül a fő egyenlegre.',
'turbo_balance_p4': 'A Turbo Drop bármikor megszakítható — de a mód csak akkor ér véget teljesen, amikor minden golyó befejezte az esést és megérkezett a szorzó zsebekbe.',
'free_bets': 'BÓNUSZ KÖRÖK',
'free_bets_p1': 'A bónusz köröket az üzemeltető biztosítja.',
'fairness': 'Méltányosság',
'fairness_p1': 'Minden leejtést egy bizonyíthatóan tisztességes véletlenszám-generátor (RNG) határoz meg.',
'fairness_p2': 'Az eredményt nem lehet megjósolni vagy befolyásolni, miután a labda leesett.',
'disconection_and_error': 'Kapcsolati szabályzat és hibakezelés',
'disconection_and_error_p1': 'Ha a kapcsolat megszakad egy tét után, a tét nem kerül törlésre. Ha a játék akciót vár a játékostól, az eredményt úgy számolják, mintha a játékos a kockázat nélküli akciót választotta volna, a tét növelése nélkül.',
'disconection_and_error_p2': 'Hiba esetén támogatói csapatunk megpróbálja a problémát minél hamarabb megoldani és folytatni a normál játékot. Ha a játék maga hibás, minden tét törlésre kerül és a tétek visszajárnak a játékosoknak.',
'other': 'Egyéb',
'other_p1': 'Játék hardver/szoftver meghibásodás esetén az érintett fogadások és kifizetések érvénytelenek, és a tétek visszatérítésre kerülnek.',
'other_p2': 'A játékszabályok angol nyelven kerültek közzétételre. A fordítások más nyelvekre jóhiszemű szolgáltatásként érhetők el. Kétértelműség esetén az angol verzió az irányadó.',
'rows': 'Sorok',
'lvl': 'Szint',
'low': 'Alacsony',
'high': 'Magas',
'ok': 'OK',
'exit_turbo_mode': 'Ki szeretne lépni a Turbo módból?',
"end": "Vége",
"turbo_mode_settings": "Turbo mód beállításai",
"stop": "MEGÁLLÍTÁS",
'invalid_bet_amount': 'Érvénytelen tét összeg',
'cashout_success': 'Kifizetés sikeres',
'stop_auto_play_first': 'Először állítsa le az automatikus játékot.',
'turbo_only_when_no_balls': 'A Turbo mód csak akkor indítható el, ha a táblán nincsenek golyók.',
'type': 'Tét típusa',
'wait_balls_to_finish': 'Várja meg, amíg az összes golyó befejezi.',
'bet_too_large_top_up_turbo_balance': 'A tét túl nagy – töltse fel a Turbo egyenlegét!',
};
langArr.it = {
'loading': 'Caricamento',
'hotkeys': 'Tasti rapidi',
'hotkeys_enabled': 'Tasti rapidi abilitati',
'enable_hotkeys_checkbox': 'Abilita i tasti rapidi mostrati qui sotto selezionando questa casella.',
'drop_ball': 'Lancia palla',
'double_bet': 'Raddoppia la puntata',
'halve_bet': 'Dividi la puntata a metà',
'min_bet': 'Puntata minima',
'max': 'Max',
'easy': 'Facile',
'medium': 'Medio',
'hard': 'Difficile',
'daredevil': 'Temerario',
'max_profit': 'Profitto massimo',
'manual': 'Manuale',
'auto': 'Automatico',
'bet_amount': 'Importo della puntata',
'difficulty': 'Difficoltà',
'payout_on_win': 'Pagamento alla vincita',
'number_of_bets': 'Numero di puntate',
'on_win': 'Alla vincita',
'on_loss': 'Alla perdita',
'stop_on_profit': 'Ferma al profitto',
'stop_on_loss': 'Ferma alla perdita',
'reset': 'Reset',
'increase_by': 'Aumenta di',
'cashout': 'INCASSA',
'start_game': 'PUNTATA',
'start_auto_game': 'INIZIA',
'difficulity_info': 'Informazioni difficoltà',
'chance_collision': 'Probabilità di collisione per gioco',
'evry_25_lane': 'per ogni 25 corsie',
'insufficiend_funds': 'Fondi insufficienti',
'cashout_inactivity': 'Incasso automatico per inattività',
'time_running_out': 'Il tempo sta per scadere! Gioca ora o il tuo biglietto sarà ritirato automaticamente in 30 secondi',
'there_was_error': 'SI È VERIFICATO UN ERRORE, RIPROVA O RICARICA',
'detailed_game_rules': 'Regole dettagliate del gioco',
'general_rules': 'REGOLE GENERALI',
'general_rules_p1': '• Il moltiplicatore parte da 1 e arriva fino a ',
'general_rules_p2': '• Le vincite vengono calcolate moltiplicando la puntata per il moltiplicatore visualizzato ad ogni passo.',
'general_rules_p3': '• Se si raggiunge il pagamento massimo, il gioco incasserà automaticamente l’importo massimo.',
'progressive_jackpot': 'JACKPOT PROGRESSIVO',
'progressive_jackpot_ss': 'Corsia del jackpot e vincita possibile',
'progressive_jackpot_p1': '% di ogni puntata è destinato al fondo del jackpot progressivo.',
'progressive_jackpot_p2': 'Il jackpot viene assegnato utilizzando la meccanica "Mystery" o "must-hit-by". Il valore di ogni jackpot "must-hit-by" è determinato immediatamente dopo il jackpot precedente tramite un generatore di numeri casuali e memorizzato come valore criptato nel database remoto.',
'progressive_jackpot_p3': 'Una volta raggiunto il valore "must-hit-by", il primo giocatore a scommettere dopo avrà la possibilità di vincere il jackpot. Un simbolo del jackpot apparirà su una corsia casuale e il jackpot sarà vinto se il giocatore raggiunge la corsia con il simbolo.',
'progressive_jackpot_p4': 'NOTA: Il round bonus non contribuisce al fondo jackpot. Durante il round bonus il jackpot non può essere vinto.',
'showdown': 'SFIDA',
'showdown_ss': 'Quadrato rosso, posizione di una collisione',
'showdown_p1': 'Dopo l’incasso del giocatore, verrà mostrato un quadrato rosso nella posizione in cui si sarebbe verificata la collisione se il giocatore avesse continuato a saltare le corsie.',
'return_to_player': 'RITORNO AL GIOCATORE',
'return_to_player_p1': 'Il ritorno teorico complessivo al giocatore (RTP) è ',
'return_to_player_p2': 'Le percentuali RTP sono continuamente monitorate e verificate da terze parti indipendenti.',
'disconnection_policy': 'POLITICA DI DISCONNESSIONE',
'disconnection_policy_p1': 'Se la connessione viene persa dopo aver piazzato una puntata, la puntata non sarà cancellata immediatamente. Se l’inattività del giocatore raggiunge ',
'disconnection_policy_p2': 'la puntata verrà incassata automaticamente e i crediti saranno applicati all’account del giocatore.',
'network_latency': 'LATENZA DI RETE',
'network_latency_p1': 'La latenza di rete è una parte inevitabile della connessione a Internet. Consideriamo tutte le puntate e gli incassi validi solo al momento in cui raggiungono il nostro server, indipendentemente dalla durata della latenza di rete.',
'sound': 'SUONO',
'sound_p1': 'Il gioco è progettato con musica di sottofondo e effetti sonori. Se desideri disattivare musica e/o effetti sonori, puoi farlo tramite le icone del menu di gioco.',
'error_handling': 'GESTIONE ERRORI',
'error_handling_p1': 'In caso di errore, il nostro team di supporto cercherà di risolvere il problema il prima possibile e continuare il gioco regolare. In caso di problema con il gioco stesso, tutte le puntate verranno annullate e l’importo restituito ai giocatori.',
'max_payout': 'Il pagamento massimo è ',
'max_bet_is': 'La puntata massima è ',
'min_bet_is': 'La puntata minima è ',
'per_bet': 'per puntata.',
'malfunction_voids': 'Malfunzionamento annulla tutti i pagamenti e le giocate.',
'attention_jackpot': 'Attenzione, Jackpot sulla corsia ',
'lane': 'corsia',
'congratulations': 'congratulazioni',
'you_won': 'hai vinto',
'balance': 'saldo',
'time': 'tempo',
'jackpot': 'jackpot',
'escaped': 'FUGGITO',
'max_win': 'VINCITA MASSIMA',
'check_internet': 'Controlla la tua connessione Internet',
'websocket_disconected': 'Websocket disconnesso',
'websocket_connection_error': 'Errore di connessione Websocket!',
'session_expired': 'La sessione è scaduta, ricarica la pagina',
'remaining_bets': 'Puntate rimanenti',
'stop_autoplay': 'FERMA',
'autoplay_and_autocashout': 'AUTOGIOCO E INCASSO AUTOMATICO',
'autoplay_and_autocashout_ss': 'Scelta tra manuale e autogioco',
'autoplay_and_autocashout_p1': 'Un giocatore può attivare l’opzione autogioco, dove una puntata viene piazzata automaticamente per ogni nuovo round usando l’importo della puntata precedente.',
'autoplay_and_autocashout_p2': 'È possibile selezionare un moltiplicatore di incasso automatico dalla schermata di gioco; se impostato, il gioco incasserà automaticamente se il giocatore non viene colpito prima di raggiungere il moltiplicatore selezionato.',
'autoplay_and_autocashout_p3': 'Il numero massimo di round di autogioco è ',
'autoplay_button_label': 'Per iniziare, scegli una corsia.',
'min_bet_amount_is': 'L’importo minimo della puntata è',
'bonus_rounds': 'round bonus',
'bonus_rounds_ss': 'I round bonus con periodo di validità',
'bonus_rounds_p1': 'Un giocatore può ricevere un round bonus (es. puntata gratuita) basato su una promozione del casinò. Verrà mostrata una finestra popup che notifica i round bonus assegnati, numero di puntate, importo per puntata ed eventuale periodo di validità.',
'bonus_rounds_p2': 'Una volta assegnati, il giocatore può scegliere quando iniziare il round bonus. Una volta iniziato, una puntata automatica con l’importo specificato viene piazzata, e il giocatore può incassare in qualsiasi momento.',
'bonus_rounds_p3': 'I round bonus possono avere un limite di tempo, dopo il quale diventano nulli e inutilizzabili.',
'bonus_rounds_p4': 'L’inattività del giocatore può comportare l’annullamento di un round bonus attivo. In questo caso, il numero di round bonus diminuisce e il saldo del giocatore rimane invariato.',
'valid_until': 'valido fino a',
'bonus': 'bonus',
'rounds': 'round',
'win_eur': 'vincita EUR',
'complete_your_bet': 'Completa prima la tua puntata',
'complete_auto_play': 'Completa prima l’autogioco',
'yes': 'sì',
'no': 'no',
'play_bonus_rounds': 'Giocare i round bonus?',
'bet_history': 'Cronologia puntate',
'jackpot_history': 'Cronologia jackpot',
'ticket_id': 'ID biglietto',
'created': 'ora di creazione',
'currency': 'valuta',
'bet': 'puntata',
'bet_eur': 'puntata EUR',
'lanes': 'corsie',
'cars': 'auto',
'multiplier': 'moltiplicatore',
'win': 'vincita',
'no_betting_history': 'Nessuna cronologia puntate trovata. Fai una puntata e apparirà qui.',
'no_jackpot_history': 'Nessuna cronologia jackpot disponibile.',
'date': 'data',
'user': 'utente',
'bet_already_active': 'La puntata è già attiva',
'please_play_the_game_in_portait_mode': 'Gioca in modalità ritratto.',
'bonus_history': 'Cronologia bonus',
'bonus_type': 'Tipo di bonus',
'no_bonus_history': 'Nessuna cronologia bonus disponibile.',
'game_menu': 'Menu di gioco',
'game_menu_ss': 'Da sinistra: Home, Cronologia puntate, Regole del gioco, Scorciatoie da tastiera, Impostazioni suoni e musica',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'REGOLE DEL GIOCO',
'game_rules_p1': 'Benvenuto in Plinko – Dove la Fortuna Comanda!',
'game_rules_p2': 'Preparati per un emozionante gioco di fortuna semplice e coinvolgente! Plinko consiste nel far cadere una pallina su una piramide piena di perni e guardare come rimbalza, si gira e rimbalza giù fino a una casella premio in basso.',
'game_rules_p3': 'Scegli tra 8 e 16 file di perni, poi siediti e goditi il caos mentre la pallina zigzaga attraverso il tabellone, guidata solo dalla gravità e dalla fortuna.',
'game_rules_p4': 'Atterrerà in una casella a basso pagamento… o vincerà il grande premio? C’è solo un modo per scoprirlo — lascia cadere la pallina e lascia che l’emozione abbia inizio!',
'general': 'GENERALE',
'general_p1': 'Lascia cadere la pallina di Plinko e spera che finisca in una delle caselle con pagamenti elevati in fondo. Il percorso è imprevedibile — ogni rimbalzo può cambiare la tua fortuna.',
'general_p2': 'Più file giochi, più l’azione diventa intensa!',
'general_p3': 'Quindi vai avanti — fidati della tua fortuna, premi DROP e insegui quella grande vincita tra i perni di Plinko!',
'betting': 'SCOMMESSE',
'betting_p1': 'Scegli l’importo della scommessa. I pulsanti “1/2”, “2x”, “Max” possono essere usati per gestire l’importo della scommessa. L’importo può anche essere inserito manualmente.',
'betting_p2': 'Scegli il livello di rischio: Basso, Medio o Alto. Un livello di rischio più basso offre risultati più coerenti (bassa volatilità), mentre uno più alto offre maggiore variabilità (alta volatilità).',
'betting_p3': 'Scegli il numero di linee nel gioco: da 8 a 16. Seleziona quante file di perni attraverserà la pallina. Più file = maggiore imprevedibilità.',
'betting_p4': 'Scegli la modalità di scommessa: Manuale o Automatica.',
'betting_p5': 'Per avviare il turno di gioco, premi il pulsante DROP BALL. Durante il turno tutti i pulsanti di scommessa diventano inattivi, tranne DROP BALL e l’importo della scommessa.',
'betting_p6': 'Una pallina Plinko rappresenta un turno. Durante il turno è possibile avviare un altro turno con le stesse impostazioni usando il pulsante DROP BALL. È possibile cambiare l’importo della scommessa mentre ci sono palline “attive” sul tavolo, ma non la difficoltà del gioco.',
'betting_p7': 'Alla fine del turno la pallina raggiunge una tasca. Su ogni tasca viene mostrato il moltiplicatore di vincita.',
'betting_p8': 'Il calcolo della vincita viene effettuato in base al moltiplicatore dove è atterrata la pallina. Il risultato viene aggiunto al saldo.',
'game_menu_p1': 'I moltiplicatori di scommessa più recenti sono mostrati nella parte inferiore della finestra di gioco.',
'game_menu_p2': 'Attraverso il pulsante “Bet history” il giocatore può rivedere le ultime scommesse in maggior dettaglio.',
'game_menu_p3': 'Per una cronologia di gioco più estesa (ad es. periodi più lunghi), il giocatore potrebbe dover accedere alla cronologia dei propri giochi direttamente sulla piattaforma di gioco.',
'game_menu_p4': 'Dal menu di gioco i giocatori possono controllare le opzioni audio, le scorciatoie da tastiera e aprire la cronologia delle scommesse e le regole del gioco.',
'game_menu_p5': 'Il gioco è progettato con una bella musica di sottofondo e effetti sonori. Musica e/o effetti sonori possono essere disattivati tramite le icone del menu di gioco.',
'game_menu_p6': 'La cronologia di gioco mostrerà una finestra con le scommesse precedenti e la cronologia dei bonus.',
'autoplay': 'Modalità Automatica (Autoplay)',
'autoplay_p1': 'Cliccando su Auto puoi far cadere automaticamente un numero di palline senza cliccare ogni volta.',
'autoplay_p2': 'Scegli l’importo da scommettere per ogni pallina.',
'autoplay_p3': 'Seleziona quante volte (turni) vuoi che cada la pallina — fino a un massimo di 100 turni.',
'autoplay_p4': 'Premi il pulsante START per iniziare e il pulsante cambierà in STOP.',
'autoplay_p5': 'La modalità automatica si fermerà quando il numero di cadute selezionato sarà completato, finiranno i fondi o premi STOP.',
'autoplay_p6': 'Ogni caduta utilizza lo stesso importo della scommessa selezionato prima di avviare la modalità automatica.',
'turbo_mode': 'Modalità Turbo',
'turbo_mode_p1': 'Turbo Drop ti permette di far cadere le palline a grande velocità tenendo premuto il pulsante DROP.',
'turbo_mode_p2': 'Le palline continueranno a cadere finché non rilasci il pulsante o fino a esaurimento del saldo.',
'turbo_mode_p3': 'Le palline continueranno a cadere finché non rilasci il pulsante o fino a esaurimento del saldo.',
'turbo_balance': 'Saldo Turbo',
'turbo_balance_p1': 'Prima di avviare Turbo Drop, scegli quanto denaro destinare — questo diventa il tuo Saldo Turbo.',
'turbo_balance_p2': 'Quando Turbo Drop è attivo, il gioco utilizza solo il Saldo Turbo per scommesse e vincite.',
'turbo_balance_p3': 'Quando fermi Turbo Drop, qualsiasi saldo Turbo rimanente torna al tuo saldo principale.',
'turbo_balance_p4': 'Puoi uscire da Turbo Drop in qualsiasi momento — ma la modalità terminerà completamente solo dopo che tutte le palline avranno finito di cadere e saranno arrivate nelle tasche dei moltiplicatori.',
'free_bets': 'TURNI BONUS',
'free_bets_p1': 'I turni bonus vengono assegnati dall’operatore.',
'fairness': 'Equità',
'fairness_p1': 'Ogni caduta è determinata da un generatore di numeri casuali provabilmente equo (RNG).',
'fairness_p2': 'Il risultato non può essere previsto o influenzato una volta che la pallina è caduta.',
'disconection_and_error': 'Politica di disconnessione e gestione degli errori',
'disconection_and_error_p1': 'Se la connessione viene persa dopo una scommessa, la scommessa non sarà annullata. Se il gioco richiede un’azione da parte del giocatore, il risultato sarà calcolato assumendo che il giocatore abbia scelto un’azione senza rischi senza aumentare la scommessa iniziale.',
'disconection_and_error_p2': 'In caso di errore, il nostro team di supporto cercherà di risolvere il problema il prima possibile e riprendere il gioco normale. In caso di problema con il gioco stesso, tutte le scommesse saranno annullate e l’importo della puntata restituito ai giocatori.',
'other': 'Altro',
'other_p1': 'In caso di malfunzionamento dell’hardware/software di gioco, tutte le scommesse e le vincite interessate sono annullate e tutte le puntate interessate sono rimborsate.',
'other_p2': 'Le regole del gioco sono pubblicate in inglese. Le traduzioni in altre lingue sono fornite come servizio in buona fede. In caso di ambiguità tra la versione inglese e la traduzione, la versione inglese ha sempre la priorità.',
'rows': 'Righe',
'lvl': 'Livello',
'low': 'Basso',
'high': 'Alto',
'ok': 'OK',
'exit_turbo_mode': 'Vuoi uscire dalla modalità Turbo?',
"end": "Fine",
"turbo_mode_settings": "Impostazioni modalità Turbo",
"stop": "FERMA",
'invalid_bet_amount': 'Importo della puntata non valido',
'cashout_success': 'Incasso riuscito',
'stop_auto_play_first': 'Ferma prima l’autogioco.',
'turbo_only_when_no_balls': 'La modalità Turbo può essere avviata solo quando non ci sono palline sul tavolo.',
'type': 'Tipo di scommessa',
'wait_balls_to_finish': 'Attendi che tutte le palline finiscano.',
'bet_too_large_top_up_turbo_balance': 'La puntata è troppo alta – ricarica il Saldo Turbo!',
};
langArr.mk = {
'loading': 'Се вчитува',
'hotkeys': 'Пречици',
'hotkeys_enabled': 'Пречици овозможени',
'enable_hotkeys_checkbox': 'Овозможи ги пречиците прикажани подолу со означување на ова поле.',
'drop_ball': 'Пушти топче',
'double_bet': 'Дуплирај облог',
'halve_bet': 'Полови облог',
'min_bet': 'Минимален облог',
'max': 'Макс',
'easy': 'Лесно',
'medium': 'Средно',
'hard': 'Тешко',
'daredevil': 'Бесстрашен',
'max_profit': 'Макс Добивка',
'manual': 'Рачно',
'auto': 'Автоматски',
'bet_amount': 'Износ на облог',
'difficulty': 'Тешкотија',
'payout_on_win': 'Исплата при победа',
'number_of_bets': 'Број на облози',
'on_win': 'При победа',
'on_loss': 'При загуба',
'stop_on_profit': 'Стоп при добивка',
'stop_on_loss': 'Стоп при загуба',
'reset': 'Ресет',
'increase_by': 'Зголеми за',
'cashout': 'ИСПЛАТИ',
'start_game': 'ОБЛОГ',
'start_auto_game': 'ПОЧНИ',
'difficulity_info': 'Информации за тешкотија',
'chance_collision': 'Шанса за судир по игра',
'evry_25_lane': 'за секои 25 патеки',
'insufficiend_funds': 'Недоволно средства',
'cashout_inactivity': 'Автоматска исплата при неактивност',
'time_running_out': 'Времето истекува! Играј сега или твојот билет автоматски ќе биде повлечен за 30 секунди',
'there_was_error': 'СЕ ПОЈАВИ ГРЕШКА, ОБИДЕТЕ СЕ ПАК ИЛИ РЕФРЕШИ',
'detailed_game_rules': 'Детални правила на играта',
'general_rules': 'ОПШТИ ПРАВИЛА',
'general_rules_p1': '• Мултипликаторот започнува од 1 и оди до ',
'general_rules_p2': '• Победите се пресметуваат со множење на облогот со мултипликаторот прикажан на секој чекор.',
'general_rules_p3': '• Ако се достигне максималната исплата, играта автоматски ќе исплати со максималниот износ.',
'progressive_jackpot': 'ПРОГРЕСИВЕН ЏЕКПОТ',
'progressive_jackpot_ss': 'Патека на џекпот и можна добивка',
'progressive_jackpot_p1': '% од секој облог оди во фондот за прогресивен џекпот.',
'progressive_jackpot_p2': 'Џекпотот се доделува со механика „Mystery“ или „must-hit-by“. Вредноста на секој „must-hit-by“ џекпот се одредува веднаш по претходниот џекпот преку генератор на случајни броеви и се чува како шифрирана вредност во оддалечена база на податоци.',
'progressive_jackpot_p3': 'Откако ќе се достигне вредноста „must-hit-by“, првиот играч кој ќе стави облог по тоа ќе има шанса да го освои џекпотот. Џекпот симболот ќе се појави на случајна патека и џекпотот се освојува ако играчот стигне до патеката со симболот.',
'progressive_jackpot_p4': 'ЗАБЕЛЕШКА: Бонус рундот не придонесува во фондот на џекпот. За време на бонус рундот џекпотот не може да се освои.',
'showdown': 'СУКОБ',
'showdown_ss': 'Црвен квадрат, локација на одреден судир',
'showdown_p1': 'Откако играчот ќе исплати, црвен квадрат ќе се прикаже на местото каде што би се случил судирот ако играчот продолжеше да прескокнува патеки.',
'return_to_player': 'ПОВРАТ НА ИГРАЧОТ',
'return_to_player_p1': 'Вкупниот теоретски повраток кон играчот (RTP) е ',
'return_to_player_p2': 'RTP процентите се континуирано следат и проверуваат од независни трети страни.',
'disconnection_policy': 'ПОЛИТИКА ЗА ПРЕКИН НА ВРСКА',
'disconnection_policy_p1': 'Ако конекцијата се изгуби по поставувањето на облогот, облогот нема веднаш да се откаже. Ако неактивноста на играчот достигне ',
'disconnection_policy_p2': 'облогот автоматски ќе се исплати и кредитите ќе бидат применети на сметката на играчот.',
'network_latency': 'МРЕЖНА ЛАТЕНЦИЈА',
'network_latency_p1': 'Мрежната латенција е неизбежен дел од интернет конекцијата. Сите облози и исплати се сметаат за валидни само во моментот кога стигнуваат до нашиот сервер, без оглед на времетраењето на латенцијата.',
'sound': 'ЗВУК',
'sound_p1': 'Играта е дизајнирана со убава позадинска музика и звучни ефекти. Ако сакате да го исклучите звукот и/или ефектите, тоа можете да го направите преку иконите во менито на играта.',
'error_handling': 'РАКУВАЊЕ СО ГРЕШКИ',
'error_handling_p1': 'Во случај на грешка, нашиот тим за поддршка ќе се обиде да го реши проблемот што е можно побрзо и да продолжи со нормалната игра. Ако има проблем со самата игра, сите облози ќе бидат откажани и износот на облогот ќе им биде вратен на играчите.',
'max_payout': 'Максимална исплата е ',
'max_bet_is': 'Максимален облог е ',
'min_bet_is': 'Минимален облог е ',
'per_bet': 'по облог.',
'malfunction_voids': 'Малфункција ги поништува сите исплати и игри.',
'attention_jackpot': 'Внимание, Џекпот на патека ',
'lane': 'патека',
'congratulations': 'честитки',
'you_won': 'победи',
'balance': 'салдо',
'time': 'време',
'jackpot': 'џекпот',
'escaped': 'ИЗБЕГАНО',
'max_win': 'МАКС. ПОБЕДА',
'check_internet': 'Ве молиме проверете ја вашата интернет конекција',
'websocket_disconected': 'Websocket прекинат',
'websocket_connection_error': 'Грешка на websocket конекција!',
'session_expired': 'Сесијата е истечена, ве молиме рефреширајте',
'remaining_bets': 'Простанати облози',
'stop_autoplay': 'СТОП',
'autoplay_and_autocashout': 'АВТОМАТСКА ИГРА И АВТОМАТСКА ИСПЛАТА',
'autoplay_and_autocashout_ss': 'Избор помеѓу рачно и автоматско',
'autoplay_and_autocashout_p1': 'Играчот може да ја активира опцијата за автоматска игра, каде облогот се става автоматски за секој нов круг користејќи го износот на претходниот облог.',
'autoplay_and_autocashout_p2': 'Може да се избере мултипликатор за автоматска исплата на екранот на играта; кога е поставен, играта автоматски ќе исплати ако играчот не биде погоден пред да достигне избраниот мултипликатор.',
'autoplay_and_autocashout_p3': 'Максималниот број на автоматски кругови е ',
'autoplay_button_label': 'За да започнете, изберете патека.',
'min_bet_amount_is': 'Минималниот износ на облог е',
'bonus_rounds': 'бонус кругови',
'bonus_rounds_ss': 'Бонус кругови со период на важност',
'bonus_rounds_p1': 'Играчот може да добие бонус круг (на пр. бесплатен облог) врз основа на казино промоција. Повеќе информации се прикажуваат во поп-ап со известување за доделените бонус кругови, бројот на облози, износот по облог и евентуален период на важност.',
'bonus_rounds_p2': 'Откако ќе бидат доделени, играчот може да избере кога да го започне бонус кругот. Откако бонус кругот ќе започне, автоматски се става облог со назначениот износ, и играчот може да инкасира во секое време.',
'bonus_rounds_p3': 'Бонус круговите може да имаат временско ограничување, по што стануваат неважечки.',
'bonus_rounds_p4': 'Неактивноста на играчот може да резултира со откажување на активен бонус круг. Во овој случај, бројот на бонус кругови се намалува, а салдото на играчот останува исто.',
'valid_until': 'важи до',
'bonus': 'бонус',
'rounds': 'кругови',
'win_eur': 'победа EUR',
'complete_your_bet': 'Ве молиме прво завршете го вашиот облог',
'complete_auto_play': 'Ве молиме прво завршете ја автоматската игра',
'yes': 'да',
'no': 'не',
'play_bonus_rounds': 'Играјте бонус кругови?',
'bet_history': 'Историја на облози',
'jackpot_history': 'Историја на џекпот',
'ticket_id': 'ID на билет',
'created': 'време на создавање',
'currency': 'валута',
'bet': 'облог',
'bet_eur': 'облог EUR',
'lanes': 'патеки',
'cars': 'автомобили',
'multiplier': 'мултипликатор',
'win': 'победа',
'no_betting_history': 'Не е пронајдена историја на облози. Направете облог и ќе се појави тука.',
'no_jackpot_history': 'Нема достапна историја на џекпот.',
'date': 'датум',
'user': 'корисник',
'bet_already_active': 'Облогот веќе е активен',
'please_play_the_game_in_portait_mode': 'Ве молиме играјте во портрет режим.',
'bonus_history': 'Историја на бонуси',
'bonus_type': 'Тип на бонус',
'no_bonus_history': 'Нема достапна историја на бонуси.',
'game_menu': 'Мени на играта',
'game_menu_ss': 'Од лево: Почетна, Историја на облози, Правила на играта, Пречици на тастатурата, Поставки за звук и музика',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'ПРАВИЛА НА ИГРАТА',
'game_rules_p1': 'Добредојдовте во Плинко – каде што среќата води!',
'game_rules_p2': 'Подгответе се за возбудлива игра на среќа која е едноставна и зависничка! Плинко е игра во која се пушта топче врз пирамида полна со клинчиња и се гледа како скока, врти и одскача надолу до џеб полн со награди на дното.',
'game_rules_p3': 'Изберете помеѓу 8 до 16 редови клинчиња, потоа седнете и уживајте во хаосот додека топчето зигзагообразно се движи по таблата, водено само од гравитацијата и среќата.',
'game_rules_p4': 'Дали ќе падне во џеб со мала исплата… или ќе го освои големиот џекпот? Има само еден начин да дознаете — пуштете го топчето и оставете го возбудувањето да започне!',
'general': 'ОПШТО',
'general_p1': 'Пуштете го Плинко топчето и надевајте се дека ќе падне во еден од џебовите со високи исплати на дното. Патеката е непредвидлива — секое одскокнување може да ја смени вашата среќа.',
'general_p2': 'Колку повеќе редови играте, толку поинтензивна е акцијата!',
'general_p3': 'Затоа продолжете — верувајте во среќата, притиснете DROP и тргнете по големата добивка низ клинчињата на Плинко!',
'betting': 'КОМБИНАЦИИ',
'betting_p1': 'Изберете износ на облогот. Копчињата “1/2”, “2x”, “Max” можат да се користат за управување со големината на облогот. Износот на облогот може да се внесе и рачно.',
'betting_p2': 'Изберете ниво на ризик: Ниско, Средно или Високо. Пониското ниво на ризик дава по-конзистентни резултати (ниска волатилност), додека повисокото дава поголема варијација (висока волатилност).',
'betting_p3': 'Изберете број на линии во играта: од 8 до 16. Изберете низ колку редови на пинови ќе паѓа топката. Повеќе редови = поголема непредвидливост.',
'betting_p4': 'Изберете начин на облог: Рачен или Автоматски.',
'betting_p5': 'За да започнете рунд на играта, притиснете го копчето DROP BALL. За време на рундот сите копчиња за облог се неактивни освен DROP BALL и износот на облогот.',
'betting_p6': 'Една Plinko топка претставува еден рунд. За време на рундот може да започне друг рунд со истите поставки користејќи го копчето DROP BALL. Можно е да се промени износот на облог додека има „активни“ топки на таблата, но не и тешкотијата на играта.',
'betting_p7': 'На крајот на рундот топката стигнува до џеб. На секој џеб е прикажан мултипликаторот за исплата.',
'betting_p8': 'Пресметката на добивката се прави според мултипликаторот каде што топката завршила. Резултатот се додава на салдото.',
'game_menu_p1': 'Најновите мултипликатори на облози се прикажани во долниот дел од прозорецот на играта.',
'game_menu_p2': 'Преку копчето “Bet history” играчот може да ги прегледа своите последни облози со повеќе детали.',
'game_menu_p3': 'За подолга историја на играта (на пр. подолги периоди), играчот може да треба да пристапи до историјата на играчот во самата платформа.',
'game_menu_p4': 'Преку менито на играта, играчите можат да ги контролираат звучните опции, пречиците на тастатурата и да ја отворат историјата на облози и правилата на играта.',
'game_menu_p5': 'Играта е дизајнирана со убава позадинска музика и звучни ефекти. Музиката и/или звучните ефекти можат да се исклучат преку иконите во менито на играта.',
'game_menu_p6': 'Историјата на играта ќе прикаже прозорец со претходни облози и историја на бонуси.',
'autoplay': 'Автоматски режим (Autoplay)',
'autoplay_p1': 'Со кликање на Auto можете автоматски да испуштите одреден број топки без да кликате секој пат.',
'autoplay_p2': 'Изберете го износот што сакате да го обложите по топка.',
'autoplay_p3': 'Изберете колку пати (рундови) сакате топката да паѓа — до максимум 100 рундови.',
'autoplay_p4': 'Притиснете го копчето START за да започнете и копчето ќе се промени во STOP.',
'autoplay_p5': 'Автоматскиот режим ќе запре кога ќе се заврши избраниот број на испуштања, ќе ви понестане средства или ќе го притиснете копчето STOP.',
'autoplay_p6': 'Секоја испуштена топка користи ист износ на облог што е избран пред да се стартува Автоматскиот режим.',
'turbo_mode': 'Турбо режим',
'turbo_mode_p1': 'Turbo Drop ви овозможува да испуштите топки многу брзо со држење на копчето DROP.',
'turbo_mode_p2': 'Топките ќе продолжат да паѓаат додека не го ослободите копчето или додека не ви заврши салдото.',
'turbo_mode_p3': 'Топките ќе продолжат да паѓаат додека не го ослободите копчето или додека не ви заврши салдото.',
'turbo_balance': 'Турбо салдо',
'turbo_balance_p1': 'Пред да започнете Turbo Drop, изберете колку пари ќе одвоите — тоа станува вашето Турбо салдо.',
'turbo_balance_p2': 'Додека Turbo Drop е активен, играта користи само вашето Турбо салдо за облози и добивки.',
'turbo_balance_p3': 'Кога ќе го запрете Turbo Drop, преостанатото Турбо салдо се враќа на вашето главно салдо.',
'turbo_balance_p4': 'Можете да излезете од Turbo Drop во секое време — но режимот целосно ќе заврши само откако сите топки ќе завршат со паѓање и ќе пристигнат во мултипликаторските џебови.',
'free_bets': 'БОНУС РУНДОВИ',
'free_bets_p1': 'Бонус рундовите се доделуваат од операторот.',
'fairness': 'Праведност',
'fairness_p1': 'Секоја паѓање е одредена од доказливо фер генератор на случајни броеви (RNG).',
'fairness_p2': 'Резултатот не може да се предвиди или влијае откако топчето ќе падне.',
'disconection_and_error': 'Политика за прекин на конекцијата и управување со грешки',
'disconection_and_error_p1': 'Ако конекцијата се изгуби по поставување на облог, облогот нема да се откаже. Ако играта бара дејство од играчот, резултатот се пресметува претпоставувајќи дека играчот избрал дејство без ризик без зголемување на почетниот облог.',
'disconection_and_error_p2': 'Во случај на грешка, нашиот тим за поддршка ќе се обиде да го реши проблемот што е можно поскоро и да продолжи со редовната игра. Во случај на проблем со самата игра, сите облози ќе бидат откажани и влоговите вратени на играчите.',
'other': 'Останато',
'other_p1': 'Во случај на дефект на хардверот/софтверот за играње, сите засегнати облози и исплати се поништуваат и сите засегнати облози се враќаат.',
'other_p2': 'Правилата на играта се објавени на англиски јазик. Преводите на други јазици се обезбедуваат како услуга со добра намера. Во случај на нејаснотии помеѓу англиската верзија и преводот, англиската верзија има предност.',
'rows': 'Редови',
'lvl': 'Ниво',
'low': 'Ниско',
'high': 'Високо',
'ok': 'OK',
'exit_turbo_mode': 'Дали сакате да излезете од Turbo режим?',
"end": "KPAJ",
"turbo_mode_settings": "Поставки за Турбо режим",
"stop": "СТОП",
'invalid_bet_amount': 'Невалиден износ на облог',
'cashout_success': 'Исплатата е успешна',
'stop_auto_play_first': 'Прво запрете ја автоматската игра.',
'turbo_only_when_no_balls': 'Турбо режимот може да се стартува само кога нема топки на таблата.',
'type': 'Тип на облог',
'wait_balls_to_finish': 'Почекајте сите топки да завршат.',
'bet_too_large_top_up_turbo_balance': 'Облогот е премногу голем – надополни го Турбо салдото!',
};
langArr.pl = {
'loading': 'Ładowanie',
'hotkeys': 'Skróty klawiszowe',
'hotkeys_enabled': 'Skróty klawiszowe włączone',
'enable_hotkeys_checkbox': 'Włącz skróty klawiszowe pokazane poniżej, zaznaczając to pole.',
'drop_ball': 'Upuść kulę',
'double_bet': 'Podwój stawkę',
'halve_bet': 'Podziel stawkę na pół',
'min_bet': 'Minimalna stawka',
'max': 'Maks',
'easy': 'Łatwy',
'medium': 'Średni',
'hard': 'Trudny',
'daredevil': 'Śmiałek',
'max_profit': 'Maksymalny zysk',
'manual': 'Ręczny',
'auto': 'Automatyczny',
'bet_amount': 'Kwota zakładu',
'difficulty': 'Trudność',
'payout_on_win': 'Wypłata przy wygranej',
'number_of_bets': 'Liczba zakładów',
'on_win': 'Przy wygranej',
'on_loss': 'Przy przegranej',
'stop_on_profit': 'Stop przy zysku',
'stop_on_loss': 'Stop przy stracie',
'reset': 'Reset',
'increase_by': 'Zwiększ o',
'cashout': 'WYPŁATA',
'start_game': 'ZAKŁAD',
'start_auto_game': 'START',
'difficulity_info': 'Informacje o trudności',
'chance_collision': 'Szansa kolizji na grę',
'evry_25_lane': 'na każde 25 torów',
'insufficiend_funds': 'Niewystarczające środki',
'cashout_inactivity': 'Automatyczna wypłata przy nieaktywności',
'time_running_out': 'Czas się kończy! Zagraj teraz lub Twój bilet zostanie automatycznie wycofany za 30 sekund',
'there_was_error': 'WYSTĄPIŁ BŁĄD, SPRÓBUJ PONOWNIE LUB ODŚWIEŻ',
'detailed_game_rules': 'Szczegółowe zasady gry',
'general_rules': 'ZASADY OGÓLNE',
'general_rules_p1': '• Mnożnik zaczyna się od 1 i rośnie do ',
'general_rules_p2': '• Wygrane oblicza się poprzez pomnożenie stawki zakładu przez mnożnik wyświetlany na każdym kroku.',
'general_rules_p3': '• Jeśli osiągnięto maksymalną wypłatę, gra automatycznie wypłaci maksymalną kwotę.',
'progressive_jackpot': 'PROGRESYWNY JACKPOT',
'progressive_jackpot_ss': 'Tor jackpot i możliwa wygrana',
'progressive_jackpot_p1': '% każdej stawki przeznaczany jest na fundusz progresywnego jackpota.',
'progressive_jackpot_p2': 'Jackpot jest przyznawany za pomocą mechaniki "Mystery" lub "must-hit-by". Wartość każdego jackpotu "must-hit-by" jest określana natychmiast po poprzednim jackpotcie przez generator liczb losowych i przechowywana jako zaszyfrowana wartość w zdalnej bazie danych.',
'progressive_jackpot_p3': 'Gdy zostanie osiągnięta wartość "must-hit-by", pierwszy gracz, który postawi zakład po tym, będzie miał szansę wygrać jackpot. Symbol jackpota pojawi się na losowym torze i jackpot zostanie wygrany, jeśli gracz dotrze do toru z symbolem.',
'progressive_jackpot_p4': 'UWAGA: Rundy bonusowe nie przyczyniają się do funduszu jackpota. Podczas rundy bonusowej jackpot nie może być wygrany.',
'showdown': 'POKAZ',
'showdown_ss': 'Czerwony kwadrat, miejsce możliwej kolizji',
'showdown_p1': 'Po wypłacie gracza, czerwony kwadrat zostanie pokazany w miejscu, w którym doszłoby do kolizji, gdyby gracz kontynuował pomijanie torów.',
'return_to_player': 'ZWROT DO GRACZA',
'return_to_player_p1': 'Całkowity teoretyczny zwrot do gracza (RTP) wynosi ',
'return_to_player_p2': 'Procenty RTP są ciągle monitorowane i weryfikowane przez niezależne strony trzecie.',
'disconnection_policy': 'POLITYKA ROZŁĄCZENIA',
'disconnection_policy_p1': 'Jeśli po postawieniu zakładu nastąpi utrata połączenia, zakład nie zostanie natychmiast anulowany. Jeśli nieaktywność gracza osiągnie ',
'disconnection_policy_p2': 'zakład zostanie automatycznie wypłacony, a kredyty przypisane do konta gracza.',
'network_latency': 'OPÓŹNIENIE SIECI',
'network_latency_p1': 'Opóźnienie sieci jest nieuniknioną częścią połączenia internetowego. Wszystkie zakłady i wypłaty są uznawane za ważne tylko w momencie dotarcia do naszego serwera, niezależnie od długości opóźnienia sieciowego.',
'sound': 'DŹWIĘK',
'sound_p1': 'Gra jest zaprojektowana z piękną muzyką w tle i efektami dźwiękowymi. Jeśli chcesz wyłączyć muzykę i/lub efekty dźwiękowe, możesz to zrobić za pomocą ikon w menu gry.',
'error_handling': 'OBSŁUGA BŁĘDÓW',
'error_handling_p1': 'W przypadku błędu nasz zespół wsparcia spróbuje rozwiązać problem tak szybko, jak to możliwe i kontynuować normalną grę. W przypadku problemu z samą grą, wszystkie zakłady zostaną anulowane, a kwota zakładu zwrócona graczom.',
'max_payout': 'Maksymalna wypłata wynosi ',
'max_bet_is': 'Maksymalny zakład wynosi ',
'min_bet_is': 'Minimalny zakład wynosi ',
'per_bet': 'za zakład.',
'malfunction_voids': 'Awaria unieważnia wszystkie wypłaty i gry.',
'attention_jackpot': 'Uwaga, Jackpot na torze ',
'lane': 'tor',
'congratulations': 'gratulacje',
'you_won': 'wygrałeś',
'balance': 'saldo',
'time': 'czas',
'jackpot': 'jackpot',
'escaped': 'UCIECZKA',
'max_win': 'MAKS. WYGRANA',
'check_internet': 'Sprawdź połączenie internetowe',
'websocket_disconected': 'Websocket rozłączony',
'websocket_connection_error': 'Błąd połączenia Websocket!',
'session_expired': 'Sesja wygasła, proszę odświeżyć',
'remaining_bets': 'Pozostałe zakłady',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOMATYCZNA GRA I WYPŁATA',
'autoplay_and_autocashout_ss': 'Wybór między ręcznym a automatycznym',
'autoplay_and_autocashout_p1': 'Gracz może aktywować opcję automatycznej gry, gdzie zakład jest automatycznie stawiany w każdej nowej rundzie przy użyciu kwoty poprzedniego zakładu.',
'autoplay_and_autocashout_p2': 'Można wybrać mnożnik automatycznej wypłaty na ekranie gry; po ustawieniu gra automatycznie wypłaci, jeśli gracz nie zostanie trafiony przed osiągnięciem wybranego mnożnika.',
'autoplay_and_autocashout_p3': 'Maksymalna liczba rund automatycznych wynosi ',
'autoplay_button_label': 'Aby rozpocząć, wybierz tor.',
'min_bet_amount_is': 'Minimalna kwota zakładu wynosi',
'bonus_rounds': 'rundy bonusowe',
'bonus_rounds_ss': 'Rundy bonusowe z okresem ważności',
'bonus_rounds_p1': 'Gracz może otrzymać rundę bonusową (np. darmowy zakład) w ramach promocji kasyna. Pojawi się wyskakujące okno informujące o przyznanych rundach bonusowych, liczbie zakładów, kwocie za zakład i opcjonalnym okresie ważności.',
'bonus_rounds_p2': 'Po przyznaniu gracz może wybrać, kiedy rozpocząć rundę bonusową. Po rozpoczęciu automatyczny zakład z określoną stawką jest ustawiany, a gracz może wypłacić w dowolnym momencie.',
'bonus_rounds_p3': 'Rundy bonusowe mogą mieć limit czasowy, po którym stają się nieważne.',
'bonus_rounds_p4': 'Bezczynność gracza może spowodować anulowanie aktywnej rundy bonusowej. W tym przypadku liczba rund bonusowych zostaje zmniejszona, a saldo gracza pozostaje bez zmian.',
'valid_until': 'ważne do',
'bonus': 'bonus',
'rounds': 'rundy',
'win_eur': 'wygrana EUR',
'complete_your_bet': 'Najpierw zakończ swój zakład',
'complete_auto_play': 'Najpierw zakończ automatyczną grę',
'yes': 'tak',
'no': 'nie',
'play_bonus_rounds': 'Zagrać rundy bonusowe?',
'bet_history': 'Historia zakładów',
'jackpot_history': 'Historia jackpotów',
'ticket_id': 'ID biletu',
'created': 'czas utworzenia',
'currency': 'waluta',
'bet': 'zakład',
'bet_eur': 'zakład EUR',
'lanes': 'tory',
'cars': 'samochody',
'multiplier': 'mnożnik',
'win': 'wygrana',
'no_betting_history': 'Nie znaleziono historii zakładów. Złóż zakład, a pojawi się tutaj.',
'no_jackpot_history': 'Brak historii jackpotów.',
'date': 'data',
'user': 'użytkownik',
'bet_already_active': 'Zakład już aktywny',
'please_play_the_game_in_portait_mode': 'Proszę grać w trybie portretowym.',
'bonus_history': 'Historia bonusów',
'bonus_type': 'Rodzaj bonusu',
'no_bonus_history': 'Brak historii bonusów.',
'game_menu': 'Menu gry',
'game_menu_ss': 'Od lewej: Strona główna, Historia zakładów, Zasady gry, Skróty klawiszowe, Ustawienia dźwięku i muzyki',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'ZASADY GRY',
'game_rules_p1': 'Witamy w Plinko – tam, gdzie szczęście rządzi!',
'game_rules_p2': 'Przygotuj się na ekscytującą grę losową, prostą i wciągającą! Plinko polega na puszczeniu kulki na piramidę pełną kołków i obserwowaniu, jak odbija się, obraca i toczy w dół do kieszeni z nagrodami na dole.',
'game_rules_p3': 'Wybierz od 8 do 16 rzędów kołków, a następnie usiądź i ciesz się chaosem, gdy kulka zygzakowato przemieszcza się po planszy, napędzana tylko grawitacją i szczęściem.',
'game_rules_p4': 'Czy wpadnie do kieszeni z niską wypłatą… czy zdobędzie dużą wygraną? Jest tylko jeden sposób, by się dowiedzieć — puść kulkę i pozwól, by emocje się zaczęły!',
'general': 'OGÓLNE',
'general_p1': 'Puść kulkę Plinko i miej nadzieję, że wpadnie do jednej z kieszeni z wysokimi wypłatami na dole. Trasa jest nieprzewidywalna — każdy odbicie może zmienić twoje szczęście.',
'general_p2': 'Im więcej rzędów grasz, tym bardziej intensywna jest akcja!',
'general_p3': 'Więc do dzieła — zaufaj swojemu szczęściu, naciśnij DROP i ścigaj wielką wygraną przez kołki Plinko!',
'betting': 'ZAKŁADY',
'betting_p1': 'Wybierz kwotę zakładu. Przyciski “1/2”, “2x”, “Max” mogą być używane do zarządzania kwotą zakładu. Kwotę zakładu można również wprowadzić ręcznie.',
'betting_p2': 'Wybierz poziom ryzyka: Niski, Średni lub Wysoki. Niższy poziom ryzyka daje bardziej stabilne wyniki (niska zmienność), podczas gdy wyższy daje większą zmienność (wysoka zmienność).',
'betting_p3': 'Wybierz liczbę linii w grze: od 8 do 16. Wybierz, przez ile rzędów kołków przejdzie kula. Więcej rzędów = większa nieprzewidywalność.',
'betting_p4': 'Wybierz tryb zakładu: Ręczny lub Automatyczny.',
'betting_p5': 'Aby rozpocząć rundę gry, naciśnij przycisk DROP BALL. W trakcie rundy wszystkie przyciski zakładu są nieaktywne, z wyjątkiem DROP BALL i kwoty zakładu.',
'betting_p6': 'Jedna kula Plinko reprezentuje jedną rundę. W trakcie rundy można rozpocząć kolejną rundę z tymi samymi ustawieniami używając przycisku DROP BALL. Możliwe jest zmienienie kwoty zakładu, gdy na planszy są „aktywne” kule, ale nie poziomu trudności gry.',
'betting_p7': 'Na końcu rundy kula trafia do kieszeni. W każdej kieszeni wyświetlany jest mnożnik wypłaty.',
'betting_p8': 'Obliczenie wygranej odbywa się zgodnie z mnożnikiem, w którym wylądowała kula. Wynik jest dodawany do salda.',
'game_menu_p1': 'Ostatnie mnożniki zakładów są wyświetlane w dolnej części okna gry.',
'game_menu_p2': 'Za pomocą przycisku “Bet history” gracz może przejrzeć swoje ostatnie zakłady w większych szczegółach.',
'game_menu_p3': 'Aby zobaczyć szerszą historię gry (np. dłuższe okresy), gracz może potrzebować dostępu do historii gracza w samej platformie gry.',
'game_menu_p4': 'Za pomocą menu gry gracze mogą kontrolować opcje dźwięku, skróty klawiaturowe oraz otwierać historię zakładów i zasady gry.',
'game_menu_p5': 'Gra została zaprojektowana z piękną muzyką w tle i efektami dźwiękowymi. Muzykę i/lub efekty dźwiękowe można wyłączyć za pomocą ikon menu gry.',
'game_menu_p6': 'Historia gry pokaże okno z poprzednimi zakładami i historią bonusów.',
'autoplay': 'Tryb Automatyczny (Autoplay)',
'autoplay_p1': 'Klikając Auto możesz automatycznie upuścić kilka kul bez konieczności klikania za każdym razem.',
'autoplay_p2': 'Wybierz kwotę, którą chcesz postawić na każdą kulę.',
'autoplay_p3': 'Wybierz, ile razy (rund) chcesz, aby kula spadła — maksymalnie do 100 rund.',
'autoplay_p4': 'Naciśnij przycisk START, aby rozpocząć, a przycisk zmieni się na STOP.',
'autoplay_p5': 'Tryb automatyczny zatrzyma się po wykonaniu wybranej liczby rzutów, wyczerpaniu środków lub kliknięciu STOP.',
'autoplay_p6': 'Każdy rzut używa tej samej kwoty zakładu, którą wybrałeś przed rozpoczęciem trybu automatycznego.',
'turbo_mode': 'Tryb Turbo',
'turbo_mode_p1': 'Turbo Drop pozwala upuszczać kule bardzo szybko, przytrzymując przycisk DROP.',
'turbo_mode_p2': 'Kule będą nadal spadać, dopóki nie puścisz przycisku lub nie skończy się saldo.',
'turbo_mode_p3': 'Kule będą nadal spadać, dopóki nie puścisz przycisku lub nie skończy się saldo.',
'turbo_balance': 'Saldo Turbo',
'turbo_balance_p1': 'Przed rozpoczęciem Turbo Drop wybierz, ile pieniędzy przeznaczyć — to stanie się Twoim saldem Turbo.',
'turbo_balance_p2': 'Gdy Turbo Drop jest aktywny, gra używa tylko salda Turbo do zakładów i wygranych.',
'turbo_balance_p3': 'Po zatrzymaniu Turbo Drop pozostałe saldo Turbo wraca na główne saldo.',
'turbo_balance_p4': 'Możesz opuścić Turbo Drop w dowolnym momencie — tryb zakończy się całkowicie dopiero po tym, jak wszystkie kule zakończą spadanie i trafią do kieszeni z mnożnikami.',
'free_bets': 'RUNY BONUSOWE',
'free_bets_p1': 'Runy bonusowe są przyznawane przez operatora.',
'fairness': 'Uczciwość',
'fairness_p1': 'Każde spadnięcie jest określane przez dowodowo uczciwy generator liczb losowych (RNG).',
'fairness_p2': 'Wynik nie może być przewidziany ani zmanipulowany po spadnięciu kulki.',
'disconection_and_error': 'Polityka rozłączenia i obsługi błędów',
'disconection_and_error_p1': 'Jeśli po złożeniu zakładu nastąpi rozłączenie, zakład nie zostanie anulowany. Jeśli gra wymaga działania gracza, wynik jest obliczany zakładając, że gracz wybrał akcję bez ryzyka bez zwiększenia początkowego zakładu.',
'disconection_and_error_p2': 'W przypadku błędu nasz zespół wsparcia postara się rozwiązać problem jak najszybciej i kontynuować normalną grę. W przypadku problemów z samą grą wszystkie zakłady zostaną anulowane, a stawki zwrócone graczom.',
'other': 'Inne',
'other_p1': 'W przypadku awarii sprzętu lub oprogramowania gry wszystkie dotknięte zakłady i wypłaty zostaną anulowane, a wszystkie dotknięte stawki zostaną zwrócone.',
'other_p2': 'Zasady gry są opublikowane w języku angielskim. Tłumaczenia na inne języki są dostarczane jako usługa w dobrej wierze. W przypadku niejasności między wersją angielską a tłumaczeniem wersja angielska ma pierwszeństwo.',
'rows': 'Rzędy',
'lvl': 'Poziom',
'low': 'Niski',
'high': 'Wysoki',
'ok': 'OK',
'exit_turbo_mode': 'Дали сакате да излезете од Turbo режим?',
"end": "KONEC",
"turbo_mode_settings": "Ustawienia trybu Turbo",
"stop": "STOP",
'invalid_bet_amount': 'Nieprawidłowa kwota zakładu',
'cashout_success': 'Wypłata zakończona sukcesem',
'stop_auto_play_first': 'Najpierw zatrzymaj automatyczną grę.',
'turbo_only_when_no_balls': 'Tryb Turbo można uruchomić tylko wtedy, gdy na planszy nie ma kul.',
'type': 'Typ zakładu',
'wait_balls_to_finish': 'Poczekaj, aż wszystkie kule się zakończą.',
'bet_too_large_top_up_turbo_balance': 'Zakład jest zbyt duży – doładuj saldo Turbo!',
};
langArr.pt = {
'loading': 'Carregando',
'hotkeys': 'Atalhos',
'hotkeys_enabled': 'Atalhos Ativados',
'enable_hotkeys_checkbox': 'Ative os atalhos mostrados abaixo marcando esta caixa.',
'drop_ball': 'Drop ball',
'double_bet': 'Dobrar aposta',
'halve_bet': 'Reduzir aposta pela metade',
'min_bet': 'Aposta mínima',
'max': 'Máximo',
'easy': 'Fácil',
'medium': 'Médio',
'hard': 'Difícil',
'daredevil': 'Corajoso',
'max_profit': 'Lucro Máximo',
'manual': 'Manual',
'auto': 'Automático',
'bet_amount': 'Valor da aposta',
'difficulty': 'Dificuldade',
'payout_on_win': 'Pagamento na vitória',
'number_of_bets': 'Número de apostas',
'on_win': 'Ao ganhar',
'on_loss': 'Ao perder',
'stop_on_profit': 'Parar no lucro',
'stop_on_loss': 'Parar na perda',
'reset': 'Redefinir',
'increase_by': 'Aumentar em',
'cashout': 'SACAR',
'start_game': 'APOSTAR',
'start_auto_game': 'COMEÇAR',
'difficulity_info': 'Informações de dificuldade',
'chance_collision': 'Chance de colisão por jogo',
'evry_25_lane': 'a cada 25 pistas',
'insufficiend_funds': 'Fundos insuficientes',
'cashout_inactivity': 'Saque automático por inatividade',
'time_running_out': 'O tempo está acabando! Jogue agora ou seu bilhete será retirado em 30 segundos',
'there_was_error': 'HOUVE UM ERRO, TENTE NOVAMENTE OU RECARREGUE',
'detailed_game_rules': 'Regras Detalhadas do Jogo',
'general_rules': 'REGRAS GERAIS',
'general_rules_p1': '• O multiplicador começa em 1 e vai até ',
'general_rules_p2': '• Os ganhos são calculados multiplicando o valor apostado pelo multiplicador exibido a cada etapa.',
'general_rules_p3': '• Se o pagamento máximo for atingido, o jogo sacará automaticamente nesse valor.',
'progressive_jackpot': 'JACKPOT PROGRESSIVO',
'progressive_jackpot_ss': 'A pista do jackpot e o prêmio possível',
'progressive_jackpot_p1': '% de cada aposta é destinada a um fundo de jackpot progressivo.',
'progressive_jackpot_p2': 'O jackpot é concedido usando uma mecânica "Mystery" ou "must-hit-by". O valor de cada jackpot "must-hit-by" é definido imediatamente após o anterior ser ganho, gerado aleatoriamente e armazenado de forma criptografada no banco de dados remoto.',
'progressive_jackpot_p3': 'Assim que o valor "must-hit-by" for alcançado, o primeiro jogador a apostar terá a chance de ganhar o jackpot. Um símbolo de jackpot aparecerá em uma pista aleatória, e o jogador ganha se alcançar essa pista. Caso saque ou perca antes, o próximo jogador verá o símbolo e terá a chance de ganhar. Esse processo se repete até alguém vencer. Apenas um bilhete/jogador pode ganhar o jackpot.',
'progressive_jackpot_p4': 'NOTA: Rodadas bônus não contribuem para o fundo de jackpot. Durante elas, o jackpot não pode ser ganho.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Quadrado vermelho, localização de colisão certa',
'showdown_p1': 'Depois de sacar, um quadrado vermelho mostrará onde a colisão teria ocorrido se o jogador continuasse.',
'return_to_player': 'RETORNO AO JOGADOR',
'return_to_player_p1': 'O retorno teórico geral ao jogador (RTP) é ',
'return_to_player_p2': 'Os percentuais de RTP são monitorados e verificados por terceiros independentes.',
'disconnection_policy': 'POLÍTICA DE DESCONECTAR',
'disconnection_policy_p1': 'Se a conexão cair após a aposta, ela não será cancelada imediatamente. Se a inatividade durar ',
'disconnection_policy_p2': 'a aposta será sacada automaticamente e o crédito aplicado na conta do jogador.',
'network_latency': 'LATÊNCIA DE REDE',
'network_latency_p1': 'A latência de rede é inevitável. Todas as apostas e saques são válidos apenas quando chegam ao nosso servidor.',
'sound': 'SOM',
'sound_p1': 'O jogo tem música de fundo e efeitos sonoros. Se quiser, é possível desativá-los pelo menu.',
'error_handling': 'TRATAMENTO DE ERROS',
'error_handling_p1': 'Em caso de erro, nosso suporte tentará resolver rapidamente. Se o problema for no jogo, as apostas são canceladas e os valores devolvidos.',
'max_payout': 'Pagamento máximo é ',
'max_bet_is': 'Aposta máxima é ',
'min_bet_is': 'Aposta mínima é ',
'per_bet': 'por aposta.',
'malfunction_voids': 'Falhas anulam todos os Pagamentos e Jogadas.',
'attention_jackpot': 'Atenção, Jackpot na pista ',
'lane': 'pista',
'congratulations': 'parabéns',
'you_won': 'você ganhou',
'balance': 'saldo',
'time': 'tempo',
'jackpot': 'jackpot',
'escaped': 'ESCAPOU',
'max_win': 'VITÓRIA MÁXIMA',
'check_internet': 'Verifique sua conexão com a internet',
'websocket_disconected': 'Websocket desconectado',
'websocket_connection_error': 'Erro de conexão Websocket!',
'session_expired': 'Sessão expirada, recarregue',
'remaining_bets': 'Apostas restantes',
'stop_autoplay': 'PARAR',
'autoplay_and_autocashout': 'AUTOMÁTICO E AUTO SAQUE',
'autoplay_and_autocashout_ss': 'Escolha entre manual e automático',
'autoplay_and_autocashout_p1': 'O jogador pode ativar o automático, apostando a cada rodada com o valor da aposta anterior.',
'autoplay_and_autocashout_p2': 'Um multiplicador de saque automático pode ser configurado, sacando automaticamente se o jogador não for atingido antes.',
'autoplay_and_autocashout_p3': 'O número máximo de rodadas automáticas é ',
'autoplay_button_label': 'Para começar, escolha uma pista.',
'min_bet_amount_is': 'Valor mínimo da aposta é',
'bonus_rounds': 'rodadas bônus',
'bonus_rounds_ss': 'Rodadas bônus com validade',
'bonus_rounds_p1': 'O jogador pode ganhar uma rodada bônus (aposta grátis) em promoções do cassino. Um aviso aparecerá indicando quantidade de apostas, valor por aposta e validade.',
'bonus_rounds_p2': 'Uma vez recebidas, o jogador escolhe quando começar. Ao iniciar, a aposta acontece automaticamente com o valor indicado.',
'bonus_rounds_p3': 'Rodadas bônus podem ter tempo limite e expirar. O prazo aparece abaixo da rodada bônus.',
'bonus_rounds_p4': 'Se o jogador ficar inativo, a rodada bônus ativa é cancelada. O saldo permanece igual.',
'valid_until': 'válido até',
'bonus': 'bônus',
'rounds': 'rodadas',
'win_eur': 'ganho EUR',
'complete_your_bet': 'Complete sua aposta primeiro',
'complete_auto_play': 'Conclua seu jogo automático primeiro',
'yes': 'sim',
'no': 'não',
'play_bonus_rounds': 'Jogar rodadas bônus?',
'bet_history': 'Histórico de apostas',
'jackpot_history': 'Histórico de jackpots',
'ticket_id': 'ID do bilhete',
'created': 'hora de criação',
'currency': 'moeda',
'bet': 'aposta',
'bet_eur': 'aposta EUR',
'lanes': 'pistas',
'cars': 'carros',
'multiplier': 'multiplicador',
'win': 'ganho',
'no_betting_history': 'Nenhum histórico encontrado. Faça uma aposta para aparecer aqui.',
'no_jackpot_history': 'Sem histórico de jackpots.',
'date': 'data',
'user': 'usuário',
'bet_already_active': 'Aposta já ativa',
'please_play_the_game_in_portait_mode': 'Jogue no modo retrato.',
'bonus_history': 'Histórico de bônus',
'bonus_type': 'Tipo de bônus',
'no_bonus_history': 'Sem histórico de bônus.',
'game_menu': 'Menu do jogo',
'game_menu_ss': 'Da esquerda: Início, Histórico, Regras, Atalhos, Sons, Música',
// 'game_menu_p1': 'No menu, jogadores podem controlar som, atalhos, histórico e regras.',
// 'game_menu_p2': 'O histórico mostra apostas anteriores e bônus.'
'game_rules': 'REGRAS DO JOGO',
'game_rules_p1': 'Bem-vindo ao Plinko – Onde a Sorte Comanda!',
'game_rules_p2': 'Prepare-se para um jogo de azar emocionante, simples e viciante! Plinko consiste em deixar cair uma bola numa pirâmide cheia de pinos e observar como ela quica, gira e rola para baixo até um bolso premiado na parte inferior.',
'game_rules_p3': 'Escolha entre 8 e 16 linhas de pinos, depois sente-se e aproveite o caos enquanto a bola ziguezagueia pelo tabuleiro, guiada apenas pela gravidade e sorte.',
'game_rules_p4': 'Será que ela vai cair num bolso com um pagamento baixo… ou ganhar o grande prêmio? Só há uma maneira de descobrir — solte a bola e deixe a emoção começar!',
'general': 'GERAL',
'general_p1': 'Deixe cair a bola Plinko e espere que ela caia num dos bolsos com pagamentos altos na parte inferior. O percurso é imprevisível — cada ricochete pode mudar a sua sorte.',
'general_p2': 'Quanto mais linhas jogar, mais intensa será a ação!',
'general_p3': 'Então vá em frente — confie na sua sorte, pressione DROP e corra atrás do grande prêmio através dos pinos do Plinko!',
'betting': 'APOSTAS',
'betting_p1': 'Escolha o valor da aposta. Os botões “1/2”, “2x”, “Max” podem ser usados para gerenciar o tamanho da aposta. O valor da aposta também pode ser inserido manualmente.',
'betting_p2': 'Escolha o Nível de Risco: Baixo, Médio ou Alto. Um nível de risco mais baixo oferece resultados mais consistentes (baixa volatilidade), enquanto um nível mais alto oferece maior variação (alta volatilidade).',
'betting_p3': 'Escolha o número de linhas no jogo: de 8 a 16. Selecione por quantas fileiras de pinos a bola vai passar. Mais fileiras = maior imprevisibilidade.',
'betting_p4': 'Escolha o Modo de Aposta: Manual ou Automático.',
'betting_p5': 'Para iniciar a rodada do jogo, pressione o botão DROP BALL. Durante a rodada, todos os botões de aposta ficam inativos, exceto DROP BALL e o valor da aposta.',
'betting_p6': 'Uma bola Plinko representa uma rodada. Durante a rodada, outra rodada com as mesmas configurações pode ser iniciada usando o botão DROP BALL. É possível alterar o valor da aposta enquanto houver bolas “ativas” na tabela, mas não a dificuldade do jogo.',
'betting_p7': 'No final da rodada, a bola chega a um bolso. Em cada bolso é mostrado o multiplicador de pagamento.',
'betting_p8': 'O cálculo do ganho é feito de acordo com o multiplicador em que a bola caiu. O resultado é adicionado ao saldo.',
'game_menu_p1': 'Os multiplicadores de apostas mais recentes são exibidos na parte inferior da janela do jogo.',
'game_menu_p2': 'No botão “Bet history”, o jogador pode rever suas últimas apostas em mais detalhes.',
'game_menu_p3': 'Para um histórico de jogo mais longo (ex: períodos maiores), o jogador pode precisar acessar o histórico dentro da própria plataforma de jogo.',
'game_menu_p4': 'Através do menu do jogo, os jogadores podem controlar opções de som, atalhos de teclado e abrir histórico de apostas e regras do jogo.',
'game_menu_p5': 'O jogo é projetado com música de fundo bonita e efeitos sonoros. A música e/ou efeitos sonoros podem ser desativados através dos ícones do menu do jogo.',
'game_menu_p6': 'O histórico do jogo mostrará uma janela com apostas anteriores e histórico de bônus.',
'autoplay': 'Modo Automático (Autoplay)',
'autoplay_p1': 'Clicando em Auto, você pode soltar automaticamente várias bolas sem precisar clicar a cada vez.',
'autoplay_p2': 'Escolha o valor que deseja apostar por bola.',
'autoplay_p3': 'Selecione quantas vezes (rodadas) deseja que a bola caia — até 100 rodadas no máximo.',
'autoplay_p4': 'Pressione o botão START para começar e o botão mudará para STOP.',
'autoplay_p5': 'O Modo Automático parará quando o número de quedas selecionado for concluído, acabar o saldo ou clicar no botão STOP.',
'autoplay_p6': 'Cada queda usa o mesmo valor de aposta que você selecionou antes de iniciar o Modo Automático.',
'turbo_mode': 'Modo Turbo',
'turbo_mode_p1': 'Turbo Drop permite soltar bolas em alta velocidade mantendo o botão DROP pressionado.',
'turbo_mode_p2': 'As bolas continuarão caindo até que você solte o botão ou fique sem saldo.',
'turbo_mode_p3': 'As bolas continuarão caindo até que você solte o botão ou fique sem saldo.',
'turbo_balance': 'Saldo Turbo',
'turbo_balance_p1': 'Antes de iniciar o Turbo Drop, escolha quanto dinheiro reservar — isso se tornará seu Saldo Turbo.',
'turbo_balance_p2': 'Enquanto o Turbo Drop estiver ativo, o jogo usará apenas seu Saldo Turbo para apostas e ganhos.',
'turbo_balance_p3': 'Quando você parar o Turbo Drop, qualquer Saldo Turbo restante volta para o saldo principal.',
'turbo_balance_p4': 'Você pode sair do Turbo Drop a qualquer momento — mas o modo terminará completamente apenas depois que todas as bolas terminarem de cair e chegarem aos bolsos multiplicadores.',
'free_bets': 'RODADAS DE BÔNUS',
'free_bets_p1': 'As rodadas de bônus são concedidas pelo operador.',
'fairness': 'Justiça',
'fairness_p1': 'Cada queda é determinada por um gerador de números aleatórios justo e comprovável (RNG).',
'fairness_p2': 'O resultado não pode ser previsto nem influenciado depois que a bola cair.',
'disconection_and_error': 'Política de desconexão e tratamento de erros',
'disconection_and_error_p1': 'Se a conexão for perdida após a aposta, a aposta não será cancelada. Se o jogo requer ação do jogador, o resultado será calculado assumindo que o jogador escolheu uma ação sem risco sem aumentar a aposta inicial.',
'disconection_and_error_p2': 'Em caso de erro, nossa equipe de suporte tentará resolver o problema o mais rápido possível e continuar o jogo normalmente. Em caso de problema no jogo em si, todas as apostas serão canceladas e os valores devolvidos aos jogadores.',
'other': 'Outros',
'other_p1': 'Em caso de falha de hardware ou software do jogo, todas as apostas e pagamentos afetados serão anulados e todas as apostas afetadas serão reembolsadas.',
'other_p2': 'As regras do jogo são publicadas em inglês. Traduções para outros idiomas são fornecidas como serviço de boa-fé. Em caso de ambiguidade entre a versão em inglês e a tradução, a versão em inglês prevalece.',
'rows': 'Linhas',
'lvl': 'Nível',
'low': 'Baixo',
'high': 'Alto',
'ok': 'OK',
'exit_turbo_mode': 'Quer sair do modo Turbo?',
"end": "FIM",
"turbo_mode_settings": "Configurações do modo Turbo",
"stop": "PARAR",
'invalid_bet_amount': 'Valor de aposta inválido',
'cashout_success': 'Saque realizado com sucesso',
'stop_auto_play_first': 'Primeiro pare o jogo automático.',
'turbo_only_when_no_balls': 'O modo Turbo só pode ser iniciado quando não há bolas na mesa.',
'type': 'Tipo de aposta',
'wait_balls_to_finish': 'Aguarde todas as bolas terminarem.',
'bet_too_large_top_up_turbo_balance': 'Aposta muito alta – recarregue o Saldo Turbo!',
};
langArr.br = {
'loading': 'Carregando',
'hotkeys': 'Atalhos',
'hotkeys_enabled': 'Atalhos Ativados',
'enable_hotkeys_checkbox': 'Ative os atalhos mostrados abaixo marcando esta caixa.',
'drop_ball': 'Drop ball',
'double_bet': 'Dobrar aposta',
'halve_bet': 'Reduzir aposta pela metade',
'min_bet': 'Aposta mínima',
'max': 'Máximo',
'easy': 'Fácil',
'medium': 'Médio',
'hard': 'Difícil',
'daredevil': 'Corajoso',
'max_profit': 'Lucro Máximo',
'manual': 'Manual',
'auto': 'Automático',
'bet_amount': 'Valor da aposta',
'difficulty': 'Dificuldade',
'payout_on_win': 'Pagamento na vitória',
'number_of_bets': 'Número de apostas',
'on_win': 'Ao ganhar',
'on_loss': 'Ao perder',
'stop_on_profit': 'Parar no lucro',
'stop_on_loss': 'Parar na perda',
'reset': 'Redefinir',
'increase_by': 'Aumentar em',
'cashout': 'SACAR',
'start_game': 'APOSTAR',
'start_auto_game': 'COMEÇAR',
'difficulity_info': 'Informações de dificuldade',
'chance_collision': 'Chance de colisão por jogo',
'evry_25_lane': 'a cada 25 pistas',
'insufficiend_funds': 'Fundos insuficientes',
'cashout_inactivity': 'Saque automático por inatividade',
'time_running_out': 'O tempo está acabando! Jogue agora ou seu bilhete será retirado em 30 segundos',
'there_was_error': 'HOUVE UM ERRO, TENTE NOVAMENTE OU RECARREGUE',
'detailed_game_rules': 'Regras Detalhadas do Jogo',
'general_rules': 'REGRAS GERAIS',
'general_rules_p1': '• O multiplicador começa em 1 e vai até ',
'general_rules_p2': '• Os ganhos são calculados multiplicando o valor apostado pelo multiplicador exibido a cada etapa.',
'general_rules_p3': '• Se o pagamento máximo for atingido, o jogo sacará automaticamente nesse valor.',
'progressive_jackpot': 'JACKPOT PROGRESSIVO',
'progressive_jackpot_ss': 'A pista do jackpot e o prêmio possível',
'progressive_jackpot_p1': '% de cada aposta é destinada a um fundo de jackpot progressivo.',
'progressive_jackpot_p2': 'O jackpot é concedido usando uma mecânica "Mystery" ou "must-hit-by". O valor de cada jackpot "must-hit-by" é definido imediatamente após o anterior ser ganho, gerado aleatoriamente e armazenado de forma criptografada no banco de dados remoto.',
'progressive_jackpot_p3': 'Assim que o valor "must-hit-by" for alcançado, o primeiro jogador a apostar terá a chance de ganhar o jackpot. Um símbolo de jackpot aparecerá em uma pista aleatória, e o jogador ganha se alcançar essa pista. Caso saque ou perca antes, o próximo jogador verá o símbolo e terá a chance de ganhar. Esse processo se repete até alguém vencer. Apenas um bilhete/jogador pode ganhar o jackpot.',
'progressive_jackpot_p4': 'NOTA: Rodadas bônus não contribuem para o fundo de jackpot. Durante elas, o jackpot não pode ser ganho.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Quadrado vermelho, localização de colisão certa',
'showdown_p1': 'Depois de sacar, um quadrado vermelho mostrará onde a colisão teria ocorrido se o jogador continuasse.',
'return_to_player': 'RETORNO AO JOGADOR',
'return_to_player_p1': 'O retorno teórico geral ao jogador (RTP) é ',
'return_to_player_p2': 'Os percentuais de RTP são monitorados e verificados por terceiros independentes.',
'disconnection_policy': 'POLÍTICA DE DESCONECTAR',
'disconnection_policy_p1': 'Se a conexão cair após a aposta, ela não será cancelada imediatamente. Se a inatividade durar ',
'disconnection_policy_p2': 'a aposta será sacada automaticamente e o crédito aplicado na conta do jogador.',
'network_latency': 'LATÊNCIA DE REDE',
'network_latency_p1': 'A latência de rede é inevitável. Todas as apostas e saques são válidos apenas quando chegam ao nosso servidor.',
'sound': 'SOM',
'sound_p1': 'O jogo tem música de fundo e efeitos sonoros. Se quiser, é possível desativá-los pelo menu.',
'error_handling': 'TRATAMENTO DE ERROS',
'error_handling_p1': 'Em caso de erro, nosso suporte tentará resolver rapidamente. Se o problema for no jogo, as apostas são canceladas e os valores devolvidos.',
'max_payout': 'Pagamento máximo é ',
'max_bet_is': 'Aposta máxima é ',
'min_bet_is': 'Aposta mínima é ',
'per_bet': 'por aposta.',
'malfunction_voids': 'Falhas anulam todos os Pagamentos e Jogadas.',
'attention_jackpot': 'Atenção, Jackpot na pista ',
'lane': 'pista',
'congratulations': 'parabéns',
'you_won': 'você ganhou',
'balance': 'saldo',
'time': 'tempo',
'jackpot': 'jackpot',
'escaped': 'ESCAPOU',
'max_win': 'VITÓRIA MÁXIMA',
'check_internet': 'Verifique sua conexão com a internet',
'websocket_disconected': 'Websocket desconectado',
'websocket_connection_error': 'Erro de conexão Websocket!',
'session_expired': 'Sessão expirada, recarregue',
'remaining_bets': 'Apostas restantes',
'stop_autoplay': 'PARAR',
'autoplay_and_autocashout': 'AUTOMÁTICO E AUTO SAQUE',
'autoplay_and_autocashout_ss': 'Escolha entre manual e automático',
'autoplay_and_autocashout_p1': 'O jogador pode ativar o automático, apostando a cada rodada com o valor da aposta anterior.',
'autoplay_and_autocashout_p2': 'Um multiplicador de saque automático pode ser configurado, sacando automaticamente se o jogador não for atingido antes.',
'autoplay_and_autocashout_p3': 'O número máximo de rodadas automáticas é ',
'autoplay_button_label': 'Para começar, escolha uma pista.',
'min_bet_amount_is': 'Valor mínimo da aposta é',
'bonus_rounds': 'rodadas bônus',
'bonus_rounds_ss': 'Rodadas bônus com validade',
'bonus_rounds_p1': 'O jogador pode ganhar uma rodada bônus (aposta grátis) em promoções do cassino. Um aviso aparecerá indicando quantidade de apostas, valor por aposta e validade.',
'bonus_rounds_p2': 'Uma vez recebidas, o jogador escolhe quando começar. Ao iniciar, a aposta acontece automaticamente com o valor indicado.',
'bonus_rounds_p3': 'Rodadas bônus podem ter tempo limite e expirar. O prazo aparece abaixo da rodada bônus.',
'bonus_rounds_p4': 'Se o jogador ficar inativo, a rodada bônus ativa é cancelada. O saldo permanece igual.',
'valid_until': 'válido até',
'bonus': 'bônus',
'rounds': 'rodadas',
'win_eur': 'ganho EUR',
'complete_your_bet': 'Complete sua aposta primeiro',
'complete_auto_play': 'Conclua seu jogo automático primeiro',
'yes': 'sim',
'no': 'não',
'play_bonus_rounds': 'Jogar rodadas bônus?',
'bet_history': 'Histórico de apostas',
'jackpot_history': 'Histórico de jackpots',
'ticket_id': 'ID do bilhete',
'created': 'hora de criação',
'currency': 'moeda',
'bet': 'aposta',
'bet_eur': 'aposta EUR',
'lanes': 'pistas',
'cars': 'carros',
'multiplier': 'multiplicador',
'win': 'ganho',
'no_betting_history': 'Nenhum histórico encontrado. Faça uma aposta para aparecer aqui.',
'no_jackpot_history': 'Sem histórico de jackpots.',
'date': 'data',
'user': 'usuário',
'bet_already_active': 'Aposta já ativa',
'please_play_the_game_in_portait_mode': 'Jogue no modo retrato.',
'bonus_history': 'Histórico de bônus',
'bonus_type': 'Tipo de bônus',
'no_bonus_history': 'Sem histórico de bônus.',
'game_menu': 'Menu do jogo',
'game_menu_ss': 'Da esquerda: Início, Histórico, Regras, Atalhos, Sons, Música',
// 'game_menu_p1': 'No menu, jogadores podem controlar som, atalhos, histórico e regras.',
// 'game_menu_p2': 'O histórico mostra apostas anteriores e bônus.'
'game_rules': 'REGRAS DO JOGO',
'game_rules_p1': 'Bem-vindo ao Plinko – Onde a Sorte Comanda!',
'game_rules_p2': 'Prepare-se para um jogo de azar emocionante, simples e viciante! Plinko consiste em deixar cair uma bola numa pirâmide cheia de pinos e observar como ela quica, gira e rola para baixo até um bolso premiado na parte inferior.',
'game_rules_p3': 'Escolha entre 8 e 16 linhas de pinos, depois sente-se e aproveite o caos enquanto a bola ziguezagueia pelo tabuleiro, guiada apenas pela gravidade e sorte.',
'game_rules_p4': 'Será que ela vai cair num bolso com um pagamento baixo… ou ganhar o grande prêmio? Só há uma maneira de descobrir — solte a bola e deixe a emoção começar!',
'general': 'GERAL',
'general_p1': 'Deixe cair a bola Plinko e espere que ela caia num dos bolsos com pagamentos altos na parte inferior. O percurso é imprevisível — cada ricochete pode mudar a sua sorte.',
'general_p2': 'Quanto mais linhas jogar, mais intensa será a ação!',
'general_p3': 'Então vá em frente — confie na sua sorte, pressione DROP e corra atrás do grande prêmio através dos pinos do Plinko!',
'betting': 'APOSTAS',
'betting_p1': 'Escolha o valor da aposta. Os botões “1/2”, “2x”, “Max” podem ser usados para gerenciar o tamanho da aposta. O valor da aposta também pode ser inserido manualmente.',
'betting_p2': 'Escolha o Nível de Risco: Baixo, Médio ou Alto. Um nível de risco mais baixo oferece resultados mais consistentes (baixa volatilidade), enquanto um nível mais alto oferece maior variação (alta volatilidade).',
'betting_p3': 'Escolha o número de linhas no jogo: de 8 a 16. Selecione por quantas fileiras de pinos a bola vai passar. Mais fileiras = maior imprevisibilidade.',
'betting_p4': 'Escolha o Modo de Aposta: Manual ou Automático.',
'betting_p5': 'Para iniciar a rodada do jogo, pressione o botão DROP BALL. Durante a rodada, todos os botões de aposta ficam inativos, exceto DROP BALL e o valor da aposta.',
'betting_p6': 'Uma bola Plinko representa uma rodada. Durante a rodada, outra rodada com as mesmas configurações pode ser iniciada usando o botão DROP BALL. É possível alterar o valor da aposta enquanto houver bolas “ativas” na tabela, mas não a dificuldade do jogo.',
'betting_p7': 'No final da rodada, a bola chega a um bolso. Em cada bolso é mostrado o multiplicador de pagamento.',
'betting_p8': 'O cálculo do ganho é feito de acordo com o multiplicador em que a bola caiu. O resultado é adicionado ao saldo.',
'game_menu_p1': 'Os multiplicadores de apostas mais recentes são exibidos na parte inferior da janela do jogo.',
'game_menu_p2': 'No botão “Bet history”, o jogador pode rever suas últimas apostas em mais detalhes.',
'game_menu_p3': 'Para um histórico de jogo mais longo (ex: períodos maiores), o jogador pode precisar acessar o histórico dentro da própria plataforma de jogo.',
'game_menu_p4': 'Através do menu do jogo, os jogadores podem controlar opções de som, atalhos de teclado e abrir histórico de apostas e regras do jogo.',
'game_menu_p5': 'O jogo é projetado com música de fundo bonita e efeitos sonoros. A música e/ou efeitos sonoros podem ser desativados através dos ícones do menu do jogo.',
'game_menu_p6': 'O histórico do jogo mostrará uma janela com apostas anteriores e histórico de bônus.',
'autoplay': 'Modo Automático (Autoplay)',
'autoplay_p1': 'Clicando em Auto, você pode soltar automaticamente várias bolas sem precisar clicar a cada vez.',
'autoplay_p2': 'Escolha o valor que deseja apostar por bola.',
'autoplay_p3': 'Selecione quantas vezes (rodadas) deseja que a bola caia — até 100 rodadas no máximo.',
'autoplay_p4': 'Pressione o botão START para começar e o botão mudará para STOP.',
'autoplay_p5': 'O Modo Automático parará quando o número de quedas selecionado for concluído, acabar o saldo ou clicar no botão STOP.',
'autoplay_p6': 'Cada queda usa o mesmo valor de aposta que você selecionou antes de iniciar o Modo Automático.',
'turbo_mode': 'Modo Turbo',
'turbo_mode_p1': 'Turbo Drop permite soltar bolas em alta velocidade mantendo o botão DROP pressionado.',
'turbo_mode_p2': 'As bolas continuarão caindo até que você solte o botão ou fique sem saldo.',
'turbo_mode_p3': 'As bolas continuarão caindo até que você solte o botão ou fique sem saldo.',
'turbo_balance': 'Saldo Turbo',
'turbo_balance_p1': 'Antes de iniciar o Turbo Drop, escolha quanto dinheiro reservar — isso se tornará seu Saldo Turbo.',
'turbo_balance_p2': 'Enquanto o Turbo Drop estiver ativo, o jogo usará apenas seu Saldo Turbo para apostas e ganhos.',
'turbo_balance_p3': 'Quando você parar o Turbo Drop, qualquer Saldo Turbo restante volta para o saldo principal.',
'turbo_balance_p4': 'Você pode sair do Turbo Drop a qualquer momento — mas o modo terminará completamente apenas depois que todas as bolas terminarem de cair e chegarem aos bolsos multiplicadores.',
'free_bets': 'RODADAS DE BÔNUS',
'free_bets_p1': 'As rodadas de bônus são concedidas pelo operador.',
'fairness': 'Justiça',
'fairness_p1': 'Cada queda é determinada por um gerador de números aleatórios justo e comprovável (RNG).',
'fairness_p2': 'O resultado não pode ser previsto nem influenciado depois que a bola cair.',
'disconection_and_error': 'Política de desconexão e tratamento de erros',
'disconection_and_error_p1': 'Se a conexão for perdida após a aposta, a aposta não será cancelada. Se o jogo requer ação do jogador, o resultado será calculado assumindo que o jogador escolheu uma ação sem risco sem aumentar a aposta inicial.',
'disconection_and_error_p2': 'Em caso de erro, nossa equipe de suporte tentará resolver o problema o mais rápido possível e continuar o jogo normalmente. Em caso de problema no jogo em si, todas as apostas serão canceladas e os valores devolvidos aos jogadores.',
'other': 'Outros',
'other_p1': 'Em caso de falha de hardware ou software do jogo, todas as apostas e pagamentos afetados serão anulados e todas as apostas afetadas serão reembolsadas.',
'other_p2': 'As regras do jogo são publicadas em inglês. Traduções para outros idiomas são fornecidas como serviço de boa-fé. Em caso de ambiguidade entre a versão em inglês e a tradução, a versão em inglês prevalece.',
'rows': 'Linhas',
'lvl': 'Nível',
'low': 'Baixo',
'high': 'Alto',
'ok': 'OK',
'exit_turbo_mode': 'Você quer sair do modo Turbo?',
"end": "FIM",
"turbo_mode_settings": "Configurações do modo Turbo",
"stop": "PARAR",
'invalid_bet_amount': 'Valor de aposta inválido',
'cashout_success': 'Saque realizado com sucesso',
'stop_auto_play_first': 'Primeiro pare o jogo automático.',
'turbo_only_when_no_balls': 'O modo Turbo só pode ser iniciado quando não há bolas na mesa.',
'type': 'Tipo de aposta',
'wait_balls_to_finish': 'Aguarde todas as bolas terminarem.',
'bet_too_large_top_up_turbo_balance': 'Aposta muito alta – recarregue o Saldo Turbo!',
};
langArr.ro = {
'loading': 'Se încarcă',
'hotkeys': 'Taste rapide',
'hotkeys_enabled': 'Taste rapide activate',
'enable_hotkeys_checkbox': 'Activați tastele rapide afișate mai jos bifând această casetă.',
'drop_ball': 'Lansează bila',
'double_bet': 'Dublează miza',
'halve_bet': 'Înjumătățește miza',
'min_bet': 'Miză minimă',
'max': 'Max',
'easy': 'Ușor',
'medium': 'Mediu',
'hard': 'Greu',
'daredevil': 'Temerar',
'max_profit': 'Profit maxim',
'manual': 'Manual',
'auto': 'Automat',
'bet_amount': 'Valoarea mizei',
'difficulty': 'Dificultate',
'payout_on_win': 'Plată la câștig',
'number_of_bets': 'Număr de pariuri',
'on_win': 'La câștig',
'on_loss': 'La pierdere',
'stop_on_profit': 'Oprește la profit',
'stop_on_loss': 'Oprește la pierdere',
'reset': 'Resetare',
'increase_by': 'Mărește cu',
'cashout': 'ÎNCASEAZĂ',
'start_game': 'PARIAZĂ',
'start_auto_game': 'START',
'difficulity_info': 'Informații dificultate',
'chance_collision': 'Șansă de coliziune per joc',
'evry_25_lane': 'pentru fiecare 25 de benzi',
'insufficiend_funds': 'Fonduri insuficiente',
'cashout_inactivity': 'Încasare automată la inactivitate',
'time_running_out': 'Timpul se scurge! Joacă acum sau biletul va fi retras automat în 30 de secunde',
'there_was_error': 'A APĂRUT O EROARE, ÎNCERCAȚI DIN NOU SAU REÎNCĂRCAȚI',
'detailed_game_rules': 'Reguli detaliate ale jocului',
'general_rules': 'REGULI GENERALE',
'general_rules_p1': '• Multiplicatorul începe de la 1 și crește până la ',
'general_rules_p2': '• Câștigurile sunt calculate prin înmulțirea mizei cu multiplicatorul afișat la fiecare pas.',
'general_rules_p3': '• Dacă se atinge plata maximă, jocul va încasa automat suma maximă.',
'progressive_jackpot': 'JACKPOT PROGRESIV',
'progressive_jackpot_ss': 'Banda jackpotului și câștigul posibil',
'progressive_jackpot_p1': '% din fiecare miză este dedicat fondului de jackpot progresiv.',
'progressive_jackpot_p2': 'Jackpotul este acordat folosind mecanismul „Mystery” sau „must-hit-by”. Valoarea fiecărui jackpot „must-hit-by” este determinată imediat după câștigarea precedentului, de un generator de numere aleatorii și stocată criptat în baza de date.',
'progressive_jackpot_p3': 'Odată ce valoarea „must-hit-by” este atinsă, primul jucător care pariază ulterior are șansa de a câștiga jackpotul. Un simbol al jackpotului va apărea pe o bandă aleatorie.',
'progressive_jackpot_p4': 'NOTĂ: Runda bonus nu contribuie la fondul jackpotului. În timpul rundei bonus, jackpotul nu poate fi câștigat.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Pătrat roșu, locația coliziunii sigure',
'showdown_p1': 'După ce jucătorul încasează, un pătrat roșu va fi afișat în locul unde s-ar fi produs coliziunea.',
'return_to_player': 'RETUR CĂTRE JUCĂTOR',
'return_to_player_p1': 'Returul teoretic total către jucător (RTP) este ',
'return_to_player_p2': 'Procentele RTP sunt monitorizate și verificate continuu de terți independenți.',
'disconnection_policy': 'POLITICA DE DECONEXIUNE',
'disconnection_policy_p1': 'Dacă conexiunea este pierdută după plasarea pariului, acesta nu va fi anulat imediat. Dacă inactivitatea jucătorului ajunge la ',
'disconnection_policy_p2': 'pariului va fi încasat automat, iar creditele vor fi aplicate contului jucătorului.',
'network_latency': 'LATENȚĂ DE REȚEA',
'network_latency_p1': 'Latența rețelei este o parte inevitabilă a conectivității la Internet. Toate pariurile și încasările sunt considerate valide doar când ajung pe serverul nostru.',
'sound': 'SUNET',
'sound_p1': 'Jocul este conceput cu muzică de fundal și efecte sonore. Acestea pot fi dezactivate din meniul jocului.',
'error_handling': 'GESTIONAREA ERORILOR',
'error_handling_p1': 'În cazul unei erori, echipa de suport va încerca să rezolve problema cât mai rapid. Dacă problema ține de joc, toate pariurile vor fi anulate.',
'max_payout': 'Plata maximă este ',
'max_bet_is': 'Pariul maxim este ',
'min_bet_is': 'Pariul minim este ',
'per_bet': 'per pariu.',
'malfunction_voids': 'Defecțiunea anulează toate plățile și jocurile.',
'attention_jackpot': 'Atenție, Jackpot pe banda ',
'lane': 'bandă',
'congratulations': 'felicitări',
'you_won': 'ai câștigat',
'balance': 'sold',
'time': 'timp',
'jackpot': 'jackpot',
'escaped': 'EVADAT',
'max_win': 'CÂȘTIG MAXIM',
'check_internet': 'Vă rugăm să verificați conexiunea la internet',
'websocket_disconected': 'Websocket deconectat',
'websocket_connection_error': 'Eroare de conexiune Websocket!',
'session_expired': 'Sesiunea a expirat, vă rugăm să reîncărcați',
'remaining_bets': 'Pariuri rămase',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY ȘI AUTO CASHOUT',
'autoplay_and_autocashout_ss': 'Selecție între manual și automat',
'autoplay_and_autocashout_p1': 'Jucătorul poate activa modul autoplay, unde pariurile sunt plasate automat.',
'autoplay_and_autocashout_p2': 'Poate fi selectat un multiplicator de auto cashout.',
'autoplay_and_autocashout_p3': 'Numărul maxim de runde autoplay este ',
'autoplay_button_label': 'Pentru a începe, alege o bandă.',
'min_bet_amount_is': 'Valoarea minimă a pariului este',
'bonus_rounds': 'runde bonus',
'bonus_rounds_ss': 'Runde bonus cu perioadă de valabilitate',
'bonus_rounds_p1': 'Jucătorul poate primi runde bonus ca parte a unei promoții.',
'bonus_rounds_p2': 'După acordare, jucătorul poate alege când să înceapă runda bonus.',
'bonus_rounds_p3': 'Rundele bonus pot avea limită de timp.',
'bonus_rounds_p4': 'Inactivitatea poate duce la anularea rundelor bonus.',
'valid_until': 'valabil până la',
'bonus': 'bonus',
'rounds': 'runde',
'win_eur': 'câștig EUR',
'complete_your_bet': 'Vă rugăm să finalizați pariul mai întâi',
'complete_auto_play': 'Vă rugăm să finalizați autoplay mai întâi',
'yes': 'da',
'no': 'nu',
'play_bonus_rounds': 'Jucați runde bonus?',
'bet_history': 'Istoric pariuri',
'jackpot_history': 'Istoric jackpot',
'ticket_id': 'ID bilet',
'created': 'timp creare',
'currency': 'monedă',
'bet': 'pariu',
'bet_eur': 'pariu EUR',
'lanes': 'benzi',
'cars': 'mașini',
'multiplier': 'multiplicator',
'win': 'câștig',
'no_betting_history': 'Nu există istoric de pariuri.',
'no_jackpot_history': 'Nu există istoric de jackpot.',
'date': 'dată',
'user': 'utilizator',
'bet_already_active': 'Pariu deja activ',
'please_play_the_game_in_portait_mode': 'Vă rugăm să jucați în modul portret.',
'bonus_history': 'Istoric bonus',
'bonus_type': 'Tip bonus',
'no_bonus_history': 'Nu există istoric de bonus.',
'game_menu': 'Meniu joc',
'game_menu_ss': 'De la stânga: Acasă, Istoric pariuri, Reguli joc, Scurtături tastatură, Setări sunet și muzică',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'REGULILE JOCULUI',
'game_rules_p1': 'Bine ați venit la Plinko – Unde Norocul Guvernează!',
'game_rules_p2': 'Pregătește-te pentru un joc captivant de noroc, simplu și captivant! Plinko constă în lăsarea unei bile să cadă pe o piramidă plină de pioneze și să urmărești cum sare, se învârte și coboară până într-un buzunar premiat din partea de jos.',
'game_rules_p3': 'Alege între 8 și 16 rânduri de pioneze, apoi așază-te și bucură-te de haos în timp ce bila zigzaguează pe tablă, ghidată doar de gravitație și noroc.',
'game_rules_p4': 'Va ateriza într-un buzunar cu plată mică… sau va câștiga marele premiu? Există doar un mod de a afla — lasă bila să cadă și lasă emoția să înceapă!',
'general': 'GENERAL',
'general_p1': 'Lasă să cadă bila Plinko și speră că va ajunge într-unul dintre buzunarele cu plăți mari din partea de jos. Parcursul este imprevizibil — fiecare săritură poate schimba norocul tău.',
'general_p2': 'Cu cât joci mai multe rânduri, cu atât acțiunea devine mai intensă!',
'general_p3': 'Așa că înaintează — ai încredere în norocul tău, apasă DROP și urmărește câștigul mare prin pionezele Plinko!',
'betting': 'PARIURI',
'betting_p1': 'Alegeți suma pariului. Butoanele “1/2”, “2x”, “Max” pot fi folosite pentru a gestiona mărimea pariului. Suma pariului poate fi introdusă și manual.',
'betting_p2': 'Alegeți Nivelul de Risc: Scăzut, Mediu sau Ridicat. Nivelul de risc mai scăzut oferă rezultate mai consistente (volatilitate scăzută), în timp ce unul mai ridicat oferă mai multă variabilitate (volatilitate ridicată).',
'betting_p3': 'Alegeți numărul de linii din joc: de la 8 la 16. Selectați prin câte rânduri de pini va cădea bila. Mai multe rânduri = mai multă imprevizibilitate.',
'betting_p4': 'Alegeți Modul de Pariere: Manual sau Automat.',
'betting_p5': 'Pentru a începe runda jocului, apăsați butonul DROP BALL. În timpul rundei, toate butoanele de pariere devin inactive, cu excepția DROP BALL și a sumei pariului.',
'betting_p6': 'O minge Plinko reprezintă o rundă. În timpul rundei, o altă rundă cu aceleași setări poate fi începută folosind butonul DROP BALL. Este posibil să schimbați suma pariului în timp ce există bile “active” pe tabel, dar nu și dificultatea jocului.',
'betting_p7': 'La sfârșitul rundei, bila ajunge în buzunar. Fiecare buzunar afișează multiplicatorul de plată.',
'betting_p8': 'Calculul câștigului se face conform multiplicatorului unde bila a aterizat. Rezultatul este adăugat la sold.',
'game_menu_p1': 'Multiplicatorii celor mai recente pariuri sunt afișați în partea de jos a ferestrei jocului.',
'game_menu_p2': 'Prin butonul “Bet history”, jucătorul poate vizualiza ultimele pariuri în detaliu.',
'game_menu_p3': 'Pentru o istorie mai extinsă a jocului (ex: perioade mai lungi), jucătorul poate avea nevoie să acceseze istoricul său direct în platforma de joc.',
'game_menu_p4': 'Prin meniul jocului, jucătorii pot controla opțiunile de sunet, scurtăturile de tastatură și pot deschide istoricul pariurilor și regulile jocului.',
'game_menu_p5': 'Jocul este conceput cu muzică de fundal frumoasă și efecte sonore. Muzica și/sau efectele sonore pot fi dezactivate prin pictogramele din meniul jocului.',
'game_menu_p6': 'Istoricul jocului va afișa o fereastră cu pariurile anterioare și istoricul bonusurilor.',
'autoplay': 'Mod Automat (Autoplay)',
'autoplay_p1': 'Apăsând Auto, puteți lăsa bilele să cadă automat fără a fi nevoie să faceți clic de fiecare dată.',
'autoplay_p2': 'Alegeți suma pe care doriți să o pariați pentru fiecare bilă.',
'autoplay_p3': 'Selectați de câte ori (runduri) doriți să cadă bila — maximum 100 de runduri.',
'autoplay_p4': 'Apăsați butonul START pentru a începe și butonul se va schimba în STOP.',
'autoplay_p5': 'Modul automat se va opri când se va finaliza numărul de căderi selectat, când rămâneți fără fonduri sau apăsați butonul STOP.',
'autoplay_p6': 'Fiecare cădere folosește aceeași sumă de pariu pe care ați selectat-o înainte de a porni modul automat.',
'turbo_mode': 'Mod Turbo',
'turbo_mode_p1': 'Turbo Drop vă permite să lăsați bilele să cadă foarte rapid ținând apăsat butonul DROP.',
'turbo_mode_p2': 'Bilele vor continua să cadă până eliberați butonul sau rămâneți fără sold.',
'turbo_mode_p3': 'Bilele vor continua să cadă până eliberați butonul sau rămâneți fără sold.',
'turbo_balance': 'Sold Turbo',
'turbo_balance_p1': 'Înainte de a porni Turbo Drop, alegeți câtă sumă să rezervați — aceasta devine Soldul Turbo.',
'turbo_balance_p2': 'Când Turbo Drop este activ, jocul folosește doar Soldul Turbo pentru pariuri și câștiguri.',
'turbo_balance_p3': 'Când opriți Turbo Drop, orice Sold Turbo rămas se întoarce la soldul principal.',
'turbo_balance_p4': 'Puteți ieși din Turbo Drop în orice moment — dar modul se va încheia complet doar după ce toate bilele au terminat căderea și au ajuns în buzunarele cu multiplicatori.',
'free_bets': 'RONDE BONUS',
'free_bets_p1': 'Rondele bonus sunt acordate de operator.',
'fairness': 'Corectitudine',
'fairness_p1': 'Fiecare cădere este determinată de un generator aleatoriu dovedit corect (RNG).',
'fairness_p2': 'Rezultatul nu poate fi prezis sau manipulat după ce bila cade.',
'disconection_and_error': 'Politica de deconectare și gestionarea erorilor',
'disconection_and_error_p1': 'Dacă conexiunea se pierde după plasarea unui pariu, pariul nu va fi anulat. Dacă jocul necesită o acțiune din partea jucătorului, rezultatul va fi calculat presupunând că jucătorul a ales o acțiune fără risc fără a crește pariul inițial.',
'disconection_and_error_p2': 'În caz de eroare, echipa noastră de suport va încerca să rezolve problema cât mai rapid posibil și să continue jocul normal. În caz de problemă cu jocul în sine, toate pariurile vor fi anulate și sumele returnate jucătorilor.',
'other': 'Altele',
'other_p1': 'În caz de defecțiune a hardware-ului/software-ului jocului, toate pariurile și plățile afectate vor fi anulate și toate pariurile afectate vor fi rambursate.',
'other_p2': 'Regulile jocului sunt publicate în limba engleză. Traducerile în alte limbi sunt oferite ca un serviciu de bună credință. În caz de ambiguitate între versiunea engleză și traducere, versiunea engleză prevalează.',
'rows': 'Rânduri',
'lvl': 'Nivel',
'low': 'Scăzut',
'high': 'Ridicat',
'ok': 'OK',
'exit_turbo_mode': 'Doriți să ieșiți din modul Turbo?',
"end": "Sfârșit",
"turbo_mode_settings": "Setări mod Turbo",
"stop": "OPREȘTE",
'invalid_bet_amount': 'Sumă pariu nevalidă',
'cashout_success': 'Încasare realizată cu succes',
'stop_auto_play_first': 'Vă rugăm să opriți mai întâi autoplay.',
'turbo_only_when_no_balls': 'Modul Turbo poate fi pornit doar când nu există bile pe masă.',
'type': 'Tip pariu',
'wait_balls_to_finish': 'Așteptați ca toate bilele să se termine.',
'bet_too_large_top_up_turbo_balance': 'Pariu prea mare – reîncărcați Soldul Turbo!',
};
langArr.ru = {
'loading': 'Загрузка',
'hotkeys': 'Горячие клавиши',
'hotkeys_enabled': 'Горячие клавиши включены',
'enable_hotkeys_checkbox': 'Включите горячие клавиши, показанные ниже, установив этот флажок.',
'drop_ball': 'Drop Ball',
'double_bet': 'Удвоить сумму ставки',
'halve_bet': 'Уменьшить ставку вдвое',
'min_bet': 'Минимальная ставка',
'max': 'Макс',
'easy': 'Легко',
'medium': 'Средне',
'hard': 'Трудно',
'daredevil': 'Смельчак',
'max_profit': 'Максимальная прибыль',
'manual': 'Ручной',
'auto': 'Авто',
'bet_amount': 'Сумма ставки',
'difficulty': 'Сложность',
'payout_on_win': 'Выплата при выигрыше',
'number_of_bets': 'Количество ставок',
'on_win': 'При выигрыше',
'on_loss': 'При проигрыше',
'stop_on_profit': 'Остановить при прибыли',
'stop_on_loss': 'Остановить при проигрыше',
'reset': 'Сброс',
'increase_by': 'Увеличить на',
'cashout': 'ВЫВОД',
'start_game': 'СТАВКА',
'start_auto_game': 'СТАРТ',
'difficulity_info': 'Информация о сложности',
'chance_collision': 'Шанс столкновения в игре',
'evry_25_lane': 'на каждые 25 линий',
'insufficiend_funds': 'Недостаточно средств',
'cashout_inactivity': 'Авто-вывод при бездействии',
'time_running_out': 'Время на исходе! Играйте сейчас или ваш билет будет автоматически отозван через 30 секунд',
'there_was_error': 'ПРОИЗОШЛА ОШИБКА, ПОПРОБУЙТЕ ЕЩЁ РАЗ ИЛИ ПЕРЕЗАГРУЗИТЕ',
'detailed_game_rules': 'Подробные правила игры',
'general_rules': 'ОБЩИЕ ПРАВИЛА',
'general_rules_p1': '• Множитель начинается с 1 и увеличивается до ',
'general_rules_p2': '• Выигрыш рассчитывается путем умножения ставки на множитель, отображаемый на каждом этапе.',
'general_rules_p3': '• Если достигнут максимальный коэффициент выплаты, игра автоматически завершится с этим значением.',
'progressive_jackpot': 'ПРОГРЕССИВНЫЙ ДЖЕКПОТ',
'progressive_jackpot_ss': 'Полоса джекпота и возможный выигрыш',
'progressive_jackpot_p1': '% от каждой ставки направляется в фонд прогрессивного джекпота.',
'progressive_jackpot_p2': 'Джекпот разыгрывается с использованием механики "Мистерия" или "Должен выпасть до". Значение каждого "Должен выпасть до" джекпота определяется сразу после выигрыша предыдущего джекпота с помощью генератора случайных чисел и сохраняется как зашифрованное значение в удаленной базе данных. Значение зашифровано и скрыто, и никто не знает его заранее.',
'progressive_jackpot_p3': 'Когда достигнуто значение "Должен выпасть до", первый игрок, сделавший ставку после этого, получит шанс выиграть джекпот. Символ джекпота появится на случайной дорожке, и игрок выиграет джекпот, если достигнет этой дорожки. Если игрок не достигнет дорожки с символом джекпота из-за вывода средств или проигрыша, следующий случайный игрок, сделавший ставку, увидит появление символа джекпота и получит шанс на выигрыш. Этот процесс повторяется до тех пор, пока джекпот не будет выигран. Только один билет/игрок может выиграть джекпот.',
'progressive_jackpot_p4': 'ПРИМЕЧАНИЕ: Бонусный раунд не участвует в формировании джекпот-фонда. Во время бонусного раунда джекпот не может быть выигран.',
'showdown': 'РАЗВЯЗКА',
'showdown_ss': 'Красный квадрат – место неизбежного столкновения',
'showdown_p1': 'После вывода средств у игрока появится красный квадрат в том месте, где произошло бы столкновение, если бы он продолжил движение по дорожкам.',
'return_to_player': 'ВОЗВРАТ ИГРОКУ',
'return_to_player_p1': 'Общий теоретический возврат игроку (RTP) составляет ',
'return_to_player_p2': 'Процент RTP непрерывно контролируется и проверяется независимыми третьими сторонами.',
'disconnection_policy': 'ПОЛИТИКА ПРИ ОБРЫВЕ СОЕДИНЕНИЯ',
'disconnection_policy_p1': 'Если соединение теряется после размещения ставки, ставка не отменяется сразу. Если бездействие игрока достигает ',
'disconnection_policy_p2': 'ставка будет автоматически выведена, и средства будут зачислены на счет игрока.',
'network_latency': 'ЗАДЕРЖКА СЕТИ',
'network_latency_p1': 'Задержка сети – это неизбежная часть интернет-соединения. Мы считаем все ставки и выводы действительными только в момент их поступления на наш сервер, независимо от продолжительности сетевой задержки.',
'sound': 'ЗВУК',
'sound_p1': 'Игра разработана с учетом красивой фоновой музыки и звуковых эффектов. Если вы хотите отключить музыку и/или звуковые эффекты, вы можете сделать это через меню игры.',
'error_handling': 'ОБРАБОТКА ОШИБОК',
'error_handling_p1': 'В случае ошибки наша служба поддержки постарается решить проблему как можно скорее и возобновить нормальную работу игры. В случае неисправности самой игры все ставки будут отменены, а суммы ставок возвращены игрокам.',
'max_payout': 'Максимальная выплата составляет ',
'max_bet_is': 'Максимальная ставка составляет ',
'min_bet_is': 'Минимальная ставка составляет ',
'per_bet': 'за ставку.',
'malfunction_voids': 'Сбой аннулирует все выплаты и игры.',
'attention_jackpot': 'Внимание, Джекпот на дорожке ',
'lane': 'дорожка',
'congratulations': 'поздравляем',
'you_won': 'вы выиграли',
'balance': 'баланс',
'time': 'время',
'jackpot': 'джекпот',
'escaped': 'СПАСЕНИЕ',
'max_win': 'МАКСИМАЛЬНЫЙ ВЫИГРЫШ',
'check_internet': 'Пожалуйста, проверьте ваше интернет-соединение',
'websocket_disconected': 'Websocket отключен',
'websocket_connection_error': 'Ошибка соединения с Websocket!',
'session_expired': 'Сессия истекла, пожалуйста, перезагрузите страницу',
'remaining_bets': 'Оставшиеся ставки',
'stop_autoplay': 'СТОП',
'autoplay_and_autocashout': 'АВТОИГРА И АВТОВЫВОД',
'autoplay_and_autocashout_ss': 'Выбор между ручной игрой и автоигрой',
'autoplay_and_autocashout_p1': 'Игрок может активировать опцию автоигры, при которой ставка автоматически размещается в каждом новом раунде, используя сумму ставки из предыдущего раунда.',
'autoplay_and_autocashout_p2': 'Автоматический множитель вывода можно выбрать на игровом экране. Если он установлен, игра автоматически завершится, если игрок не столкнется до достижения выбранного множителя.',
'autoplay_and_autocashout_p3': 'Максимальное количество раундов автоигры составляет ',
'autoplay_button_label': 'Чтобы начать, выберите дорожку.',
'min_bet_amount_is': 'Минимальная сумма ставки составляет',
'bonus_rounds': 'бонусные раунды',
'bonus_rounds_ss': 'Бонусные раунды с периодом действия',
'bonus_rounds_p1': 'Игрок может получить бонусный раунд (например, бесплатную ставку) в рамках акции казино. На экране появится всплывающее сообщение, информирующее игрока о начисленных бонусных раундах, количестве ставок, сумме на ставку и, возможно, сроке действия.',
'bonus_rounds_p2': 'После начисления бонусного раунда игрок может выбрать, когда его использовать. Как только бонусный раунд активирован, автоматически размещается ставка с указанной суммой, и игрок сам решает, когда вывести выигрыш.',
'bonus_rounds_p3': 'Бонусные раунды могут иметь ограниченный срок действия, после которого они аннулируются и становятся недоступными. Если срок действия установлен, он отображается под бонусным раундом.',
'bonus_rounds_p4': 'Если игрок бездействует, активный бонусный раунд может быть отменен. В этом случае количество бонусных раундов уменьшается, а баланс игрока остается неизменным.',
'valid_until': 'срок до',
'bonus': 'бонус',
'rounds': 'раунды',
'win_eur': 'выигрыш в EUR',
'complete_your_bet': 'Пожалуйста, завершите свою ставку',
'complete_auto_play': 'Пожалуйста, завершите свою автоигру',
'yes': 'да',
'no': 'нет',
'play_bonus_rounds': 'Играть в бонусные раунды?',
'bet_history': 'История ставок',
'jackpot_history': 'История джекпотов',
'ticket_id': 'ID билета',
'created': 'время создания',
'currency': 'валюта',
'bet': 'ставка',
'bet_eur': 'ставка в EUR',
'lanes': 'дорожки',
'cars': 'машины',
'multiplier': 'множитель',
'win': 'выигрыш',
'no_betting_history': 'История ставок не найдена. Сделайте ставку, и она появится здесь.',
'no_jackpot_history': 'История джекпотов отсутствует.',
'date': 'дата',
'user': 'пользователь',
'bet_already_active': 'Ставка уже активна',
'please_play_the_game_in_portait_mode': 'Пожалуйста, играйте в портретном режиме.',
'bonus_history': 'История бонусов',
'bonus_type': 'Тип бонуса',
'no_bonus_history': 'История бонусов отсутствует.',
'game_menu': 'Игровое меню',
'game_menu_ss': 'Слева направо: Главная, История ставок, Правила игры, Горячие клавиши, Настройки звуковых эффектов, Музыка',
// 'game_menu_p1': 'Через игровое меню игроки могут управлять настройками звука, горячими клавишами, а также открывать историю игры и правила.',
// 'game_menu_p2': 'История игры покажет окно с предыдущими ставками и историей бонусов.',
'game_rules': 'ПРАВИЛА ИГРЫ',
'game_rules_p1': 'Добро пожаловать в Плинко – там, где правит удача!',
'game_rules_p2': 'Приготовьтесь к захватывающей игре на удачу, простой и увлекательной! Плинко — это игра, в которой вы отпускаете шарик на пирамиду с штырьками и наблюдаете, как он отскакивает, крутится и катится вниз в призовой карман внизу.',
'game_rules_p3': 'Выберите от 8 до 16 рядов штырьков, затем сядьте и наслаждайтесь хаосом, пока шарик зигзагами движется по доске, ведомый лишь гравитацией и удачей.',
'game_rules_p4': 'Упадет ли он в карман с небольшой выплатой… или выиграет большой приз? Есть только один способ узнать — отпустите шарик и позвольте азарту начаться!',
'general': 'ОБЩЕЕ',
'general_p1': 'Отпустите шарик Plinko и надеетесь, что он попадет в один из карманов с высокими выплатами внизу. Маршрут непредсказуем — каждый отскок может изменить вашу удачу.',
'general_p2': 'Чем больше рядов вы играете, тем более интенсивным становится игровой процесс!',
'general_p3': 'Так что вперед — доверьтесь своей удаче, нажмите DROP и гонитесь за большим выигрышем через штырьки Плинко!',
'betting': 'СТАВКИ',
'betting_p1': 'Выберите сумму ставки. Кнопки “1/2”, “2x”, “Max” можно использовать для управления размером ставки. Сумму ставки также можно ввести вручную.',
'betting_p2': 'Выберите уровень риска: Низкий, Средний или Высокий. Более низкий уровень риска дает более стабильные результаты (низкая волатильность), а более высокий — большую вариативность (высокая волатильность).',
'betting_p3': 'Выберите количество линий в игре: от 8 до 16. Выберите, через сколько рядов штырей пройдет мяч. Больше рядов = больше непредсказуемости.',
'betting_p4': 'Выберите режим ставки: Ручной или Авто.',
'betting_p5': 'Чтобы начать раунд игры, нажмите кнопку DROP BALL. Во время раунда все кнопки ставок неактивны, кроме DROP BALL и суммы ставки.',
'betting_p6': 'Один шарик Plinko представляет один раунд. Во время раунда можно начать новый раунд с теми же настройками, используя кнопку DROP BALL. Можно изменить сумму ставки, пока на столе есть “активные” шары, но не сложность игры.',
'betting_p7': 'В конце раунда мяч попадает в карман. В каждом кармане отображается множитель выплаты.',
'betting_p8': 'Вычисление выигрыша происходит согласно множителю, на котором приземлился мяч. Результат добавляется к балансу.',
'game_menu_p1': 'Последние множители ставок отображаются в нижней части игрового окна.',
'game_menu_p2': 'С помощью кнопки “Bet history” игрок может просмотреть свои последние ставки более подробно.',
'game_menu_p3': 'Для более продолжительной истории игры (например, за более длинные периоды) игроку может понадобиться доступ к истории игрока внутри самой игровой платформы.',
'game_menu_p4': 'Через меню игры игроки могут управлять звуковыми настройками, горячими клавишами, а также открывать историю ставок и правила игры.',
'game_menu_p5': 'Игра разработана с красивой фоновой музыкой и звуковыми эффектами. Музыку и/или звуковые эффекты можно отключить через иконки меню игры.',
'game_menu_p6': 'История игры покажет окно с предыдущими ставками и историей бонусов.',
'autoplay': 'Авто режим (Autoplay)',
'autoplay_p1': 'Нажав Auto, вы можете автоматически сбрасывать несколько шаров без необходимости каждый раз нажимать.',
'autoplay_p2': 'Выберите сумму ставки на один шар.',
'autoplay_p3': 'Выберите, сколько раз (раундов) вы хотите сбросить шар — максимум 100 раундов.',
'autoplay_p4': 'Нажмите кнопку START, чтобы начать, кнопка изменится на STOP.',
'autoplay_p5': 'Авто режим остановится, когда выбранное количество сбросов будет выполнено, закончатся средства или вы нажмете STOP.',
'autoplay_p6': 'Каждый сброс использует ту же сумму ставки, которую вы выбрали до начала Авто режима.',
'turbo_mode': 'Турбо режим',
'turbo_mode_p1': 'Turbo Drop позволяет сбрасывать шары очень быстро, удерживая кнопку DROP.',
'turbo_mode_p2': 'Шары будут падать, пока вы не отпустите кнопку или не закончится баланс.',
'turbo_mode_p3': 'Шары будут падать, пока вы не отпустите кнопку или не закончится баланс.',
'turbo_balance': 'Турбо баланс',
'turbo_balance_p1': 'Перед запуском Turbo Drop выберите, сколько денег отложить — это станет вашим Турбо балансом.',
'turbo_balance_p2': 'Когда Turbo Drop активен, игра использует только ваш Турбо баланс для ставок и выигрышей.',
'turbo_balance_p3': 'Когда вы останавливаете Turbo Drop, оставшийся Турбо баланс возвращается на основной баланс.',
'turbo_balance_p4': 'Вы можете выйти из Turbo Drop в любое время — но режим полностью завершится только после того, как все шары закончат падать и попадут в карманы с множителями.',
'free_bets': 'БОНУСНЫЕ РАУНДЫ',
'free_bets_p1': 'Бонусные раунды предоставляются оператором.',
'fairness': 'Честность',
'fairness_p1': 'Каждое падение определяется доказуемо честным генератором случайных чисел (RNG).',
'fairness_p2': 'Результат нельзя предсказать или изменить после падения шарика.',
'disconection_and_error': 'Политика отключения и обработки ошибок',
'disconection_and_error_p1': 'Если после размещения ставки произойдет отключение, ставка не будет отменена. Если игра требует действий от игрока, результат рассчитывается, предполагая, что игрок выбрал безопасное действие без увеличения исходной ставки.',
'disconection_and_error_p2': 'В случае ошибки наша служба поддержки постарается решить проблему как можно скорее и продолжить игру. При проблемах с самой игрой все ставки будут отменены, а средства возвращены игрокам.',
'other': 'Прочее',
'other_p1': 'В случае сбоя оборудования или программного обеспечения игры все затронутые ставки и выплаты будут аннулированы, а средства возвращены.',
'other_p2': 'Правила игры опубликованы на английском языке. Переводы на другие языки предоставляются как услуга доброй воли. В случае расхождений между английской версией и переводом преимущественной является английская версия.',
'rows': 'Ряды',
'lvl': 'Уровень',
'low': 'Низкий',
'high': 'Высокий',
'ok': 'OK',
'exit_turbo_mode': 'Вы хотите выйти из режима Турбо?',
"end": "Конец",
"turbo_mode_settings": "Настройки режима Турбо",
"stop": "СТОП",
'invalid_bet_amount': 'Недопустимая сумма ставки',
'cashout_success': 'Вывод средств успешно выполнен',
'stop_auto_play_first': 'Пожалуйста, сначала остановите автоигру.',
'turbo_only_when_no_balls': 'Режим Турбо можно включить только при отсутствии шаров на столе.',
'type': 'Тип ставки',
'wait_balls_to_finish': 'Пожалуйста, дождитесь окончания всех шаров.',
'bet_too_large_top_up_turbo_balance': 'Ставка слишком велика – пополните Турбо баланс!',
};
langArr.sq = {
'loading': 'Duke u ngarkuar',
'hotkeys': 'Shkurtore tastiere',
'hotkeys_enabled': 'Shkurtoret e tastierës aktive',
'enable_hotkeys_checkbox': 'Aktivizoni shkurtoret e tastierës të shfaqura më poshtë duke shënuar këtë kuti.',
'drop_ball': 'Lësho topin',
'double_bet': 'Dyfisho bastin',
'halve_bet': 'Përgjysmo bastin',
'min_bet': 'Bast minimal',
'max': 'Max',
'easy': 'Lehtë',
'medium': 'Mesatar',
'hard': 'Vështirë',
'daredevil': 'Guximtar',
'max_profit': 'Fitim maksimal',
'manual': 'Manual',
'auto': 'Automatik',
'bet_amount': 'Shuma e bastit',
'difficulty': 'Vështirësi',
'payout_on_win': 'Pagesë në fitore',
'number_of_bets': 'Numri i basteve',
'on_win': 'Në fitore',
'on_loss': 'Në humbje',
'stop_on_profit': 'Ndalo në fitim',
'stop_on_loss': 'Ndalo në humbje',
'reset': 'Rivendos',
'increase_by': 'Rrit me',
'cashout': 'NXJERRJE',
'start_game': 'BASTO',
'start_auto_game': 'FILLIM',
'difficulity_info': 'Informacion mbi vështirësinë',
'chance_collision': 'Shansi i përplasjes për lojë',
'evry_25_lane': 'për çdo 25 korsi',
'insufficiend_funds': 'Fonde të pamjaftueshme',
'cashout_inactivity': 'Nxjerrje automatike në mungesë aktiviteti',
'time_running_out': 'Koha po mbaron! Luaj tani ose bileta juaj do të tërhiqet automatikisht pas 30 sekondash',
'there_was_error': 'KA NDODHUR NJË GABIM, JU LUTEM PROVONI PËRSËRI OSE RINGARKONI',
'detailed_game_rules': 'Rregulla të detajuara të lojës',
'general_rules': 'RREGULLA TË PËRGJITHSHME',
'general_rules_p1': '• Shumëzuesi fillon nga 1 dhe rritet deri në ',
'general_rules_p2': '• Fitimet llogariten duke shumëzuar shumën e bastit me shumëzuesin e shfaqur në çdo hap.',
'general_rules_p3': '• Nëse arrihet pagesa maksimale, loja do të bëjë automatikisht nxjerrjen në shumën maksimale.',
'progressive_jackpot': 'JACKPOT PROGRESIV',
'progressive_jackpot_ss': 'Korsia e jackpot-it dhe fitimi i mundshëm',
'progressive_jackpot_p1': '% e çdo basti i dedikohet fondit progresiv të jackpot-it.',
'progressive_jackpot_p2': 'Jackpot-i jepet duke përdorur mekanizmin "Mystery" ose "must-hit-by". Vlera e çdo jackpot-i "must-hit-by" përcaktohet menjëherë pas fitimit të mëparshëm nga një gjenerator numrash të rastësishëm dhe ruhet e enkriptuar në bazën e të dhënave.',
'progressive_jackpot_p3': 'Sapo të arrihet vlera "must-hit-by", lojtari i parë që vendos bast më pas ka mundësinë të fitojë jackpot-in. Një simbol jackpot-i do të shfaqet në një korsi të rastësishme.',
'progressive_jackpot_p4': 'SHËNIM: Raundi bonus nuk kontribuon në fondin e jackpot-it. Gjatë raundit bonus, jackpot-i nuk mund të fitohet.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Katror i kuq, vendndodhja e përplasjes së sigurt',
'showdown_p1': 'Pasi lojtari bën nxjerrjen, do të shfaqet një katror i kuq në vendin ku do të ndodhte përplasja.',
'return_to_player': 'KTHIMI TE LOJTARI',
'return_to_player_p1': 'Kthimi teorik total te lojtari (RTP) është ',
'return_to_player_p2': 'Përqindjet RTP monitorohen dhe verifikohen vazhdimisht nga palë të treta të pavarura.',
'disconnection_policy': 'POLITIKA E SHKËPUTJES',
'disconnection_policy_p1': 'Nëse lidhja humbet pasi vendoset basti, basti nuk do të anulohet menjëherë. Nëse mungesa e aktivitetit të lojtarit arrin ',
'disconnection_policy_p2': 'basti do të nxirret automatikisht dhe kreditë do të aplikohen në llogarinë e lojtarit.',
'network_latency': 'VONESË RRJETI',
'network_latency_p1': 'Vonesa e rrjetit është pjesë e pashmangshme e lidhjes në internet. Të gjitha bastet dhe nxjerrjet konsiderohen të vlefshme vetëm kur arrijnë në serverin tonë.',
'sound': 'ZËRI',
'sound_p1': 'Loja është projektuar me muzikë sfondi dhe efekte zanore. Nëse dëshironi t’i çaktivizoni, mund ta bëni këtë nga menuja e lojës.',
'error_handling': 'MENAXHIMI I GABIMEVE',
'error_handling_p1': 'Në rast gabimi, ekipi ynë i mbështetjes do të përpiqet ta zgjidhë sa më shpejt dhe të rifillojë lojën normale.',
'max_payout': 'Pagesa maksimale është ',
'max_bet_is': 'Basti maksimal është ',
'min_bet_is': 'Basti minimal është ',
'per_bet': 'për bast.',
'malfunction_voids': 'Defekti anulon të gjitha pagesat dhe lojërat.',
'attention_jackpot': 'Kujdes, Jackpot në korsinë ',
'lane': 'korsi',
'congratulations': 'urime',
'you_won': 'keni fituar',
'balance': 'bilanc',
'time': 'kohë',
'jackpot': 'jackpot',
'escaped': 'IKUR',
'max_win': 'FITIM MAKSIMAL',
'check_internet': 'Ju lutem kontrolloni lidhjen tuaj në internet',
'websocket_disconected': 'Websocket i shkëputur',
'websocket_connection_error': 'Gabim lidhjeje Websocket!',
'session_expired': 'Sesioni ka skaduar, ju lutem ringarkoni',
'remaining_bets': 'Baste të mbetura',
'stop_autoplay': 'NDALO',
'autoplay_and_autocashout': 'AUTOPLAY DHE AUTO NXJERRJE',
'autoplay_and_autocashout_ss': 'Zgjedhje midis manual dhe automatik',
'autoplay_and_autocashout_p1': 'Lojtari mund të aktivizojë opsionin autoplay ku bastet vendosen automatikisht.',
'autoplay_and_autocashout_p2': 'Mund të zgjidhet shumëzuesi i auto nxjerrjes.',
'autoplay_and_autocashout_p3': 'Numri maksimal i raundeve autoplay është ',
'autoplay_button_label': 'Për të filluar, zgjidhni një korsi.',
'min_bet_amount_is': 'Shuma minimale e bastit është',
'bonus_rounds': 'raunde bonus',
'bonus_rounds_ss': 'Raunde bonus me periudhë vlefshmërie',
'bonus_rounds_p1': 'Lojtari mund të fitojë raunde bonus si pjesë e një promocioni.',
'bonus_rounds_p2': 'Pasi jepen, lojtari mund të zgjedhë kur të fillojë raundin bonus.',
'bonus_rounds_p3': 'Raundet bonus mund të kenë kufizim kohor.',
'bonus_rounds_p4': 'Mungesa e aktivitetit mund të çojë në anulimin e raundeve bonus.',
'valid_until': 'i vlefshëm deri më',
'bonus': 'bonus',
'rounds': 'raunde',
'win_eur': 'fitim EUR',
'complete_your_bet': 'Ju lutem përfundoni bastin tuaj më parë',
'complete_auto_play': 'Ju lutem përfundoni autoplay më parë',
'yes': 'po',
'no': 'jo',
'play_bonus_rounds': 'Të luani raundet bonus?',
'bet_history': 'Historiku i basteve',
'jackpot_history': 'Historiku i jackpot-it',
'ticket_id': 'ID bilete',
'created': 'koha e krijimit',
'currency': 'monedhë',
'bet': 'bast',
'bet_eur': 'bast EUR',
'lanes': 'korsi',
'cars': 'makina',
'multiplier': 'shumëzues',
'win': 'fitim',
'no_betting_history': 'Nuk u gjet historik bastesh.',
'no_jackpot_history': 'Nuk ka historik jackpot-i.',
'date': 'datë',
'user': 'përdorues',
'bet_already_active': 'Basti tashmë aktiv',
'please_play_the_game_in_portait_mode': 'Ju lutem luani lojën në modalitet portret.',
'bonus_history': 'Historiku i bonusit',
'bonus_type': 'Lloji i bonusit',
'no_bonus_history': 'Nuk ka historik bonusi.',
'game_menu': 'Menuja e lojës',
'game_menu_ss': 'Nga e majta: Kryefaqja, Historiku i basteve, Rregullat e lojës, Shkurtore tastiere, Cilësimet e zërit dhe muzikës',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'RREGULLAT E LOJËS',
'game_rules_p1': 'Mirësevini në Plinko – Ku Lëviz Fati!',
'game_rules_p2': 'Përgatitu për një lojë emocionuese fatkeqe që është po aq e thjeshtë sa dhe e varur! Plinko është rreth hedhjes së një topi mbi një piramidë me gozhda dhe shikimit të tij duke u kërcyer, rrotulluar dhe duke u lëvizur deri në një çarje me shpërblime në fund.',
'game_rules_p3': 'Zgjidh midis 8 deri në 16 rreshta me gozhda, pastaj ulesh dhe shijon kaosin ndërsa topi kalon zigzage përmes bordit, i udhëhequr vetëm nga graviteti dhe fati.',
'game_rules_p4': 'A do të përfundojë në një çarje me pagesë të ulët… apo do të godasë fitimin e madh? Ka vetëm një mënyrë për ta zbuluar — hidhe topin dhe lejo emocionin të zhvillohet!',
'general': 'TË PËRGJITHSHME',
'general_p1': 'Hidhe topin Plinko dhe shpreso që ai të përfundojë në njërën nga çarjet me pagesë të lartë në fund. Rruga është e paparashikueshme — çdo kërcim mund të ndryshojë fatin tënd.',
'general_p2': 'Sa më shumë rreshta të luash, aq më intensive bëhet veprimi!',
'general_p3': 'Pra, vazhdo — beso në fatin tënd, shtyp DROP dhe ndjek fitimin e madh përmes gozhdave të Plinko!',
'betting': 'BASHTE',
'betting_p1': 'Zgjidhni shumën e bastit. Butonat “1/2”, “2x”, “Max” mund të përdoren për të menaxhuar madhësinë e bastit. Vlera e bastit mund të futet edhe manualisht.',
'betting_p2': 'Zgjidhni Nivelin e Rrezikut: i Ulët, Mesatar ose i Lartë. Një nivel më i ulët rreziku jep rezultate më të qëndrueshme (volatilitet i ulët), ndërsa një nivel më i lartë jep më shumë variacion (volatilitet i lartë).',
'betting_p3': 'Zgjidhni numrin e linjave në lojë: nga 8 deri në 16. Zgjidhni sa rreshta me gozhdë do të kalojë topi. Më shumë rreshta = më shumë paparashikueshmëri.',
'betting_p4': 'Zgjidhni Modalitetin e Bastit: Manual ose Automatik.',
'betting_p5': 'Për të filluar raundin e lojës, shtypni butonin DROP BALL. Gjatë raundit, të gjitha butonat e bastit bëhen joaktivë përveç DROP BALL dhe shumës së bastit.',
'betting_p6': 'Një top Plinko përfaqëson një raund. Gjatë raundit mund të fillohet një raund tjetër me të njëjtat cilësime duke përdorur butonin DROP BALL. Mund të ndryshohet shuma e bastit ndërsa ka topa “aktivë” në tabelë, por jo vështirësia e lojës.',
'betting_p7': 'Në fund të raundit, topi arrin në xhep. Në çdo xhep shfaqet shumëzuesi i fitimit.',
'betting_p8': 'Llogaritja e fitimit bëhet sipas shumëzuesit ku topi ka rënë. Rezultati shtohet në bilanc.',
'game_menu_p1': 'Shumëzuesit e fundit të basteve shfaqen në pjesën e poshtme të dritares së lojës.',
'game_menu_p2': 'Në butonin “Bet history” lojtari mund të shikojë bastet e fundit me më shumë detaje.',
'game_menu_p3': 'Për histori më të gjatë loje (p.sh. periudha më të gjata), lojtari mund të ketë nevojë të hyjë në historinë e tij brenda platformës së lojës.',
'game_menu_p4': 'Përmes menusë së lojës, lojtarët mund të kontrollojnë opsionet e zërit, shkurtoret e tastierës dhe të hapin historinë e basteve dhe rregullat e lojës.',
'game_menu_p5': 'Lojë është dizajnuar me muzikë të bukur sfondi dhe efekte zanore. Muzika dhe/ose efektet zanore mund të çaktivizohen përmes ikonave të menusë së lojës.',
'game_menu_p6': 'Historia e lojës do të tregojë një dritare me bastet e mëparshme dhe historinë e bonusit.',
'autoplay': 'Modalitet Automatik (Autoplay)',
'autoplay_p1': 'Duke klikuar Auto, mund të lëshoni automatikisht disa topa pa pasur nevojë të klikoni çdo herë.',
'autoplay_p2': 'Zgjidhni shumën që dëshironi të bastoni për çdo top.',
'autoplay_p3': 'Zgjidhni sa herë (rundë) dëshironi që topi të bjerë — maksimumi 100 raunde.',
'autoplay_p4': 'Shtypni butonin START për të filluar dhe butoni do të ndryshojë në STOP.',
'autoplay_p5': 'Modaliteti automatik do të ndalet kur të përfundojë numri i zgjedhur i lëshimeve, kur ju mbarojnë fondet ose kur të shtypni butonin STOP.',
'autoplay_p6': 'Çdo lëshim përdor të njëjtën shumë basti që keni zgjedhur para fillimit të Modalitetit Automatik.',
'turbo_mode': 'Modalitet Turbo',
'turbo_mode_p1': 'Turbo Drop ju lejon të lëshoni topa shumë shpejt duke mbajtur shtypur butonin DROP.',
'turbo_mode_p2': 'Topat do të vazhdojnë të bien deri sa të lironi butonin ose të mbarojë bilanci.',
'turbo_mode_p3': 'Topat do të vazhdojnë të bien deri sa të lironi butonin ose të mbarojë bilanci.',
'turbo_balance': 'Bilanci Turbo',
'turbo_balance_p1': 'Para se të filloni Turbo Drop, zgjidhni sa para të vendosni mënjanë — kjo bëhet Bilanci juaj Turbo.',
'turbo_balance_p2': 'Gjatë Turbo Drop aktiv, loja përdor vetëm Bilancin Turbo për baste dhe fitime.',
'turbo_balance_p3': 'Kur ndaloni Turbo Drop, çdo Bilanc Turbo i mbetur kthehet në bilancin kryesor.',
'turbo_balance_p4': 'Mund të dilni nga Turbo Drop në çdo kohë — por modaliteti do të përfundojë plotësisht vetëm pasi të gjitha topat të përfundojnë rënien dhe të arrijnë në xhepat me shumëzues.',
'free_bets': 'RAUNDË BONUS',
'free_bets_p1': 'Raundet bonus jepen nga operatori.',
'fairness': 'Drejtësi',
'fairness_p1': 'Çdo rënie përcaktohet nga një gjenerator i numrave të rastësishëm të provuar të drejtë (RNG).',
'fairness_p2': 'Rezultati nuk mund të parashikohet ose të ndikojë pasi topi të jetë lëshuar.',
'disconection_and_error': 'Politika e shkëputjes dhe trajtimi i gabimeve',
'disconection_and_error_p1': 'Nëse lidhja humbet pas vendosjes së një basti, basti nuk do të anulohet. Nëse loja kërkon veprim nga lojtari, rezultati llogaritet duke supozuar se lojtari ka zgjedhur një veprim pa rrezik pa rritur bastin fillestar.',
'disconection_and_error_p2': 'Në rast gabimi, ekipi ynë i mbështetjes do të përpiqet të zgjidhë çështjen sa më shpejt të jetë e mundur dhe të vazhdojë me lojën normale. Në rast problemi me lojën vetë, të gjitha bastet do të anulohen dhe shuma do t’u kthehet lojtarëve.',
'other': 'Të tjera',
'other_p1': 'Në rast defekti të harduerit ose softuerit të lojës, të gjitha bastet dhe pagesat e prekura anulohen dhe të gjitha bastet e prekura rimbursohen.',
'other_p2': 'Rregullat e lojës janë publikuar në anglisht. Përkthimet në gjuhë të tjera ofrohen si shërbim me mirëbesim. Në rast dyshimi mes versionit në anglisht dhe përkthimit, versioni në anglisht ka përparësi.',
'rows': 'Rreshta',
'lvl': 'Nivel',
'low': 'I ulët',
'high': 'I lartë',
'ok': 'OK',
'exit_turbo_mode': 'Dëshironi të dilni nga mënyra Turbo?',
"end": "Fundi",
"turbo_mode_settings": "Cilësimet e mënyrës Turbo",
"stop": "NDALO",
'invalid_bet_amount': 'Shumë e pavlefshme e bastit',
'cashout_success': 'Nxjerrja u krye me sukses',
'stop_auto_play_first': 'Ju lutem ndaloni autoplay më parë.',
'turbo_only_when_no_balls': 'Mënyra Turbo mund të aktivizohet vetëm kur nuk ka topa në tavolinë.',
'type': 'Lloji i bastit',
'wait_balls_to_finish': 'Ju lutem prisni që të gjithë topat të përfundojnë.',
'bet_too_large_top_up_turbo_balance': 'Basti është shumë i madh – mbushni bilancin Turbo!',
};
langArr.sv = {
'loading': 'Laddar',
'hotkeys': 'Kortkommandon',
'hotkeys_enabled': 'Kortkommandon aktiverade',
'enable_hotkeys_checkbox': 'Aktivera kortkommandona nedan genom att markera denna ruta.',
'drop_ball': 'Släpp bollen',
'double_bet': 'Dubbla insatsen',
'halve_bet': 'Halvera insatsen',
'min_bet': 'Minsta insats',
'max': 'Max',
'easy': 'Lätt',
'medium': 'Medel',
'hard': 'Svår',
'daredevil': 'Våghals',
'max_profit': 'Maximal vinst',
'manual': 'Manuell',
'auto': 'Automatisk',
'bet_amount': 'Insatsbelopp',
'difficulty': 'Svårighetsgrad',
'payout_on_win': 'Utbetalning vid vinst',
'number_of_bets': 'Antal insatser',
'on_win': 'Vid vinst',
'on_loss': 'Vid förlust',
'stop_on_profit': 'Stoppa vid vinst',
'stop_on_loss': 'Stoppa vid förlust',
'reset': 'Återställ',
'increase_by': 'Öka med',
'cashout': 'TA UT',
'start_game': 'SPELA',
'start_auto_game': 'STARTA',
'difficulity_info': 'Svårighetsinfo',
'chance_collision': 'Kollisionschans per spel',
'evry_25_lane': 'för varje 25 banor',
'insufficiend_funds': 'Otillräckliga medel',
'cashout_inactivity': 'Automatisk uttag vid inaktivitet',
'time_running_out': 'Tiden håller på att ta slut! Spela nu eller din biljett dras tillbaka automatiskt om 30 sek',
'there_was_error': 'ETT FEL HAR INTRÄFFAT, FÖRSÖK IGEN ELLER LADDA OM',
'detailed_game_rules': 'Detaljerade spelregler',
'general_rules': 'ALLMÄNNA REGLER',
'general_rules_p1': '• Multiplikatorn börjar på 1 och ökar till ',
'general_rules_p2': '• Vinster beräknas genom att multiplicera insatsen med multiplikatorn.',
'general_rules_p3': '• Om maximal utbetalning nås sker automatisk utbetalning.',
'progressive_jackpot': 'PROGRESSIV JACKPOT',
'progressive_jackpot_ss': 'Jackpotbana och möjlig vinst',
'progressive_jackpot_p1': '% av varje insats går till jackpotfonden.',
'progressive_jackpot_p2': 'Jackpoten delas ut via "Mystery" eller "must-hit-by"-mekanik.',
'progressive_jackpot_p3': 'När värdet nås får nästa spelare chans att vinna jackpoten.',
'progressive_jackpot_p4': 'OBS: Bonusrundor bidrar inte till jackpotfonden.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Röd ruta, säker kollisionsplats',
'showdown_p1': 'Efter uttag visas platsen där kollisionen skulle ha skett.',
'return_to_player': 'ÅTERBETALNING TILL SPELARE',
'return_to_player_p1': 'Total teoretisk RTP är ',
'return_to_player_p2': 'RTP övervakas av oberoende parter.',
'disconnection_policy': 'FRÅNKOPPLINGSPOLICY',
'disconnection_policy_p1': 'Om anslutningen bryts annulleras inte insatsen direkt.',
'disconnection_policy_p2': 'insatsen betalas ut automatiskt.',
'network_latency': 'NÄTVERKSFÖRDRÖJNING',
'network_latency_p1': 'Alla insatser är giltiga när de når servern.',
'sound': 'LJUD',
'sound_p1': 'Musik och ljudeffekter kan stängas av i menyn.',
'error_handling': 'FELHANTERING',
'error_handling_p1': 'Vid fel försöker supporten lösa problemet snabbt.',
'max_payout': 'Maximal utbetalning är ',
'max_bet_is': 'Maxinsats är ',
'min_bet_is': 'Mininsats är ',
'per_bet': 'per insats.',
'malfunction_voids': 'Tekniskt fel ogiltigförklarar alla spel.',
'attention_jackpot': 'Observera, Jackpot på bana ',
'lane': 'bana',
'congratulations': 'grattis',
'you_won': 'du vann',
'balance': 'saldo',
'time': 'tid',
'jackpot': 'jackpot',
'escaped': 'UNDKOM',
'max_win': 'MAXVINST',
'check_internet': 'Kontrollera din internetanslutning',
'websocket_disconected': 'Websocket frånkopplad',
'websocket_connection_error': 'Websocket-anslutningsfel!',
'session_expired': 'Sessionen har gått ut, ladda om',
'remaining_bets': 'Återstående insatser',
'stop_autoplay': 'STOPPA',
'autoplay_and_autocashout': 'AUTOSPEL OCH AUTO-UTTAG',
'autoplay_and_autocashout_ss': 'Val mellan manuell och auto',
'autoplay_and_autocashout_p1': 'Autospelet placerar automatiskt insatser.',
'autoplay_and_autocashout_p2': 'Automatisk uttagsmultiplikator kan väljas.',
'autoplay_and_autocashout_p3': 'Max antal autospelet är ',
'autoplay_button_label': 'Välj en bana för att börja.',
'min_bet_amount_is': 'Minsta insats är',
'bonus_rounds': 'bonusrundor',
'bonus_rounds_ss': 'Bonusrundor med giltighetstid',
'bonus_rounds_p1': 'Bonusrundor kan delas ut via kampanjer.',
'bonus_rounds_p2': 'Spelaren väljer när bonusrundan startar.',
'bonus_rounds_p3': 'Bonusrundor kan ha tidsgräns.',
'bonus_rounds_p4': 'Inaktivitet kan annullera bonusrundor.',
'valid_until': 'giltig till',
'bonus': 'bonus',
'rounds': 'rundor',
'win_eur': 'vinst EUR',
'complete_your_bet': 'Slutför din insats först',
'complete_auto_play': 'Slutför autospelet först',
'yes': 'ja',
'no': 'nej',
'play_bonus_rounds': 'Spela bonusrundor?',
'bet_history': 'Insatshistorik',
'jackpot_history': 'Jackpothistorik',
'ticket_id': 'Biljett-ID',
'created': 'skapad tid',
'currency': 'valuta',
'bet': 'insats',
'bet_eur': 'insats EUR',
'lanes': 'banor',
'cars': 'bilar',
'multiplier': 'multiplikator',
'win': 'vinst',
'no_betting_history': 'Ingen insatshistorik hittades.',
'no_jackpot_history': 'Ingen jackpothistorik.',
'date': 'datum',
'user': 'användare',
'bet_already_active': 'Insats redan aktiv',
'please_play_the_game_in_portait_mode': 'Spela spelet i porträttläge.',
'bonus_history': 'Bonushistorik',
'bonus_type': 'Bonustyp',
'no_bonus_history': 'Ingen bonushistorik.',
'game_menu': 'Spelmeny',
'game_menu_ss': 'Hem, Historik, Regler, Kortkommandon, Ljud & Musik',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'SPELREGLER',
'game_rules_p1': 'Välkommen till Plinko – Där Turen Bestämmer!',
'game_rules_p2': 'Gör dig redo för ett spännande chansspel som är lika enkelt som det är beroendeframkallande! Plinko går ut på att släppa en boll på en pyramid fylld med piggar och se hur den studsar, snurrar och rullar ner till en prisfylld ficka längst ner.',
'game_rules_p3': 'Välj mellan 8 till 16 rader med piggar, sedan kan du luta dig tillbaka och njuta av kaoset när bollen zigzagar genom brädet, styrd endast av gravitation och tur.',
'game_rules_p4': 'Kommer den landa i en lågbetalande ficka… eller ta storvinsten? Det finns bara ett sätt att ta reda på det — släpp bollen och låt spänningen börja!',
'general': 'ALLMÄNT',
'general_p1': 'Släpp Plinko-bollen och hoppas att den landar i en av de högbetalande fickorna längst ner. Vägen är oförutsägbar — varje studs kan förändra din lycka.',
'general_p2': 'Ju fler rader du spelar, desto mer intensiv blir actionen!',
'general_p3': 'Så kör på — lita på din tur, tryck på DROP och jaga storvinsten genom Plinko-piggarna!',
'betting': 'SPELINSATSER',
'betting_p1': 'Välj insatsbelopp. Knappen “1/2”, “2x”, “Max” kan användas för att hantera insatsens storlek. Insatsbeloppet kan även anges manuellt.',
'betting_p2': 'Välj Risknivå: Låg, Medel eller Hög. Låg risknivå ger mer konsekventa resultat (låg volatilitet) medan hög risknivå ger större variation (hög volatilitet).',
'betting_p3': 'Välj antal linjer i spelet: från 8 till 16. Välj hur många rader med pinnar bollen ska falla genom. Fler rader = mer oförutsägbarhet.',
'betting_p4': 'Välj Insatsläge: Manuellt eller Auto.',
'betting_p5': 'För att starta spelrundan tryck på knappen DROP BALL. Under rundan blir alla insatsknappar inaktiva förutom DROP BALL och insatsbeloppet.',
'betting_p6': 'En Plinko-boll representerar en runda. Under rundan kan en ny runda med samma inställningar startas med DROP BALL-knappen. Det är möjligt att ändra insatsbelopp medan det finns “aktiva” bollar på brädet, men inte spelets svårighet.',
'betting_p7': 'I slutet av rundan når bollen fickan. På varje ficka visas utbetalningsmultiplikatorn.',
'betting_p8': 'Vinsten beräknas enligt multiplikatorn där bollen landade. Resultatet läggs till saldot.',
'game_menu_p1': 'Senaste insatsmultiplikatorerna visas längst ner i spelrutan.',
'game_menu_p2': 'På knappen “Bet history” kan spelaren se sina senaste insatser i mer detalj.',
'game_menu_p3': 'För längre spelhistorik (t.ex. längre perioder) kan spelaren behöva gå in på spelarhistoriken inom spelplattformen.',
'game_menu_p4': 'Via spelmenyn kan spelare styra ljudinställningar, tangentbordsgenvägar och öppna insatshistorik samt spelregler.',
'game_menu_p5': 'Spelet är designat med vacker bakgrundsmusik och ljudeffekter. Musik och/eller ljudeffekter kan stängas av via spelmenyikonerna.',
'game_menu_p6': 'Spelhistorik visar ett fönster med tidigare insatser och bonushistorik.',
'autoplay': 'Automatiskt läge (Autoplay)',
'autoplay_p1': 'Klicka på Auto för att automatiskt släppa ett antal bollar utan att klicka varje gång.',
'autoplay_p2': 'Välj beloppet du vill satsa per boll.',
'autoplay_p3': 'Välj hur många gånger (rundor) du vill att bollen ska släppas — upp till 100 rundor max.',
'autoplay_p4': 'Tryck på START för att börja och knappen ändras till STOP.',
'autoplay_p5': 'Automatiskt läge stoppar när det valda antalet släpp är slutfört, du har slut på medel eller trycker på STOP.',
'autoplay_p6': 'Varje släpp använder samma insatsbelopp som du valde innan du startade Automatiskt läge.',
'turbo_mode': 'Turbo-läge',
'turbo_mode_p1': 'Turbo Drop låter dig släppa bollar mycket snabbt genom att hålla ner DROP-knappen.',
'turbo_mode_p2': 'Bollarna fortsätter att falla tills du släpper knappen eller tills saldot tar slut.',
'turbo_mode_p3': 'Bollarna fortsätter att falla tills du släpper knappen eller tills saldot tar slut.',
'turbo_balance': 'Turbo-saldo',
'turbo_balance_p1': 'Innan du startar Turbo Drop väljer du hur mycket pengar som ska avsättas — detta blir ditt Turbo-saldo.',
'turbo_balance_p2': 'När Turbo Drop är aktiv använder spelet endast ditt Turbo-saldo för insatser och vinster.',
'turbo_balance_p3': 'När du stoppar Turbo Drop går eventuellt kvarvarande Turbo-saldo tillbaka till ditt huvudsaldo.',
'turbo_balance_p4': 'Du kan lämna Turbo Drop när som helst — men läget avslutas helt först när alla bollar har slutat falla och landat i multiplikatorfickorna.',
'free_bets': 'BONUSRUNDOR',
'free_bets_p1': 'Bonusrundor tilldelas av operatören.',
'fairness': 'Rättvisa',
'fairness_p1': 'Varje släpp bestäms av en bevisat rättvis slumpgenerator (RNG).',
'fairness_p2': 'Resultatet kan inte förutsägas eller påverkas när bollen väl släppts.',
'disconection_and_error': 'Policy för frånkoppling och felhantering',
'disconection_and_error_p1': 'Om anslutningen tappas efter att en insats placerats, kommer insatsen inte att avbrytas. Om spelet kräver åtgärd från spelaren, räknas resultatet med antagandet att spelaren valt en riskfri åtgärd utan att höja den ursprungliga insatsen.',
'disconection_and_error_p2': 'Vid fel kommer vårt supportteam att försöka lösa problemet så snabbt som möjligt och återuppta det ordinarie spelet. Vid problem med spelet i sig kommer alla insatser att annulleras och insatser återbetalas.',
'other': 'Övrigt',
'other_p1': 'Vid fel på spelhårdvara/-mjukvara görs alla berörda insatser och utbetalningar ogiltiga och alla berörda insatser återbetalas.',
'other_p2': 'Spelreglerna är publicerade på engelska. Översättningar till andra språk tillhandahålls som en tjänst i god tro. Vid otydlighet mellan engelska och översättning gäller alltid den engelska versionen.',
'rows': 'Rader',
'lvl': 'Nivå',
'low': 'Låg',
'high': 'Hög',
'ok': 'OK',
'exit_turbo_mode': 'Vill du lämna Turbo-läget?',
"end": "Slut",
"turbo_mode_settings": "Turbo-lägesinställningar",
"stop": "STOPPA",
'invalid_bet_amount': 'Ogiltigt insatsbelopp',
'cashout_success': 'Uttag lyckades',
'stop_auto_play_first': 'Stoppa autospelet först.',
'turbo_only_when_no_balls': 'Turbo-läget kan endast aktiveras när det inte finns några bollar på bordet.',
'type': 'Insatstyp',
'wait_balls_to_finish': 'Vänligen vänta tills alla bollar är klara.',
'bet_too_large_top_up_turbo_balance': 'Insatsen är för stor – fyll på ditt Turbo-saldo!',
};
langArr.tr = {
'loading': 'Yükleniyor',
'hotkeys': 'Klavye kısayolları',
'hotkeys_enabled': 'Klavye kısayolları etkin',
'enable_hotkeys_checkbox': 'Aşağıdaki kısayolları etkinleştirmek için bu kutuyu işaretleyin.',
'drop_ball': 'Topu bırak',
'double_bet': 'Bahsi ikiye katla',
'halve_bet': 'Bahsi yarıya indir',
'min_bet': 'Minimum bahis',
'max': 'Maks',
'easy': 'Kolay',
'medium': 'Orta',
'hard': 'Zor',
'daredevil': 'Gözü pek',
'max_profit': 'Maksimum kazanç',
'manual': 'Manuel',
'auto': 'Otomatik',
'bet_amount': 'Bahis tutarı',
'difficulty': 'Zorluk',
'payout_on_win': 'Kazanıldığında ödeme',
'number_of_bets': 'Bahis sayısı',
'on_win': 'Kazanıldığında',
'on_loss': 'Kaybedildiğinde',
'stop_on_profit': 'Kârda durdur',
'stop_on_loss': 'Zararda durdur',
'reset': 'Sıfırla',
'increase_by': 'Artır',
'cashout': 'NAKİT AL',
'start_game': 'BAHİS',
'start_auto_game': 'BAŞLAT',
'difficulity_info': 'Zorluk bilgisi',
'chance_collision': 'Oyun başına çarpışma ihtimali',
'evry_25_lane': 'her 25 şerit için',
'insufficiend_funds': 'Yetersiz bakiye',
'cashout_inactivity': 'Hareketsizlikte otomatik nakit alma',
'time_running_out': 'Zaman doluyor! Şimdi oyna yoksa bilet 30 saniye içinde iptal edilir',
'there_was_error': 'BİR HATA OLUŞTU, LÜTFEN TEKRAR DENEYİN',
'detailed_game_rules': 'Detaylı oyun kuralları',
'general_rules': 'GENEL KURALLAR',
'general_rules_p1': '• Çarpan 1’den başlar ve ',
'general_rules_p2': '• Kazançlar, bahis tutarının çarpanla çarpılmasıyla hesaplanır.',
'general_rules_p3': '• Maksimum ödeme ulaşıldığında otomatik olarak nakit alınır.',
'progressive_jackpot': 'PROGRESİF JACKPOT',
'progressive_jackpot_ss': 'Jackpot şeridi ve olası kazanç',
'progressive_jackpot_p1': 'Her bahsin %’si jackpot fonuna ayrılır.',
'progressive_jackpot_p2': 'Jackpot “Mystery” veya “must-hit-by” mekaniğiyle verilir.',
'progressive_jackpot_p3': 'Değer ulaşıldığında, bir sonraki bahis yapan oyuncu jackpotu kazanma şansı elde eder.',
'progressive_jackpot_p4': 'NOT: Bonus turları jackpot fonuna katkı sağlamaz.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Kırmızı kare, çarpışma konumu',
'showdown_p1': 'Nakit alımdan sonra çarpışma noktası gösterilir.',
'return_to_player': 'OYUNCUYA DÖNÜŞ',
'return_to_player_p1': 'Toplam teorik RTP ',
'return_to_player_p2': 'RTP bağımsız kuruluşlarca doğrulanır.',
'disconnection_policy': 'BAĞLANTI KESİNTİSİ POLİTİKASI',
'disconnection_policy_p1': 'Bahisten sonra bağlantı koparsa bahis hemen iptal edilmez.',
'disconnection_policy_p2': 'bahis otomatik olarak nakit alınır.',
'network_latency': 'AĞ GECİKMESİ',
'network_latency_p1': 'Bahisler sunucuya ulaştığında geçerlidir.',
'sound': 'SES',
'sound_p1': 'Ses ve müzik oyun menüsünden kapatılabilir.',
'error_handling': 'HATA YÖNETİMİ',
'error_handling_p1': 'Hata durumunda destek ekibi sorunu çözer.',
'max_payout': 'Maksimum ödeme ',
'max_bet_is': 'Maksimum bahis ',
'min_bet_is': 'Minimum bahis ',
'per_bet': 'bahis başına.',
'malfunction_voids': 'Arıza tüm oyunları geçersiz kılar.',
'attention_jackpot': 'Dikkat, Jackpot şeritte ',
'lane': 'şerit',
'congratulations': 'tebrikler',
'you_won': 'kazandınız',
'balance': 'bakiye',
'time': 'zaman',
'jackpot': 'jackpot',
'escaped': 'KAÇTI',
'max_win': 'MAKS KAZANÇ',
'check_internet': 'İnternet bağlantınızı kontrol edin',
'websocket_disconected': 'Websocket bağlantısı kesildi',
'websocket_connection_error': 'Websocket bağlantı hatası!',
'session_expired': 'Oturum süresi doldu, yenileyin',
'remaining_bets': 'Kalan bahisler',
'stop_autoplay': 'DURDUR',
'autoplay_and_autocashout': 'OTOMATİK OYUN VE NAKİT ALMA',
'autoplay_and_autocashout_ss': 'Manuel ve otomatik seçim',
'autoplay_and_autocashout_p1': 'Bahisler otomatik olarak yerleştirilir.',
'autoplay_and_autocashout_p2': 'Otomatik nakit alma çarpanı seçilebilir.',
'autoplay_and_autocashout_p3': 'Maksimum otomatik tur sayısı ',
'autoplay_button_label': 'Başlamak için bir şerit seçin.',
'min_bet_amount_is': 'Minimum bahis tutarı',
'bonus_rounds': 'bonus turları',
'bonus_rounds_ss': 'Geçerlilik süreli bonus turları',
'bonus_rounds_p1': 'Promosyonla bonus tur verilebilir.',
'bonus_rounds_p2': 'Oyuncu ne zaman başlayacağını seçer.',
'bonus_rounds_p3': 'Bonus turlar süreli olabilir.',
'bonus_rounds_p4': 'Hareketsizlik bonusu iptal edebilir.',
'valid_until': 'geçerli',
'bonus': 'bonus',
'rounds': 'turlar',
'win_eur': 'kazanç EUR',
'complete_your_bet': 'Önce bahsi tamamlayın',
'complete_auto_play': 'Önce otomatik oyunu tamamlayın',
'yes': 'evet',
'no': 'hayır',
'play_bonus_rounds': 'Bonus turları oynansın mı?',
'bet_history': 'Bahis geçmişi',
'jackpot_history': 'Jackpot geçmişi',
'ticket_id': 'Bilet ID',
'created': 'oluşturma zamanı',
'currency': 'para birimi',
'bet': 'bahis',
'bet_eur': 'bahis EUR',
'lanes': 'şeritler',
'cars': 'arabalar',
'multiplier': 'çarpan',
'win': 'kazanç',
'no_betting_history': 'Bahis geçmişi bulunamadı.',
'no_jackpot_history': 'Jackpot geçmişi yok.',
'date': 'tarih',
'user': 'kullanıcı',
'bet_already_active': 'Bahis zaten aktif',
'please_play_the_game_in_portait_mode': 'Lütfen oyunu dikey modda oynayın.',
'bonus_history': 'Bonus geçmişi',
'bonus_type': 'Bonus türü',
'no_bonus_history': 'Bonus geçmişi yok.',
'game_menu': 'Oyun menüsü',
'game_menu_ss': 'Ana sayfa, Geçmiş, Kurallar, Kısayollar, Ses ve Müzik',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'OYUN KURALLARI',
'game_rules_p1': 'Plinko’ya Hoş Geldiniz – Şansın Önde Olduğu Yer!',
'game_rules_p2': 'Hem basit hem de bağımlılık yapıcı heyecan verici bir şans oyunu için hazır olun! Plinko, topun çivilerle dolu bir piramidin üzerine bırakılması ve topun zıplayıp, dönüp, çarpıp aşağıdaki ödüllü yuvalardan birine ulaşmasını izlemekle ilgilidir.',
'game_rules_p3': '8 ila 16 sıra çivi arasından seçim yapın, ardından topun yer çekimi ve şans tarafından yönlendirilen karmaşık yolculuğunun tadını çıkarın.',
'game_rules_p4': 'Top düşük ödüllü bir yuvaya mı düşecek… yoksa büyük ikramiyeyi mi vuracak? Öğrenmenin tek yolu topu bırakmak ve heyecanı yaşamak!',
'general': 'GENEL',
'general_p1': 'Plinko topunu bırakın ve topun aşağıdaki yüksek ödeme yapan yuvalardan birine düşmesini umut edin. Yol tahmin edilemez — her sekme şansınızı değiştirebilir.',
'general_p2': 'Ne kadar çok sıra oynarsanız, aksiyon o kadar yoğun olur!',
'general_p3': 'Hadi, şansınıza güvenin, DROP’a basın ve Plinko’nun çivileri arasından büyük ödülün peşine düşün!',
'betting': 'BAHİS',
'betting_p1': 'Bahis miktarını seçin. “1/2”, “2x”, “Max” düğmeleri bahis miktarını yönetmek için kullanılabilir. Bahis miktarı manuel olarak da girilebilir.',
'betting_p2': 'Risk Seviyesini seçin: Düşük, Orta veya Yüksek. Daha düşük risk seviyesi daha tutarlı sonuçlar verir (düşük volatilite), daha yüksek risk seviyesi ise daha fazla değişkenlik sağlar (yüksek volatilite).',
'betting_p3': 'Oyundaki çizgi sayısını seçin: 8 ila 16 arasında. Topun kaç sıra pimi geçeceğini seçin. Daha fazla sıra = daha fazla öngörülemezlik.',
'betting_p4': 'Bahis Modunu seçin: Manuel veya Otomatik.',
'betting_p5': 'Oyun turunu başlatmak için DROP BALL düğmesine basın. Tur sırasında tüm bahis düğmeleri devre dışı kalır, yalnızca DROP BALL ve bahis miktarı aktif olur.',
'betting_p6': 'Bir Plinko topu bir turu temsil eder. Tur sırasında DROP BALL düğmesini kullanarak aynı ayarlarla başka bir tur başlatabilirsiniz. Toplar “aktif”ken bahis miktarını değiştirmek mümkündür, ancak oyun zorluğunu değiştiremezsiniz.',
'betting_p7': 'Tur sonunda top cebe ulaşır. Her cebe ödeme çarpanı gösterilir.',
'betting_p8': 'Kazanma hesaplaması topun indiği çarpana göre yapılır. Sonuç bakiye alanına eklenir.',
'game_menu_p1': 'En son bahis çarpanları oyun penceresinin alt kısmında gösterilir.',
'game_menu_p2': '“Bet history” düğmesine tıklayarak oyuncu son bahislerini daha detaylı inceleyebilir.',
'game_menu_p3': 'Daha uzun oyun geçmişi (ör. daha uzun süreler) için oyuncu, oyun platformunun kendi içinde oyuncu geçmişine erişmelidir.',
'game_menu_p4': 'Oyun menüsü aracılığıyla oyuncular ses seçeneklerini, klavye kısayollarını kontrol edebilir ve bahis geçmişi ile oyun kurallarını açabilir.',
'game_menu_p5': 'Oyun, güzel bir arka plan müziği ve ses efektleriyle tasarlanmıştır. Müzik ve/veya ses efektleri oyun menüsü simgeleri aracılığıyla kapatılabilir.',
'game_menu_p6': 'Oyun geçmişi, önceki bahisler ve bonus geçmişi ile bir pencere gösterir.',
'autoplay': 'Otomatik Mod (Autoplay)',
'autoplay_p1': 'Auto’ya tıklayarak her seferinde tıklamadan otomatik olarak top bırakabilirsiniz.',
'autoplay_p2': 'Her top için bahis yapmak istediğiniz miktarı seçin.',
'autoplay_p3': 'Topun kaç kez (tur) düşmesini istediğinizi seçin — maksimum 100 tur.',
'autoplay_p4': 'Başlamak için START düğmesine basın ve düğme STOP’a dönüşür.',
'autoplay_p5': 'Seçilen düşüş sayısı tamamlandığında, bakiye bittiğinde veya STOP’a tıkladığınızda Otomatik Mod durur.',
'autoplay_p6': 'Her düşüş, Otomatik Modu başlatmadan önce seçtiğiniz aynı bahis miktarını kullanır.',
'turbo_mode': 'Turbo Modu',
'turbo_mode_p1': 'Turbo Drop, DROP düğmesini basılı tutarak topları çok hızlı bırakmanızı sağlar.',
'turbo_mode_p2': 'Toplar, düğmeyi bırakana veya bakiye bitene kadar düşmeye devam eder.',
'turbo_mode_p3': 'Toplar, düğmeyi bırakana veya bakiye bitene kadar düşmeye devam eder.',
'turbo_balance': 'Turbo Bakiye',
'turbo_balance_p1': 'Turbo Drop’u başlatmadan önce ne kadar para ayıracağınızı seçin — bu sizin Turbo Bakiyeniz olur.',
'turbo_balance_p2': 'Turbo Drop etkin olduğunda, oyun yalnızca Turbo Bakiyenizi bahis ve kazançlar için kullanır.',
'turbo_balance_p3': 'Turbo Drop’u durdurduğunuzda kalan Turbo Bakiye ana bakiyenize geri döner.',
'turbo_balance_p4': 'Turbo Drop’tan istediğiniz zaman çıkabilirsiniz — ancak tüm toplar düşüp çarpan ceplerine ulaşana kadar mod tamamen sona ermez.',
'free_bets': 'BONUS TUR',
'free_bets_p1': 'Bonus Turlar operatör tarafından verilir.',
'fairness': 'Adalet',
'fairness_p1': 'Her düşüş, kanıtlanabilir adil bir rastgele sayı üreteci (RNG) tarafından belirlenir.',
'fairness_p2': 'Top bırakıldıktan sonra sonuç tahmin edilemez veya etkilenemez.',
'disconection_and_error': 'Bağlantı Kesilme Politikası ve Hata Yönetimi',
'disconection_and_error_p1': 'Bahis yapıldıktan sonra bağlantı kesilirse, bahis iptal edilmez. Oyun oyuncudan bir işlem yapmasını istiyorsa, sonuç, oyuncunun ilk bahsi artırmadan risk içermeyen işlemi seçtiği varsayılarak hesaplanır.',
'disconection_and_error_p2': 'Hata durumunda destek ekibimiz sorunu en kısa sürede çözmeye çalışır ve oyuna normal şekilde devam eder. Oyunda bir sorun varsa, tüm bahisler iptal edilir ve bahis miktarı oyunculara iade edilir.',
'other': 'Diğer',
'other_p1': 'Oyun donanımı/yazılımında bir arıza olması durumunda, tüm ilgili bahisler ve ödemeler geçersiz sayılır ve tüm bahisler geri ödenir.',
'other_p2': 'Oyun Kuralları İngilizce olarak yayımlanmıştır. Diğer dillere yapılan çeviriler iyi niyetle hizmet olarak sunulmaktadır. İngilizce versiyon ile çeviri arasında bir belirsizlik olması durumunda İngilizce versiyon önceliklidir.',
'rows': 'Satırlar',
'lvl': 'Seviye',
'low': 'Düşük',
'high': 'Yüksek',
'ok': 'OK',
'exit_turbo_mode': 'Turbo modundan çıkmak istiyor musunuz?',
"end": "Son",
"turbo_mode_settings": "Turbo mod ayarları",
"stop": "DURDUR",
'invalid_bet_amount': 'Geçersiz bahis tutarı',
'cashout_success': 'Nakit alma başarılı',
'stop_auto_play_first': 'Önce otomatik oyunu durdurun.',
'turbo_only_when_no_balls': 'Turbo modu, masada top olmadığında etkinleştirilebilir yalnızca.',
'type': 'Bahis türü',
'wait_balls_to_finish': 'Lütfen tüm topların bitmesini bekleyin.',
'bet_too_large_top_up_turbo_balance': 'Bahis çok büyük – Turbo bakiyenizi doldurun!',
};
langArr.uk = {
'loading': 'Завантаження',
'hotkeys': 'Гарячі клавіші',
'hotkeys_enabled': 'Гарячі клавіші увімкнено',
'enable_hotkeys_checkbox': 'Увімкніть гарячі клавіші, встановивши цей прапорець.',
'drop_ball': 'Скинути кулю',
'double_bet': 'Подвоїти ставку',
'halve_bet': 'Зменшити ставку вдвічі',
'min_bet': 'Мінімальна ставка',
'max': 'Макс',
'easy': 'Легко',
'medium': 'Середньо',
'hard': 'Важко',
'daredevil': 'Відчайдух',
'max_profit': 'Максимальний прибуток',
'manual': 'Ручний',
'auto': 'Авто',
'bet_amount': 'Сума ставки',
'difficulty': 'Складність',
'payout_on_win': 'Виплата при виграші',
'number_of_bets': 'Кількість ставок',
'on_win': 'При виграші',
'on_loss': 'При програші',
'stop_on_profit': 'Зупинити при прибутку',
'stop_on_loss': 'Зупинити при втраті',
'reset': 'Скинути',
'increase_by': 'Збільшити на',
'cashout': 'ВИВЕСТИ',
'start_game': 'СТАВКА',
'start_auto_game': 'ПОЧАТИ',
'difficulity_info': 'Інформація про складність',
'chance_collision': 'Ймовірність зіткнення за гру',
'evry_25_lane': 'кожні 25 доріжок',
'insufficiend_funds': 'Недостатньо коштів',
'cashout_inactivity': 'Автовивід при бездіяльності',
'time_running_out': 'Час закінчується! Грайте зараз або квиток буде скасовано через 30 секунд',
'there_was_error': 'СТАЛАСЯ ПОМИЛКА, СПРОБУЙТЕ ЩЕ РАЗ',
'detailed_game_rules': 'Детальні правила гри',
'general_rules': 'ЗАГАЛЬНІ ПРАВИЛА',
'general_rules_p1': '• Множник починається з 1 та ',
'general_rules_p2': '• Виграш розраховується як ставка, помножена на множник.',
'general_rules_p3': '• При досягненні максимального виграшу відбувається автоматичний вивід.',
'progressive_jackpot': 'ПРОГРЕСИВНИЙ ДЖЕКПОТ',
'progressive_jackpot_ss': 'Смуга джекпоту та можливий виграш',
'progressive_jackpot_p1': 'Частина кожної ставки додається до фонду джекпоту.',
'progressive_jackpot_p2': 'Джекпот має механіку “Mystery” або “must-hit-by”.',
'progressive_jackpot_p3': 'Після досягнення значення наступний гравець має шанс виграти джекпот.',
'progressive_jackpot_p4': 'ПРИМІТКА: Бонусні раунди не поповнюють фонд джекпоту.',
'showdown': 'ПОКАЗ',
'showdown_ss': 'Червоний квадрат — позиція зіткнення',
'showdown_p1': 'Після виводу показується точка зіткнення.',
'return_to_player': 'ПОВЕРНЕННЯ ГРАВЦЮ',
'return_to_player_p1': 'Загальний теоретичний RTP ',
'return_to_player_p2': 'RTP підтверджено незалежними організаціями.',
'disconnection_policy': 'ПОЛІТИКА ВІДКЛЮЧЕННЯ',
'disconnection_policy_p1': 'Якщо з’єднання втрачено після ставки, вона не анулюється одразу.',
'disconnection_policy_p2': 'ставка буде автоматично виведена.',
'network_latency': 'ЗАТРИМКА МЕРЕЖІ',
'network_latency_p1': 'Ставки вважаються дійсними після отримання сервером.',
'sound': 'ЗВУК',
'sound_p1': 'Звук та музика вимикаються в меню гри.',
'error_handling': 'ОБРОБКА ПОМИЛОК',
'error_handling_p1': 'У разі помилки служба підтримки вирішує проблему.',
'max_payout': 'Максимальна виплата ',
'max_bet_is': 'Максимальна ставка ',
'min_bet_is': 'Мінімальна ставка ',
'per_bet': 'за ставку.',
'malfunction_voids': 'Збій анулює всі ігри.',
'attention_jackpot': 'Увага, джекпот на доріжці ',
'lane': 'доріжка',
'congratulations': 'вітаємо',
'you_won': 'ви виграли',
'balance': 'баланс',
'time': 'час',
'jackpot': 'джекпот',
'escaped': 'ВТІК',
'max_win': 'МАКСИМАЛЬНИЙ ВИГРАШ',
'check_internet': 'Перевірте підключення до Інтернету',
'websocket_disconected': 'WebSocket з’єднання втрачено',
'websocket_connection_error': 'Помилка WebSocket з’єднання!',
'session_expired': 'Сесію завершено, оновіть сторінку',
'remaining_bets': 'Залишилось ставок',
'stop_autoplay': 'ЗУПИНИТИ',
'autoplay_and_autocashout': 'АВТОГРА ТА АВТОВИВІД',
'autoplay_and_autocashout_ss': 'Ручний та автоматичний вибір',
'autoplay_and_autocashout_p1': 'Ставки робляться автоматично.',
'autoplay_and_autocashout_p2': 'Можна вибрати множник автокешаута.',
'autoplay_and_autocashout_p3': 'Максимальна кількість автоматичних раундів ',
'autoplay_button_label': 'Оберіть доріжку для початку.',
'min_bet_amount_is': 'Мінімальна сума ставки',
'bonus_rounds': 'бонусні раунди',
'bonus_rounds_ss': 'Бонусні раунди з терміном дії',
'bonus_rounds_p1': 'Бонусні раунди можуть надаватись у рамках акції.',
'bonus_rounds_p2': 'Гравець обирає час початку.',
'bonus_rounds_p3': 'Бонусні раунди можуть бути обмежені у часі.',
'bonus_rounds_p4': 'Бездіяльність може скасувати бонус.',
'valid_until': 'дійсно до',
'bonus': 'бонус',
'rounds': 'раунди',
'win_eur': 'виграш EUR',
'complete_your_bet': 'Спочатку завершіть ставку',
'complete_auto_play': 'Спочатку завершіть автогру',
'yes': 'так',
'no': 'ні',
'play_bonus_rounds': 'Грати бонусні раунди?',
'bet_history': 'Історія ставок',
'jackpot_history': 'Історія джекпотів',
'ticket_id': 'ID квитка',
'created': 'створено',
'currency': 'валюта',
'bet': 'ставка',
'bet_eur': 'ставка EUR',
'lanes': 'доріжки',
'cars': 'авто',
'multiplier': 'множник',
'win': 'виграш',
'no_betting_history': 'Історія ставок відсутня.',
'no_jackpot_history': 'Історія джекпотів відсутня.',
'date': 'дата',
'user': 'користувач',
'bet_already_active': 'Ставка вже активна',
'please_play_the_game_in_portait_mode': 'Будь ласка, грайте в портретному режимі.',
'bonus_history': 'Історія бонусів',
'bonus_type': 'Тип бонусу',
'no_bonus_history': 'Історія бонусів відсутня.',
'game_menu': 'Меню гри',
'game_menu_ss': 'Головна, Історія, Правила, Клавіші, Звук і Музика',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'ПРАВИЛА ГРИ',
'game_rules_p1': 'Ласкаво просимо до Plinko – Де Вдача Керує!',
'game_rules_p2': 'Приготуйтеся до захопливої гри на удачу, яка є такою ж простою, як і захоплюючою! Plinko полягає у тому, щоб кинути кульку на піраміду, заповнену штифтами, і спостерігати, як вона відскакує, крутиться та рикошетує до призового слота внизу.',
'game_rules_p3': 'Виберіть від 8 до 16 рядів штифтів, потім сядьте і насолоджуйтеся хаосом, коли кулька звивається крізь дошку, керована лише гравітацією та удачею.',
'game_rules_p4': 'Чи потрапить вона в слот з низькою виплатою… чи зірве великий виграш? Є лише один спосіб дізнатися — киньте кульку і нехай розгортається хвилювання!',
'general': 'ЗАГАЛЬНЕ',
'general_p1': 'Киньте кульку Plinko і сподівайтеся, що вона потрапить в один із високоплатних слотів унизу. Шлях непередбачуваний — кожен відскок може змінити вашу удачу.',
'general_p2': 'Чим більше рядків ви граєте, тим інтенсивніші дії!',
'general_p3': 'Тож вперед — довіряйте своїй удачі, натисніть DROP і гоніться за великим виграшем через штифти Plinko!',
'betting': 'СТАВКИ',
'betting_p1': 'Виберіть суму ставки. Кнопки “1/2”, “2x”, “Max” можна використовувати для керування розміром ставки. Суму ставки також можна вводити вручну.',
'betting_p2': 'Виберіть рівень ризику: Низький, Середній або Високий. Нижчий рівень ризику дає більш стабільні результати (низька волатильність), тоді як вищий дає більшу варіативність (висока волатильність).',
'betting_p3': 'Виберіть кількість ліній у грі: від 8 до 16. Виберіть, через скільки рядів штифтів буде падати м’яч. Більше рядів = більше непередбачуваності.',
'betting_p4': 'Виберіть режим ставки: Ручний або Авто.',
'betting_p5': 'Щоб почати раунд гри, натисніть кнопку DROP BALL. Під час раунду всі кнопки ставок неактивні, крім DROP BALL та суми ставки.',
'betting_p6': 'Один м’яч Plinko представляє один раунд. Під час раунду можна почати ще один раунд з тими ж налаштуваннями, використовуючи кнопку DROP BALL. Можна змінювати суму ставки, поки на столі є “активні” м’ячі, але не складність гри.',
'betting_p7': 'Наприкінці раунду м’яч досягає кишені. У кожній кишені відображається множник виплати.',
'betting_p8': 'Виграш розраховується відповідно до множника, на якому впав м’яч. Результат додається до балансу.',
'game_menu_p1': 'Останні множники ставок відображаються в нижній частині вікна гри.',
'game_menu_p2': 'За допомогою кнопки “Bet history” гравець може переглянути свої останні ставки детальніше.',
'game_menu_p3': 'Для довшої історії гри (наприклад, за більші періоди) гравцю може знадобитися доступ до історії гравця всередині платформи гри.',
'game_menu_p4': 'Через меню гри гравці можуть керувати звуковими параметрами, гарячими клавішами, а також відкривати історію ставок та правила гри.',
'game_menu_p5': 'Гра розроблена з красивою фоновою музикою та звуковими ефектами. Музику та/або звукові ефекти можна вимкнути через іконки меню гри.',
'game_menu_p6': 'Історія гри покаже вікно з попередніми ставками та історією бонусів.',
'autoplay': 'Авто режим (Autoplay)',
'autoplay_p1': 'Натиснувши Auto, ви можете автоматично скидати кілька м’ячів без необхідності кожного разу натискати.',
'autoplay_p2': 'Виберіть суму, яку хочете поставити на один м’яч.',
'autoplay_p3': 'Виберіть, скільки разів (раундів) ви хочете скинути м’яч — максимум 100 раундів.',
'autoplay_p4': 'Натисніть кнопку START, щоб почати, кнопка зміниться на STOP.',
'autoplay_p5': 'Авто режим зупиниться, коли вибрана кількість скидань буде завершена, закінчаться кошти або ви натиснете STOP.',
'autoplay_p6': 'Кожне скидання використовує ту саму суму ставки, яку ви вибрали перед запуском Авто режиму.',
'turbo_mode': 'Турбо режим',
'turbo_mode_p1': 'Turbo Drop дозволяє скидати м’ячі дуже швидко, утримуючи кнопку DROP.',
'turbo_mode_p2': 'М’ячі продовжуватимуть падати, поки ви не відпустите кнопку або не закінчиться баланс.',
'turbo_mode_p3': 'М’ячі продовжуватимуть падати, поки ви не відпустите кнопку або не закінчиться баланс.',
'turbo_balance': 'Турбо баланс',
'turbo_balance_p1': 'Перед запуском Turbo Drop виберіть, яку суму відкласти — це стане вашим Турбо балансом.',
'turbo_balance_p2': 'Коли Turbo Drop активний, гра використовує лише ваш Турбо баланс для ставок і виграшів.',
'turbo_balance_p3': 'Коли ви зупиняєте Turbo Drop, залишок Турбо балансу повертається на основний баланс.',
'turbo_balance_p4': 'Ви можете вийти з Turbo Drop у будь-який момент — але режим завершиться повністю лише після того, як усі м’ячі впадуть і потраплять у кишені з множниками.',
'free_bets': 'БОНУСНІ РАУНДИ',
'free_bets_p1': 'Бонусні раунди надаються оператором.',
'fairness': 'Чесність',
'fairness_p1': 'Кожне скидання визначається доказово чесним генератором випадкових чисел (RNG).',
'fairness_p2': 'Результат не можна передбачити або вплинути після скидання кульки.',
'disconection_and_error': 'Політика відключення та обробка помилок',
'disconection_and_error_p1': 'Якщо з’єднання втрачено після ставки, ставка не скасовується. Якщо гра вимагає дії від гравця, результат розраховується, припускаючи, що гравець вибрав дію без ризику без підвищення початкової ставки.',
'disconection_and_error_p2': 'У разі помилки наша служба підтримки намагатиметься вирішити проблему якомога швидше і продовжити звичайну гру. У разі проблем із самою грою всі ставки будуть скасовані, а ставки повернені гравцям.',
'other': 'Інше',
'other_p1': 'У разі несправності ігрового обладнання/програмного забезпечення всі відповідні ставки та виплати визнаються недійсними, а всі відповідні ставки повертаються.',
'other_p2': 'Правила гри опубліковані англійською мовою. Переклади іншими мовами надаються як послуга з добрими намірами. У разі розбіжностей між англійською версією та перекладом пріоритет завжди має англійська версія.',
'rows': 'Ряди',
'lvl': 'Рівень',
'low': 'Низький',
'high': 'Високий',
'ok': 'OK',
'exit_turbo_mode': 'Бажаєте вийти з режиму Turbo?',
"end": "Кінець",
"turbo_mode_settings": "Налаштування режиму Turbo",
"stop": "СТОП",
'invalid_bet_amount': 'Недійсна сума ставки',
'cashout_success': 'Вивід успішний',
'stop_auto_play_first': 'Спочатку зупиніть автогру.',
'turbo_only_when_no_balls': 'Режим Turbo можна активувати лише коли на столі немає кульок.',
'type': 'Тип ставки',
'wait_balls_to_finish': 'Будь ласка, дочекайтеся завершення всіх кульок.',
'bet_too_large_top_up_turbo_balance': 'Ставка занадто велика – поповніть Турбо баланс!',
};
langArr.sr = {
'loading': 'Učitavanje',
'hotkeys': 'Prečice',
'hotkeys_enabled': 'Prečice aktivne',
'enable_hotkeys_checkbox': 'Omogući prečice aktiviranjem ove opcije.',
'drop_ball': 'Ispusti lopticu',
'double_bet': 'Dupliraj ulog',
'halve_bet': 'Prepolovi ulog',
'min_bet': 'Minimalni ulog',
'max': 'Max',
'easy': 'Lako',
'medium': 'Osrednje',
'hard': 'Teško',
'daredevil': 'Izazovno',
'max_profit': 'Max Profit',
'manual': 'Ručno',
'auto': 'Automatski',
'bet_amount': 'Iznos opklade',
'difficulty': 'Težina',
'payout_on_win': 'Isplata po dobitku',
'number_of_bets': 'Broj opklada',
'on_win': 'po dobitku',
'on_loss': 'po gubitku',
'stop_on_profit': 'Prekini na profitu',
'stop_on_loss': 'Prekini na gubitku',
'reset': 'Reset',
'increase_by': 'Povećaj za',
'cashout': 'ISPLATI TIKET',
'start_game': 'UPLATI TIKET',
'start_auto_game': 'START',
'difficulity_info': 'Težina igre',
'chance_collision': 'Šansa za sudar po igri',
'evry_25_lane': 'za svih 25 traka',
'insufficiend_funds': 'Nemate dovoljno novca',
'cashout_inactivity': 'Isplata usled neaktivnosti',
'time_running_out': 'Vreme ističe! Igraj odmah ili će tvoj tiket biti isplaćen u narednih 30 sekundi',
'there_was_error': 'Dogodila se greška! Učitaj igru ponovo.',
'detailed_game_rules': 'Detaljna Pravila Igre',
'general_rules': 'OPŠTA PRAVILA',
'general_rules_p1': '• Množilac počinje sa 1 i ide do ',
'general_rules_p2': '• Dobitak se izračunava množenjem opklade sa množiteljem u trenutku klika na dugme ISPLATI TIKET.',
'general_rules_p3': '• Ako je dostignut maksimalni dobitak opklada se automatski unovčava.',
'progressive_jackpot': 'PROGRESIVNI DŽEKPOT',
'progressive_jackpot_ss': 'Džekpot traka i mogućnost osvajanja',
'progressive_jackpot_p1': '% od svakog uloga se izdvaja u fond za progresivni džekpot.',
'progressive_jackpot_p2': 'Džekpot se dodeljuje putem mehanike "Mistery" ili "must-hit-by". Vrednost svakog "must-hit-by" džekpota se određuje odmah nakon što prethodni džekpot bude osvojen, koristeći generator slučajnih brojeva. Ta vrednost se čuva kao šifrovani broj u bazi podataka, što znači da je skrivena i nepoznata.',
'progressive_jackpot_p3': 'Kada se dostigne vrednost "must-hit-by", prvi igrač koji uloži nakon toga imaće priliku da osvoji džekpot. Simbol džekpota će se pojaviti na nasumičnoj traci, a džekpot se osvaja ako igrač stigne do trake sa džekpot simbolom. Ako igrač ne stigne do trake sa simbolom džekpota zbog isplate ili sudara, sledeći igrač koji uloži videće simbol džekpota i imati priliku da ga osvoji. Ovaj proces se ponavlja dok džekpot ne bude osvojen. Samo jedan igrač/tiket može da osvoji džekpot.',
'progressive_jackpot_p4': 'NAPOMENA: Besplatne opklade tj. bonus runde ne učestvuju u fondu za progresivni džekpot. Džekpot ne može biti osvoje tokom bonus runde.',
'showdown': 'OTKRIVANJE',
'showdown_ss': 'Crveni kvadrad, mesto garantovanog sudara',
'showdown_p1': 'Nakon izvršene isplate, crveni kvadrat će biti prikazan na poziciji gde bi se sudar dogodio da je igrač nastavio sa igrom.',
'return_to_player': 'POVRAĆAJ IGRAČU',
'return_to_player_p1': 'Ukupni teoretski povraćaj igraču (RTP) je ',
'return_to_player_p2': 'Procente RTP -a stalno prate i verifikuju nezavisne treće strane.',
'disconnection_policy': 'POLITIKA POVEZIVANJA',
'disconnection_policy_p1': 'Ako se veza prekine nakon postavljanja opklade, opklada se neće poništiti. Ako je igrač neaktivan više od ',
'disconnection_policy_p2': 's opklada će biti automatski isplaćena a krediti vraćeni na račun igrača.',
'network_latency': 'KAŠNJENJA U MREŽI',
'network_latency_p1': 'Kašnjenja prilikom prenosa podataka u mreži su sastavni deo funkcionisanja interneta. Akcije Uplate i Isplate su validne onoga trenutka kada ti zahtevi stignu na server, bez obzira na to kada je igrač inicirao akciju na svojoj strani.',
'sound': 'ZVUK',
'sound_p1': 'Igra je dizajnirana sa prelepom muzikom u pozadini i zvučnim efektima. Ako želite da ugasite muziku ili zvučne efekte korisite ikone za kontrolu zvuka iz menija igre.',
'error_handling': 'U SLUČAJU GREŠKE',
'error_handling_p1': 'U slučaju greške naš tim za podršku će pokušati rešiti problem što je pre moguće. U slučaju problema sa samom igrom, sve opklade će biti poništene, a iznos uloga vraćen igračima.',
'max_payout': 'Maksimalna isplata je ',
'max_bet_is': 'Maksimalni ulog je ',
'min_bet_is': 'Minimalni ulog je ',
'per_bet': 'po opkladi.',
'malfunction_voids': 'Neispravnost u radu poništava sve isplate i igre.',
'attention_jackpot': 'Pažnja, Džekpot na traci ',
'lane': 'traka',
'congratulations': 'bravo',
'you_won': 'osvojio si',
'balance': 'balans',
'time': 'vreme',
'jackpot': 'džekpot',
'escaped': 'POBEGAO',
'max_win': 'MAX DOBITAK',
'check_internet': 'Molimo proverite internet konekciju',
'websocket_disconected': 'Websocket diskonektovan',
'websocket_connection_error': 'Websocket greska u konekciji !',
'session_expired': 'Sesija je istekla',
'remaining_bets': 'Preostale opklade',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTO-IGRA I AUTO-ISPLATA',
'autoplay_and_autocashout_ss': 'Izbor ručne i automatske igre',
'autoplay_and_autocashout_p1': 'Igrač može aktivirati opciju auto-igra gde se opklada automatski stavlja za svaku novu rundu koristeći iznos opklade iz prethodne runde. ',
'autoplay_and_autocashout_p2': 'Odabir množioca za svaku partiju se vrši sa ekran igra. Kada je množilac podešen igra će automatski izvršiti isplatu ako igrač ne doživi sudar pre nego što dostigne izabrani množilac.',
'autoplay_and_autocashout_p3': 'Maskimalan broj rundi u automatskoj igri je ',
'autoplay_button_label': 'Za pocetak, izaberi traku.',
'min_bet_amount_is': 'Min iznos opklade je',
'bonus_rounds': 'bonus runde',
'bonus_rounds_ss': 'Prikaz bonus rundi sa rokom važenja',
'bonus_rounds_p1': 'Igrač može biti nagrađen besplatnim opkladama u vidu bonus rundi tokom promocije od strane kazina. Na ekranu će iskočiti slika koja obaveštava igrača o dodeljenim besplatnim rundama, broju rundi, iznosu po opkladi i opciono roku važenja.',
'bonus_rounds_p2': 'Nakon što se dodele bonus runde, igrač može izabrati kada počinje besplatnu rundu opklade. Nakon što započne runda besplatnih opklada, postavlja se automatska opklada sa navedenim ulogom, a na igraču je da isplati u svakom trenutku.',
'bonus_rounds_p3': 'Besplatne opklade mogu imati rok važenja nakon čega ističu i ne mogu se koristiti. Rok važenja, ako postoji, je prikazan ispod bonus rundi.',
'bonus_rounds_p4': 'Neaktivnost igrača moze prouzrokovati otkazivanje aktivne bonus runde. U tom slučaju, broj bonus rundi se smanjuje a balans igrača ostaje nepromenjen.',
'valid_until': 'važi do',
'bonus': 'bonus',
'rounds': 'runda',
'win_eur': 'dobitak EUR',
'complete_your_bet': 'Prvo završite vašu opkladu',
'complete_auto_play': 'Prvo završite vašu auto-igru',
'yes': 'Da',
'no': 'Ne',
'play_bonus_rounds': 'Igraj Bonus runde?',
'bet_history': 'Istorija opklada',
'jackpot_history': 'Istorija džekpota',
'ticket_id': 'Ticket ID',
'created': 'vreme kreiranja',
'currency': 'valuta',
'bet': 'ulog',
'bet_eur': 'ulog EUR',
'lanes': 'trake',
'cars': 'automobili',
'multiplier': 'množilac',
'win': 'dobitak',
'no_betting_history': 'Istorija opklada nije pronađena. Napravite opkladu i ona će se pojaviti ovde.',
'no_jackpot_history': 'Nema dostupne istorije džekpota.',
'date': 'datum',
'user': 'igrač',
'bet_already_active': 'Opklada je već aktivna',
'please_play_the_game_in_portait_mode': 'Molim vas igrajte u portret modu.',
'bonus_history': 'Istorija bonusa',
'bonus_type': 'Tip bonusa',
'no_bonus_history': 'Nema dostupne istorije bonusa.',
'game_menu': 'MENI IGRE',
'game_menu_ss': 'Sa leva na desno: povratak na početak, istorija opklada, pravila igre, prečice, zvučni efekti, muzika',
// 'game_menu_p1': 'Kroz meni igre, igrači mogu kontrolisati opcije zvuka, prečice na tastaturi, otvoriti istoriju opklada i pravila igre.',
// 'game_menu_p2': 'Istorija oplada prikazuje prethodne opklade i istoriju bonusa.',
'game_rules': 'PRAVILA IGRE',
'game_rules_p1': 'Dobrodošli u Plinko – gde sreća vodi!',
'game_rules_p2': 'Pripremite se za uzbudljivu igru na sreću, jednostavnu i zaraznu! Plinko je igra u kojoj se kuglica ispušta na piramidu punu čepova i prati kako se odbija, okreće i skreće dok ne padne u džep sa nagradama na dnu.',
'game_rules_p3': 'Izaberite između 8 i 16 redova čepova, zatim se opustite i uživajte u haosu dok kuglica vijuga kroz tablu, vođena samo gravitacijom i srećom.',
'game_rules_p4': 'Hoće li pasti u džep sa malom isplatom… ili pogoditi veliki dobitak? Postoji samo jedan način da saznate — ispustite kuglicu i neka uzbuđenje počne!',
'general': 'OPŠTE',
'general_p1': 'Ispustite Plinko kuglicu i nadajte se da će pasti u jedan od džepova sa velikim isplatama na dnu. Putanja je nepredvidiva — svaki odskok može promeniti vašu sreću.',
'general_p2': 'Što više redova odigrate, to je akcija intenzivnija!',
'general_p3': 'Pa, samo napred — verujte u svoju sreću, pritisnite ISPUSTI LOPTICU i jurite veliki dobitak kroz čepove Plinka!',
'betting': 'KLAĐENJE',
'betting_p1': 'Izaberite iznos opklade. Dugmad “1/2”, “2x”, “Max” mogu se koristiti za upravljanje iznosom opklade. Iznos opklade se može uneti i ručno.',
'betting_p2': 'Izaberite nivo rizika: lak, osrednji i težak. Laki nivo rizika daje konzistentnije ishode (nisku volatilnost), dok teži donosi veću varijaciju (visoku volatilnost).',
'betting_p3': 'Izaberite broj linija u igri: od 8 do 16. Odaberite kroz koliko redova klinova lopta prolazi. Više redova = veća nepredvidivost.',
'betting_p4': 'Izaberite režim opklade: ručni ili automatski.',
'betting_p5': 'Za početak runde pritisnite dugme ISPUSTI LOPTICU. Tokom runde sva dugmad za opkladu su neaktivna osim ISPUSTI LOPTICU i iznosa opklade.',
'betting_p6': 'Jedna Plinko lopta predstavlja jednu rundu. Tokom runde može se započeti nova runda sa istim podešavanjima pomoću dugmeta ISPUSTI LOPTICU. Iznos opklade se može menjati dok su lopte aktivne, ali ne i težina igre.',
'betting_p7': 'Na kraju runde lopta stiže u džep. Na svakom džepu je prikazan multiplikator isplate.',
'betting_p8': 'Obračun dobitka se vrši prema multiplikatoru na kojem je lopta završila. Rezultat se dodaje na stanje.',
'game_menu_p1': 'Najnoviji multiplikatori opklada prikazani su u donjem delu prozora igre.',
'game_menu_p2': 'Preko dugmeta "ISTORIJA OPKLADA" igrač može detaljnije pregledati svoje poslednje opklade.',
'game_menu_p3': 'Za detaljniju istoriju igranja igrač treba da pristupi istoriji naloga unutar same platforme.',
'game_menu_p4': 'Putem menija igre igrači mogu kontrolisati zvuk, prečice na tastaturi i otvoriti istoriju opklada i pravila igre.',
'game_menu_p5': 'Igra je dizajnirana sa lepom pozadinskom muzikom i zvučnim efektima. Muzika i/ili efekti mogu se isključiti u meniju igre.',
'game_menu_p6': 'Istorija igre prikazuje prozor sa prethodnim opkladama i bonus istorijom.',
'autoplay': 'Automatski režim (Autoplay)',
'autoplay_p1': 'Klikom na Automatski omogućavate automatsko spuštanje više lopti bez ručnog klika.',
'autoplay_p2': 'Izaberite iznos koji želite da uložite po lopti.',
'autoplay_p3': 'Izaberite koliko puta (rundi) želite da se lopta spusti — maksimalno do 100 rundi.',
'autoplay_p4': 'Pritisnite START za početak, a dugme će se promeniti u STOP.',
'autoplay_p5': 'Automatski režim se zaustavlja kada se završi izabrani broj spuštanja, ponestane sredstava ili pritisnete STOP.',
'autoplay_p6': 'Svako spuštanje koristi isti iznos opklade koji ste izabrali pre pokretanja automatskog režima.',
'turbo_mode': 'Turbo režim',
'turbo_mode_p1': 'Turbo režim omogućava izuzetno brzo spuštanje lopti držanjem dugmeta ISPUSTI LOPTICU.',
'turbo_mode_p2': 'Lopte će nastaviti da padaju dok ne pustite dugme ili dok ne ponestane sredstava.',
'turbo_mode_p3': 'Lopte će nastaviti da padaju dok ne pustite dugme ili dok ne ponestane sredstava.',
'turbo_balance': 'Turbo balans',
'turbo_balance_p1': 'Pre pokretanja Turbo režima birate iznos koji izdvajate — to postaje vaš Turbo balans.',
'turbo_balance_p2': 'Dok je Turbo režim aktivan, igra koristi samo Turbo balans za opklade i dobitke.',
'turbo_balance_p3': 'Kada zaustavite Turbo režim, preostali Turbo balans se vraća na glavni balans.',
'turbo_balance_p4': 'Turbo režim možete napustiti u bilo kom trenutku — ali režim se u potpunosti završava tek kada sve lopte završe pad i slete u džepove.',
'free_bets': 'BONUS RUNDE',
'free_bets_p1': 'Bonus runde dodeljuje operater.',
'fairness': 'Pravda',
'fairness_p1': 'Svaki pad loptice određuje fer generator slučajnih brojeva (RNG).',
'fairness_p2': 'Ishod nije moguće predvideti niti uticati nakon što kuglica padne.',
'disconection_and_error': 'Politika prekida veze i rukovanje greškama',
'disconection_and_error_p1': 'Ako se veza prekine nakon postavljanja opklade, opklada se neće poništiti. Ako igra zahteva akciju igrača, rezultat se računa pod pretpostavkom da je igrač odabrao akciju bez rizika bez povećanja početne opklade.',
'disconection_and_error_p2': 'U slučaju greške naš tim za podršku će pokušati da reši problem što pre i nastavi redovnu igru. U slučaju problema sa samom igrom, sve opklade će biti poništene i ulozi vraćeni igračima.',
'other': 'Ostalo',
'other_p1': 'U slučaju kvara hardvera ili softvera igre, sve pogođene opklade i isplate postaju nevažeće i svi pogođeni ulozi se vraćaju.',
'other_p2': 'Pravila igre su objavljena na engleskom jeziku. Prevodi na druge jezike se pružaju kao usluga u dobroj veri. U slučaju nejasnoća između engleske verzije i prevoda, engleska verzija ima prioritet.',
'rows': 'Redovi',
'lvl': 'Nivo',
'low': 'Nizak',
'high': 'Visok',
'ok': 'OK',
'exit_turbo_mode': 'Da li želite da izađete iz Turbo moda?',
"end": "KRAJ",
"turbo_mode_settings": "Podešavanja Turbo moda",
"stop": "STOP",
'invalid_bet_amount': 'Nevažeći iznos opklade',
'cashout_success': 'Isplata uspešna',
'stop_auto_play_first': 'Prvo zaustavite automatsku igru.',
'turbo_only_when_no_balls': 'Turbo režim se može aktivirati samo kada na tabli nema lopti.',
'type': 'Tip opklade',
'wait_balls_to_finish': 'Sačekajte da sve loptice upadnu',
'bet_too_large_top_up_turbo_balance': 'Opklada je prevelika – dopunite Turbo balans!',
};
langArr.rs = {
'loading': 'Učitavanje',
'hotkeys': 'Prečice',
'hotkeys_enabled': 'Prečice aktivne',
'enable_hotkeys_checkbox': 'Omogući prečice aktiviranjem ove opcije.',
'drop_ball': 'Ispusti lopticu',
'double_bet': 'Dupliraj ulog',
'halve_bet': 'Prepolovi ulog',
'min_bet': 'Minimalni ulog',
'max': 'Max',
'easy': 'Lako',
'medium': 'Osrednje',
'hard': 'Teško',
'daredevil': 'Izazovno',
'max_profit': 'Max Profit',
'manual': 'Ručno',
'auto': 'Automatski',
'bet_amount': 'Iznos opklade',
'difficulty': 'Težina',
'payout_on_win': 'Isplata po dobitku',
'number_of_bets': 'Broj opklada',
'on_win': 'po dobitku',
'on_loss': 'po gubitku',
'stop_on_profit': 'Prekini na profitu',
'stop_on_loss': 'Prekini na gubitku',
'reset': 'Reset',
'increase_by': 'Povećaj za',
'cashout': 'ISPLATI TIKET',
'start_game': 'UPLATI TIKET',
'start_auto_game': 'START',
'difficulity_info': 'Težina igre',
'chance_collision': 'Šansa za sudar po igri',
'evry_25_lane': 'za svih 25 traka',
'insufficiend_funds': 'Nemate dovoljno novca',
'cashout_inactivity': 'Isplata usled neaktivnosti',
'time_running_out': 'Vreme ističe! Igraj odmah ili će tvoj tiket biti isplaćen u narednih 30 sekundi',
'there_was_error': 'Dogodila se greška! Učitaj igru ponovo.',
'detailed_game_rules': 'Detaljna Pravila Igre',
'general_rules': 'OPŠTA PRAVILA',
'general_rules_p1': '• Množilac počinje sa 1 i ide do ',
'general_rules_p2': '• Dobitak se izračunava množenjem opklade sa množiteljem u trenutku klika na dugme ISPLATI TIKET.',
'general_rules_p3': '• Ako je dostignut maksimalni dobitak opklada se automatski unovčava.',
'progressive_jackpot': 'PROGRESIVNI DŽEKPOT',
'progressive_jackpot_ss': 'Džekpot traka i mogućnost osvajanja',
'progressive_jackpot_p1': '% od svakog uloga se izdvaja u fond za progresivni džekpot.',
'progressive_jackpot_p2': 'Džekpot se dodeljuje putem mehanike "Mistery" ili "must-hit-by". Vrednost svakog "must-hit-by" džekpota se određuje odmah nakon što prethodni džekpot bude osvojen, koristeći generator slučajnih brojeva. Ta vrednost se čuva kao šifrovani broj u bazi podataka, što znači da je skrivena i nepoznata.',
'progressive_jackpot_p3': 'Kada se dostigne vrednost "must-hit-by", prvi igrač koji uloži nakon toga imaće priliku da osvoji džekpot. Simbol džekpota će se pojaviti na nasumičnoj traci, a džekpot se osvaja ako igrač stigne do trake sa džekpot simbolom. Ako igrač ne stigne do trake sa simbolom džekpota zbog isplate ili sudara, sledeći igrač koji uloži videće simbol džekpota i imati priliku da ga osvoji. Ovaj proces se ponavlja dok džekpot ne bude osvojen. Samo jedan igrač/tiket može da osvoji džekpot.',
'progressive_jackpot_p4': 'NAPOMENA: Besplatne opklade tj. bonus runde ne učestvuju u fondu za progresivni džekpot. Džekpot ne može biti osvoje tokom bonus runde.',
'showdown': 'OTKRIVANJE',
'showdown_ss': 'Crveni kvadrad, mesto garantovanog sudara',
'showdown_p1': 'Nakon izvršene isplate, crveni kvadrat će biti prikazan na poziciji gde bi se sudar dogodio da je igrač nastavio sa igrom.',
'return_to_player': 'POVRAĆAJ IGRAČU',
'return_to_player_p1': 'Ukupni teoretski povraćaj igraču (RTP) je ',
'return_to_player_p2': 'Procente RTP -a stalno prate i verifikuju nezavisne treće strane.',
'disconnection_policy': 'POLITIKA POVEZIVANJA',
'disconnection_policy_p1': 'Ako se veza prekine nakon postavljanja opklade, opklada se neće poništiti. Ako je igrač neaktivan više od ',
'disconnection_policy_p2': 's opklada će biti automatski isplaćena a krediti vraćeni na račun igrača.',
'network_latency': 'KAŠNJENJA U MREŽI',
'network_latency_p1': 'Kašnjenja prilikom prenosa podataka u mreži su sastavni deo funkcionisanja interneta. Akcije Uplate i Isplate su validne onoga trenutka kada ti zahtevi stignu na server, bez obzira na to kada je igrač inicirao akciju na svojoj strani.',
'sound': 'ZVUK',
'sound_p1': 'Igra je dizajnirana sa prelepom muzikom u pozadini i zvučnim efektima. Ako želite da ugasite muziku ili zvučne efekte korisite ikone za kontrolu zvuka iz menija igre.',
'error_handling': 'U SLUČAJU GREŠKE',
'error_handling_p1': 'U slučaju greške naš tim za podršku će pokušati rešiti problem što je pre moguće. U slučaju problema sa samom igrom, sve opklade će biti poništene, a iznos uloga vraćen igračima.',
'max_payout': 'Maksimalna isplata je ',
'max_bet_is': 'Maksimalni ulog je ',
'min_bet_is': 'Minimalni ulog je ',
'per_bet': 'po opkladi.',
'malfunction_voids': 'Neispravnost u radu poništava sve isplate i igre.',
'attention_jackpot': 'Pažnja, Džekpot na traci ',
'lane': 'traka',
'congratulations': 'bravo',
'you_won': 'osvojio si',
'balance': 'balans',
'time': 'vreme',
'jackpot': 'džekpot',
'escaped': 'POBEGAO',
'max_win': 'MAX DOBITAK',
'check_internet': 'Molimo proverite internet konekciju',
'websocket_disconected': 'Websocket diskonektovan',
'websocket_connection_error': 'Websocket greska u konekciji !',
'session_expired': 'Sesija je istekla',
'remaining_bets': 'Preostale opklade',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTO-IGRA I AUTO-ISPLATA',
'autoplay_and_autocashout_ss': 'Izbor ručne i automatske igre',
'autoplay_and_autocashout_p1': 'Igrač može aktivirati opciju auto-igra gde se opklada automatski stavlja za svaku novu rundu koristeći iznos opklade iz prethodne runde. ',
'autoplay_and_autocashout_p2': 'Odabir množioca za svaku partiju se vrši sa ekran igra. Kada je množilac podešen igra će automatski izvršiti isplatu ako igrač ne doživi sudar pre nego što dostigne izabrani množilac.',
'autoplay_and_autocashout_p3': 'Maskimalan broj rundi u automatskoj igri je ',
'autoplay_button_label': 'Za pocetak, izaberi traku.',
'min_bet_amount_is': 'Min iznos opklade je',
'bonus_rounds': 'bonus runde',
'bonus_rounds_ss': 'Prikaz bonus rundi sa rokom važenja',
'bonus_rounds_p1': 'Igrač može biti nagrađen besplatnim opkladama u vidu bonus rundi tokom promocije od strane kazina. Na ekranu će iskočiti slika koja obaveštava igrača o dodeljenim besplatnim rundama, broju rundi, iznosu po opkladi i opciono roku važenja.',
'bonus_rounds_p2': 'Nakon što se dodele bonus runde, igrač može izabrati kada počinje besplatnu rundu opklade. Nakon što započne runda besplatnih opklada, postavlja se automatska opklada sa navedenim ulogom, a na igraču je da isplati u svakom trenutku.',
'bonus_rounds_p3': 'Besplatne opklade mogu imati rok važenja nakon čega ističu i ne mogu se koristiti. Rok važenja, ako postoji, je prikazan ispod bonus rundi.',
'bonus_rounds_p4': 'Neaktivnost igrača moze prouzrokovati otkazivanje aktivne bonus runde. U tom slučaju, broj bonus rundi se smanjuje a balans igrača ostaje nepromenjen.',
'valid_until': 'važi do',
'bonus': 'bonus',
'rounds': 'runda',
'win_eur': 'dobitak EUR',
'complete_your_bet': 'Prvo završite vašu opkladu',
'complete_auto_play': 'Prvo završite vašu auto-igru',
'yes': 'Da',
'no': 'Ne',
'play_bonus_rounds': 'Igraj Bonus runde?',
'bet_history': 'Istorija opklada',
'jackpot_history': 'Istorija džekpota',
'ticket_id': 'Ticket ID',
'created': 'vreme kreiranja',
'currency': 'valuta',
'bet': 'ulog',
'bet_eur': 'ulog EUR',
'lanes': 'trake',
'cars': 'automobili',
'multiplier': 'množilac',
'win': 'dobitak',
'no_betting_history': 'Istorija opklada nije pronađena. Napravite opkladu i ona će se pojaviti ovde.',
'no_jackpot_history': 'Nema dostupne istorije džekpota.',
'date': 'datum',
'user': 'igrač',
'bet_already_active': 'Opklada je već aktivna',
'please_play_the_game_in_portait_mode': 'Molim vas igrajte u portret modu.',
'bonus_history': 'Istorija bonusa',
'bonus_type': 'Tip bonusa',
'no_bonus_history': 'Nema dostupne istorije bonusa.',
'game_menu': 'MENI IGRE',
'game_menu_ss': 'Sa leva na desno: povratak na početak, istorija opklada, pravila igre, prečice, zvučni efekti, muzika',
// 'game_menu_p1': 'Kroz meni igre, igrači mogu kontrolisati opcije zvuka, prečice na tastaturi, otvoriti istoriju opklada i pravila igre.',
// 'game_menu_p2': 'Istorija oplada prikazuje prethodne opklade i istoriju bonusa.',
'game_rules': 'PRAVILA IGRE',
'game_rules_p1': 'Dobrodošli u Plinko – gde sreća vodi!',
'game_rules_p2': 'Pripremite se za uzbudljivu igru na sreću, jednostavnu i zaraznu! Plinko je igra u kojoj se kuglica ispušta na piramidu punu čepova i prati kako se odbija, okreće i skreće dok ne padne u džep sa nagradama na dnu.',
'game_rules_p3': 'Izaberite između 8 i 16 redova čepova, zatim se opustite i uživajte u haosu dok kuglica vijuga kroz tablu, vođena samo gravitacijom i srećom.',
'game_rules_p4': 'Hoće li pasti u džep sa malom isplatom… ili pogoditi veliki dobitak? Postoji samo jedan način da saznate — ispustite kuglicu i neka uzbuđenje počne!',
'general': 'OPŠTE',
'general_p1': 'Ispustite Plinko kuglicu i nadajte se da će pasti u jedan od džepova sa velikim isplatama na dnu. Putanja je nepredvidiva — svaki odskok može promeniti vašu sreću.',
'general_p2': 'Što više redova odigrate, to je akcija intenzivnija!',
'general_p3': 'Pa, samo napred — verujte u svoju sreću, pritisnite DROP i jurite veliki dobitak kroz čepove Plinka!',
'betting': 'KLAĐENJE',
'betting_p1': 'Izaberite iznos opklade. Dugmad “1/2”, “2x”, “Max” mogu se koristiti za upravljanje iznosom opklade. Iznos opklade se može uneti i ručno.',
'betting_p2': 'Izaberite nivo rizika: lak, osrednji i težak. Laki nivo rizika daje konzistentnije ishode (nisku volatilnost), dok teži donosi veću varijaciju (visoku volatilnost).',
'betting_p3': 'Izaberite broj linija u igri: od 8 do 16. Odaberite kroz koliko redova klinova lopta prolazi. Više redova = veća nepredvidivost.',
'betting_p4': 'Izaberite režim opklade: ručni ili automatski.',
'betting_p5': 'Za početak runde pritisnite dugme ISPUSTI LOPTICU. Tokom runde sva dugmad za opkladu su neaktivna osim ISPUSTI LOPTICU i iznosa opklade.',
'betting_p6': 'Jedna Plinko lopta predstavlja jednu rundu. Tokom runde može se započeti nova runda sa istim podešavanjima pomoću dugmeta ISPUSTI LOPTICU. Iznos opklade se može menjati dok su lopte aktivne, ali ne i težina igre.',
'betting_p7': 'Na kraju runde lopta stiže u džep. Na svakom džepu je prikazan multiplikator isplate.',
'betting_p8': 'Obračun dobitka se vrši prema multiplikatoru na kojem je lopta završila. Rezultat se dodaje na stanje.',
'game_menu_p1': 'Najnoviji multiplikatori opklada prikazani su u donjem delu prozora igre.',
'game_menu_p2': 'Preko dugmeta "ISTORIJA OPKLADA" igrač može detaljnije pregledati svoje poslednje opklade.',
'game_menu_p3': 'Za detaljniju istoriju igranja igrač treba da pristupi istoriji naloga unutar same platforme.',
'game_menu_p4': 'Putem menija igre igrači mogu kontrolisati zvuk, prečice na tastaturi i otvoriti istoriju opklada i pravila igre.',
'game_menu_p5': 'Igra je dizajnirana sa lepom pozadinskom muzikom i zvučnim efektima. Muzika i/ili efekti mogu se isključiti u meniju igre.',
'game_menu_p6': 'Istorija igre prikazuje prozor sa prethodnim opkladama i bonus istorijom.',
'autoplay': 'Automatski režim (Autoplay)',
'autoplay_p1': 'Klikom na Automatski omogućavate automatsko spuštanje više lopti bez ručnog klika.',
'autoplay_p2': 'Izaberite iznos koji želite da uložite po lopti.',
'autoplay_p3': 'Izaberite koliko puta (rundi) želite da se lopta spusti — maksimalno do 100 rundi.',
'autoplay_p4': 'Pritisnite START za početak, a dugme će se promeniti u STOP.',
'autoplay_p5': 'Automatski režim se zaustavlja kada se završi izabrani broj spuštanja, ponestane sredstava ili pritisnete STOP.',
'autoplay_p6': 'Svako spuštanje koristi isti iznos opklade koji ste izabrali pre pokretanja automatskog režima.',
'turbo_mode': 'Turbo režim',
'turbo_mode_p1': 'Turbo režim omogućava izuzetno brzo spuštanje lopti držanjem dugmeta ISPUSTI LOPTICU.',
'turbo_mode_p2': 'Lopte će nastaviti da padaju dok ne pustite dugme ili dok ne ponestane sredstava.',
'turbo_mode_p3': 'Lopte će nastaviti da padaju dok ne pustite dugme ili dok ne ponestane sredstava.',
'turbo_balance': 'Turbo balans',
'turbo_balance_p1': 'Pre pokretanja Turbo režima birate iznos koji izdvajate — to postaje vaš Turbo balans.',
'turbo_balance_p2': 'Dok je Turbo režim aktivan, igra koristi samo Turbo balans za opklade i dobitke.',
'turbo_balance_p3': 'Kada zaustavite Turbo režim, preostali Turbo balans se vraća na glavni balans.',
'turbo_balance_p4': 'Turbo režim možete napustiti u bilo kom trenutku — ali režim se u potpunosti završava tek kada sve lopte završe pad i slete u džepove.',
'free_bets': 'BONUS RUNDE',
'free_bets_p1': 'Bonus runde dodeljuje operater.',
'fairness': 'Pravda',
'fairness_p1': 'Svaki pad loptice određuje fer generator slučajnih brojeva (RNG).',
'fairness_p2': 'Ishod nije moguće predvideti niti uticati nakon što kuglica padne.',
'disconection_and_error': 'Politika prekida veze i rukovanje greškama',
'disconection_and_error_p1': 'Ako se veza prekine nakon postavljanja opklade, opklada se neće poništiti. Ako igra zahteva akciju igrača, rezultat se računa pod pretpostavkom da je igrač odabrao akciju bez rizika bez povećanja početne opklade.',
'disconection_and_error_p2': 'U slučaju greške naš tim za podršku će pokušati da reši problem što pre i nastavi redovnu igru. U slučaju problema sa samom igrom, sve opklade će biti poništene i ulozi vraćeni igračima.',
'other': 'Ostalo',
'other_p1': 'U slučaju kvara hardvera ili softvera igre, sve pogođene opklade i isplate postaju nevažeće i svi pogođeni ulozi se vraćaju.',
'other_p2': 'Pravila igre su objavljena na engleskom jeziku. Prevodi na druge jezike se pružaju kao usluga u dobroj veri. U slučaju nejasnoća između engleske verzije i prevoda, engleska verzija ima prioritet.',
'rows': 'Redovi',
'lvl': 'Nivo',
'low': 'Nizak',
'high': 'Visok',
'ok': 'OK',
'exit_turbo_mode': 'Da li želite da izađete iz Turbo moda?',
"end": "KRAJ",
"turbo_mode_settings": "Podešavanja Turbo moda",
"stop": "STOP",
'invalid_bet_amount': 'Nevažeći iznos opklade',
'cashout_success': 'Isplata uspešna',
'stop_auto_play_first': 'Prvo zaustavite automatsku igru.',
'turbo_only_when_no_balls': 'Turbo režim se može aktivirati samo kada na tabli nema lopti.',
'type': 'Tip opklade',
'wait_balls_to_finish': 'Sačekajte da sve loptice upadnu',
'bet_too_large_top_up_turbo_balance': 'Opklada je prevelika – dopunite Turbo balans!',
};
langArr.zh = {
'loading': '加载中',
'hotkeys': '快捷键',
'hotkeys_enabled': '快捷键已启用',
'enable_hotkeys_checkbox': '勾选此框以启用下方显示的快捷键。',
'drop_ball': '放下球',
'double_bet': '下注加倍',
'halve_bet': '下注减半',
'min_bet': '最小下注',
'max': '最大',
'easy': '简单',
'medium': '中等',
'hard': '困难',
'daredevil': '胆大',
'max_profit': '最大收益',
'manual': '手动',
'auto': '自动',
'bet_amount': '下注金额',
'difficulty': '难度',
'payout_on_win': '获胜时支付',
'number_of_bets': '下注次数',
'on_win': '获胜时',
'on_loss': '失败时',
'stop_on_profit': '盈利时停止',
'stop_on_loss': '亏损时停止',
'reset': '重置',
'increase_by': '增加',
'cashout': '提现',
'start_game': '下注',
'start_auto_game': '开始',
'difficulity_info': '难度信息',
'chance_collision': '每局碰撞概率',
'evry_25_lane': '每25条轨道',
'insufficiend_funds': '余额不足',
'cashout_inactivity': '无操作自动提现',
'time_running_out': '时间即将结束！请立即游戏，否则投注将在30秒后取消',
'there_was_error': '发生错误，请重试',
'detailed_game_rules': '详细游戏规则',
'general_rules': '基本规则',
'general_rules_p1': '• 倍率从1开始并 ',
'general_rules_p2': '• 奖金为下注金额乘以倍率。',
'general_rules_p3': '• 达到最大奖金时将自动提现。',
'progressive_jackpot': '累积奖池',
'progressive_jackpot_ss': '奖池轨道及潜在奖金',
'progressive_jackpot_p1': '每次下注的一部分将加入奖池。',
'progressive_jackpot_p2': '奖池采用“神秘”或“必出”机制。',
'progressive_jackpot_p3': '达到数值后，下一位玩家有机会赢得奖池。',
'progressive_jackpot_p4': '注意：奖励回合不计入奖池。',
'showdown': '结果展示',
'showdown_ss': '红色方块表示碰撞位置',
'showdown_p1': '提现后将显示碰撞点。',
'return_to_player': '玩家回报率',
'return_to_player_p1': '理论RTP ',
'return_to_player_p2': 'RTP由独立机构验证。',
'disconnection_policy': '断线政策',
'disconnection_policy_p1': '下注后断线不会立即取消。',
'disconnection_policy_p2': '投注将自动提现。',
'network_latency': '网络延迟',
'network_latency_p1': '服务器接收后投注即生效。',
'sound': '声音',
'sound_p1': '可在游戏菜单中关闭声音和音乐。',
'error_handling': '错误处理',
'error_handling_p1': '发生错误时由客服解决。',
'max_payout': '最大支付 ',
'max_bet_is': '最大下注 ',
'min_bet_is': '最小下注 ',
'per_bet': '每次下注。',
'malfunction_voids': '系统故障将使所有游戏无效。',
'attention_jackpot': '注意，奖池在轨道 ',
'lane': '轨道',
'congratulations': '恭喜',
'you_won': '你赢了',
'balance': '余额',
'time': '时间',
'jackpot': '奖池',
'escaped': '已躲避',
'max_win': '最高奖金',
'check_internet': '请检查网络连接',
'websocket_disconected': 'WebSocket 已断开',
'websocket_connection_error': 'WebSocket 连接错误！',
'session_expired': '会话已过期，请刷新',
'remaining_bets': '剩余下注',
'stop_autoplay': '停止',
'autoplay_and_autocashout': '自动游戏和自动提现',
'autoplay_and_autocashout_ss': '手动与自动选择',
'autoplay_and_autocashout_p1': '系统将自动下注。',
'autoplay_and_autocashout_p2': '可选择自动提现倍率。',
'autoplay_and_autocashout_p3': '最大自动回合数 ',
'autoplay_button_label': '请选择一条轨道开始。',
'min_bet_amount_is': '最小下注金额',
'bonus_rounds': '奖励回合',
'bonus_rounds_ss': '限时奖励回合',
'bonus_rounds_p1': '促销可能提供奖励回合。',
'bonus_rounds_p2': '玩家可选择开始时间。',
'bonus_rounds_p3': '奖励回合可能有时间限制。',
'bonus_rounds_p4': '无操作可能导致奖励失效。',
'valid_until': '有效期至',
'bonus': '奖励',
'rounds': '回合',
'win_eur': '赢得 EUR',
'complete_your_bet': '请先完成下注',
'complete_auto_play': '请先完成自动游戏',
'yes': '是',
'no': '否',
'play_bonus_rounds': '是否进行奖励回合？',
'bet_history': '下注历史',
'jackpot_history': '奖池历史',
'ticket_id': '票据 ID',
'created': '创建时间',
'currency': '货币',
'bet': '下注',
'bet_eur': '下注 EUR',
'lanes': '轨道',
'cars': '车辆',
'multiplier': '倍率',
'win': '赢得',
'no_betting_history': '没有下注记录。',
'no_jackpot_history': '没有奖池记录。',
'date': '日期',
'user': '用户',
'bet_already_active': '下注已激活',
'please_play_the_game_in_portait_mode': '请以竖屏模式进行游戏。',
'bonus_history': '奖励历史',
'bonus_type': '奖励类型',
'no_bonus_history': '没有奖励记录。',
'game_menu': '游戏菜单',
'game_menu_ss': '主页、历史、规则、快捷键、声音和音乐',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': '游戏规则',
'game_rules_p1': '欢迎来到Plinko——幸运主宰一切！',
'game_rules_p2': '准备好体验这款既简单又令人上瘾的刺激游戏吧！Plinko就是将一个球丢到满是钉子的金字塔上，看它弹跳、旋转、反弹，最终落入底部的奖品槽中。',
'game_rules_p3': '选择8到16排钉子，然后坐下来享受球在棋盘上在重力和运气的引导下曲折前进的混乱过程。',
'game_rules_p4': '它会落入低奖金槽……还是中大奖？只有一个办法知道——丢下球，让激动人心的时刻展开！',
'general': '通用',
'general_p1': '丢下Plinko球，希望它落入底部的高奖金槽。路径不可预测——每一次弹跳都可能改变你的命运。',
'general_p2': '玩得排数越多，动作越激烈！',
'general_p3': '所以，放手一搏，按下“DROP”，在Plinko的钉子间追逐大奖吧！',
'betting': '投注',
'betting_p1': '选择下注金额。按钮“1/2”、“2x”、“Max”可用于管理下注金额。下注金额也可以手动输入。',
'betting_p2': '选择风险等级：低、中或高。较低的风险等级提供更稳定的结果（低波动），较高的风险等级提供更大变动（高波动）。',
'betting_p3': '选择游戏线路数：8 到 16。选择小球将经过的钉子行数。更多行 = 更不可预测。',
'betting_p4': '选择下注模式：手动或自动。',
'betting_p5': '要开始游戏回合，请按 DROP BALL 按钮。回合期间，除 DROP BALL 和下注金额外，所有下注按钮将失效。',
'betting_p6': '一个 Plinko 小球代表一轮。在回合中，可以使用 DROP BALL 按钮以相同设置开始另一轮。可以在有“活跃”小球在桌上时更改下注金额，但不能更改游戏难度。',
'betting_p7': '回合结束时，小球到达口袋。每个口袋显示支付倍数。',
'betting_p8': '根据小球落入的倍数计算奖金。结果将添加到余额中。',
'game_menu_p1': '最近的下注倍数显示在游戏窗口底部。',
'game_menu_p2': '在“Bet history”按钮上，玩家可以更详细地查看最近的下注。',
'game_menu_p3': '若要查看更多的游戏历史（例如更长时间段），玩家可能需要在游戏平台内访问玩家历史记录。',
'game_menu_p4': '通过游戏菜单，玩家可以控制音效选项、快捷键，并打开下注历史和游戏规则。',
'game_menu_p5': '游戏设计有优美的背景音乐和音效。可以通过游戏菜单图标关闭音乐和/或音效。',
'game_menu_p6': '游戏历史将显示包含先前下注和奖励历史的窗口。',
'autoplay': '自动模式 (Autoplay)',
'autoplay_p1': '点击 Auto 可自动丢出若干小球，无需每次点击。',
'autoplay_p2': '选择每个小球的下注金额。',
'autoplay_p3': '选择小球丢出的次数（回合数）——最多 100 回合。',
'autoplay_p4': '按下 START 开始，按钮将变为 STOP。',
'autoplay_p5': '当达到选择的丢出次数、资金耗尽或点击 STOP 时，自动模式将停止。',
'autoplay_p6': '每次丢出使用您在启动自动模式前选择的相同下注金额。',
'turbo_mode': '极速模式',
'turbo_mode_p1': 'Turbo Drop 让您按住 DROP 按钮快速丢出小球。',
'turbo_mode_p2': '小球将继续下落，直到您松开按钮或余额用尽。',
'turbo_mode_p3': '小球将继续下落，直到您松开按钮或余额用尽。',
'turbo_balance': '极速余额',
'turbo_balance_p1': '在开始 Turbo Drop 之前，选择要预留的金额——这将成为您的极速余额。',
'turbo_balance_p2': 'Turbo Drop 活动时，游戏仅使用您的极速余额进行下注和支付。',
'turbo_balance_p3': '停止 Turbo Drop 后，剩余的极速余额将返回到主余额。',
'turbo_balance_p4': '您可以随时退出 Turbo Drop——但模式将仅在所有小球完成下落并到达倍数口袋后完全结束。',
'free_bets': '奖励回合',
'free_bets_p1': '奖励回合由运营商提供。',
'fairness': '公平性',
'fairness_p1': '每次丢球由可验证公平的随机数生成器（RNG）决定。',
'fairness_p2': '一旦丢球，结果无法预测或被操控。',
'disconection_and_error': '断线政策与错误处理',
'disconection_and_error_p1': '下注后如果断线，下注不会取消。如果游戏要求玩家操作，结果将按玩家选择无风险操作且不加注计算。',
'disconection_and_error_p2': '出现错误时，客服团队会尽快解决问题并恢复正常游戏。如游戏本身出现问题，所有投注将取消并退还下注金额。',
'other': '其他',
'other_p1': '若游戏硬件/软件出现故障，所有受影响的投注和支付将无效，且所有受影响的投注将被退款。',
'other_p2': '游戏规则以英语发布。其他语言翻译仅作为善意服务提供。如英文版与翻译有歧义，英文版优先。',
'rows': '行列',
'lvl': '等级',
'low': '低',
'high': '高',
'ok': 'OK',
'exit_turbo_mode': '您想退出 Turbo 模式吗？',
"end": "结束",
"turbo_mode_settings": "Turbo 模式设置",
"stop": "停止",
'invalid_bet_amount': '无效的下注金额',
'cashout_success': '提现成功',
'stop_auto_play_first': '请先停止自动游戏。',
'turbo_only_when_no_balls': '仅当桌上没有小球时才能激活 Turbo 模式。',
'type': '下注类型',
'wait_balls_to_finish': '请等待所有小球落下',
'bet_too_large_top_up_turbo_balance': '下注过大——请充值极速余额！',
};
langArr.hi = {
'loading': 'लोड हो रहा है',
'hotkeys': 'शॉर्टकट कुंजियाँ',
'hotkeys_enabled': 'शॉर्टकट सक्षम हैं',
'enable_hotkeys_checkbox': 'नीचे दिखाए गए शॉर्टकट सक्षम करने के लिए इस बॉक्स को चुनें।',
'drop_ball': 'गेंद छोड़ें',
'double_bet': 'दांव दोगुना करें',
'halve_bet': 'दांव आधा करें',
'min_bet': 'न्यूनतम दांव',
'max': 'अधिकतम',
'easy': 'आसान',
'medium': 'मध्यम',
'hard': 'कठिन',
'daredevil': 'निडर',
'max_profit': 'अधिकतम लाभ',
'manual': 'मैनुअल',
'auto': 'ऑटो',
'bet_amount': 'दांव राशि',
'difficulty': 'कठिनाई',
'payout_on_win': 'जीत पर भुगतान',
'number_of_bets': 'दांवों की संख्या',
'on_win': 'जीत पर',
'on_loss': 'हार पर',
'stop_on_profit': 'लाभ पर रोकें',
'stop_on_loss': 'हानि पर रोकें',
'reset': 'रीसेट',
'increase_by': 'बढ़ाएँ',
'cashout': 'निकासी',
'start_game': 'दांव लगाएँ',
'start_auto_game': 'शुरू करें',
'difficulity_info': 'कठिनाई जानकारी',
'chance_collision': 'प्रति खेल टकराव की संभावना',
'evry_25_lane': 'हर 25 लेन',
'insufficiend_funds': 'अपर्याप्त बैलेंस',
'cashout_inactivity': 'निष्क्रियता पर ऑटो निकासी',
'time_running_out': 'समय समाप्त हो रहा है! अभी खेलें या 30 सेकंड में टिकट रद्द हो जाएगा',
'there_was_error': 'कोई त्रुटि हुई, कृपया पुनः प्रयास करें',
'detailed_game_rules': 'विस्तृत खेल नियम',
'general_rules': 'सामान्य नियम',
'general_rules_p1': '• गुणक 1 से शुरू होता है और ',
'general_rules_p2': '• जीत की गणना दांव राशि × गुणक से होती है।',
'general_rules_p3': '• अधिकतम जीत पर ऑटो निकासी होती है।',
'progressive_jackpot': 'प्रोग्रेसिव जैकपॉट',
'progressive_jackpot_ss': 'जैकपॉट लेन और संभावित जीत',
'progressive_jackpot_p1': 'हर दांव का एक हिस्सा जैकपॉट फंड में जाता है।',
'progressive_jackpot_p2': 'जैकपॉट “Mystery” या “must-hit-by” मैकेनिज़्म का उपयोग करता है।',
'progressive_jackpot_p3': 'मान पूरा होने पर अगला खिलाड़ी जैकपॉट जीत सकता है।',
'progressive_jackpot_p4': 'नोट: बोनस राउंड जैकपॉट में योगदान नहीं करते।',
'showdown': 'प्रदर्शन',
'showdown_ss': 'लाल बॉक्स टकराव स्थान दिखाता है',
'showdown_p1': 'निकासी के बाद टकराव बिंदु दिखाया जाता है।',
'return_to_player': 'खिलाड़ी को वापसी',
'return_to_player_p1': 'कुल सैद्धांतिक RTP ',
'return_to_player_p2': 'RTP स्वतंत्र संस्थाओं द्वारा सत्यापित है।',
'disconnection_policy': 'डिस्कनेक्शन नीति',
'disconnection_policy_p1': 'दांव के बाद कनेक्शन कटने पर तुरंत रद्द नहीं होता।',
'disconnection_policy_p2': 'दांव ऑटो निकासी के साथ समाप्त होगा।',
'network_latency': 'नेटवर्क विलंब',
'network_latency_p1': 'सर्वर पर पहुँचते ही दांव मान्य होता है।',
'sound': 'ध्वनि',
'sound_p1': 'ध्वनि और संगीत गेम मेनू से बंद किए जा सकते हैं।',
'error_handling': 'त्रुटि प्रबंधन',
'error_handling_p1': 'त्रुटि होने पर सपोर्ट समस्या हल करता है।',
'max_payout': 'अधिकतम भुगतान ',
'max_bet_is': 'अधिकतम दांव ',
'min_bet_is': 'न्यूनतम दांव ',
'per_bet': 'प्रति दांव।',
'malfunction_voids': 'खराबी सभी खेलों को अमान्य कर देती है।',
'attention_jackpot': 'ध्यान दें, जैकपॉट लेन ',
'lane': 'लेन',
'congratulations': 'बधाई हो',
'you_won': 'आप जीते',
'balance': 'बैलेंस',
'time': 'समय',
'jackpot': 'जैकपॉट',
'escaped': 'बच गया',
'max_win': 'अधिकतम जीत',
'check_internet': 'कृपया इंटरनेट कनेक्शन जाँचें',
'websocket_disconected': 'WebSocket डिस्कनेक्ट हो गया',
'websocket_connection_error': 'WebSocket कनेक्शन त्रुटि!',
'session_expired': 'सत्र समाप्त हो गया, कृपया रिफ्रेश करें',
'remaining_bets': 'शेष दांव',
'stop_autoplay': 'रोकें',
'autoplay_and_autocashout': 'ऑटो खेल और ऑटो निकासी',
'autoplay_and_autocashout_ss': 'मैनुअल और ऑटो चयन',
'autoplay_and_autocashout_p1': 'दांव स्वतः लगाए जाते हैं।',
'autoplay_and_autocashout_p2': 'ऑटो निकासी गुणक चुना जा सकता है।',
'autoplay_and_autocashout_p3': 'अधिकतम ऑटो राउंड ',
'autoplay_button_label': 'शुरू करने के लिए एक लेन चुनें।',
'min_bet_amount_is': 'न्यूनतम दांव राशि',
'bonus_rounds': 'बोनस राउंड',
'bonus_rounds_ss': 'समय-सीमित बोनस राउंड',
'bonus_rounds_p1': 'प्रमोशन में बोनस राउंड मिल सकते हैं।',
'bonus_rounds_p2': 'खिलाड़ी शुरू करने का समय चुनता है।',
'bonus_rounds_p3': 'बोनस राउंड समयबद्ध हो सकते हैं।',
'bonus_rounds_p4': 'निष्क्रियता से बोनस रद्द हो सकता है।',
'valid_until': 'मान्य तक',
'bonus': 'बोनस',
'rounds': 'राउंड',
'win_eur': 'जीत EUR',
'complete_your_bet': 'कृपया पहले दांव पूरा करें',
'complete_auto_play': 'कृपया पहले ऑटो खेल पूरा करें',
'yes': 'हाँ',
'no': 'नहीं',
'play_bonus_rounds': 'बोनस राउंड खेलें?',
'bet_history': 'दांव इतिहास',
'jackpot_history': 'जैकपॉट इतिहास',
'ticket_id': 'टिकट ID',
'created': 'निर्माण समय',
'currency': 'मुद्रा',
'bet': 'दांव',
'bet_eur': 'दांव EUR',
'lanes': 'लेन',
'cars': 'कारें',
'multiplier': 'गुणक',
'win': 'जीत',
'no_betting_history': 'कोई दांव इतिहास नहीं।',
'no_jackpot_history': 'कोई जैकपॉट इतिहास नहीं।',
'date': 'तारीख',
'user': 'उपयोगकर्ता',
'bet_already_active': 'दांव पहले से सक्रिय है',
'please_play_the_game_in_portait_mode': 'कृपया गेम को पोर्ट्रेट मोड में खेलें।',
'bonus_history': 'बोनस इतिहास',
'bonus_type': 'बोनस प्रकार',
'no_bonus_history': 'कोई बोनस इतिहास नहीं।',
'game_menu': 'गेम मेनू',
'game_menu_ss': 'होम, इतिहास, नियम, शॉर्टकट, ध्वनि और संगीत',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'खेल के नियम',
'game_rules_p1': 'प्लिंको में आपका स्वागत है – जहाँ भाग्य मुख्य भूमिका निभाता है!',
'game_rules_p2': 'एक रोमांचक मौका खेल के लिए तैयार हो जाएं जो जितना सरल है उतना ही लत लगने वाला भी है! प्लिंको में एक गेंद को पिनों से भरे पिरामिड पर गिराना होता है और देखना होता है कि वह नीचे की ओर पुरस्कार भरे स्लॉट तक कैसे उछलती, घूमती और टकराती हुई पहुँचती है।',
'game_rules_p3': '8 से 16 पंक्तियों में से चुनें, फिर बैठ जाएं और देखें कि गेंद बोर्ड के बीच से गुरुत्वाकर्षण और भाग्य के मार्गदर्शन में zigzag करती हुई नीचे जाती है।',
'game_rules_p4': 'क्या वह कम भुगतान वाले स्लॉट में गिरेगी… या बड़ी जीत हासिल करेगी? जानने का एक ही तरीका है — गेंद गिराएं और रोमांच का आनंद लें!',
'general': 'सामान्य',
'general_p1': 'प्लिंको गेंद गिराएं और आशा करें कि वह नीचे के उच्च भुगतान वाले स्लॉट में गिरे। रास्ता अप्रत्याशित है — हर उछाल आपकी किस्मत बदल सकता है।',
'general_p2': 'जितनी अधिक पंक्तियाँ आप खेलेंगे, उतना ही अधिक रोमांच होगा!',
'general_p3': 'तो आगे बढ़ें — अपनी किस्मत पर भरोसा करें, DROP दबाएं, और प्लिंको के पिनों के बीच बड़ी जीत के पीछे भागें!',
'betting': 'शर्त लगाना',
'betting_p1': 'शर्त की राशि चुनें। “1/2”, “2x”, “Max” बटन का उपयोग शर्त का आकार प्रबंधित करने के लिए किया जा सकता है। शर्त की राशि को मैन्युअल रूप से भी दर्ज किया जा सकता है।',
'betting_p2': 'जोखिम स्तर चुनें: कम, मध्यम या उच्च। कम जोखिम स्तर अधिक स्थिर परिणाम देता है (कम अस्थिरता), जबकि उच्च जोखिम स्तर अधिक विविधता देता है (उच्च अस्थिरता)।',
'betting_p3': 'खेल में लाइनों की संख्या चुनें: 8 से 16 तक। चुनें कि गेंद कितनी पिन की पंक्तियों से गिरेगी। अधिक पंक्तियाँ = अधिक अनिश्चितता।',
'betting_p4': 'शर्त मोड चुनें: मैनुअल या ऑटो।',
'betting_p5': 'खेल राउंड शुरू करने के लिए DROP BALL बटन दबाएँ। राउंड के दौरान, सभी शर्त बटन निष्क्रिय हो जाते हैं, सिवाय DROP BALL और शर्त राशि के।',
'betting_p6': 'एक Plinko गेंद एक राउंड का प्रतिनिधित्व करती है। राउंड के दौरान, DROP BALL बटन का उपयोग करके उसी सेटिंग्स के साथ एक और राउंड शुरू किया जा सकता है। जब बोर्ड पर "सक्रिय" गेंदें हों, तब शर्त राशि बदलना संभव है, लेकिन खेल की कठिनाई नहीं।',
'betting_p7': 'राउंड के अंत में, गेंद पॉकेट तक पहुँचती है। प्रत्येक पॉकेट पर भुगतान गुणांक दिखाया जाता है।',
'betting_p8': 'जीत की गणना उस गुणांक के अनुसार की जाती है जहाँ गेंद गिरी। परिणाम बैलेंस में जोड़ा जाता है।',
'game_menu_p1': 'हाल की शर्त गुणांक खेल विंडो के नीचे दिखाई देती हैं।',
'game_menu_p2': '“Bet history” बटन पर क्लिक करके खिलाड़ी अपनी हाल की शर्तों को अधिक विवरण में देख सकता है।',
'game_menu_p3': 'अधिक खेल इतिहास (जैसे, लंबे समय की अवधि) के लिए, खिलाड़ी को गेमिंग प्लेटफ़ॉर्म के भीतर खिलाड़ी इतिहास तक पहुँचने की आवश्यकता हो सकती है।',
'game_menu_p4': 'खेल मेनू के माध्यम से, खिलाड़ी ध्वनि विकल्पों, कीबोर्ड शॉर्टकट्स को नियंत्रित कर सकते हैं, और शर्त इतिहास तथा खेल नियम खोल सकते हैं।',
'game_menu_p5': 'खेल को सुंदर पृष्ठभूमि संगीत और ध्वनि प्रभावों के साथ डिज़ाइन किया गया है। संगीत और/या ध्वनि प्रभाव खेल मेनू आइकन के माध्यम से अक्षम किए जा सकते हैं।',
'game_menu_p6': 'खेल इतिहास पिछले शर्तों और बोनस इतिहास वाली विंडो दिखाएगा।',
'autoplay': 'स्वचालित मोड (Autoplay)',
'autoplay_p1': 'Auto पर क्लिक करके आप प्रत्येक बार क्लिक किए बिना स्वतः गेंद गिरा सकते हैं।',
'autoplay_p2': 'प्रत्येक गेंद पर लगाने के लिए राशि चुनें।',
'autoplay_p3': 'चुनें कि आप कितनी बार (राउंड) गेंद गिराना चाहते हैं — अधिकतम 100 राउंड।',
'autoplay_p4': 'शुरू करने के लिए START बटन दबाएँ और बटन STOP में बदल जाएगा।',
'autoplay_p5': 'चयनित गिरावट संख्या पूरी होने, धन समाप्त होने या STOP बटन दबाने पर ऑटो मोड बंद हो जाएगा।',
'autoplay_p6': 'प्रत्येक गिरावट उसी शर्त राशि का उपयोग करती है जिसे आपने ऑटो मोड शुरू करने से पहले चुना था।',
'turbo_mode': 'टर्बो मोड',
'turbo_mode_p1': 'Turbo Drop आपको DROP बटन दबाए रखने से गेंदें बहुत तेज़ी से गिराने देता है।',
'turbo_mode_p2': 'जब तक आप बटन छोड़ते नहीं हैं या बैलेंस खत्म नहीं होता, गेंदें गिरती रहेंगी।',
'turbo_mode_p3': 'जब तक आप बटन छोड़ते नहीं हैं या बैलेंस खत्म नहीं होता, गेंदें गिरती रहेंगी।',
'turbo_balance': 'टर्बो बैलेंस',
'turbo_balance_p1': 'Turbo Drop शुरू करने से पहले, तय करें कि कितनी राशि अलग रखनी है — यह आपका टर्बो बैलेंस बन जाता है।',
'turbo_balance_p2': 'Turbo Drop सक्रिय होने पर, खेल केवल आपके टर्बो बैलेंस का उपयोग शर्तों और जीत के लिए करता है।',
'turbo_balance_p3': 'जब आप Turbo Drop बंद करते हैं, तो कोई भी शेष टर्बो बैलेंस आपके मुख्य बैलेंस में वापस आ जाता है।',
'turbo_balance_p4': 'आप किसी भी समय Turbo Drop से बाहर निकल सकते हैं — लेकिन मोड तभी पूरी तरह समाप्त होगा जब सभी गेंदें गिरना समाप्त कर दें और गुणांक पॉकेट में पहुँच जाएँ।',
'free_bets': 'बोनस राउंड',
'free_bets_p1': 'बोनस राउंड ऑपरेटर द्वारा प्रदान किए जाते हैं।',
'fairness': 'न्यायसंगतता',
'fairness_p1': 'प्रत्येक ड्रॉप एक प्रमाणित निष्पक्ष रैंडम नंबर जनरेटर (RNG) द्वारा निर्धारित होता है।',
'fairness_p2': 'गेंद गिराने के बाद परिणाम की भविष्यवाणी या प्रभाव संभव नहीं है।',
'disconection_and_error': 'डिस्कनेक्शन नीति और त्रुटि प्रबंधन',
'disconection_and_error_p1': 'यदि दांव लगाने के बाद कनेक्शन खो जाता है, तो दांव रद्द नहीं किया जाएगा। यदि खेल खिलाड़ी से कार्रवाई चाहता है, तो परिणाम यह मानकर गिना जाएगा कि खिलाड़ी ने बिना अतिरिक्त दांव लगाए जोखिम मुक्त कार्रवाई चुनी है।',
'disconection_and_error_p2': 'त्रुटि की स्थिति में हमारी सहायता टीम समस्या को यथाशीघ्र हल करने का प्रयास करेगी और सामान्य खेल जारी रखेगी। खेल में समस्या होने पर सभी दांव रद्द कर दिए जाएंगे और दांव की राशि खिलाड़ियों को लौटाई जाएगी।',
'other': 'अन्य',
'other_p1': 'यदि गेमिंग हार्डवेयर/सॉफ्टवेयर में खराबी होती है, तो सभी प्रभावित दांव और भुगतान अमान्य घोषित किए जाएंगे और सभी प्रभावित दांव वापसी की जाएगी।',
'other_p2': 'खेल के नियम अंग्रेज़ी में प्रकाशित हैं। अन्य भाषाओं में अनुवाद एक सद्भावना सेवा के रूप में प्रदान किए जाते हैं। अंग्रेज़ी संस्करण और अनुवाद के बीच किसी भी अस्पष्टता की स्थिति में अंग्रेज़ी संस्करण को प्राथमिकता दी जाती है।',
'rows': 'पंक्तियाँ',
'lvl': 'स्तर',
'low': 'निम्न',
'high': 'उच्च',
'ok': 'OK',
'exit_turbo_mode': 'क्या आप टर्बो मोड से बाहर निकलना चाहते हैं?',
"end": "समाप्त",
"turbo_mode_settings": "टर्बो मोड सेटिंग्स",
"stop": "रोकें",
'invalid_bet_amount': 'अमान्य दांव राशि',
'cashout_success': 'निकासी सफल',
'stop_auto_play_first': 'कृपया पहले ऑटो खेल रोकें।',
'turbo_only_when_no_balls': 'टर्बो मोड केवल तब सक्रिय किया जा सकता है जब बोर्ड पर कोई गेंद न हो।',
'type': 'दांव प्रकार',
'wait_balls_to_finish': 'कृपया सभी गेंदों के गिरने का इंतजार करें',
'bet_too_large_top_up_turbo_balance': 'दांव बहुत बड़ा है — कृपया टर्बो बैलेंस रिचार्ज करें!',
};
langArr.cs = {
'loading': 'Načítání',
'hotkeys': 'Klávesové zkratky',
'hotkeys_enabled': 'Klávesové zkratky povoleny',
'enable_hotkeys_checkbox': 'Zaškrtnutím tohoto pole povolíte níže zobrazené klávesové zkratky.',
'drop_ball': 'Pustit míček',
'double_bet': 'Zdvojnásobit sázku',
'halve_bet': 'Snížit sázku na polovinu',
'min_bet': 'Minimální sázka',
'max': 'Max',
'easy': 'Snadné',
'medium': 'Střední',
'hard': 'Těžké',
'daredevil': 'Hazardér',
'max_profit': 'Maximální zisk',
'manual': 'Manuální',
'auto': 'Auto',
'bet_amount': 'Výše sázky',
'difficulty': 'Obtížnost',
'payout_on_win': 'Výplata při výhře',
'number_of_bets': 'Počet sázek',
'on_win': 'Při výhře',
'on_loss': 'Při prohře',
'stop_on_profit': 'Zastavit při zisku',
'stop_on_loss': 'Zastavit při ztrátě',
'reset': 'Reset',
'increase_by': 'Zvýšit o',
'cashout': 'VÝBĚR',
'start_game': 'SÁZKA',
'start_auto_game': 'START',
'difficulity_info': 'Informace o obtížnosti',
'chance_collision': 'Pravděpodobnost kolize na hru',
'evry_25_lane': 'na každých 25 drah',
'insufficiend_funds': 'Nedostatek prostředků',
'cashout_inactivity': 'Automatický výběr při neaktivitě',
'time_running_out': 'Čas se krátí! Hrajte nyní nebo bude tiket automaticky zrušen za 30 sekund',
'there_was_error': 'DOŠLO K CHYBĚ, ZKUSTE TO ZNOVU NEBO OBNOVTE STRÁNKU',
'detailed_game_rules': 'Podrobná pravidla hry',
'general_rules': 'OBECNÁ PRAVIDLA',
'general_rules_p1': '• Násobitel začíná na 1 a ',
'general_rules_p2': '• Výhra se vypočítá jako vklad vynásobený zobrazeným násobitelem.',
'general_rules_p3': '• Po dosažení maximální výplaty dojde k automatickému výběru.',
'progressive_jackpot': 'PROGRESIVNÍ JACKPOT',
'progressive_jackpot_ss': 'Jackpotová dráha a možná výhra',
'progressive_jackpot_p1': 'Část každé sázky je přidána do jackpotového fondu.',
'progressive_jackpot_p2': 'Jackpot používá mechaniku „Mystery“ nebo „must-hit-by“.',
'progressive_jackpot_p3': 'Po dosažení hodnoty má další hráč šanci vyhrát jackpot.',
'progressive_jackpot_p4': 'POZNÁMKA: Bonusová kola nepřispívají do jackpotu.',
'showdown': 'ODHALENÍ',
'showdown_ss': 'Červený čtverec označuje místo kolize',
'showdown_p1': 'Po výběru se zobrazí místo možné kolize.',
'return_to_player': 'NÁVRATNOST HRÁČI',
'return_to_player_p1': 'Celková teoretická RTP je ',
'return_to_player_p2': 'RTP je průběžně ověřována nezávislými stranami.',
'disconnection_policy': 'POLITIKA ODPOJENÍ',
'disconnection_policy_p1': 'Pokud dojde ke ztrátě spojení po vsazení, sázka nebude okamžitě zrušena.',
'disconnection_policy_p2': 'sázka bude automaticky vybrána.',
'network_latency': 'SÍŤOVÁ LATENCE',
'network_latency_p1': 'Sázky a výběry jsou platné v okamžiku doručení na server.',
'sound': 'ZVUK',
'sound_p1': 'Hudbu a zvukové efekty lze vypnout v herním menu.',
'error_handling': 'ZPRACOVÁNÍ CHYB',
'error_handling_p1': 'V případě chyby se podpora pokusí problém co nejrychleji vyřešit.',
'max_payout': 'Maximální výplata je ',
'max_bet_is': 'Maximální sázka je ',
'min_bet_is': 'Minimální sázka je ',
'per_bet': 'na sázku.',
'malfunction_voids': 'Porucha ruší všechny výhry a hry.',
'attention_jackpot': 'Pozor, jackpot na dráze ',
'lane': 'dráha',
'congratulations': 'gratulujeme',
'you_won': 'vyhráli jste',
'balance': 'zůstatek',
'time': 'čas',
'jackpot': 'jackpot',
'escaped': 'UNIKL',
'max_win': 'MAXIMÁLNÍ VÝHRA',
'check_internet': 'Zkontrolujte připojení k internetu',
'websocket_disconected': 'WebSocket odpojen',
'websocket_connection_error': 'Chyba připojení WebSocket!',
'session_expired': 'Relace vypršela, obnovte stránku',
'remaining_bets': 'Zbývající sázky',
'stop_autoplay': 'ZASTAVIT',
'autoplay_and_autocashout': 'AUTOPLAY A AUTO VÝBĚR',
'autoplay_and_autocashout_ss': 'Volba mezi manuálním a automatickým režimem',
'autoplay_and_autocashout_p1': 'Sázky jsou automaticky umístěny v každém kole.',
'autoplay_and_autocashout_p2': 'Lze zvolit automatický násobitel výběru.',
'autoplay_and_autocashout_p3': 'Maximální počet automatických kol je ',
'autoplay_button_label': 'Pro zahájení vyberte dráhu.',
'min_bet_amount_is': 'Minimální výše sázky je',
'bonus_rounds': 'bonusová kola',
'bonus_rounds_ss': 'Bonusová kola s dobou platnosti',
'bonus_rounds_p1': 'Bonusová kola mohou být udělena v rámci promoakce.',
'bonus_rounds_p2': 'Hráč si může zvolit, kdy bonusová kola zahájí.',
'bonus_rounds_p3': 'Bonusová kola mohou mít časové omezení.',
'bonus_rounds_p4': 'Neaktivita hráče může vést ke zrušení bonusových kol.',
'valid_until': 'platné do',
'bonus': 'bonus',
'rounds': 'kola',
'win_eur': 'výhra EUR',
'complete_your_bet': 'Nejprve dokončete sázku',
'complete_auto_play': 'Nejprve dokončete automatickou hru',
'yes': 'ano',
'no': 'ne',
'play_bonus_rounds': 'Hrát bonusová kola?',
'bet_history': 'Historie sázek',
'jackpot_history': 'Historie jackpotů',
'ticket_id': 'ID tiketu',
'created': 'čas vytvoření',
'currency': 'měna',
'bet': 'sázka',
'bet_eur': 'sázka EUR',
'lanes': 'dráhy',
'cars': 'auta',
'multiplier': 'násobitel',
'win': 'výhra',
'no_betting_history': 'Nenalezena žádná historie sázek.',
'no_jackpot_history': 'Žádná historie jackpotů.',
'date': 'datum',
'user': 'uživatel',
'bet_already_active': 'Sázka je již aktivní',
'please_play_the_game_in_portait_mode': 'Hrajte prosím hru v portrétním režimu.',
'bonus_history': 'Historie bonusů',
'bonus_type': 'Typ bonusu',
'no_bonus_history': 'Žádná historie bonusů.',
'game_menu': 'Herní menu',
'game_menu_ss': 'Domů, Historie sázek, Pravidla hry, Klávesové zkratky, Zvuk, Hudba',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'PRAVIDLA HRY',
'game_rules_p1': 'Vítejte v Plinku – kde vede štěstí!',
'game_rules_p2': 'Připravte se na napínavou hru náhody, která je stejně jednoduchá jako návyková! Plinko spočívá v tom, že pustíte kuličku na pyramidu plnou kolíků a sledujete, jak poskakuje, točí se a odráží se dolů k cenovému slotu na spodku.',
'game_rules_p3': 'Vyberte si mezi 8 až 16 řadami kolíků, pak se posaďte a užijte si chaos, kdy kulička kličkuje skrz desku, řízena jen gravitací a štěstím.',
'game_rules_p4': 'Padne do slotu s nízkou výhrou… nebo trefí velkou výhru? Existuje jen jeden způsob, jak to zjistit — pusťte kuličku a nechte vzrušení rozvinout!',
'general': 'OBECNÉ',
'general_p1': 'Pusťte Plinko kuličku a doufejte, že skončí v některém z vysoce placených slotů dole. Cesta je nepředvídatelná — každý odskok může změnit vaše štěstí.',
'general_p2': 'Čím více řad hrajete, tím intenzivnější akce!',
'general_p3': 'Tak směle do toho — věřte svému štěstí, stiskněte DROP a pronásledujte velkou výhru mezi kolíky Plinka!',
'betting': 'SÁZENÍ',
'betting_p1': 'Vyberte částku sázky. Tlačítka “1/2”, “2x”, “Max” lze použít k řízení velikosti sázky. Hodnotu sázky lze zadat také ručně.',
'betting_p2': 'Vyberte úroveň rizika: Nízká, Střední nebo Vysoká. Nižší úroveň rizika poskytuje konzistentnější výsledky (nízká volatilita), zatímco vyšší úroveň poskytuje větší rozptyl (vysoká volatilita).',
'betting_p3': 'Vyberte počet herních řad: od 8 do 16. Vyberte, kolik řad kolíků projde míček. Více řad = větší nepředvídatelnost.',
'betting_p4': 'Vyberte režim sázky: Manuální nebo Auto.',
'betting_p5': 'Pro spuštění kola hry stiskněte tlačítko DROP BALL. Během kola jsou všechna sázková tlačítka neaktivní kromě DROP BALL a částky sázky.',
'betting_p6': 'Jedna Plinko koule představuje jedno kolo. Během kola lze pomocí tlačítka DROP BALL zahájit další kolo se stejným nastavením. Je možné změnit částku sázky, pokud jsou na stole "aktivní" koule, ale ne obtížnost hry.',
'betting_p7': 'Na konci kola míček dosáhne kapsy. Na každé kapse je zobrazen výplatní násobitel.',
'betting_p8': 'Výhra se počítá podle násobitele, na který míček dopadl. Výsledek se přidá k zůstatku.',
'game_menu_p1': 'Nejnovější násobitele sázek zobrazí spodní část herního okna.',
'game_menu_p2': 'Pomocí tlačítka “Bet history” může hráč podrobněji prohlédnout své poslední sázky.',
'game_menu_p3': 'Pro delší herní historii (např. delší období) může hráč potřebovat přístup k historii hráče přímo na herní platformě.',
'game_menu_p4': 'Pomocí herního menu mohou hráči ovládat zvukové možnosti, klávesové zkratky a otevřít historii sázek a herní pravidla.',
'game_menu_p5': 'Hra je navržena s krásnou hudbou na pozadí a zvukovými efekty. Hudbu a/nebo zvukové efekty lze vypnout přes ikony v herním menu.',
'game_menu_p6': 'Historie hry zobrazí okno s předchozími sázkami a historií bonusů.',
'autoplay': 'Automatický režim (Autoplay)',
'autoplay_p1': 'Kliknutím na Auto můžete automaticky pustit několik koulí, aniž byste museli kliknout pokaždé.',
'autoplay_p2': 'Vyberte částku, kterou chcete vsadit na jednu kouli.',
'autoplay_p3': 'Vyberte, kolikrát (kol) chcete kouli pustit — maximálně 100 kol.',
'autoplay_p4': 'Stiskněte tlačítko START pro spuštění a tlačítko se změní na STOP.',
'autoplay_p5': 'Automatický režim se zastaví, když bude dokončen vybraný počet poklesů, dojdou prostředky nebo stisknete STOP.',
'autoplay_p6': 'Každý pokles používá stejnou sázku, kterou jste vybrali před spuštěním automatického režimu.',
'turbo_mode': 'Turbo režim',
'turbo_mode_p1': 'Turbo Drop umožňuje rychle pouštět koule podržením tlačítka DROP.',
'turbo_mode_p2': 'Koule budou padat, dokud neuvolníte tlačítko nebo nedojde zůstatek.',
'turbo_mode_p3': 'Koule budou padat, dokud neuvolníte tlačítko nebo nedojde zůstatek.',
'turbo_balance': 'Turbo zůstatek',
'turbo_balance_p1': 'Před spuštěním Turbo Drop vyberte, kolik peněz chcete vyhradit — to se stane vaším Turbo zůstatkem.',
'turbo_balance_p2': 'Když je Turbo Drop aktivní, hra používá pouze váš Turbo zůstatek pro sázky a výhry.',
'turbo_balance_p3': 'Když zastavíte Turbo Drop, zůstatek Turbo se vrátí na hlavní zůstatek.',
'turbo_balance_p4': 'Z Turbo Drop můžete kdykoli odejít — režim bude zcela ukončen až poté, co všechny koule dokončí pád a dorazí do kapsy s násobiteli.',
'free_bets': 'BONUSOVÁ KOLA',
'free_bets_p1': 'Bonusová kola poskytuje provozovatel.',
'fairness': 'Spravedlnost',
'fairness_p1': 'Každý pád je určen prokazatelně spravedlivým generátorem náhodných čísel (RNG).',
'fairness_p2': 'Výsledek nelze po spuštění kuličky předvídat nebo ovlivnit.',
'disconection_and_error': 'Pravidla odpojení a řešení chyb',
'disconection_and_error_p1': 'Pokud dojde k odpojení po vsazení, sázka nebude zrušena. Pokud hra vyžaduje akci hráče, výsledek se počítá s předpokladem, že hráč zvolil akci bez rizika bez zvýšení původní sázky.',
'disconection_and_error_p2': 'V případě chyby se náš tým podpory pokusí problém co nejdříve vyřešit a pokračovat v běžné hře. Pokud je problém s hrou samotnou, všechny sázky budou zrušeny a vsazené částky vráceny hráčům.',
'other': 'Ostatní',
'other_p1': 'V případě selhání herního hardwaru/software jsou všechny ovlivněné sázky a výplaty neplatné a všechny ovlivněné sázky jsou vráceny.',
'other_p2': 'Pravidla hry jsou zveřejněna v angličtině. Překlady do jiných jazyků jsou poskytovány jako služba v dobré víře. V případě nejasností mezi anglickou verzí a překladem má přednost anglická verze.',
'rows': 'Řádky',
'lvl': 'Úroveň',
'low': 'Nízký',
'high': 'Vysoký',
'ok': 'OK',
'exit_turbo_mode': 'Chcete opustit Turbo režim?',
"end": "Konec",
"turbo_mode_settings": "Nastavení Turbo režimu",
"stop": "ZASTAVIT",
'invalid_bet_amount': 'Neplatná výše sázky',
'cashout_success': 'Výběr proběhl úspěšně',
'stop_auto_play_first': 'Nejprve zastavte automatickou hru.',
'turbo_only_when_no_balls': 'Turbo režim lze aktivovat pouze, když na stole nejsou žádné koule.',
'type': 'Typ sázky',
'wait_balls_to_finish': 'Počkejte prosím, až všechny koule dokončí pád',
'bet_too_large_top_up_turbo_balance': 'Sázka je příliš vysoká — doplňte prosím Turbo zůstatek!',
};
langArr.id = {
'loading': 'Memuat',
'hotkeys': 'Tombol pintas',
'hotkeys_enabled': 'Tombol pintas diaktifkan',
'enable_hotkeys_checkbox': 'Aktifkan tombol pintas di bawah dengan mencentang kotak ini.',
'drop_ball': 'Jatuhkan bola',
'double_bet': 'Gandakan taruhan',
'halve_bet': 'Kurangi taruhan setengah',
'min_bet': 'Taruhan minimum',
'max': 'Maks',
'easy': 'Mudah',
'medium': 'Sedang',
'hard': 'Sulit',
'daredevil': 'Nekat',
'max_profit': 'Keuntungan maksimum',
'manual': 'Manual',
'auto': 'Otomatis',
'bet_amount': 'Jumlah taruhan',
'difficulty': 'Tingkat kesulitan',
'payout_on_win': 'Pembayaran saat menang',
'number_of_bets': 'Jumlah taruhan',
'on_win': 'Saat menang',
'on_loss': 'Saat kalah',
'stop_on_profit': 'Hentikan saat untung',
'stop_on_loss': 'Hentikan saat rugi',
'reset': 'Atur ulang',
'increase_by': 'Tingkatkan sebesar',
'cashout': 'TARIK',
'start_game': 'PASANG TARUHAN',
'start_auto_game': 'MULAI',
'difficulity_info': 'Informasi tingkat kesulitan',
'chance_collision': 'Peluang tabrakan per permainan',
'evry_25_lane': 'setiap 25 jalur',
'insufficiend_funds': 'Dana tidak mencukupi',
'cashout_inactivity': 'Penarikan otomatis karena tidak aktif',
'time_running_out': 'Waktu hampir habis! Mainkan sekarang atau tiket akan ditarik otomatis dalam 30 detik',
'there_was_error': 'TERJADI KESALAHAN, SILAKAN COBA LAGI ATAU MUAT ULANG',
'detailed_game_rules': 'Aturan permainan lengkap',
'general_rules': 'ATURAN UMUM',
'general_rules_p1': '• Pengganda dimulai dari 1 dan ',
'general_rules_p2': '• Kemenangan dihitung dari taruhan dikalikan pengganda.',
'general_rules_p3': '• Jika pembayaran maksimum tercapai, penarikan otomatis dilakukan.',
'progressive_jackpot': 'JACKPOT PROGRESIF',
'progressive_jackpot_ss': 'Jalur jackpot dan kemungkinan kemenangan',
'progressive_jackpot_p1': 'Sebagian dari setiap taruhan dimasukkan ke dana jackpot.',
'progressive_jackpot_p2': 'Jackpot menggunakan mekanisme “Mystery” atau “must-hit-by”.',
'progressive_jackpot_p3': 'Setelah nilai tercapai, pemain berikutnya berkesempatan menang.',
'progressive_jackpot_p4': 'CATATAN: Putaran bonus tidak berkontribusi pada jackpot.',
'showdown': 'HASIL',
'showdown_ss': 'Kotak merah menunjukkan lokasi tabrakan',
'showdown_p1': 'Setelah penarikan, lokasi tabrakan akan ditampilkan.',
'return_to_player': 'PENGEMBALIAN KE PEMAIN',
'return_to_player_p1': 'Total RTP teoritis adalah ',
'return_to_player_p2': 'RTP diverifikasi oleh pihak independen.',
'disconnection_policy': 'KEBIJAKAN KONEKSI TERPUTUS',
'disconnection_policy_p1': 'Jika koneksi terputus setelah taruhan, taruhan tidak langsung dibatalkan.',
'disconnection_policy_p2': 'taruhan akan ditarik secara otomatis.',
'network_latency': 'LATENSI JARINGAN',
'network_latency_p1': 'Taruhan dan penarikan sah saat diterima server.',
'sound': 'SUARA',
'sound_p1': 'Musik dan efek suara dapat dimatikan melalui menu permainan.',
'error_handling': 'PENANGANAN KESALAHAN',
'error_handling_p1': 'Jika terjadi kesalahan, tim dukungan akan segera menangani.',
'max_payout': 'Pembayaran maksimum adalah ',
'max_bet_is': 'Taruhan maksimum adalah ',
'min_bet_is': 'Taruhan minimum adalah ',
'per_bet': 'per taruhan.',
'malfunction_voids': 'Kerusakan membatalkan semua permainan dan pembayaran.',
'attention_jackpot': 'Perhatian, jackpot di jalur ',
'lane': 'jalur',
'congratulations': 'selamat',
'you_won': 'anda menang',
'balance': 'saldo',
'time': 'waktu',
'jackpot': 'jackpot',
'escaped': 'LOLOS',
'max_win': 'KEMENANGAN MAKSIMAL',
'check_internet': 'Silakan periksa koneksi internet Anda',
'websocket_disconected': 'WebSocket terputus',
'websocket_connection_error': 'Kesalahan koneksi WebSocket!',
'session_expired': 'Sesi telah berakhir, silakan muat ulang',
'remaining_bets': 'Sisa taruhan',
'stop_autoplay': 'HENTIKAN',
'autoplay_and_autocashout': 'AUTOPLAY DAN PENARIKAN OTOMATIS',
'autoplay_and_autocashout_ss': 'Pilihan antara manual dan autoplay',
'autoplay_and_autocashout_p1': 'Taruhan akan dipasang otomatis di setiap ronde.',
'autoplay_and_autocashout_p2': 'Pengganda penarikan otomatis dapat dipilih.',
'autoplay_and_autocashout_p3': 'Jumlah maksimum ronde otomatis adalah ',
'autoplay_button_label': 'Pilih jalur untuk memulai.',
'min_bet_amount_is': 'Jumlah taruhan minimum adalah',
'bonus_rounds': 'putaran bonus',
'bonus_rounds_ss': 'Putaran bonus dengan masa berlaku',
'bonus_rounds_p1': 'Putaran bonus dapat diberikan melalui promosi.',
'bonus_rounds_p2': 'Pemain dapat memilih kapan memulai.',
'bonus_rounds_p3': 'Putaran bonus dapat memiliki batas waktu.',
'bonus_rounds_p4': 'Ketidakaktifan dapat membatalkan putaran bonus.',
'valid_until': 'berlaku hingga',
'bonus': 'bonus',
'rounds': 'putaran',
'win_eur': 'menang EUR',
'complete_your_bet': 'Silakan selesaikan taruhan terlebih dahulu',
'complete_auto_play': 'Silakan selesaikan autoplay terlebih dahulu',
'yes': 'ya',
'no': 'tidak',
'play_bonus_rounds': 'Mainkan putaran bonus?',
'bet_history': 'Riwayat taruhan',
'jackpot_history': 'Riwayat jackpot',
'ticket_id': 'ID tiket',
'created': 'waktu dibuat',
'currency': 'mata uang',
'bet': 'taruhan',
'bet_eur': 'taruhan EUR',
'lanes': 'jalur',
'cars': 'mobil',
'multiplier': 'pengganda',
'win': 'menang',
'no_betting_history': 'Tidak ada riwayat taruhan.',
'no_jackpot_history': 'Tidak ada riwayat jackpot.',
'date': 'tanggal',
'user': 'pengguna',
'bet_already_active': 'Taruhan sudah aktif',
'please_play_the_game_in_portait_mode': 'Silakan mainkan game dalam mode potret.',
'bonus_history': 'Riwayat bonus',
'bonus_type': 'Jenis bonus',
'no_bonus_history': 'Tidak ada riwayat bonus.',
'game_menu': 'Menu permainan',
'game_menu_ss': 'Beranda, Riwayat Taruhan, Aturan Permainan, Pintasan Keyboard, Suara, Musik',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'ATURAN PERMAINAN',
'game_rules_p1': 'Selamat datang di Plinko – Tempat Keberuntungan Memimpin!',
'game_rules_p2': 'Bersiaplah untuk permainan peluang yang mendebarkan dan semudah itu membuat ketagihan! Plinko adalah tentang menjatuhkan bola ke piramida berisi pasak dan menyaksikannya memantul, berputar, dan memantul turun ke slot hadiah di bawah.',
'game_rules_p3': 'Pilih antara 8 hingga 16 baris pasak, lalu duduk dan nikmati kekacauan saat bola berzigzag melalui papan, dipandu hanya oleh gravitasi dan keberuntungan.',
'game_rules_p4': 'Apakah bola akan jatuh ke slot dengan pembayaran rendah… atau mendapatkan kemenangan besar? Hanya ada satu cara untuk mengetahuinya — jatuhkan bola dan biarkan keseruan berlangsung!',
'general': 'UMUM',
'general_p1': 'Jatuhkan bola Plinko dan berharap itu jatuh ke salah satu slot dengan pembayaran tinggi di bawah. Jalannya tidak dapat diprediksi — setiap pantulan dapat mengubah keberuntungan Anda.',
'general_p2': 'Semakin banyak baris yang Anda mainkan, semakin intens aksinya!',
'general_p3': 'Jadi lanjutkan — percayalah pada keberuntungan Anda, tekan DROP, dan kejar kemenangan besar melalui pasak Plinko!',
'betting': 'PENEMPATAN TARUHAN',
'betting_p1': 'Pilih jumlah taruhan. Tombol “1/2”, “2x”, “Max” dapat digunakan untuk mengatur ukuran taruhan. Nilai taruhan juga dapat dimasukkan secara manual.',
'betting_p2': 'Pilih Tingkat Risiko: Rendah, Sedang, atau Tinggi. Tingkat risiko rendah memberikan hasil lebih konsisten (volatilitas rendah), sedangkan tingkat risiko tinggi memberikan lebih banyak variasi (volatilitas tinggi).',
'betting_p3': 'Pilih jumlah garis dalam permainan: dari 8 hingga 16. Pilih berapa baris pin yang akan dilalui bola. Semakin banyak baris = semakin tidak dapat diprediksi.',
'betting_p4': 'Pilih Mode Taruhan: Manual atau Otomatis.',
'betting_p5': 'Untuk memulai ronde permainan, tekan tombol DROP BALL. Selama ronde, semua tombol taruhan menjadi tidak aktif kecuali DROP BALL dan jumlah taruhan.',
'betting_p6': 'Satu bola Plinko mewakili satu ronde. Selama ronde, ronde lain dengan pengaturan yang sama dapat dimulai menggunakan tombol DROP BALL. Bisa mengubah jumlah taruhan saat ada bola “aktif” di papan, tetapi tidak dapat mengubah tingkat kesulitan permainan.',
'betting_p7': 'Di akhir ronde, bola mencapai kantong. Pada setiap kantong ditampilkan pengali pembayaran.',
'betting_p8': 'Perhitungan kemenangan dilakukan sesuai dengan pengali tempat bola mendarat. Hasilnya ditambahkan ke saldo.',
'game_menu_p1': 'Pengali taruhan terbaru ditampilkan di bagian bawah jendela permainan.',
'game_menu_p2': 'Pada tombol “Bet history”, pemain dapat meninjau taruhan terakhir mereka secara lebih rinci.',
'game_menu_p3': 'Untuk riwayat permainan lebih lama (mis. periode lebih panjang), pemain mungkin perlu mengakses riwayat pemain di dalam platform permainan.',
'game_menu_p4': 'Melalui menu permainan, pemain dapat mengatur opsi suara, pintasan keyboard, dan membuka riwayat taruhan serta aturan permainan.',
'game_menu_p5': 'Permainan dirancang dengan musik latar dan efek suara yang indah. Musik dan/atau efek suara dapat dinonaktifkan melalui ikon menu permainan.',
'game_menu_p6': 'Riwayat permainan akan menampilkan jendela dengan taruhan sebelumnya dan riwayat bonus.',
'autoplay': 'Mode Otomatis (Autoplay)',
'autoplay_p1': 'Mengklik Auto memungkinkan Anda secara otomatis menjatuhkan beberapa bola tanpa harus mengklik setiap kali.',
'autoplay_p2': 'Pilih jumlah yang ingin Anda pertaruhkan per bola.',
'autoplay_p3': 'Pilih berapa kali (ronde) bola ingin dijatuhkan — maksimum 100 ronde.',
'autoplay_p4': 'Tekan tombol START untuk memulai dan tombol akan berubah menjadi STOP.',
'autoplay_p5': 'Mode Otomatis akan berhenti ketika jumlah jatuh yang dipilih selesai, dana habis, atau tombol STOP ditekan.',
'autoplay_p6': 'Setiap jatuhan menggunakan jumlah taruhan yang sama seperti yang Anda pilih sebelum memulai Mode Otomatis.',
'turbo_mode': 'Mode Turbo',
'turbo_mode_p1': 'Turbo Drop memungkinkan Anda menjatuhkan bola dengan cepat dengan menahan tombol DROP.',
'turbo_mode_p2': 'Bola akan terus jatuh sampai Anda melepaskan tombol atau saldo habis.',
'turbo_mode_p3': 'Bola akan terus jatuh sampai Anda melepaskan tombol atau saldo habis.',
'turbo_balance': 'Saldo Turbo',
'turbo_balance_p1': 'Sebelum memulai Turbo Drop, pilih berapa banyak uang yang akan disisihkan — ini menjadi Saldo Turbo Anda.',
'turbo_balance_p2': 'Saat Turbo Drop aktif, permainan hanya menggunakan Saldo Turbo Anda untuk taruhan dan kemenangan.',
'turbo_balance_p3': 'Saat Anda menghentikan Turbo Drop, sisa Saldo Turbo kembali ke saldo utama.',
'turbo_balance_p4': 'Anda dapat keluar dari Turbo Drop kapan saja — tetapi mode akan sepenuhnya selesai hanya setelah semua bola selesai jatuh dan mendarat di kantong pengali.',
'free_bets': 'RONDE BONUS',
'free_bets_p1': 'Ronde bonus diberikan oleh operator.',
'fairness': 'Keadilan',
'fairness_p1': 'Setiap jatuhan ditentukan oleh generator angka acak yang dapat dibuktikan adil (RNG).',
'fairness_p2': 'Hasilnya tidak dapat diprediksi atau dipengaruhi setelah bola dijatuhkan.',
'disconection_and_error': 'Kebijakan Putus Sambung dan Penanganan Kesalahan',
'disconection_and_error_p1': 'Jika koneksi hilang setelah memasang taruhan, taruhan tidak akan dibatalkan. Jika permainan membutuhkan aksi dari pemain, hasil akan dihitung dengan asumsi pemain memilih aksi tanpa risiko tanpa menaikkan taruhan awal.',
'disconection_and_error_p2': 'Jika terjadi kesalahan, tim dukungan kami akan mencoba menyelesaikan masalah sesegera mungkin dan melanjutkan permainan reguler. Jika terjadi masalah dengan permainan itu sendiri, semua taruhan akan dibatalkan dan jumlah taruhan dikembalikan kepada pemain.',
'other': 'Lainnya',
'other_p1': 'Jika terjadi kerusakan pada perangkat keras/perangkat lunak game, semua taruhan dan pembayaran yang terpengaruh dianggap batal dan semua taruhan yang terpengaruh dikembalikan.',
'other_p2': 'Aturan permainan diterbitkan dalam bahasa Inggris. Terjemahan ke bahasa lain disediakan sebagai layanan dengan itikad baik. Jika terdapat ketidaksesuaian antara versi bahasa Inggris dan terjemahan, versi bahasa Inggris yang diutamakan.',
'rows': 'Baris',
'lvl': 'Tingkat',
'low': 'Rendah',
'high': 'Tinggi',
'ok': 'OK',
'exit_turbo_mode': 'Apakah Anda ingin keluar dari mode Turbo?',
"end": "AKHIR",
"turbo_mode_settings": "Pengaturan Mode Turbo",
"stop": "BERHENTI",
'invalid_bet_amount': 'Jumlah taruhan tidak valid',
'cashout_success': 'Penarikan berhasil',
'stop_auto_play_first': 'Silakan hentikan autoplay terlebih dahulu.',
'turbo_only_when_no_balls': 'Mode Turbo hanya dapat diaktifkan saat tidak ada bola di papan.',
'type': 'Jenis taruhan',
'wait_balls_to_finish': 'Silakan tunggu hingga semua bola selesai jatuh',
'bet_too_large_top_up_turbo_balance': 'Taruhan terlalu besar — silakan isi ulang Saldo Turbo Anda!',
};
langArr.th = {
'loading': 'กำลังโหลด',
'hotkeys': 'ปุ่มลัด',
'hotkeys_enabled': 'เปิดใช้งานปุ่มลัดแล้ว',
'enable_hotkeys_checkbox': 'เปิดใช้งานปุ่มลัดด้านล่างโดยทำเครื่องหมายในช่องนี้',
'drop_ball': 'ปล่อยลูกบอล',
'double_bet': 'เพิ่มเงินเดิมพันเป็นสองเท่า',
'halve_bet': 'ลดเงินเดิมพันลงครึ่งหนึ่ง',
'min_bet': 'เงินเดิมพันขั้นต่ำ',
'max': 'สูงสุด',
'easy': 'ง่าย',
'medium': 'ปานกลาง',
'hard': 'ยาก',
'daredevil': 'สายเสี่ยง',
'max_profit': 'กำไรสูงสุด',
'manual': 'แมนนวล',
'auto': 'อัตโนมัติ',
'bet_amount': 'จำนวนเงินเดิมพัน',
'difficulty': 'ระดับความยาก',
'payout_on_win': 'จ่ายเงินเมื่อชนะ',
'number_of_bets': 'จำนวนการเดิมพัน',
'on_win': 'เมื่อชนะ',
'on_loss': 'เมื่อแพ้',
'stop_on_profit': 'หยุดเมื่อได้กำไร',
'stop_on_loss': 'หยุดเมื่อขาดทุน',
'reset': 'รีเซ็ต',
'increase_by': 'เพิ่มขึ้น',
'cashout': 'ถอนเงิน',
'start_game': 'วางเดิมพัน',
'start_auto_game': 'เริ่ม',
'difficulity_info': 'ข้อมูลระดับความยาก',
'chance_collision': 'โอกาสการชนต่อเกม',
'evry_25_lane': 'ทุก ๆ 25 เลน',
'insufficiend_funds': 'ยอดเงินไม่เพียงพอ',
'cashout_inactivity': 'ถอนเงินอัตโนมัติเมื่อไม่มีการใช้งาน',
'time_running_out': 'เวลาหมดลงแล้ว! เล่นตอนนี้ มิฉะนั้นตั๋วจะถูกยกเลิกอัตโนมัติใน 30 วินาที',
'there_was_error': 'เกิดข้อผิดพลาด โปรดลองอีกครั้งหรือรีโหลด',
'detailed_game_rules': 'กติกาเกมโดยละเอียด',
'general_rules': 'กติกาทั่วไป',
'general_rules_p1': '• ตัวคูณเริ่มต้นที่ 1 และ ',
'general_rules_p2': '• เงินรางวัลคำนวณจากเงินเดิมพันคูณด้วยตัวคูณ',
'general_rules_p3': '• เมื่อถึงการจ่ายสูงสุด ระบบจะถอนเงินอัตโนมัติ',
'progressive_jackpot': 'แจ็กพอตสะสม',
'progressive_jackpot_ss': 'เลนแจ็กพอตและรางวัลที่เป็นไปได้',
'progressive_jackpot_p1': 'เงินเดิมพันส่วนหนึ่งจะถูกนำไปสมทบกองทุนแจ็กพอต',
'progressive_jackpot_p2': 'แจ็กพอตใช้กลไก “Mystery” หรือ “must-hit-by”',
'progressive_jackpot_p3': 'เมื่อถึงมูลค่าที่กำหนด ผู้เล่นถัดไปมีโอกาสชนะ',
'progressive_jackpot_p4': 'หมายเหตุ: รอบโบนัสไม่สะสมแจ็กพอต',
'showdown': 'แสดงผล',
'showdown_ss': 'สี่เหลี่ยมสีแดงแสดงตำแหน่งการชน',
'showdown_p1': 'หลังจากถอนเงิน ระบบจะแสดงตำแหน่งการชน',
'return_to_player': 'อัตราการคืนผู้เล่น',
'return_to_player_p1': 'ค่า RTP ตามทฤษฎีคือ ',
'return_to_player_p2': 'ค่า RTP ได้รับการตรวจสอบโดยหน่วยงานอิสระ',
'disconnection_policy': 'นโยบายการตัดการเชื่อมต่อ',
'disconnection_policy_p1': 'หากการเชื่อมต่อขาดหลังวางเดิมพัน จะไม่ถูกยกเลิกทันที',
'disconnection_policy_p2': 'การเดิมพันจะถูกถอนเงินอัตโนมัติ',
'network_latency': 'ความหน่วงของเครือข่าย',
'network_latency_p1': 'การเดิมพันจะถือว่าถูกต้องเมื่อถึงเซิร์ฟเวอร์',
'sound': 'เสียง',
'sound_p1': 'สามารถปิดเสียงและเพลงได้จากเมนูเกม',
'error_handling': 'การจัดการข้อผิดพลาด',
'error_handling_p1': 'ทีมสนับสนุนจะดำเนินการแก้ไขโดยเร็วที่สุด',
'max_payout': 'การจ่ายสูงสุดคือ ',
'max_bet_is': 'เงินเดิมพันสูงสุดคือ ',
'min_bet_is': 'เงินเดิมพันขั้นต่ำคือ ',
'per_bet': 'ต่อการเดิมพัน',
'malfunction_voids': 'ความขัดข้องทำให้การเดิมพันและการจ่ายทั้งหมดเป็นโมฆะ',
'attention_jackpot': 'ระวัง แจ็กพอตที่เลน ',
'lane': 'เลน',
'congratulations': 'ขอแสดงความยินดี',
'you_won': 'คุณชนะ',
'balance': 'ยอดเงิน',
'time': 'เวลา',
'jackpot': 'แจ็กพอต',
'escaped': 'หลบหนี',
'max_win': 'ชนะสูงสุด',
'check_internet': 'กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ต',
'websocket_disconected': 'WebSocket ถูกตัดการเชื่อมต่อ',
'websocket_connection_error': 'ข้อผิดพลาดการเชื่อมต่อ WebSocket!',
'session_expired': 'เซสชันหมดอายุ กรุณารีโหลด',
'remaining_bets': 'การเดิมพันที่เหลือ',
'stop_autoplay': 'หยุด',
'autoplay_and_autocashout': 'เล่นอัตโนมัติและถอนเงินอัตโนมัติ',
'autoplay_and_autocashout_ss': 'เลือกเล่นแบบแมนนวลหรืออัตโนมัติ',
'autoplay_and_autocashout_p1': 'ระบบจะวางเดิมพันอัตโนมัติในแต่ละรอบ',
'autoplay_and_autocashout_p2': 'สามารถเลือกตัวคูณถอนเงินอัตโนมัติได้',
'autoplay_and_autocashout_p3': 'จำนวนรอบอัตโนมัติสูงสุดคือ ',
'autoplay_button_label': 'เลือกเลนเพื่อเริ่มต้น',
'min_bet_amount_is': 'จำนวนเงินเดิมพันขั้นต่ำคือ',
'bonus_rounds': 'รอบโบนัส',
'bonus_rounds_ss': 'รอบโบนัสพร้อมระยะเวลาที่กำหนด',
'bonus_rounds_p1': 'รอบโบนัสอาจได้รับจากโปรโมชั่น',
'bonus_rounds_p2': 'ผู้เล่นสามารถเลือกเวลาเริ่มได้',
'bonus_rounds_p3': 'รอบโบนัสอาจมีการจำกัดเวลา',
'bonus_rounds_p4': 'การไม่ใช้งานอาจทำให้รอบโบนัสถูกยกเลิก',
'valid_until': 'ใช้ได้จนถึง',
'bonus': 'โบนัส',
'rounds': 'รอบ',
'win_eur': 'ชนะ EUR',
'complete_your_bet': 'กรุณาวางเดิมพันให้เสร็จก่อน',
'complete_auto_play': 'กรุณาทำการเล่นอัตโนมัติให้เสร็จก่อน',
'yes': 'ใช่',
'no': 'ไม่',
'play_bonus_rounds': 'เล่นรอบโบนัสหรือไม่?',
'bet_history': 'ประวัติการเดิมพัน',
'jackpot_history': 'ประวัติแจ็กพอต',
'ticket_id': 'รหัสตั๋ว',
'created': 'เวลาที่สร้าง',
'currency': 'สกุลเงิน',
'bet': 'เดิมพัน',
'bet_eur': 'เดิมพัน EUR',
'lanes': 'เลน',
'cars': 'รถ',
'multiplier': 'ตัวคูณ',
'win': 'ชนะ',
'no_betting_history': 'ไม่พบประวัติการเดิมพัน',
'no_jackpot_history': 'ไม่มีประวัติแจ็กพอต',
'date': 'วันที่',
'user': 'ผู้ใช้',
'bet_already_active': 'มีการเดิมพันที่กำลังใช้งานอยู่แล้ว',
'please_play_the_game_in_portait_mode': 'กรุณาเล่นเกมในโหมดแนวตั้ง',
'bonus_history': 'ประวัติโบนัส',
'bonus_type': 'ประเภทโบนัส',
'no_bonus_history': 'ไม่มีประวัติโบนัส',
'game_menu': 'เมนูเกม',
'game_menu_ss': 'หน้าแรก, ประวัติเดิมพัน, กติกาเกม, ปุ่มลัด, เสียง, เพลง',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'กติกาเกม',
'game_rules_p1': 'ยินดีต้อนรับสู่ Plinko – ที่โชคชะตาคือผู้นำ!',
'game_rules_p2': 'เตรียมตัวให้พร้อมสำหรับเกมเสี่ยงโชคที่น่าตื่นเต้น ง่ายและติดใจ! Plinko คือการปล่อยลูกบอลลงบนพีระมิดที่เต็มไปด้วยตะปู แล้วดูมันเด้ง หมุน และกระเด็นลงไปยังช่องรางวัลด้านล่าง',
'game_rules_p3': 'เลือกจำนวนแถวตะปูตั้งแต่ 8 ถึง 16 แถว จากนั้นนั่งลงและสนุกไปกับความวุ่นวายขณะที่ลูกบอลวิ่งซิกแซกผ่านกระดาน โดยได้รับการชี้นำจากแรงโน้มถ่วงและโชค',
'game_rules_p4': 'ลูกบอลจะตกลงในช่องที่จ่ายน้อย... หรือชนะรางวัลใหญ่? มีเพียงวิธีเดียวที่จะรู้ — ปล่อยลูกบอลและปล่อยให้ความตื่นเต้นเริ่มขึ้น!',
'general': 'ทั่วไป',
'general_p1': 'ปล่อยลูกบอล Plinko และหวังว่ามันจะตกลงในช่องที่จ่ายสูงด้านล่าง เส้นทางไม่สามารถคาดเดาได้ — ทุกการเด้งสามารถเปลี่ยนโชคชะตาของคุณได้',
'general_p2': 'ยิ่งคุณเล่นหลายแถว ยิ่งตื่นเต้นมากขึ้น!',
'general_p3': 'ไปเลย — เชื่อโชคของคุณ กด DROP แล้วไล่ล่าชัยชนะครั้งใหญ่ผ่านตะปูใน Plinko!',
'betting': 'การเดิมพัน',
'betting_p1': 'เลือกจำนวนเดิมพัน ปุ่ม “1/2”, “2x”, “Max” ใช้จัดการขนาดเดิมพันได้ จำนวนเดิมพันสามารถป้อนด้วยตนเองได้เช่นกัน',
'betting_p2': 'เลือกระดับความเสี่ยง: ต่ำ, ปานกลาง หรือ สูง ระดับความเสี่ยงต่ำให้ผลลัพธ์ที่สม่ำเสมอมากขึ้น (ความผันผวนต่ำ) ในขณะที่ระดับสูงให้ความแปรปรวนมากขึ้น (ความผันผวนสูง)',
'betting_p3': 'เลือกจำนวนเส้นในเกม: จาก 8 ถึง 16 เลือกจำนวนแถวหมุดที่ลูกบอลจะตกผ่าน ยิ่งมีแถวมาก = ยิ่งคาดเดาไม่ได้มาก',
'betting_p4': 'เลือกโหมดเดิมพัน: ด้วยตนเอง หรือ อัตโนมัติ',
'betting_p5': 'เริ่มรอบเกมโดยกดปุ่ม DROP BALL ในรอบนี้ปุ่มเดิมพันทั้งหมดจะไม่สามารถใช้งานได้ ยกเว้น DROP BALL และจำนวนเดิมพัน',
'betting_p6': 'ลูกบอล Plinko หนึ่งลูกแทนหนึ่งรอบ ในระหว่างรอบสามารถเริ่มรอบใหม่ด้วยการตั้งค่าเดิมโดยใช้ปุ่ม DROP BALL สามารถเปลี่ยนจำนวนเดิมพันได้ในขณะที่ลูกบอล “สด” อยู่บนโต๊ะ แต่ไม่สามารถเปลี่ยนความยากของเกมได้',
'betting_p7': 'เมื่อสิ้นสุดรอบ ลูกบอลจะไปถึงช่องจ่ายเงิน ในแต่ละช่องจะแสดงตัวคูณการจ่าย',
'betting_p8': 'การคำนวณการชนะทำตามตัวคูณที่ลูกบอลตก ผลลัพธ์จะถูกเพิ่มไปยังยอดคงเหลือ',
'game_menu_p1': 'ตัวคูณเดิมพันล่าสุดจะแสดงที่ด้านล่างของหน้าต่างเกม',
'game_menu_p2': 'ที่ปุ่ม “Bet history” ผู้เล่นสามารถตรวจสอบการเดิมพันล่าสุดของตนอย่างละเอียด',
'game_menu_p3': 'สำหรับประวัติการเล่นเพิ่มเติม (เช่น ช่วงเวลายาว) ผู้เล่นอาจต้องเข้าถึงประวัติผู้เล่นภายในแพลตฟอร์มเกม',
'game_menu_p4': 'ผ่านเมนูเกม ผู้เล่นสามารถควบคุมตัวเลือกเสียง ปุ่มลัดคีย์บอร์ด และเปิดประวัติการเดิมพันและกฎเกม',
'game_menu_p5': 'เกมถูกออกแบบด้วยเพลงพื้นหลังและเอฟเฟกต์เสียงที่สวยงาม เพลงและ/หรือเอฟเฟกต์เสียงสามารถปิดได้ผ่านไอคอนเมนูเกม',
'game_menu_p6': 'ประวัติการเล่นจะแสดงหน้าต่างที่มีการเดิมพันก่อนหน้าและประวัติโบนัส',
'autoplay': 'โหมดอัตโนมัติ (Autoplay)',
'autoplay_p1': 'คลิก Auto เพื่อให้คุณสามารถปล่อยลูกบอลจำนวนหนึ่งโดยอัตโนมัติโดยไม่ต้องคลิกทุกครั้ง',
'autoplay_p2': 'เลือกจำนวนเงินที่คุณต้องการเดิมพันต่อบอล',
'autoplay_p3': 'เลือกจำนวนครั้ง (รอบ) ที่คุณต้องการให้ลูกบอลตก — สูงสุด 100 รอบ',
'autoplay_p4': 'กดปุ่ม START เพื่อเริ่มและปุ่มจะเปลี่ยนเป็น STOP',
'autoplay_p5': 'โหมดอัตโนมัติจะหยุดเมื่อจำนวนการปล่อยที่เลือกเสร็จสิ้น เงินหมด หรือคุณกดปุ่ม STOP',
'autoplay_p6': 'การปล่อยแต่ละครั้งจะใช้จำนวนเดิมพันเดียวกับที่คุณเลือกก่อนเริ่มโหมดอัตโนมัติ',
'turbo_mode': 'โหมดเทอร์โบ',
'turbo_mode_p1': 'Turbo Drop ให้คุณปล่อยลูกบอลอย่างรวดเร็วโดยกดปุ่ม DROP ค้างไว้',
'turbo_mode_p2': 'ลูกบอลจะตกต่อเนื่องจนกว่าคุณจะปล่อยปุ่มหรือเงินหมด',
'turbo_mode_p3': 'ลูกบอลจะตกต่อเนื่องจนกว่าคุณจะปล่อยปุ่มหรือเงินหมด',
'turbo_balance': 'ยอดคงเหลือเทอร์โบ',
'turbo_balance_p1': 'ก่อนเริ่ม Turbo Drop เลือกจำนวนเงินที่จะกันไว้ — ซึ่งจะเป็นยอดคงเหลือเทอร์โบของคุณ',
'turbo_balance_p2': 'ขณะ Turbo Drop ทำงาน เกมจะใช้ยอดคงเหลือเทอร์โบของคุณเท่านั้นสำหรับการเดิมพันและการชนะ',
'turbo_balance_p3': 'เมื่อคุณหยุด Turbo Drop ยอดคงเหลือเทอร์โบที่เหลือจะกลับไปยังยอดคงเหลือหลัก',
'turbo_balance_p4': 'คุณสามารถออกจาก Turbo Drop ได้ทุกเวลา — แต่โหมดจะสิ้นสุดสมบูรณ์ก็ต่อเมื่อบอลทั้งหมดตกลงและลงในช่องตัวคูณ',
'free_bets': 'รอบโบนัส',
'free_bets_p1': 'รอบโบนัสมอบโดยผู้ให้บริการ',
'fairness': 'ความยุติธรรม',
'fairness_p1': 'ทุกการปล่อยลูกบอลจะถูกกำหนดโดยตัวสร้างตัวเลขสุ่มที่โปร่งใสและตรวจสอบได้ (RNG)',
'fairness_p2': 'ผลลัพธ์ไม่สามารถทำนายหรือควบคุมได้หลังจากปล่อยลูกบอลแล้ว',
'disconection_and_error': 'นโยบายการตัดการเชื่อมต่อและการจัดการข้อผิดพลาด',
'disconection_and_error_p1': 'ถ้าการเชื่อมต่อขาดหลังวางเดิมพัน เดิมพันจะไม่ถูกยกเลิก หากเกมต้องการการกระทำจากผู้เล่น ผลลัพธ์จะถูกนับโดยถือว่าผู้เล่นเลือกการกระทำที่ไม่มีความเสี่ยงโดยไม่เพิ่มเดิมพันเริ่มต้น',
'disconection_and_error_p2': 'หากเกิดข้อผิดพลาด ทีมสนับสนุนจะพยายามแก้ไขปัญหาโดยเร็วที่สุดและดำเนินเกมต่อ หากเกิดปัญหากับเกมทั้งหมด เดิมพันทั้งหมดจะถูกยกเลิกและคืนเงินให้ผู้เล่น',
'other': 'อื่นๆ',
'other_p1': 'ในกรณีที่ฮาร์ดแวร์/ซอฟต์แวร์เกมผิดพลาด เดิมพันและการจ่ายเงินที่ได้รับผลกระทบทั้งหมดจะถือเป็นโมฆะและเดิมพันที่ได้รับผลกระทบจะคืนเงินทั้งหมด',
'other_p2': 'กติกาเกมถูกเผยแพร่เป็นภาษาอังกฤษ การแปลเป็นภาษาอื่นเป็นบริการที่ให้ด้วยความสุจริตใจ หากมีความคลุมเครือระหว่างเวอร์ชันภาษาอังกฤษและการแปล เวอร์ชันภาษาอังกฤษจะเป็นหลัก',
'rows': 'แถว',
'lvl': 'ระดับ',
'low': 'ต่ำ',
'high': 'สูง',
'ok': 'OK',
'exit_turbo_mode': 'คุณต้องการออกจากโหมด Turbo หรือไม่?',
"end": "จบ",
"turbo_mode_settings": "การตั้งค่าโหมดเทอร์โบ",
"stop": "หยุด",
'invalid_bet_amount': 'จำนวนเงินเดิมพันไม่ถูกต้อง',
'cashout_success': 'ถอนเงินสำเร็จ',
'stop_auto_play_first': 'กรุณาหยุดการเล่นอัตโนมัติก่อน',
'turbo_only_when_no_balls': 'โหมดเทอร์โบสามารถเปิดใช้งานได้เมื่อไม่มีลูกบอลบนโต๊ะเท่านั้น',
'type': 'ประเภทเดิมพัน',
'wait_balls_to_finish': 'กรุณารอจนกว่าลูกบอลทั้งหมดจะตกลงเสร็จ',
'bet_too_large_top_up_turbo_balance': 'เดิมพันสูงเกินไป — กรุณาเติมยอดคงเหลือเทอร์โบของคุณ!',
};
langArr.tl = {
'loading': 'Naglo-load',
'hotkeys': 'Mga shortcut key',
'hotkeys_enabled': 'Pinagana ang mga shortcut key',
'enable_hotkeys_checkbox': 'I-enable ang mga shortcut key sa ibaba sa pamamagitan ng pag-check sa kahong ito.',
'drop_ball': 'Ihulog ang bola',
'double_bet': 'Doblihin ang taya',
'halve_bet': 'Bawasan ng kalahati ang taya',
'min_bet': 'Minimum na taya',
'max': 'Max',
'easy': 'Madali',
'medium': 'Katamtaman',
'hard': 'Mahirap',
'daredevil': 'Mapangahas',
'max_profit': 'Pinakamataas na kita',
'manual': 'Manwal',
'auto': 'Auto',
'bet_amount': 'Halaga ng taya',
'difficulty': 'Antas ng hirap',
'payout_on_win': 'Bayad kapag panalo',
'number_of_bets': 'Bilang ng taya',
'on_win': 'Kapag panalo',
'on_loss': 'Kapag talo',
'stop_on_profit': 'Itigil kapag may kita',
'stop_on_loss': 'Itigil kapag may lugi',
'reset': 'I-reset',
'increase_by': 'Dagdagan ng',
'cashout': 'I-WITHDRAW',
'start_game': 'TUMAYA',
'start_auto_game': 'SIMULAN',
'difficulity_info': 'Impormasyon sa antas ng hirap',
'chance_collision': 'Tsansa ng banggaan bawat laro',
'evry_25_lane': 'bawat 25 lane',
'insufficiend_funds': 'Hindi sapat ang balanse',
'cashout_inactivity': 'Auto withdraw kapag walang aktibidad',
'time_running_out': 'Malapit nang maubos ang oras! Maglaro ngayon o awtomatikong mababawi ang tiket sa loob ng 30 segundo',
'there_was_error': 'MAY NAGANAP NA ERROR, PAKISUBUKAN MULI O I-RELOAD',
'detailed_game_rules': 'Detalyadong patakaran ng laro',
'general_rules': 'PANGKALAHATANG PATUNTUNAN',
'general_rules_p1': '• Ang multiplier ay nagsisimula sa 1 at ',
'general_rules_p2': '• Ang panalo ay kalkuladong taya × multiplier.',
'general_rules_p3': '• Kapag naabot ang max payout, awtomatikong magka-cashout.',
'progressive_jackpot': 'PROGRESIBONG JACKPOT',
'progressive_jackpot_ss': 'Jackpot lane at posibleng panalo',
'progressive_jackpot_p1': 'Bahagi ng bawat taya ay napupunta sa jackpot fund.',
'progressive_jackpot_p2': 'Gumagamit ang jackpot ng “Mystery” o “must-hit-by” mechanics.',
'progressive_jackpot_p3': 'Kapag naabot ang halaga, ang susunod na manlalaro ay may tsansang manalo.',
'progressive_jackpot_p4': 'TANDAAN: Ang bonus rounds ay hindi kasama sa jackpot.',
'showdown': 'IPAKITA',
'showdown_ss': 'Pulang kahon ang lokasyon ng banggaan',
'showdown_p1': 'Pagkatapos ng cashout, ipapakita ang posisyon ng banggaan.',
'return_to_player': 'BALIK SA MANLALARO',
'return_to_player_p1': 'Ang kabuuang teoretikal na RTP ay ',
'return_to_player_p2': 'Ang RTP ay sinusuri ng mga independent na third party.',
'disconnection_policy': 'PATAKARAN SA DISKONEKSYON',
'disconnection_policy_p1': 'Kung maputol ang koneksyon pagkatapos tumaya, hindi agad makakansela.',
'disconnection_policy_p2': 'ang taya ay awtomatikong ika-cashout.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Ang mga taya ay balido kapag natanggap ng server.',
'sound': 'TUNOG',
'sound_p1': 'Maaaring i-off ang tunog at musika sa menu ng laro.',
'error_handling': 'PAGHAHANDLE NG ERROR',
'error_handling_p1': 'Susubukan ng support team na ayusin agad ang problema.',
'max_payout': 'Ang maximum payout ay ',
'max_bet_is': 'Ang maximum na taya ay ',
'min_bet_is': 'Ang minimum na taya ay ',
'per_bet': 'bawat taya.',
'malfunction_voids': 'Ang malfunction ay nagva-void ng lahat ng laro at bayad.',
'attention_jackpot': 'Babala, jackpot sa lane ',
'lane': 'lane',
'congratulations': 'binabati kita',
'you_won': 'ikaw ay nanalo',
'balance': 'balanse',
'time': 'oras',
'jackpot': 'jackpot',
'escaped': 'NAKAIWAS',
'max_win': 'PINAKAMALAKING PANALO',
'check_internet': 'Pakisuri ang iyong internet connection',
'websocket_disconected': 'Nadiskonek ang WebSocket',
'websocket_connection_error': 'Error sa koneksyon ng WebSocket!',
'session_expired': 'Nag-expire ang session, paki-reload',
'remaining_bets': 'Natitirang taya',
'stop_autoplay': 'ITIGIL',
'autoplay_and_autocashout': 'AUTOPLAY AT AUTO CASHOUT',
'autoplay_and_autocashout_ss': 'Pagpili ng manual o autoplay',
'autoplay_and_autocashout_p1': 'Awtomatikong naglalagay ng taya sa bawat round.',
'autoplay_and_autocashout_p2': 'Maaaring pumili ng auto cashout multiplier.',
'autoplay_and_autocashout_p3': 'Ang maximum na bilang ng autoplay rounds ay ',
'autoplay_button_label': 'Pumili ng lane para magsimula.',
'min_bet_amount_is': 'Ang minimum na halaga ng taya ay',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'Mga bonus round na may validity period',
'bonus_rounds_p1': 'Maaaring makatanggap ng bonus rounds mula sa promo.',
'bonus_rounds_p2': 'Maaaring piliin ng manlalaro kung kailan sisimulan.',
'bonus_rounds_p3': 'Maaaring may limitasyon sa oras ang bonus rounds.',
'bonus_rounds_p4': 'Ang kawalan ng aktibidad ay maaaring magresulta sa kanselasyon.',
'valid_until': 'balido hanggang',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'panalo EUR',
'complete_your_bet': 'Pakikumpleto muna ang iyong taya',
'complete_auto_play': 'Pakikumpleto muna ang autoplay',
'yes': 'oo',
'no': 'hindi',
'play_bonus_rounds': 'Laruin ang bonus rounds?',
'bet_history': 'Kasaysayan ng taya',
'jackpot_history': 'Kasaysayan ng jackpot',
'ticket_id': 'Ticket ID',
'created': 'oras ng paggawa',
'currency': 'pera',
'bet': 'taya',
'bet_eur': 'taya EUR',
'lanes': 'mga lane',
'cars': 'mga kotse',
'multiplier': 'multiplier',
'win': 'panalo',
'no_betting_history': 'Walang nahanap na kasaysayan ng taya.',
'no_jackpot_history': 'Walang kasaysayan ng jackpot.',
'date': 'petsa',
'user': 'user',
'bet_already_active': 'May aktibong taya na',
'please_play_the_game_in_portait_mode': 'Pakilaro ang game sa portrait mode.',
'bonus_history': 'Kasaysayan ng bonus',
'bonus_type': 'Uri ng bonus',
'no_bonus_history': 'Walang kasaysayan ng bonus.',
'game_menu': 'Menu ng laro',
'game_menu_ss': 'Home, Kasaysayan ng Taya, Mga Patakaran, Keyboard Shortcuts, Tunog, Musika',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'MGA PANUNTUNAN NG LARO',
'game_rules_p1': 'Maligayang pagdating sa Plinko – Kung saan ang Kapalaran ang Nangunguna!',
'game_rules_p2': 'Maghanda para sa isang kapanapanabik na laro ng pagkakataon na kasing simple at nakakaadik! Ang Plinko ay tungkol sa pagpapakawala ng bola sa isang pyramid na puno ng mga pegs at panoorin itong tumalbog, umikot, at tumalbog pababa sa isang prize-filled slot sa ilalim.',
'game_rules_p3': 'Pumili mula 8 hanggang 16 na hanay ng mga pegs, pagkatapos ay umupo at tamasahin ang kaguluhan habang zigzag ang bola sa board, na ginagabayan ng grabidad at kapalaran.',
'game_rules_p4': 'Mababa ba ang patutunguhang slot... o makakamit ang malaking panalo? Isang paraan lang ang alam para malaman — pakawalan ang bola at hayaang umusbong ang saya!',
'general': 'PANGKALAHATAN',
'general_p1': 'Pakawalan ang Plinko ball at sana ay mapunta ito sa isa sa mga high-paying slot sa ibaba. Hindi tiyak ang landas — bawat talbog ay maaaring baguhin ang iyong kapalaran.',
'general_p2': 'Mas maraming hanay ang iyong laruin, mas matindi ang aksyon!',
'general_p3': 'Kaya sige — pagkatiwalaan ang iyong kapalaran, pindutin ang DROP, at habulin ang malaking panalo sa mga pegs ng Plinko!',
'betting': 'PAGTAYA',
'betting_p1': 'Piliin ang halaga ng pusta. Maaaring gamitin ang mga button na “1/2”, “2x”, “Max” upang pamahalaan ang laki ng pusta. Maaari ring manu-manong ilagay ang halaga ng pusta.',
'betting_p2': 'Piliin ang Antas ng Panganib: Mababa, Katamtaman, o Mataas. Ang mas mababang antas ng panganib ay nagbibigay ng mas konsistenteng resulta (mababang volatility), habang ang mataas na antas ay nagbibigay ng mas mataas na pagbabago (mataas na volatility).',
'betting_p3': 'Piliin ang bilang ng mga linya sa laro: mula 8 hanggang 16. Piliin kung ilang hanay ng mga pin ang tatahakin ng bola. Mas maraming hanay = mas hindi mahuhulaan.',
'betting_p4': 'Piliin ang Mode ng Pusta: Manual o Auto.',
'betting_p5': 'Upang simulan ang round ng laro, pindutin ang DROP BALL button. Sa panahon ng round, ang lahat ng button ng pusta ay hindi aktibo maliban sa DROP BALL at halaga ng pusta.',
'betting_p6': 'Isang Plinko ball ang kumakatawan sa isang round. Sa panahon ng round, maaaring magsimula ng isa pang round gamit ang parehong setting gamit ang DROP BALL button. Posible ang pagbabago ng halaga ng pusta habang may “live” na bola sa board, ngunit hindi ang hirap ng laro.',
'betting_p7': 'Sa pagtatapos ng round, ang bola ay makarating sa pocket. Sa bawat pocket ipinapakita ang payout multiplier.',
'betting_p8': 'Ang pagkalkula ng panalo ay ayon sa multiplier kung saan napunta ang bola. Idinadagdag ang resulta sa balanse.',
'game_menu_p1': 'Ang pinakabagong mga multiplier ng pusta ay ipinapakita sa ibabang bahagi ng window ng laro.',
'game_menu_p2': 'Sa button na “Bet history”, maaaring tingnan ng manlalaro ang kanyang pinakabagong mga pusta nang mas detalyado.',
'game_menu_p3': 'Para sa mas mahabang kasaysayan ng laro (hal. mas mahahabang panahon), maaaring kailanganin ng manlalaro na ma-access ang kasaysayan ng manlalaro sa loob ng platform ng laro.',
'game_menu_p4': 'Sa pamamagitan ng menu ng laro, maaaring kontrolin ng mga manlalaro ang mga opsyon sa tunog, mga shortcut sa keyboard, at buksan ang kasaysayan ng pusta at mga patakaran ng laro.',
'game_menu_p5': 'Ang laro ay idinisenyo na may magandang background music at sound effects. Ang musika at/o sound effects ay maaaring i-off sa pamamagitan ng mga icon sa menu ng laro.',
'game_menu_p6': 'Ipinapakita ng game history ang window na may mga nakaraang pusta at kasaysayan ng bonus.',
'autoplay': 'Auto Mode (Autoplay)',
'autoplay_p1': 'Sa pag-click ng Auto, maaari mong awtomatikong ibagsak ang ilang bola nang hindi kinakailangang mag-click sa bawat oras.',
'autoplay_p2': 'Piliin ang halaga na nais mong itaya kada bola.',
'autoplay_p3': 'Piliin kung ilang beses (rounds) mo nais ibagsak ang bola — hanggang 100 rounds maximum.',
'autoplay_p4': 'Pindutin ang START button upang magsimula at ang button ay magiging STOP.',
'autoplay_p5': 'Titigil ang Auto Mode kapag nakumpleto na ang napiling bilang ng drops, naubos ang pondo, o na-click ang STOP button.',
'autoplay_p6': 'Bawat drop ay gumagamit ng parehong halaga ng pusta na pinili mo bago simulan ang Auto Mode.',
'turbo_mode': 'Turbo Mode',
'turbo_mode_p1': 'Pinapabilis ng Turbo Drop ang pagbagsak ng mga bola sa pamamagitan ng pagpindot nang matagal sa DROP button.',
'turbo_mode_p2': 'Patuloy na babagsak ang mga bola hanggang bitawan mo ang button o maubos ang balanse.',
'turbo_mode_p3': 'Patuloy na babagsak ang mga bola hanggang bitawan mo ang button o maubos ang balanse.',
'turbo_balance': 'Turbo Balance',
'turbo_balance_p1': 'Bago simulan ang Turbo Drop, piliin kung magkano ang ilalaan para dito — ito ang magiging Turbo Balance mo.',
'turbo_balance_p2': 'Habang aktibo ang Turbo Drop, ginagamit lamang ng laro ang iyong Turbo Balance para sa pusta at panalo.',
'turbo_balance_p3': 'Kapag hinarang mo ang Turbo Drop mode, anumang natitirang Turbo Balance ay bumabalik sa iyong pangunahing balanse.',
'turbo_balance_p4': 'Maaaring lumabas sa Turbo Drop anumang oras — ngunit matatapos lamang ang mode kapag ang lahat ng bola ay nahulog at napunta sa multiplier pockets.',
'free_bets': 'BONUS ROUNDS',
'free_bets_p1': 'Ang Bonus Rounds ay ibinibigay ng operator.',
'fairness': 'Katarungan',
'fairness_p1': 'Ang bawat drop ay tinutukoy ng isang napatunayang patas na random number generator (RNG).',
'fairness_p2': 'Hindi maaaring hulaan o impluwensyahan ang resulta kapag na-drop na ang bola.',
'disconection_and_error': 'Patakaran sa Pagkakahiwalay at Paghawak ng Error',
'disconection_and_error_p1': 'Kung mawawala ang koneksyon pagkatapos maglagay ng taya, hindi makakansela ang taya. Kung kailangan ng laro ng aksyon mula sa manlalaro, bibilangin ang resulta sa pag-aakalang pinili ng manlalaro ang aksyon na walang panganib nang hindi itinaas ang paunang taya.',
'disconection_and_error_p2': 'Kung may error, susubukan ng aming support team na ayusin ito kaagad at ipagpatuloy ang normal na laro. Kung may problema mismo sa laro, kakanselahin ang lahat ng taya at ibabalik ang taya sa mga manlalaro.',
'other': 'Iba Pa',
'other_p1': 'Kung magkaroon ng malfunction sa hardware/software ng laro, lahat ng apektadong taya at payout ay magiging walang bisa at ang lahat ng apektadong taya ay ibabalik.',
'other_p2': 'Ang Mga Panuntunan ng Laro ay inilathala sa Ingles. Ang mga pagsasalin sa ibang mga wika ay ibinibigay bilang serbisyo nang may mabuting hangarin. Kung may hindi pagkakaunawaan sa pagitan ng Ingles na bersyon at pagsasalin, ang Ingles na bersyon ang mananaig.',
'rows': 'Mga Hanay',
'lvl': 'Antas',
'low': 'Mababa',
'high': 'Mataas',
'ok': 'OK',
'exit_turbo_mode': 'Gusto mo bang lumabas sa Turbo mode?',
"end": "Tapos na",
"turbo_mode_settings": "Mga Setting ng Turbo Mode",
"stop": "ITIGIL",
'invalid_bet_amount': 'Hindi wastong halaga ng taya',
'cashout_success': 'Matagumpay na pag-withdraw',
'stop_auto_play_first': 'Pakihinto muna ang autoplay',
'turbo_only_when_no_balls': 'Maaaring paganahin ang Turbo mode kapag walang bola sa board lamang',
'type': 'Uri ng taya',
'wait_balls_to_finish': 'Pakihintay na matapos ang lahat ng bola',
'bet_too_large_top_up_turbo_balance': 'Masyadong malaki ang taya — pakipuno ang iyong Turbo Balance!',
};
langArr.xe = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'drop_ball': 'Drop ball',
'double_bet': 'Double play amount',
'halve_bet': 'Halve play amount',
'min_bet': 'Minimum play amount',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Reward',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Play amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Reward on Win',
'number_of_bets': 'Number of Plays',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Reward',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'COLLECT',
'start_game': 'PLAY',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficiend_funds': 'Not enough coins',
'cashout_inactivity': 'Auto collect on inactivity',
'time_running_out': 'Time is running out! Start now or your round will close automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Rewards are calculated by multiplying the play amount by the multiplier shown.',
'general_rules_p3': '• If the maximum reward is reached, the round will automatically collect.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot slot and possible reward',
'progressive_jackpot_p1': 'Part of each play contributes to a progressive jackpot pool.',
'progressive_jackpot_p2': 'Jackpot is triggered using a mystery or must-hit-by mechanic with a hidden value.',
'progressive_jackpot_p3': 'When reached, a player gets a chance to trigger the jackpot slot and receive the jackpot reward.',
'progressive_jackpot_p4': 'NOTE: Bonus rounds do not contribute to the jackpot pool.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After collect, a red square shows where a collision would have happened if play continued.',
'return_to_player': 'RETURN VALUE',
'return_to_player_p1': 'The overall theoretical return value is ',
'return_to_player_p2': 'Return values are continuously monitored and verified.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after play starts, it will not be cancelled immediately. If inactivity reaches ',
'disconnection_policy_p2': 'the round will be auto-collected and coins credited.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'All actions are valid only when received by our server.',
'sound': 'SOUND',
'sound_p1': 'Music and sound effects can be enabled or disabled in the game menu.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'If a game issue occurs, active plays will be cancelled and coins returned.',
'max_payout': 'Maximum reward is ',
'max_bet_is': 'Max play amount is ',
'min_bet_is': 'Min play amount is ',
'per_bet': 'per play.',
'malfunction_voids': 'Malfunction voids all rewards and plays.',
'attention_jackpot': 'Attention, Jackpot at slot ',
'lane': 'slot',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Plays',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTO PLAY AND AUTO COLLECT',
'autoplay_and_autocashout_ss': 'Selection between manual and auto play',
'autoplay_and_autocashout_p1': 'Auto play automatically starts new rounds using the same play amount.',
'autoplay_and_autocashout_p2': 'Auto collect can be set to collect rewards automatically.',
'autoplay_and_autocashout_p3': 'Maximum number of auto rounds is ',
'autoplay_button_label': 'To begin, choose a drop position.',
'min_bet_amount_is': 'Minimum Play Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'Bonus rounds with validity period',
'bonus_rounds_p1': 'Players may receive bonus rounds with free plays.',
'bonus_rounds_p2': 'Bonus rounds run with predefined play amounts.',
'bonus_rounds_p3': 'Bonus rounds may expire after a time limit.',
'bonus_rounds_p4': 'Player inactivity may cancel an active bonus round.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win coins',
'complete_your_bet': 'Please complete your play first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Play history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Round ID',
'created': 'created time',
'currency': 'currency',
'bet': 'play',
'bet_eur': 'play coins',
'lanes': 'slots',
'cars': 'balls',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No play history found. Start a round and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Play already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'Home, History, Rules, Hotkeys, Sound, Music',
'game_rules': 'GAME RULES',
'game_rules_p1': 'Welcome to Plinko — drop the ball and watch it bounce to a reward slot!',
'game_rules_p2': 'Drop a ball onto the peg board and follow its random path downward.',
'game_rules_p3': 'Choose between 8 to 16 rows and enjoy the unpredictable motion.',
'game_rules_p4': 'Land in higher multiplier slots to earn bigger rewards.',
'general': 'GENERAL',
'general_p1': 'Drop the ball and try to reach high-multiplier slots.',
'general_p2': 'More rows mean more variation in outcomes.',
'general_p3': 'Press DROP and enjoy the ride.',
'betting': 'PLAY SETTINGS',
'betting_p1': 'Choose the play amount using -, +, Min and Max buttons.',
'betting_p2': 'Choose Risk Level: Low, Normal or High.',
'betting_p3': 'Choose number of rows from 8 to 16.',
'betting_p4': 'Choose Play Mode: Manual or Auto.',
'betting_p5': 'Press DROP BALL to start the round.',
'betting_p6': 'You can start another drop with the same settings.',
'betting_p7': 'Each slot shows a reward multiplier.',
'betting_p8': 'Rewards are added to your balance.',
'game_menu_p1': 'Recent multipliers are shown at the bottom of the screen.',
'game_menu_p2': 'History button shows your recent rounds.',
'game_menu_p3': 'Extended history may be available on the platform.',
'game_menu_p4': 'Menu allows sound and shortcut controls.',
'game_menu_p5': 'Music and sound can be disabled in menu.',
'game_menu_p6': 'History shows previous rounds and bonuses.',
'autoplay': 'Auto Mode',
'autoplay_p1': 'Auto mode drops multiple balls automatically.',
'autoplay_p2': 'Choose play amount per ball.',
'autoplay_p3': 'Choose number of drops — up to 100.',
'autoplay_p4': 'Press DROP to begin.',
'autoplay_p5': 'Button changes to STOP with remaining drops.',
'autoplay_p6': 'Stops when drops finish, coins run out, or STOP is pressed.',
'autoplay_p7': 'Each drop uses the same play amount.',
'turbo_mode': 'Turbo Mode',
'turbo_mode_p1': 'Turbo mode enables very fast drops.',
'turbo_mode_p2': 'Hold DROP to release balls quickly.',
'turbo_mode_p3': 'Stops when released or coins run out.',
'turbo_balance': 'Turbo Balance',
'turbo_balance_p1': 'Choose how many coins to allocate for Turbo mode.',
'turbo_balance_p2': 'Turbo mode uses only Turbo Balance.',
'turbo_balance_p3': 'Unused Turbo Balance returns to main balance.',
'turbo_balance_p4': 'Mode ends after all balls land.',
'free_bets': 'Free Plays',
'free_bets_p1': 'Free plays are awarded by the operator.',
'fairness': 'Fairness',
'fairness_p1': 'Each drop is determined by a certified random generator.',
'fairness_p2': 'Results cannot be predicted or influenced.',
'disconection_and_error': 'Disconnection Policy and Error Handling',
'disconection_and_error_p1': 'If connection is lost after play starts, the round will still resolve.',
'disconection_and_error_p2': 'If a system error occurs, affected plays are cancelled and coins returned.',
'other': 'Other',
'other_p1': 'System malfunction voids affected rounds and rewards.',
'other_p2': 'English rules take priority over translations.',
'rows': 'Rows',
'lvl': 'Lvl',
'low': 'Low',
'high': 'High',
'ok': 'OK',
'exit_turbo_mode': 'Do you want to exit Turbo mode?',
'end': 'End',
'turbo_mode_settings': 'Turbo Mode Settings',
'stop': 'STOP',
'invalid_bet_amount': 'Invalid play amount',
'cashout_success': 'Collect successful',
'stop_auto_play_first': 'Please stop auto play first',
'turbo_only_when_no_balls': 'Turbo mode can be enabled only when there are no balls on the board',
'type': 'Play type',
'wait_balls_to_finish': 'Please wait for balls to finish',
'bet_too_large_top_up_turbo_balance': 'Amount too large — please add more Turbo Balance!',
};
langArr.da = {
'loading': 'Indlæser',
'hotkeys': 'Genvejstaster',
'hotkeys_enabled': 'Genvejstaster er aktiveret',
'enable_hotkeys_checkbox': 'Aktivér genvejstasterne nedenfor ved at markere dette felt.',
'drop_ball': 'Slip bolden',
'double_bet': 'Fordobl indsatsen',
'halve_bet': 'Halvér indsatsen',
'min_bet': 'Minimumsindsats',
'max': 'Maks',
'easy': 'Let',
'medium': 'Middel',
'hard': 'Svær',
'daredevil': 'Vovehals',
'max_profit': 'Maksimal gevinst',
'manual': 'Manuel',
'auto': 'Auto',
'bet_amount': 'Indsatsbeløb',
'difficulty': 'Sværhedsgrad',
'payout_on_win': 'Udbetaling ved gevinst',
'number_of_bets': 'Antal indsatser',
'on_win': 'Ved gevinst',
'on_loss': 'Ved tab',
'stop_on_profit': 'Stop ved gevinst',
'stop_on_loss': 'Stop ved tab',
'reset': 'Nulstil',
'increase_by': 'Forøg med',
'cashout': 'Hæv',
'start_game': 'PLACÉR INDSATS',
'start_auto_game': 'START',
'difficulity_info': 'Information om sværhedsgrad',
'chance_collision': 'Kollisionschance pr. spil',
'evry_25_lane': 'hver 25. bane',
'insufficiend_funds': 'Utilstrækkelig saldo',
'cashout_inactivity': 'Automatisk udbetaling ved inaktivitet',
'time_running_out': 'Tiden er ved at løbe ud! Spil nu, ellers annulleres billetten automatisk om 30 sekunder',
'there_was_error': 'DER OPSTOD EN FEJL, PRØV IGEN ELLER GENINDLÆS',
'detailed_game_rules': 'Detaljerede spilleregler',
'general_rules': 'GENERELLE REGLER',
'general_rules_p1': '• Multiplikatoren starter ved 1 og ',
'general_rules_p2': '• Gevinst beregnes som indsats × multiplikator.',
'general_rules_p3': '• Når maksimal udbetaling nås, udbetales automatisk.',
'progressive_jackpot': 'PROGRESSIV JACKPOT',
'progressive_jackpot_ss': 'Jackpot-bane og mulige gevinster',
'progressive_jackpot_p1': 'En del af hver indsats går til jackpotpuljen.',
'progressive_jackpot_p2': 'Jackpotten bruger “Mystery” eller “must-hit-by” mekanik.',
'progressive_jackpot_p3': 'Når beløbet nås, har næste spiller chance for at vinde.',
'progressive_jackpot_p4': 'BEMÆRK: Bonusrunder bidrager ikke til jackpotten.',
'showdown': 'VIS',
'showdown_ss': 'Den røde firkant markerer kollisionspunktet',
'showdown_p1': 'Efter udbetaling vises kollisionspositionen.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'Den samlede teoretiske RTP er ',
'return_to_player_p2': 'RTP kontrolleres af uafhængige tredjeparter.',
'disconnection_policy': 'POLITIK FOR AFBRUDT FORBINDELSE',
'disconnection_policy_p1': 'Hvis forbindelsen afbrydes efter indsats, annulleres den ikke straks.',
'disconnection_policy_p2': 'indsatsen udbetales automatisk.',
'network_latency': 'NETVÆRKSLATENS',
'network_latency_p1': 'Indsatser er gyldige, når de modtages af serveren.',
'sound': 'LYD',
'sound_p1': 'Lyd og musik kan slås fra i spilmenuen.',
'error_handling': 'FEJLHÅNDTERING',
'error_handling_p1': 'Supportteamet vil forsøge at løse problemet hurtigst muligt.',
'max_payout': 'Maksimal udbetaling er ',
'max_bet_is': 'Maksimal indsats er ',
'min_bet_is': 'Minimumsindsats er ',
'per_bet': 'pr. indsats.',
'malfunction_voids': 'Fejl annullerer alle spil og udbetalinger.',
'attention_jackpot': 'Advarsel, jackpot på bane ',
'lane': 'bane',
'congratulations': 'tillykke',
'you_won': 'du vandt',
'balance': 'saldo',
'time': 'tid',
'jackpot': 'jackpot',
'escaped': 'UNDGÅET',
'max_win': 'MAKSIMAL GEVINST',
'check_internet': 'Kontrollér venligst din internetforbindelse',
'websocket_disconected': 'WebSocket afbrudt',
'websocket_connection_error': 'WebSocket-forbindelsesfejl!',
'session_expired': 'Sessionen er udløbet, genindlæs venligst',
'remaining_bets': 'Resterende indsatser',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOSPIL OG AUTO-UDBETALING',
'autoplay_and_autocashout_ss': 'Vælg mellem manuel eller autospil',
'autoplay_and_autocashout_p1': 'Placerer automatisk indsatser i hver runde.',
'autoplay_and_autocashout_p2': 'Du kan vælge auto-udbetalingsmultiplikator.',
'autoplay_and_autocashout_p3': 'Maksimalt antal autospilsrunder er ',
'autoplay_button_label': 'Vælg bane for at starte.',
'min_bet_amount_is': 'Minimumsindsatsbeløbet er',
'bonus_rounds': 'bonusrunder',
'bonus_rounds_ss': 'Bonusrunder med gyldighedsperiode',
'bonus_rounds_p1': 'Bonusrunder kan modtages via kampagner.',
'bonus_rounds_p2': 'Spilleren kan vælge, hvornår de starter.',
'bonus_rounds_p3': 'Bonusrunder kan være tidsbegrænsede.',
'bonus_rounds_p4': 'Inaktivitet kan føre til annullering.',
'valid_until': 'gyldig indtil',
'bonus': 'bonus',
'rounds': 'runder',
'win_eur': 'gevinst EUR',
'complete_your_bet': 'Fuldfør venligst din indsats først',
'complete_auto_play': 'Fuldfør venligst autospil først',
'yes': 'ja',
'no': 'nej',
'play_bonus_rounds': 'Vil du spille bonusrunder?',
'bet_history': 'Indsatshistorik',
'jackpot_history': 'Jackpot-historik',
'ticket_id': 'Billet-ID',
'created': 'oprettet',
'currency': 'valuta',
'bet': 'indsats',
'bet_eur': 'indsats EUR',
'lanes': 'baner',
'cars': 'biler',
'multiplier': 'multiplikator',
'win': 'gevinst',
'no_betting_history': 'Ingen indsatshistorik fundet.',
'no_jackpot_history': 'Ingen jackpot-historik.',
'date': 'dato',
'user': 'bruger',
'bet_already_active': 'Der er allerede en aktiv indsats',
'please_play_the_game_in_portait_mode': 'Spil venligst spillet i portrættilstand.',
'bonus_history': 'Bonushistorik',
'bonus_type': 'Bonustype',
'no_bonus_history': 'Ingen bonushistorik.',
'game_menu': 'Spilmenu',
'game_menu_ss': 'Hjem, Indsatshistorik, Spilleregler, Genvejstaster, Lyd, Musik',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'SPILREGLER',
'game_rules_p1': 'Velkommen til Plinko – hvor heldet bestemmer!',
'game_rules_p2': 'Gør dig klar til et spændende spil baseret på held, der er lige så enkelt, som det er vanedannende! Plinko handler om at slippe en kugle ned på en pyramide fyldt med pinde og se den hoppe, dreje og springe ned til en præmieplads nederst.',
'game_rules_p3': 'Vælg mellem 8 til 16 rækker med pinde, sæt dig tilbage og nyd kaosset, mens kuglen zigzagger gennem brættet, styret af intet andet end tyngdekraft og held.',
'game_rules_p4': 'Vil den lande i en lavt betalende slot… eller ramme den store gevinst? Der er kun én måde at finde ud af det på — slip kuglen og lad spændingen folde sig ud!',
'general': 'GENERELT',
'general_p1': 'Slip Plinko-kuglen og håb, at den lander i en af de højt betalende slots nederst. Vejen er uforudsigelig — hvert hop kan ændre dit held.',
'general_p2': 'Jo flere rækker du spiller, jo mere intens bliver spillet!',
'general_p3': 'Så gå videre — stol på dit held, tryk på DROP, og jagt den store gevinst gennem Plinko-pindene!',
'betting': 'VÆDDEN',
'betting_p1': 'Vælg indsatsbeløb. Knapperne “1/2”, “2x”, “Max” kan bruges til at styre indsatsstørrelsen. Indsatsbeløbet kan også indtastes manuelt.',
'betting_p2': 'Vælg risikoniveau: Lav, Medium eller Høj. Lavere risikoniveau giver mere konsistente resultater (lav volatilitet), mens højere giver større variation (høj volatilitet).',
'betting_p3': 'Vælg antal linjer i spillet: fra 8 til 16. Vælg hvor mange rækker af pinde bolden skal falde igennem. Flere rækker = mere uforudsigelighed.',
'betting_p4': 'Vælg indsatsmode: Manuel eller Auto.',
'betting_p5': 'For at starte en runde, tryk på DROP BALL-knappen. Under runden bliver alle indsatsknapper inaktive bortset fra DROP BALL og indsatsbeløbet.',
'betting_p6': 'En Plinko-bold repræsenterer en runde. Under runden kan en ny runde med samme indstillinger startes med DROP BALL-knappen. Det er muligt at ændre indsatsbeløbet, mens der er “aktive” bolde på bordet, men ikke spillets sværhedsgrad.',
'betting_p7': 'Ved slutningen af runden når bolden lommen. På hver lomme vises udbetalingsmultiplikator.',
'betting_p8': 'Vindsten beregnes efter multiplikatoren, hvor bolden landede. Resultatet tilføjes til saldoen.',
'game_menu_p1': 'Seneste indsatsmultiplikatorer vises i bunden af spilvinduet.',
'game_menu_p2': 'På “Bet history”-knappen kan spilleren gennemgå sine seneste indsatser mere detaljeret.',
'game_menu_p3': 'For længere spilhistorik (f.eks. længere perioder) kan spilleren have brug for adgang til spillerhistorik inden for selve spilplatformen.',
'game_menu_p4': 'Gennem spilmenuen kan spillere kontrollere lydindstillinger, tastaturgenveje og åbne indsatsoversigt og spilleregler.',
'game_menu_p5': 'Spillet er designet med smuk baggrundsmusik og lydeffekter. Musik og/eller lydeffekter kan deaktiveres via spilmenuikoner.',
'game_menu_p6': 'Spilhistorik viser et vindue med tidligere indsatser og bonusoversigt.',
'autoplay': 'Automatisk Mode (Autoplay)',
'autoplay_p1': 'Klik på Auto for automatisk at slippe flere bolde uden at skulle klikke hver gang.',
'autoplay_p2': 'Vælg beløbet du vil satse pr. bold.',
'autoplay_p3': 'Vælg hvor mange gange (runder) bolden skal falde — maks 100 runder.',
'autoplay_p4': 'Tryk på START-knappen for at starte, knappen ændres til STOP.',
'autoplay_p5': 'Automatisk Mode stopper, når det valgte antal fald er gennemført, midlerne er opbrugt, eller STOP-knappen trykkes.',
'autoplay_p6': 'Hvert fald bruger samme indsatsbeløb som valgt før Auto Mode start.',
'turbo_mode': 'Turbo Mode',
'turbo_mode_p1': 'Turbo Drop lader dig slippe bolde hurtigt ved at holde DROP-knappen nede.',
'turbo_mode_p2': 'Boldene vil fortsætte med at falde, indtil du slipper knappen eller balancen er opbrugt.',
'turbo_mode_p3': 'Boldene vil fortsætte med at falde, indtil du slipper knappen eller balancen er opbrugt.',
'turbo_balance': 'Turbo Balance',
'turbo_balance_p1': 'Før du starter Turbo Drop, vælg hvor mange penge der skal afsættes — dette bliver din Turbo Balance.',
'turbo_balance_p2': 'Mens Turbo Drop er aktiv, bruger spillet kun din Turbo Balance til indsatser og gevinster.',
'turbo_balance_p3': 'Når du stopper Turbo Drop, går eventuel tilbageværende Turbo Balance tilbage til din hovedbalance.',
'turbo_balance_p4': 'Du kan forlade Turbo Drop når som helst — men mode afsluttes først, når alle bolde er faldet og landet i multiplikatorlommer.',
'free_bets': 'BONUS RUNDER',
'free_bets_p1': 'Bonus Runder tildeles af operatøren.',
'fairness': 'Retfærdighed',
'fairness_p1': 'Hvert fald bestemmes af en bevist fair tilfældighedsgenerator (RNG).',
'fairness_p2': 'Resultatet kan ikke forudsiges eller påvirkes, når bolden er sluppet.',
'disconection_and_error': 'Afbrydelsespolitik og fejlhåndtering',
'disconection_and_error_p1': 'Hvis forbindelsen mistes efter en indsats, bliver indsatsen ikke annulleret. Hvis spillet kræver handling fra spilleren, beregnes resultatet under antagelse af, at spilleren har valgt en risikofri handling uden at øge den oprindelige indsats.',
'disconection_and_error_p2': 'Ved fejl vil vores supportteam forsøge at løse problemet hurtigst muligt og genoptage det normale spil. Hvis der er et problem med selve spillet, annulleres alle væddemål, og indsatsbeløbet refunderes til spillerne.',
'other': 'Andet',
'other_p1': 'Ved fejl på spillets hardware/software annulleres alle berørte spilvæddemål og udbetalinger, og alle berørte væddemål refunderes.',
'other_p2': 'Spilreglerne offentliggøres på engelsk. Oversættelser til andre sprog leveres som en service i god tro. Hvis der er uoverensstemmelse mellem den engelske version og oversættelsen, har den engelske version forrang.',
'rows': 'Rækker',
'lvl': 'Niveau',
'low': 'Lav',
'high': 'Høj',
'ok': 'OK',
'exit_turbo_mode': 'Vil du forlade Turbo-tilstand?',
"end": "AFSLUT",
"turbo_mode_settings": "Turbo-tilstandsindstillinger",
"stop": "STOP",
'invalid_bet_amount': 'Ugyldigt indsatsbeløb',
'cashout_success': 'Hævning lykkedes',
'stop_auto_play_first': 'Stop venligst autospil først',
'turbo_only_when_no_balls': 'Turbo-tilstand kan kun aktiveres, når der ikke er bolde på brættet',
'type': 'Indsats type',
'wait_balls_to_finish': 'Vent venligst på, at boldene er færdige',
'bet_too_large_top_up_turbo_balance': 'Indsats for stor — venligst fyld op på din Turbo Balance!',
};
langArr.nl = {
'loading': 'Laden',
'hotkeys': 'Sneltoetsen',
'hotkeys_enabled': 'Sneltoetsen zijn ingeschakeld',
'enable_hotkeys_checkbox': 'Schakel de onderstaande sneltoetsen in door dit vakje aan te vinken.',
'drop_ball': 'Laat de bal vallen',
'double_bet': 'Verdubbel inzet',
'halve_bet': 'Halveer inzet',
'min_bet': 'Minimale inzet',
'max': 'Max',
'easy': 'Makkelijk',
'medium': 'Gemiddeld',
'hard': 'Moeilijk',
'daredevil': 'Waaghals',
'max_profit': 'Maximale winst',
'manual': 'Handmatig',
'auto': 'Auto',
'bet_amount': 'Inzetbedrag',
'difficulty': 'Moeilijkheidsgraad',
'payout_on_win': 'Uitbetaling bij winst',
'number_of_bets': 'Aantal inzetten',
'on_win': 'Bij winst',
'on_loss': 'Bij verlies',
'stop_on_profit': 'Stop bij winst',
'stop_on_loss': 'Stop bij verlies',
'reset': 'Reset',
'increase_by': 'Verhoog met',
'cashout': 'Uitbetalen',
'start_game': 'INZET PLAATSEN',
'start_auto_game': 'START',
'difficulity_info': 'Informatie over moeilijkheidsgraad',
'chance_collision': 'Botsingskans per spel',
'evry_25_lane': 'elke 25e baan',
'insufficiend_funds': 'Onvoldoende saldo',
'cashout_inactivity': 'Automatisch uitbetalen bij inactiviteit',
'time_running_out': 'De tijd loopt bijna af! Speel nu, anders wordt het ticket automatisch geannuleerd binnen 30 seconden',
'there_was_error': 'ER IS EEN FOUT OPGETREDEN, PROBEER OPNIEUW OF HERLAAD',
'detailed_game_rules': 'Gedetailleerde spelregels',
'general_rules': 'ALGEMENE REGELS',
'general_rules_p1': '• De multiplier begint bij 1 en ',
'general_rules_p2': '• Winst wordt berekend als inzet × multiplier.',
'general_rules_p3': '• Bij het bereiken van de maximale uitbetaling wordt automatisch uitbetaald.',
'progressive_jackpot': 'PROGRESSIEVE JACKPOT',
'progressive_jackpot_ss': 'Jackpotbaan en mogelijke winsten',
'progressive_jackpot_p1': 'Een deel van elke inzet gaat naar de jackpotpot.',
'progressive_jackpot_p2': 'De jackpot gebruikt “Mystery” of “must-hit-by” mechanismen.',
'progressive_jackpot_p3': 'Wanneer het bedrag is bereikt, heeft de volgende speler kans om te winnen.',
'progressive_jackpot_p4': 'LET OP: Bonusrondes dragen niet bij aan de jackpot.',
'showdown': 'TONEN',
'showdown_ss': 'Het rode vak toont de botsingslocatie',
'showdown_p1': 'Na uitbetaling wordt de botsingspositie weergegeven.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'De totale theoretische RTP is ',
'return_to_player_p2': 'De RTP wordt gecontroleerd door onafhankelijke derden.',
'disconnection_policy': 'VERBINDINGSVERBREKINGSBELEID',
'disconnection_policy_p1': 'Als de verbinding wordt verbroken na het plaatsen van een inzet, wordt deze niet direct geannuleerd.',
'disconnection_policy_p2': 'de inzet wordt automatisch uitbetaald.',
'network_latency': 'NETWERKLATENTIE',
'network_latency_p1': 'Inzetten zijn geldig zodra ze door de server zijn ontvangen.',
'sound': 'GELUID',
'sound_p1': 'Geluid en muziek kunnen worden uitgeschakeld via het spelmenu.',
'error_handling': 'FOUTAFHANDELING',
'error_handling_p1': 'Het supportteam zal proberen het probleem zo snel mogelijk op te lossen.',
'max_payout': 'De maximale uitbetaling is ',
'max_bet_is': 'De maximale inzet is ',
'min_bet_is': 'De minimale inzet is ',
'per_bet': 'per inzet.',
'malfunction_voids': 'Storingen maken alle spellen en uitbetalingen ongeldig.',
'attention_jackpot': 'Let op, jackpot op baan ',
'lane': 'baan',
'congratulations': 'gefeliciteerd',
'you_won': 'je hebt gewonnen',
'balance': 'saldo',
'time': 'tijd',
'jackpot': 'jackpot',
'escaped': 'ONTKOMEN',
'max_win': 'MAXIMALE WINST',
'check_internet': 'Controleer uw internetverbinding',
'websocket_disconected': 'WebSocket verbroken',
'websocket_connection_error': 'WebSocket-verbindingsfout!',
'session_expired': 'Sessie verlopen, herlaad alstublieft',
'remaining_bets': 'Resterende inzetten',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY EN AUTO-UITBETALING',
'autoplay_and_autocashout_ss': 'Keuze tussen handmatig of autoplay',
'autoplay_and_autocashout_p1': 'Plaatst automatisch inzetten in elke ronde.',
'autoplay_and_autocashout_p2': 'U kunt een auto-uitbetalingsmultiplier kiezen.',
'autoplay_and_autocashout_p3': 'Het maximale aantal autoplay-rondes is ',
'autoplay_button_label': 'Kies een baan om te starten.',
'min_bet_amount_is': 'Het minimale inzetbedrag is',
'bonus_rounds': 'bonusrondes',
'bonus_rounds_ss': 'Bonusrondes met geldigheidsperiode',
'bonus_rounds_p1': 'Bonusrondes kunnen via promoties worden verkregen.',
'bonus_rounds_p2': 'De speler kan kiezen wanneer deze starten.',
'bonus_rounds_p3': 'Bonusrondes kunnen tijdsgebonden zijn.',
'bonus_rounds_p4': 'Inactiviteit kan leiden tot annulering.',
'valid_until': 'geldig tot',
'bonus': 'bonus',
'rounds': 'rondes',
'win_eur': 'winst EUR',
'complete_your_bet': 'Voltooi eerst uw inzet',
'complete_auto_play': 'Voltooi eerst autoplay',
'yes': 'ja',
'no': 'nee',
'play_bonus_rounds': 'Bonusrondes spelen?',
'bet_history': 'Inzethistorie',
'jackpot_history': 'Jackpothistorie',
'ticket_id': 'Ticket-ID',
'created': 'aangemaakt',
'currency': 'valuta',
'bet': 'inzet',
'bet_eur': 'inzet EUR',
'lanes': 'banen',
'cars': 'auto’s',
'multiplier': 'multiplier',
'win': 'winst',
'no_betting_history': 'Geen inzethistorie gevonden.',
'no_jackpot_history': 'Geen jackpothistorie.',
'date': 'datum',
'user': 'gebruiker',
'bet_already_active': 'Er is al een actieve inzet',
'please_play_the_game_in_portait_mode': 'Speel het spel alstublieft in portretmodus.',
'bonus_history': 'Bonushistorie',
'bonus_type': 'Bonustype',
'no_bonus_history': 'Geen bonushistorie.',
'game_menu': 'Spelmenu',
'game_menu_ss': 'Home, Inzethistorie, Spelregels, Sneltoetsen, Geluid, Muziek',
// 'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
// 'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'game_rules': 'SPELREGELS',
'game_rules_p1': 'Welkom bij Plinko – Waar geluk de leiding neemt!',
'game_rules_p2': 'Maak je klaar voor een spannend kansspel dat net zo eenvoudig als verslavend is! Plinko draait om het laten vallen van een bal op een piramide vol pinnen en te zien hoe hij stuitert, draait en kaatst naar een prijs-slot onderaan.',
'game_rules_p3': 'Kies tussen 8 en 16 rijen pinnen, ga zitten en geniet van de chaos terwijl de bal zigzagt door het bord, geleid door niets anders dan zwaartekracht en geluk.',
'game_rules_p4': 'Zal hij in een laagbetaald slot landen... of de grote prijs pakken? Er is maar één manier om erachter te komen — laat de bal vallen en laat de spanning zich ontvouwen!',
'general': 'ALGEMEEN',
'general_p1': 'Laat de Plinko-bal vallen en hoop dat hij in een van de hoogbetaalde slots onderaan terechtkomt. Het pad is onvoorspelbaar — elke stuiter kan je geluk veranderen.',
'general_p2': 'Hoe meer rijen je speelt, hoe intenser de actie!',
'general_p3': 'Dus ga ervoor — vertrouw op je geluk, druk op DROP en jaag die grote winst na door de pinnen van Plinko!',
'betting': 'INZETTEN',
'betting_p1': 'Kies het inzetbedrag. Knoppen “1/2”, “2x”, “Max” kunnen worden gebruikt om de inzetgrootte te beheren. Het inzetbedrag kan ook handmatig worden ingevoerd.',
'betting_p2': 'Kies het risiconiveau: Laag, Medium of Hoog. Een lager risiconiveau geeft meer consistente resultaten (lage volatiliteit), terwijl een hoger niveau meer variatie geeft (hoge volatiliteit).',
'betting_p3': 'Kies het aantal lijnen in het spel: van 8 tot 16. Kies door hoeveel rijen pinnen de bal zal vallen. Meer rijen = meer onvoorspelbaarheid.',
'betting_p4': 'Kies de inzetmodus: Handmatig of Auto.',
'betting_p5': 'Om een spelronde te starten, druk op de DROP BALL-knop. Tijdens de ronde worden alle inzetknoppen inactief behalve DROP BALL en het inzetbedrag.',
'betting_p6': 'Één Plinko-bal vertegenwoordigt één ronde. Tijdens de ronde kan een andere ronde met dezelfde instellingen worden gestart met de DROP BALL-knop. Het is mogelijk het inzetbedrag te wijzigen terwijl er “live” ballen op het bord zijn, maar niet de moeilijkheid van het spel.',
'betting_p7': 'Aan het einde van de ronde bereikt de bal de pocket. Op elke pocket wordt de uitbetalingsvermenigvuldiger weergegeven.',
'betting_p8': 'De berekening van de winst gebeurt volgens de vermenigvuldiger waar de bal is geland. Het resultaat wordt toegevoegd aan het saldo.',
'game_menu_p1': 'De meest recente inzetvermenigvuldigers worden onderaan het spelvenster weergegeven.',
'game_menu_p2': 'Op de knop “Bet history” kan een speler zijn laatste inzetten gedetailleerder bekijken.',
'game_menu_p3': 'Voor een langere speelgeschiedenis (bijv. langere periodes) moet een speler mogelijk toegang krijgen tot de spelersgeschiedenis binnen het speelplatform zelf.',
'game_menu_p4': 'Via het spelmenu kunnen spelers geluidsopties, sneltoetsen en inzetgeschiedenis en spelregels openen.',
'game_menu_p5': 'Het spel is ontworpen met mooie achtergrondmuziek en geluidseffecten. Muziek en/of geluidseffecten kunnen worden uitgeschakeld via spelmenu-icoontjes.',
'game_menu_p6': 'Spelgeschiedenis toont een venster met eerdere inzetten en bonusgeschiedenis.',
'autoplay': 'Automatische modus (Autoplay)',
'autoplay_p1': 'Door op Auto te klikken, kunt u automatisch een aantal ballen laten vallen zonder elke keer te klikken.',
'autoplay_p2': 'Kies het bedrag dat u per bal wilt inzetten.',
'autoplay_p3': 'Selecteer hoe vaak (rondes) u de bal wilt laten vallen — maximaal 100 rondes.',
'autoplay_p4': 'Druk op START om te beginnen en de knop verandert in STOP.',
'autoplay_p5': 'De automatische modus stopt wanneer het geselecteerde aantal drops is voltooid, u geen saldo meer heeft of op STOP klikt.',
'autoplay_p6': 'Elke drop gebruikt hetzelfde inzetbedrag als dat u heeft gekozen voordat u de automatische modus startte.',
'turbo_mode': 'Turbo Modus',
'turbo_mode_p1': 'Turbo Drop laat u ballen razendsnel laten vallen door de DROP-knop ingedrukt te houden.',
'turbo_mode_p2': 'De ballen blijven vallen totdat u de knop loslaat of uw saldo op is.',
'turbo_mode_p3': 'De ballen blijven vallen totdat u de knop loslaat of uw saldo op is.',
'turbo_balance': 'Turbo Saldo',
'turbo_balance_p1': 'Voordat u Turbo Drop start, kiest u hoeveel geld u wilt reserveren — dit wordt uw Turbo Saldo.',
'turbo_balance_p2': 'Terwijl Turbo Drop actief is, gebruikt het spel alleen uw Turbo Saldo voor inzetten en winsten.',
'turbo_balance_p3': 'Wanneer u Turbo Drop stopt, gaat het resterende Turbo Saldo terug naar uw hoofdsaldo.',
'turbo_balance_p4': 'U kunt op elk moment uit Turbo Drop stappen — maar de modus eindigt volledig pas nadat alle ballen zijn gevallen en in de vermenigvuldigerpockets zijn geland.',
'free_bets': 'BONUSRONDEN',
'free_bets_p1': 'Bonusrondes worden toegekend door de operator.',
'fairness': 'Eerlijkheid',
'fairness_p1': 'Elke drop wordt bepaald door een aantoonbaar eerlijke willekeurige nummergenerator (RNG).',
'fairness_p2': 'De uitkomst kan niet worden voorspeld of beïnvloed zodra de bal is gevallen.',
'disconection_and_error': 'Verbindingsbeleid en foutafhandeling',
'disconection_and_error_p1': 'Als de verbinding verloren gaat nadat een inzet is geplaatst, wordt de inzet niet geannuleerd. Als het spel actie van een speler vereist, wordt het resultaat berekend met de aanname dat de speler een risicovrije actie kiest zonder de oorspronkelijke inzet te verhogen.',
'disconection_and_error_p2': 'In geval van een fout zal ons ondersteuningsteam proberen het probleem zo snel mogelijk op te lossen en het reguliere spel hervatten. Bij een probleem met het spel zelf worden alle inzetten geannuleerd en wordt het inzetbedrag aan de spelers terugbetaald.',
'other': 'Overige',
'other_p1': 'In geval van een storing in de game hardware/software worden alle getroffen inzetten en uitbetalingen ongeldig verklaard en worden alle getroffen inzetten terugbetaald.',
'other_p2': 'De spelregels worden gepubliceerd in het Engels. Vertalingen naar andere talen worden als service met goede intenties geleverd. Bij onduidelijkheid tussen de Engelse versie en een vertaling, geldt de Engelse versie.',
'rows': 'Rijen',
'lvl': 'Niveau',
'low': 'Laag',
'high': 'Hoog',
'ok': 'OK',
'exit_turbo_mode': 'Wilt u de Turbo-modus verlaten?',
"end": "EINDE",
"turbo_mode_settings": "Turbo Modus Instellingen",
"stop": "STOP",
'invalid_bet_amount': 'Ongeldig inzetbedrag',
'cashout_success': 'Uitbetaling geslaagd',
'stop_auto_play_first': 'Stop eerst autoplay',
'turbo_only_when_no_balls': 'Turbo-modus kan alleen worden ingeschakeld wanneer er geen ballen op het bord zijn',
'type': 'Inzet type',
'wait_balls_to_finish': 'Wacht alstublieft tot de ballen klaar zijn',
'bet_too_large_top_up_turbo_balance': 'Inzet te groot — vul uw Turbo Saldo aan!',
};
